import { Fragment, useMemo, useState, useRef } from "react";
import { Alerts, Btn, btn } from "../../AbstractElements";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
  Spinner,
  Form,
  CardTitle,
} from "reactstrap";
import SubmittedModal from "./SubmittedModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers";
import * as yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  faCopy,
  faEye,
  faBroom,
  faFilePen,
  faTentArrowLeftRight,
  faFloppyDiskPen,
  faChevronsDown,
  faArrowLeft,
  faFaceSmile,
  faUsers,
  faDatabase,
  faList,
} from "@fortawesome/pro-duotone-svg-icons";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import HistoryDataTable from "../../CommonComponents/HistoryDataTable";
// import DifferencesModal from "../OutsideEmployment/components/DifferencesModal";
import DifferencesModalBlanket from "./Components/DifferencesModalBlanket";
import TransactionHistoryTable from "../../CommonComponents/TransactionHistoryTable";
import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  TextField,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  TableContainer,
  IconButton,
  Select,
  MenuItem,
  Alert,
  Link,
  Tooltip,
  Grid
} from "@mui/material";
import { ContactsOutlined, ExpandMore, MacroOff } from "@mui/icons-material";
import { useNavigate, useParams, useLocation, NavLink } from "react-router-dom";
import moment from "moment";
import { fetchGGTrackData, getBBMRAnalyst } from "./slices/ggTrackSlice";
import { getBBMRJobOrder, getBatchList, transactionData } from "./slices/TransactionDataSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  ConcatenedColumns,
  loadingPanel,
  sortingFunc,
} from "../../CommonComponents/CommonFunction/index";

import {
  getDataBySSN,
  getDataBySSNAndAction,
  getAuditHistoryData,
  GetAutoPopulate,
} from "./slices/getDataBySSNSlice";
import { useFormik } from "formik";
import { Breadcrumbs } from "../../AbstractElements";
import { NumericFormat } from "react-number-format";
import { useAuth } from "oidc-react";
import HistoryColumns from "./HistoryColumns";
import {
  getUserRole,
  isAllowedURL,
  ShowError,
  ShowSucess,
  ShowWarning,
  extractApiError,
} from "../../_helper/helper";
import CustomTextField from "../../Layout/Components/TextField";
import ChangeWorkStatusModal from "./ChangeWorkStatusModal";
import CustomLegand from "./CustomLegand";
import GG1Workflow from "../CGITrackingNew/components/GG1Workflow";
import StatusChangeModalBlanket from "./StatusChangeModalBlanket";
import {
  getProcessesStatusList,
  getProcessesStatusListByNOA,
} from "../../store/process/actions";
import { flashManagerIcon } from "@progress/kendo-svg-icons";
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";
import { cloneNode } from "@babel/types";
import { async } from "q";
import PreviewModal from "./PreviewModel";
import ComponentToPrint from "./ComponentToPrint";
import { useReactToPrint } from "react-to-print";
import DocumentListing from "../../CommonComponents/DocumentListing";
import { deleteGG1Action } from "../../store/GG1-Crud/actions";
import { injectReducer } from "../../store";
import NextIncrOverDueModal from "./NextIncrOverDueModal";
import { Icon } from "@progress/kendo-react-common";
import ErrorBoundary from "../../ErrorBoundry";
import GG1SubWorkflow from "../CGITrackingNew/components/GG1SubWorkflow";
import JobOrderSelectModal from "./JobOrderSelectModal";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import AssignBatchVisibleColumn from "./AssignBatchVisibleColumn";
// import DataTable from "../PayrollEmployeeRole/DataTable";
import DataTable from "./Components/DataTable";
import axios from "axios";
import GG1WorkflowBlanket from "./GG1WorkflowBlanket";
import GG1SubWorkflowBlanket from "./GG1SubWorkflowBlanket";
import BBMRSummaryModal from "./BBMRSummaryModal";
import { set } from "lodash";
import ResetModel from "./ResetModel";
import AccessDenide from "./AccessDenide";
import AssignBatchVisibleColumnTwo from "./AssignBatchVisibleColumnTwo";

const DepartmentsToSkipBBMR = [
  "GUAM LEGISLATURE",
  // "Public Defender Services Corporation", // we have PUBLIC DEFENDER, PUBLIC DEFENDER CORPORATION OF GUAM
  "JUDICIARY OF GUAM", //"Unified Judiciary of Guam" instead we have JUDICIARY OF GUAM 
  "MAYOR'S COUNCIL",
  "OFFICE OF PUBLIC ACCOUNTABILITY",
  "OFFICE OF THE ATTORNEY GENERAL",
  "GUAM MEMORIAL HOSPITAL AUTHORITY",
  "GUAM VISITOR'S BUREAU",
  // "University of Guam", // We don't have in list
  "GUAM COMMUNITY COLLEGE",
  "GUAM ELECTION COMMISSION",
  "GUAM ANCESTRAL LANDS COMMISSION",
  "CHAMORRO LAND TRUST COMMISSION",
  "GUAM COMM. FOR EDUCATOR CERTIFICATION",
  "GSWA - GUAM SOLID WASTE AUTHORITY",
  "GWSA - GUAM SOLID WASTE AUTHORITY",
  "GUAM ETHICS COMMISSION"
]

const DeptCodesToSkipBBMR = [
  "LE",
  // "Public Defender Services Corporation", // we have PUBLIC DEFENDER, PUBLIC DEFENDER CORPORATION OF GUAM
  "JO", //"Unified Judiciary of Guam" instead we have JUDICIARY OF GUAM 
  "28",
  "9959",//"OFFICE OF PUBLIC ACCOUNTABILITY",
  "11",
  "GM",
  "GV",
  // "University of Guam", // We don't have in list
  "GC",
  "07",
  "2970", // 2970 "GUAM ANCESTRAL LANDS COMMISSION",
  "44",
  "76",
  "9910",// 99 "GSWA - GUAM SOLID WASTE AUTHORITY"
  "46"
]

const AssignTransactionsBatch = (props) => {
  const formikRef = useRef();
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  // const { actn_no, employeeID, actionNo, noa } = useParams();
  const { actn_no, employeeID, hrControl, noa, batchId } = useParams();
  const { userData } = useAuth();
  const role = getUserRole(userData);
  // const currentRole = getUserRole(userData);
  // const selectedRole = useSelector((state) => state?.CommonReducer?.role);
  // const role1 = Array.isArray(currentRole) ? selectedRole : currentRole;
  // // const userInfo = getUserIn
  // const [role,setRole] = useState(role1);
  // console.log("123123 roles ::: ", role)

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  // console.log("111111111 ::: ",query, noa)
  // const empID = query.get('eId');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [open50, setOpen50] = useState(false);
  const [showDoc, setShowDoc] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState();

  const handleOpen50 = () => setOpen50(true);
  const handleClose50 = () => setOpen50(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [jobOrderModal, setJobOrderModal] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [natureCode, setNatureCode] = useState({
    value: "",
    label: "",
  });
  const [sortData, setSortData] = useState([
    { field: "currentProcessStatus", dir: "desc" },
  ]);
  const [openDiffModal, setOpenDiffModal] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [openTransactionHistory, setOpenTransactionHistory] = useState(false);
  const [differenceData, setDifferenceData] = useState([]);
  const [pageStatus, setPageStatus] = useState("create");
  const [updatedData, setUpdatedData] = useState({}); //useState([]);
  const [empID, setEmpID] = useState(employeeID);
  const [errorHighLight, setErrorHighLight] = useState([]);
  const [highlight, setHighlight] = useState([]);
  const [sysGenHighlight, setSysGenHighlight] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [optionalMessages, setOptionalMessages] = useState([]);
  const [optionalMsgShown, setOptionalMsgShown] = useState(false);
  const [transactionView, setTransactionView] = useState(true);
  const [batchView, setBatchView] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [professionalView, setProfessionalView] = useState(true);
  const [jobView, setJobView] = useState(true);
  const [contactView, setContactView] = useState(true);
  const [documentView, setDocumentView] = useState(true);
  const [currentStatus, setCurrentStatus] = useState(false);
  const [printForm, setPrintForm] = useState(false);
  const [viewForm, setViewForm] = useState(false);
  const currentDate = dayjs(new Date()).format("MM/DD/YYYY HH:mm:ss.SSS");
  let date = moment().format("MM/DD/YYYY");

  const resetEnable = false;

  const location = useLocation();
  // const columns = location.state;
  const [sortedColumns, setSortedColumns] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  // const { auditHistory,HistoryDataAllColumn } = useSelector((state) => state.getDataBySSNSlice);

  const Todaydate = ""; //moment().format("MM-DD-YYYY");
  const [openStatusChange, setOpenStatusChange] = useState(false);
  const [statusRemark, setStatusRemark] = useState("");
  const [newProcessStatus, setNewProcessStatus] = useState({});
  const [statusAction, setStatusAction] = useState("");

  const [renderProcessFlow, setRenderProcessFlow] = useState(false);
  const [processStatusChanged, setProcessStatusChanged] = useState(false);
  const [tempProcessStatus, setTempProcessStatus] = useState({
    value: 0,
    label: "",
  });
  const [npaStarted, setNpaStarted] = useState(false);
  const [amendmentPerformed, setAmendmentPerformed] = useState(false);
  const [historyDataApplied, setHistoryDataApplied] = useState(false);
  const [detailActionSelected, setDetailActionSelected] = useState(false);
  const [amendedNOA, setAmendedNOA] = useState("");
  const [refHRforHistoryData, setRefHRforHistoryData] = useState("");

  const [reviewDisable, setReviewDisable] = useState(false);
  const [batchInfoLoader, setBatchInfoLoader] = useState(false)

  const [durationType, setDurationType] = useState({
    value: 1,
    label: "Days",
  });
  let durationList = [
    { value: 1, label: "Days" },
    { value: 2, label: "Months" },
    { value: 3, label: "Years" },
  ];

  const [consideration, setConsideration] = useState({
    value: 3,
    label: "Open",
  });
  let recruitApptList = [
    {
      value: 1,
      label: "Probational Appointment",
    },
    {
      value: 2,
      label: "Competitive Limited Term Appointment",
    },
  ];
  let considerationList = [
    {
      value: 1,
      label: "Departmental",
    },
    {
      value: 2,
      label: "Governmental",
    },
    {
      value: 3,
      label: "Open",
    },
  ];
  let GG1Colums = [
    "dateOfRequest",
    "socialSecurityNumber",
    "dateOfBirth",
    "currentProcessStatus",
    "fromLastName",
    "fromFirstName",
    "fromMiddleName",
    "toLastName",
    "toFirstName",
    "toMiddleName",
    "employeeId",
    "requestId",
    "actionEffectiveDate",
    "natureOfActionTitle",
    "fromPositionTitle",
    "fromPayGrade",
    "fromStep",
    "fromRate",
    "fromSalary",
    "fromDepartment",
    "toPositionTitle",
    "toPayGrade",
    "toStep",
    "toRate",
    "toSalary",
    "toDepartment",
    "fteNo",
    "remarks",
    "budgetAcctNo",
    "contactFullName",
    "contactDepartment",
    "contactNumber",
    "contactEmail",
  ];

  const auditLogColumns = [
    "ActionType",
    "Columnupdate",
    "LogAt",
    "Id",
    "Effective_Date",
    "Dept",
    "Divison",
    "Position_No",
    "Position_title",
    "Pay_Grade",
    "Rate",
    "Salary",
    "Step",
    "ProcessID",
    "CurrentProcessStatus",
    "BBMR_Analyst",
    "Remarks",
    "Status",
    "HRControlNo",
    "WorkSchedule",
    "CreatedAt",
    "UpdatedAt",
    "Createdby",
    "updatedby",
    "Nature_of_Action_Code",
    "NoOfHours",
    "Batchname",
    "TerminationDate",
    "LegalAuthority",
    "RequestID",
    "Blanket_Type",
    "From_Dept",
    "From_Divison",
    "From_Position_No",
    "From_Position_title",
    "From_Pay_Grade",
    "From_Rate",
    "From_Salary",
    "From_Step",
    "FTENO",
    "From_FTENO"
  ]


  /****** */
  const [rolesArray, setRolesArray] = useState([]);
  const [roleLoader, setRoleLoader] = useState(false)
  const getValidRole = (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "vw_Get_Valid_Role_by_path",
      SearchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "Id ASC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `path='GG1Blanket/parents-listing'`,
    };
    let retrievedData = [];
    setRoleLoader(true)
    axios
      .post(`${newBaseURL}/AdvanceSearch/global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        if (response.data?.success === false) {
          const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
          ShowError(parts.length ? parts.join(' | ') : "Failed to load role data.");
          return;
        }
        retrievedData = response.data.results;
        // console.log("finalResponsexxx",retrievedData)
        let roles = retrievedData.map((id) => { return id.roles?.toLowerCase() })
        setRolesArray(roles);
        // console.log("finalResponsexxx",rolesArray,roles)
      })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      }).finally(() => {
        setRoleLoader(false)
      });
  };
  useEffect(() => {
    getValidRole()
  }, [])
  /****** */
  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: async (props) => {
          const findIndex =
            auditTrailHistory &&
            auditTrailHistory.findIndex((item) => {
              return item?.LogAt === props?.dataItem?.LogAt;
            });

          if (findIndex !== -1 && findIndex + 1 < auditTrailHistory?.length) {
            const filterData = [
              auditTrailHistory[findIndex],
              auditTrailHistory[findIndex + 1],
            ];

            // let newFilterData = [];
            // newFilterData = filterData.map((item) => {
            //   return Object.keys(item).forEach((key) =>
            //   GG1Colums.includes(key)
            //   );
            // });

            // console.log("filterData 1234564", filterData);
            // const newFilterData_ = [...filterData];

            // let newFilterDataJD = [];

            // newFilterData_.forEach((item) => {
            //   console.log("filterData 12345 item", item);
            //   let newObject = {};
            //   GG1Colums.forEach((element) => {
            //     newObject[element] = item[element];
            //   });
            //   newFilterDataJD.push(newObject);
            // });

            // console.log("filterData 1234564 4567578977", newFilterDataJD);

            // const newFilterData = await Promise.all(
            //   filterData.map((obj) => {
            //     console.log("obj123456", obj);

            //     return Object.fromEntries(
            //       Object.entries(obj).filter(([key]) => GG1Colums.includes(key))
            //     );
            //   })
            // );

            // console.log("filterData 1234564", newFilterDataJD);

            // await Promise.all(
            //   filterData.map(async (item) => {
            //     // const { updatedColumns, ...rest } = item;
            //     let updatedItem = {};
            //     GG1Colums.map((objKey) => {
            //       updatedItem[objKey] = item[objKey];
            //       // if (!GG1Colums.includes(objKey)) {
            //       //   delete updatedItem[objKey];
            //       // }
            //     });
            //     console.log(
            //       "121212 updated item ",
            //       JSON.stringify(updatedItem)
            //     );
            //     newFilterData.push(updatedItem);
            //     return updatedItem;
            //   })
            // );

            // console.log("121212 Filter Data :: ", filterData);
            // setDifferenceData(filterData);

            // let NFD = filterData.map((item) => {
            //   let newObj = {};
            //   Object.keys(item).forEach((key) => {
            //     console.log("121212 KEYYYYYYYYYYYY", key);
            //     if (GG1Colums.includes(key)) {
            //       newObj[key] = item[key];
            //     }
            //   });
            //   return newObj;
            // });

            // const newFilterData = filterData.map((obj) => {
            //   return Object.fromEntries(
            //     Object.entries(obj).filter(([key]) => GG1Colums.includes(key))
            //   );
            // });

            // console.log(filteredArray
            setDifferenceData(filterData);
            setOpenDiffModal(true);
          }
        },
        icon: { iconName: 'k-icon  k-i-eye' },
        // icon: faEye,
        className: "font-primary",
        style: { cursor: "pointer" },
      },
    ];
  });

  const OpenHistoryComponent = () => {
    setOpenHistory(true);
  };
  const OpenTransactionHistoryComponent = () => {
    setOpenTransactionHistory(true);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
  };
  // const handleFilterChange = (data) => {
  //   setAdditionalWhere(data);
  // };

  // useEffect(() => {
  //   if (auditHistory?.length !== 0) {
  //     setHistoryData(auditHistory);
  //   }
  // }, [auditHistory]);

  // useEffect(() => {
  //   // ConcatenedColumns(columns, HistoryColumns, setSortedColumns, userData);
  //   ConcatenedColumns(HistoryDataAllColumn, HistoryColumns, setSortedColumns, userData);
  // }, [columns,HistoryDataAllColumn, sortData]);

  useEffect(() => {
    console.log("123123 auditLogColumns::: ", auditLogColumns, HistoryColumns)
    ConcatenedColumns(auditLogColumns, HistoryColumns, setSortedColumns, userData);
  }, []);
  // ConcatenedColumns(auditLogColumns, HistoryColumns, setSortedColumns, userData);

  useEffect(() => {
    if (historyData?.length > 0) {
      sortingFunc(sortData, historyData, setHistoryData);
    }
  }, [sortData]);
  useEffect(() => {
    if (employeeID && (hrControl || hrControl !== undefined)) {
      setPageStatus("update");
    } else {
      setPageStatus("create");
    }
  }, [employeeID, hrControl]);

  const renderValue = (value, valueType = "TEXT", decimal = 2) => {
    if (valueType === "DATE")
      return value ? moment(value).format("MM/DD/YYYY") : null;
    else if (valueType === "CURRENCY")
      return value ? (
        <NumericFormat
          value={value}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
      ) : null;
    else if (valueType === "DECIMAL")
      return value ? value.toFixed(decimal) : null;
    else if (valueType === "TEXT") return value || null;
  };

  const hrState = useSelector(
    (state) =>
      state?.DocumentUploadReducer?.uploadedDocumentAttechment?.referenceId
  );
  const uploadedDocuments = useSelector(
    (state) => state?.advanceSearchv2Reducer?.searchResults?.results
  );

  let initialValues = {
    employeeID: "",
    hrControlNo: hrState ? hrState : hrControl ? hrControl : "",
    ActionNo: "",
    // natureCode: { value: noa ? noa : 0, label: "" },
    natureCode: { value: 28, label: "UNCLASSIFIED APPOINTMENT" },
    // NatureOf: { value: 28, label: "UNCLASSIFIED APPOINTMENT" },
    EffDate: null,
    RequestID: "",
    LegalAuthority: "4GCA4102A(6)", //"",
    ActionDate: null,
    FR_NAME_LAST: "",
    FR_NAME_FIRST: "",
    FR_NAME_MIDDLE: "",
    TO_NAME_LAST: "",
    TO_NAME_FIRST: "",
    TO_NAME_MIDDLE: "",
    FR_PositionTitle: {
      value: "",
      label: "",
      range_next: "",
      titleWithGrade: "",
      tdp: false,
      isLawEnforcementPosition: false,
    },
    FR_ClassCode: "",
    FR_Grade: "",
    FR_Step: "",
    FR_Rate: 0,
    FR_Salary: 0,

    FR_Dept_Div_Sec: { value: "", label: "", division: "" },
    FR_Department: { value: "", label: "" },
    FR_Division: { value: "", label: "" },
    FR_FTE_Number: "",
    // TO_PositionTitle: {
    //   value: "",
    //   label: "",
    //   range_next: "",
    //   titleWithGrade: "",
    //   tdp: false,
    //   isLawEnforcementPosition: false,
    // },
    TO_PositionTitle: {
      value: "9999082225",
      label: "SUMMER TRAINEE",
      range_next: "SDYA",
      titleWithGrade: "SUMMER TRAINEE-SDYA",
      tdp: false,
      isLawEnforcementPosition: false,
    },
    TO_ClassCode: "",
    TO_Grade: "SDYA", //"",
    TO_Step: "01", //"",
    TO_Rate: 10.00, // 0
    TO_Salary: 20800, // 0
    TO_Dept_Div_Sec: { value: "", label: "", division: "" },
    // TO_Department: { value: "", label: "" },
    // TO_Division: { value: "", label: "" },
    TO_Department: { value: '20', label: 'DEPARTMENT OF YOUTH AFFAIRS', deptNo: '20', deptDiv: '' }, //{ value: "", label: "" },
    TO_Division: { value: '2010', label: 'DYA - YOUTH DEVELOPMENT', deptNo: '20', deptDiv: '10' }, //{ value: "", label: "" },
    TO_FTE_Number: "",
    TO_POST_TITLE_NO: "",
    to_budget_no: "",
    Next_INCR_date: null,
    duration: null,
    units: "",
    Term_Date: null,
    Evalution_Type: { value: "", label: "" },
    TO_budget_no: "",
    Health: "",
    life: "",
    Payroll_Date: null,
    EMP_Contract_NO: "",
    Remarks: "THIS APPOINTMENT NOT TO EXCEED 150 HOURS.    THIS POSITION IS 100% FEDERALLY FUNDED AND IS CONTINGENT ON THE AVAILABILITY OF FEDERAL FUNDS. ", //"",
    empl_type: "",
    empl_status: "",
    nposition_no: "",
    budge_pos_no: "",
    dp1: "",
    TO_budget_no: "",
    ndate_increm: "",
    date_term: "",
    annual_salary: "",
    inactive_status: "",
    // worK_SCH: {
    //   value: "",
    //   label: "",
    // },
    worK_SCH: { value: "FULL-TIME", label: "Full-Time" },
    fullName: "",
    _empl_days_count: "",
    DP1: "",
    CurrentProcessStatus: { value: 18, label: "Dept Admin" }, //{ value: 0, label: "" },
    // CurrentProcessStatus: { value: 0, label: "" },
    Posting_Date: null,
    Posting_Flag: "N",
    Final_Post: "N",
    Probation_Date: null,
    Budget_Account_Number: "",
    EmploymentDate: "",
    ExpirationDate: "",
    Social_Security_Number: "",
    Contact_Number: "",
    Contact_Email: "",
    Contact_Department: {
      value: "",
      label: "",
    },
    Contact_Position: {
      value: "",
      label: "",
    },
    Contact_FullName: "",
    RequestedBy_FullName: "",
    RequestedBy_Position: {
      value: "",
      label: "",
    },
    NatureOfActionTitle: "",
    DOB: "",
    DOR: date,
    Employment_Duration: 0,
    Employment_Duration_Type: {
      value: 1,
      label: "Days",
    },
    RetireSsCode: "",
    RetSsDesc: "",
    Retirement_Coverage: "",
    UserName: "",
    UserContactNo: "",
    recruitmentType: recruitApptList[0], // { value: 0, label: "" },
    considerationArea: considerationList[0], // { value: 0, label: "" },
    bbmrAnalyst: null,

    JOB_Order_Number: "", //{key : 0,value : ""}, //"",
    Main_Account: null,
    Account_Description: null,
    Description: null,
    AS400_Account_No: null,
    // D365_Account_No:null,
    Fund_Dimension: null,
    Year_Dimension: null,
    maxHours: 180,

  };

  let ClassCodeOptions = [
    { value: "1", label: "NON BASE - DEFINED BENEFIT" },
    { value: "2", label: "SOCIAL SECURITY/MEDICARE DEDUCTION" },
    { value: "3", label: "RETIREMENT DEDUCTION-TEMP EMPLOYEE" },
    { value: "4", label: "GUAM RETIREMENT SECURITY PLAN (GRSP)" },
    { value: "5", label: "DEFINED BENEFIT DEDUCTION" },
  ];

  let showFieldInitialValues = {
    natureCode: true,
    CurrentProcessStatus: true,
    EmployeeID: true,
    ActionNo: true,
    RequestID: true,
    LegalAuthority: true,
    ActionDate: true,
    EffDate: true,
    FR_NAME_FIRST: true,
    FR_NAME_MIDDLE: true,
    FR_NAME_LAST: true,
    TO_NAME_FIRST: true,
    TO_NAME_MIDDLE: true,
    TO_NAME_LAST: true,
    fullName: true,
    FR_PositionTitle: true,
    FR_ClassCode: true,
    FR_Grade: true,
    FR_Step: true,
    FR_Rate: true,
    FR_Salary: true,
    FR_Dept_Div_Sec: true,
    FR_Department: true,
    FR_Division: true,
    FR_FTE_Number: true,
    TO_PositionTitle: true,
    TO_ClassCode: true,
    TO_Grade: true,
    TO_Step: true,
    TO_Rate: true,
    TO_Salary: true,
    TO_Dept_Div_Sec: true,
    TO_Department: true,
    TO_Division: true,
    TO_FTE_Number: true,
    Next_INCR_date: true,
    duration: true,
    units: true,
    Term_Date: true,
    Evalution_Type: true,
    Health: true,
    life: true,
    Payroll_Date: true,
    EMP_Contract_NO: true,
    Remarks: true,

    Posting_Flag: true,
    Posting_Date: true,
    Probation_Date: true,
    payroll_date: true,
    Retirement_Coverage: true,
    RequestID: true,
    JOB_Order_Number: true,
    Budget_Account_Number: true,
    Social_Security_Number: true,
    Final_Post: true,
    Contact_Number: true,
    Contact_Email: true,
    Contact_Department: true,
    Contact_Position: true,
    Contact_FullName: true,
    RequestedBy_FullName: true,
    RequestedBy_Position: true,
    DOB: true,
    DOR: true,
    Employment_Duration: true,
    worK_SCH: true,
    maxHours: true
  };
  const [showField, setShowField] = useState(showFieldInitialValues);

  // useEffect(() => {
  //   dispatch(fetchGGTrackData(actionNo));
  // }, [actionNo]);
  const [initialItem, setInitialItem] = useState(initialValues);
  const [schema, setSetSchema] = useState({});
  const [natureOptionsExceptSI, setNatureOptionsExceptSI] = useState([]);

  const natureOfOptions = useSelector(
    (state) => state.ggTrackSlice.GGTrackData?.nature
  );
  const positionTitleOptions = useSelector(
    (state) => state.ggTrackSlice?.GGTrackData?.positionTitle
  );
  const jobOrderOptions = useSelector(
    (state) => state.ggTrackSlice?.GGTrackData?.jobOrderItems
  );
  const DpDvOptions = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.dpdvItems
  );
  const DataBySSN = useSelector(
    (state) => state.getDataBySSNSlice.TransactionsBySSN
  );
  const TransactionCreated = useSelector(
    (state) => state.TransactionDataSlice.GGTrackData
  );
  const BBMRJobOrdersNo = useSelector(
    (state) => state.TransactionDataSlice.BBMRJobOrdersNo
  );
  const type = useSelector((state) => state.TransactionDataSlice.status);
  const evalTypeItems = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.evalTypeItems
  );
  const salaryItemsList = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.salaryItemsList
  );
  const processStatusItems = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.processStatusItems
  );
  const stateError = useSelector(
    (state) => state.getDataBySSNSlice.error
  );
  const stateLookupError = useSelector(
    (state) => state.ggTrackSlice.GGTrackData.error
  );

  const { BBMRList: BBMRAnalyst, isBBMRLoading } = useSelector(
    (state) => state.ggTrackSlice
  );

  const { processStatusList } = useSelector((state) => state.processReducer);
  const {
    transaction: TransactionsBySSNAndAction,
    transactionProcessStatuses,
  } =
    useSelector(
      (state) => state.getDataBySSNSlice.TransactionsBySSNAndAction
    ) || {};
  const DataByAutoPopulate = useSelector(
    (state) => state.getDataBySSNSlice.AutoPopulateData
  );
  const { previousDataItem } = useSelector(
    (state) => state.ggTrackSlice.PreviousItem
  );

  const loding = useSelector((state) => state.getDataBySSNSlice.loding);

  const [disabledNature, setDisabledNature] = useState("");
  const [item, setItem] = useState(DataBySSN ? DataBySSN : {});
  const [autoGeneratedItem, setAutoGeneratedItem] = useState(
    DataByAutoPopulate ? DataByAutoPopulate : {}
  );
  // console.log("autoGenerateItem", autoGeneratedItem);
  const [openSubmitted, setOpenSubmitted] = useState(false);
  const [evalTypes, setEvalTypes] = useState(evalTypeItems);

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [classifiedPositionOption, setClassifiedPositionOption] = useState([]);

  const [filteredDivisionOptions, setFilteredDivisionOptions] = useState([]);
  const [BBMRList, setBBMRList] = useState([]);
  const [filteredDivisionFromOptions, setFilteredDivisionFromOptions] =
    useState([]);

  const [documentsUploaded, setDocumentsUploaded] = useState([]);

  const workStatusOptions = [
    { value: "", label: "" },
    { value: "FULL-TIME", label: "Full-Time" },
    { value: "INTERMEDIATE", label: "Intermediate" },
    { value: "PART-TIME", label: "Part-Time" },
  ];

  const [LatestValue, setLatestValue] = useState({});
  const [TransactionStatuswd, setTransactionStatus] = useState(false);
  const [BBMRSkipLogin, setBBMRSkipLogin] = useState(false);
  const [openBBMRSummary, setOpenBBMRSummary] = useState(false);
  const [openResetmodal, setOpenResetModal] = useState(false);

  const [isFromEditable, setIsFromEditable] = useState(false);
  const [isToEditable, setIsToEditable] = useState(false);

  const SeparationNOAs = [
    "10",
    "14",
    "15",
    "16",
    "17",
    "18",
    "40",
    "41",
    "42",
    "45",
    "48",
    "49",
    "64",
    "71",
    "79",
    "83",
    "92",
  ];
  const AppointmentNOAs = [
    "3",
    "7",
    "20",
    "24",
    "25",
    "28",
    "38",
    "47",
    "52",
    "54",
    "57",
    "76",
  ];

  const [maxState, setMaxState] = useState(0);
  const [localCurrentStatus, setLocalCurrentStatus] = useState();

  const SelectedTransactionHandler = (props) => {
    setIsloading(true);
    // debugger
    // if (props && Object.keys(props)?.length > 0) {
    //   console.log("Letetset prop", props);
    //   setLatestValue(props);
    //   setTransactionStatus(true);
    // }
    // setTimeout(() => {
    //   setIsloading(false);
    // }, 400);
  };

  const [showReload, setShowReload] = useState(false);

  /********** For Batch data Upload */
  // const [bulkData, setBulkData] = useState([]);
  // const [uploadFileName,setUploadFileName] = useState("");
  // const [batchListGG1, setBatchListGG1] = useState([]);
  // const [selectedBatch, setSelectedBatch] = useState("");

  // const { BatchListData : BatchList } = useSelector(
  //   (state) => state.TransactionDataSlice
  // );

  // useEffect(()=>{
  //   dispatch(getBatchList())
  // },[])

  // useEffect(()=>{
  //   if(BatchList?.length){
  //     setBatchListGG1(BatchList)
  //   }
  // },[BatchList])

  // const getBatchData = (batchNo)=>{
  //   console.log("1111111 Selected Batch is : ",batchNo)
  //   setSelectedBatch(batchNo);
  // }

  /*********** */

  useEffect(() => {
    console.log("stateerror", stateError, '#', stateLookupError);
    if (stateError || stateLookupError) {
      setShowReload(true);
    } else {
      setShowReload(false);
    }
  }, [stateError, stateLookupError])

  useEffect(() => {
    let abortcontrol = true;
    console.log("Timer completed after 1111", previousDataItem);
    if (
      previousDataItem &&
      Object.keys(previousDataItem).length > 0 &&
      abortcontrol
    ) {
      console.log("Timer completed after 2000ms", previousDataItem);
      setLatestValue(previousDataItem);
      setTransactionStatus(true);
      setOpenHistory(false);
      // setIsloading(true);
    }
    return () => {
      abortcontrol = false;
    };
  }, [previousDataItem]);
  // console.log("LatestValue", LatestValue);

  useEffect(() => {
    if (LatestValue && Object.keys(LatestValue).length > 0) {
      console.log("LatestValueLatestValuecalled 1");
      if (TransactionStatuswd == true) {
        console.log("LatestValueLatestValuecalled 2");
        setOpenHistory(false);
        // setTimeout(() => {
        setIsloading(true);
        // }, 1000);
        if (values?.natureCode?.value == "31") {
          setPreviousTransactionData(LatestValue);
          setDisabledNature(true);
          // setTimeout(() => {

          //   setIsloading(false);
          // }, 2000);
        } else if (values?.natureCode?.value == "4") {
          setPreviousTransactionDataForCancellation();
          // setIsloading(false);
        } else if (
          values?.natureCode?.value == "73" ||
          values?.natureCode?.value == "80"
        ) {
          // setPreviousTransactionData();
          setPreviousTransactionDataToFrom();
          // setIsloading(false);
        } else if (values?.natureCode?.value == "51") {
          setPreviousTransactionDataToFromReverse();
          // setIsloading(false);
        }
      }
    }
  }, [LatestValue]);

  useEffect(() => {
    if (uploadedDocuments && uploadedDocuments?.length) {
      setDocumentsUploaded(uploadedDocuments);
    } else {
      setDocumentsUploaded([]);
    }
    // console.log(
    //   "121212 uploadedDocs ::: ",
    //   documentsUploaded,
    //   uploadedDocuments
    // );
  }, [uploadedDocuments]);

  useEffect(() => {
    setFieldValue("hrControlNo", hrState);
  }, [hrState]);

  let salaryItemsListNew = salaryItemsList.map((item) => {
    return item.grade;
  });
  let PayGradeData =
    salaryItemsListNew.filter(
      (item, index) => salaryItemsListNew.indexOf(item) === index
    ) || [];



  const handleCloseSubmitted = () => {
    setOpenSubmitted(false);
    dispatch(transactionData({}));
    if (role == "BBMR-ADMIN" || role == "BBMR-ANALYST" || role == "BBMR-SUPERVISOR" || role == "BBMR-DIRECTOR") {
      navigate(`/bbmr-gg1-tracking`);
    } else {
      navigate(`/gg1-tracking`);
    }
  };

  const closeAlert = () => {
    setOpenAlert(false);
    dispatch(transactionData({}));
    if (role == "BBMR-ADMIN" || role == "BBMR-ANALYST" || role == "BBMR-SUPERVISOR" || role == "BBMR-DIRECTOR") {
      navigate(`/bbmr-gg1-tracking`);
    } else {
      navigate(`/gg1-tracking`);
    }
  };

  useEffect(() => {
    if (employeeID && !hrControl)
      if (
        TransactionCreated !== null &&
        TransactionCreated !== undefined &&
        Object.keys(TransactionCreated)?.length !== 0 &&
        DataBySSN
      ) {
        setOpenSubmitted(true);
      }
  }, [TransactionCreated, employeeID]);

  useEffect(() => {
    if (natureOfOptions && noa) {
      let data = natureOfOptions.find((item) => {
        return item.value == noa;
      });
      setNatureCode({ value: noa, label: data?.label });
      setFieldValue("natureCode", {
        value: noa,
        label: data?.label,
      });
      setFieldValue("NatureOf", {
        value: noa,
        label: data?.label,
      });
      setFieldValue("LegalAuthority", data?.authority);
      setOptionalMsgShown(false);
      // let newNOAs = natureOfOptions.filter((item)=>item.value != "30")
      // setNatureOptionsExceptSI(newNOAs);
    }
  }, [noa, natureOfOptions]);

  useEffect(() => {
    if (type === "create") {
      setOpenSubmitted(true);
    }
  }, [type]);

  // const onSubmit = async () => {
  //   await createSchemaRendom(values);
  //   // if (
  //   //   values?.CurrentProcessStatus?.value === 18 ||
  //   //   values?.CurrentProcessStatus?.value === 6
  //   // ) {

  //  if(values?.CurrentProcessStatus?.value == "19"){
  //   let infoMsgs = [];
  //    if (
  //      values?.EffDate == null ||
  //      values?.EffDate == "" ||
  //      values?.EffDate == undefined
  //    ){
  //      infoMsgs.push({
  //        id: "EffDate",
  //        msg: "Eff Date cannot be the blank",
  //      });
  //    }
  //   //  setErrorMessage(infoMsgs);
  //    setTimeout(() => {}, 1000);
  //     if (infoMsgs?.length) {
  //       infoMsgs.map((item) => {
  //         ShowError(item?.msg);
  //       });
  //       setProcessStatusChanged(false);
  //       return;
  //     }
  //  }
  //   // console.log("121212 on submit :::: ", errorMessage);
  //   if (
  //     errorMessage?.length 
  //     // ||
  //     // (optionalMessages?.length && !optionalMsgShown)
  //   ) {
  //     setTimeout(() => { }, 1000);
  //     if (errorMessage?.length) {
  //       errorMessage.map((item) => {
  //         ShowError(item?.msg);
  //       });
  //     }
  //     // if (optionalMessages?.length && !optionalMsgShown) {
  //     //   optionalMessages.map((item) => {
  //     //     ShowError(item?.msg);
  //     //   });
  //     //   setOptionalMessages([]);
  //     //   setOptionalMsgShown(true);
  //     // }
  //     setProcessStatusChanged(false);
  //     return;
  //   }

  //   console.log("121212 on submit ::: ", documentsUploaded, uploadedDocuments);
  //   if (
  //     (values?.natureCode?.value == "20" ||
  //       values?.natureCode?.value == "91" ||
  //       values?.natureCode?.value == "47" ||
  //       values?.natureCode?.value == "30" ||
  //       values?.natureCode?.value == "58") &&
  //     documentsUploaded &&
  //     documentsUploaded?.length == 0
  //   ) {
  //     // console.log("121212 on submit 111::: ", documentsUploaded);
  //     if (values?.natureCode?.value == "20") {
  //       ShowError("Please Upload Employment Contract Document");
  //     } else if (values?.natureCode?.value == "91") {
  //       ShowError("Please Upload Position Description Document");
  //     } else if (values?.natureCode?.value == "47") {
  //       ShowError("Please Upload Acting Appointment Letter from Governor.");
  //     } else if (
  //       values?.natureCode?.value == "30" ||
  //       values?.natureCode?.value == "58"
  //     ) {
  //       ShowError("Please Upload Performance Evaluation Document.");
  //     }
  //     setProcessStatusChanged(false);
  //     if (errorMessage?.length) {
  //       errorMessage.map((item) => {
  //         ShowError(item?.msg);
  //       });
  //     }
  //     return;
  //   }

  //   // Create Time
  //   // const payload = {
  //   //   employeeID: parseInt(values.employeeID),
  //   //   actnNo: values?.ActionNo !== undefined ? values.ActionNo : "",
  //   //   actnEffDate:
  //   //     values.EffDate != null &&
  //   //     values.EffDate != undefined &&
  //   //     values.EffDate != ""
  //   //       ? moment(values.EffDate).format()
  //   //       : null,
  //   //   actnDate:
  //   //     values.ActionDate != null &&
  //   //     values.ActionDate != undefined &&
  //   //     values.ActionDate != ""
  //   //       ? moment(values.ActionDate).format()
  //   //       : null,
  //   //   actnNo: values?.ActionNo !== undefined ? values.ActionNo : "",
  //   //   legal: values?.LegalAuthority,
  //   //   natureActn: values.NatureOf.value,
  //   //   actnType: "",
  //   //   amdEffdt: null,
  //   //   amdActn: "",
  //   //   toBudgetNo: values?.TO_FTE_Number,
  //   //   frBudgetNo: values?.FR_FTE_Number,
  //   //   toCollar: "",
  //   //   frCollar: "",
  //   //   toOldRange: "",
  //   //   toNewGrade: values?.TO_Grade,
  //   //   frOldRange: "",
  //   //   frNewGrade: values?.FR_Grade,
  //   //   toStep: values?.TO_Step,
  //   //   frStep: values?.FR_Step,
  //   //   toRate: values?.TO_Rate ? values?.TO_Rate : null,
  //   //   frRate: values?.FR_Rate ? values?.FR_Rate : null,
  //   //   toSalary:
  //   //     values.TO_Salary !== "" &&
  //   //     values.TO_Salary !== null &&
  //   //     values.TO_Salary !== undefined
  //   //       ? values.TO_Salary
  //   //       : null,
  //   //   frSalary: values.FR_Salary ? values.FR_Salary : null,
  //   //   addSalary: 0,
  //   //   toPostTitleNo: values?.TO_PositionTitle?.value,
  //   //   frPostTitleNo: values?.FR_PositionTitle?.value,
  //   //   toDeptDivSec: values?.TO_Dept_Div_Sec?.value,
  //   //   frDeptDivSec: values?.FR_Dept_Div_Sec?.value,
  //   //   i9: "",
  //   //   healthPlan: values.Health,
  //   //   lifePlan: values.life,
  //   //   retSs: "",
  //   //   toNameLast: values?.TO_NAME_LAST,
  //   //   toNameFirst: values?.TO_NAME_FIRST,
  //   //   toNameMiddle: values?.TO_NAME_MIDDLE,
  //   //   frNameLast: values?.FR_NAME_LAST,
  //   //   frNameFirst: values?.FR_NAME_FIRST,
  //   //   frNameMiddle: values?.FR_NAME_MIDDLE,
  //   //   toNameFull: `${values.TO_NAME_FIRST}  ${values.TO_NAME_MIDDLE}  ${values.TO_NAME_LAST}`,
  //   //   remarks: values.Remarks,
  //   //   detailFrCollr: "",
  //   //   detailToCollr: "",
  //   //   detailFrRange: "",
  //   //   detailToRange: "",
  //   //   detailFrStep: "",
  //   //   detailToStep: "",
  //   //   detailExtend: "",
  //   //   baseIncrDate: null,
  //   //   nextIncrDate: values.Next_INCR_date
  //   //     ? moment(values.Next_INCR_date).format()
  //   //     : null,
  //   //   termDate: values.Term_Date ? moment(values.Term_Date).format() : null,
  //   //   emplDaysCount: 0,
  //   //   calendarWorkDays: "",
  //   //   hold: "",
  //   //   postingFlag: values?.Posting_Flag ? values?.Posting_Flag : "",
  //   //   postingDate: values?.Posting_Date ? values?.Posting_Date : "",
  //   //   termId: "",
  //   //   userId: "",
  //   //   addRate: 0,
  //   //   cancelEffdt: null,
  //   //   cancelActn: "",
  //   //   probationDate: values?.Probation_Date ? values?.Probation_Date : "",
  //   //   printFlag: "",
  //   //   printHold: "",
  //   //   detailToRate: 0,
  //   //   detailFrRate: 0,
  //   //   detailToSalry: 0,
  //   //   detailFrSalry: 0,
  //   //   finalPost: values?.Final_Post ? values?.Final_Post : "",
  //   //   payrollDate: values?.Payroll_Date ? values?.Payroll_Date : "",
  //   //   payrollInt: "",
  //   //   printOption: "",
  //   //   requestId: values?.RequestID ? values?.RequestID : "",
  //   //   jacketNo: "",
  //   //   dp1: "",
  //   //   dp2: "",
  //   //   evalType: values?.Evalution_Type?.value,
  //   //   evalRemarks: values?.Evalution_Type?.label,
  //   //   emplContractNo: values.EMP_Contract_NO,
  //   //   jobOrderNo: values?.JOB_Order_Number ? values?.JOB_Order_Number : "",
  //   //   budgetAcctNo: values?.Budget_Account_Number
  //   //     ? values?.Budget_Account_Number
  //   //     : "",
  //   //   policeClrDate: null,
  //   //   courtClrDate: null,
  //   //   dateEntered: null,
  //   //   dateEdit: null,
  //   //   enterBy: "",
  //   //   editBy: "",
  //   //   testdata: 0,
  //   //   testdata1: "",
  //   //   processId: 0,
  //   //   currentProcessStatus: values?.CurrentProcessStatus?.value,
  //   //   worK_SCH: values.worK_SCH,
  //   //   JOB_Order_Number: values.job_order_no,
  //   //   // retirement_Amount: values?.Retirement_Coverage,
  //   //   // retire_ss_code_master: values?.Retirement_Coverage,
  //   //   // ret_ss: values?.Retirement_Coverage,
  //   //   retSs: values?.Retirement_Coverage,
  //   //   name2: values?.fullName,
  //   // };

  //   // New Payload
  //   // const payloadD = {
  //   //   EmployeeId: parseInt(values.employeeID),
  //   //   EmployeeSeq: "",
  //   //   HrControl: "",
  //   //   ActionDate:
  //   //     values.ActionDate != null &&
  //   //     values.ActionDate != undefined &&
  //   //     values.ActionDate != ""
  //   //       ? moment(values.ActionDate).format()
  //   //       : null,
  //   //   ActionEffectiveDate:
  //   //     values.EffDate != null &&
  //   //     values.EffDate != undefined &&
  //   //     values.EffDate != ""
  //   //       ? moment(values.EffDate).format()
  //   //       : null,
  //   //   BudgetAcctNo: "",
  //   //   EmploymentContractNo: values.EMP_Contract_NO,
  //   //   FinalPost: values.Final_Post,
  //   //   FromDepartment: values.FR_Dept_Div_Sec,
  //   //   FromFirstName: values.FR_NAME_FIRST,
  //   //   FromFteNo: values.FR_FTE_Number,
  //   //   FromLastName: values.FR_NAME_LAST,
  //   //   FromMiddleName: values.FR_NAME_MIDDLE,
  //   //   FromPayGrade: values.FR_Grade,
  //   //   FromPositionTitle: values.FR_PositionTitle,
  //   //   FromRate: values.FR_Rate,
  //   //   FromSalary: values.FR_Salary,
  //   //   FromStep: values.FR_Step,
  //   //   JobOrderNumber: values.JOB_Order_Number,
  //   //   LegalAuthority: values.LegalAuthority,
  //   //   NatureOfActionCode: values.natureCode,
  //   //   NextIncrementDate: values.Next_INCR_date,
  //   //   OverallEvaluation: values.Evalution_Type,
  //   //   PayrollDate: values.Payroll_Date,
  //   //   PostingDate: values.Posting_Date,
  //   //   PostingFlag: values.Posting_Flag,
  //   //   ProbationEndDate: values.Probation_Date,
  //   //   RequestId: values.RequestID,
  //   //   RetirementCoverage: values.Retirement_Coverage,
  //   //   SocialSecurityNumber: values.employeeID,
  //   //   TerminationDate: values.Term_Date,
  //   //   ToDepartment: values.TO_Dept_Div_Sec,
  //   //   ToFirstName: values.TO_NAME_FIRST,
  //   //   ToFteNo: values.TO_FTE_Number,
  //   //   ToFullName: `${values.TO_NAME_FIRST}  ${values.TO_NAME_MIDDLE}  ${values.TO_NAME_LAST}`,
  //   //   ToLastName: values.TO_NAME_LAST,
  //   //   ToMiddleName: values.TO_NAME_MIDDLE,
  //   //   ToPayGrade: values.TO_Grade,
  //   //   ToPositionTitle: values.TO_PositionTitle,
  //   //   ToRate: values.TO_Rate,
  //   //   ToSalary: values.TO_Salary,
  //   //   ToStep: values.TO_Step,
  //   //   ProcessId: 0,
  //   //   CurrentProcessStatus: values?.CurrentProcessStatus?.value,
  //   //   ActnNo: values.ActionNo,
  //   //   FullName: values.fullName,
  //   //   FromDeptDivSec: values.FR_Dept_Div_Sec,
  //   //   ToDeptDivSec: values.TO_Dept_Div_Sec,
  //   //   FromBudgetNo: values?.FR_FTE_Number,
  //   //   ToBudgetNo: values?.TO_FTE_Number,
  //   //   Dp1: "",
  //   //   Dp2: "",
  //   //   TermDate: values.Term_Date,
  //   //   HealthPlan: values.Health,
  //   //   LifePlan: values.life,
  //   //   RetSs: values?.Retirement_Coverage,
  //   //   ProbationDate: values.Probation_Date,
  //   //   EvalType: values.Evalution_Type.value,
  //   //   EvaluationTypeDescription: values.Evalution_Type.label,
  //   //   CancelActn: "",
  //   //   EmployeeDaysCount: 0,
  //   //   RetireSsCode: "",
  //   //   RetireSsCodeMaster: "",
  //   //   RetSsDesc: "",
  //   //   RetSsDescMaster: "",
  //   //   FromDeptKey: "",
  //   //   ToDeptKey: "",
  //   //   FromNpositionNo: "",
  //   //   ToNpositionNo: "",
  //   //   NatureTitle: values?.NatureOf.label,
  //   //   FromPositionTitlewithgrade: "",
  //   //   ToPositionTitlewithgrade: "",
  //   //   FteNo: "",
  //   //   Remarks: "",
  //   //   EvaluationDescription: values?.Evalution_Type.label,
  //   //   ToPostTitleNo: values?.TO_PositionTitle?.value,
  //   //   FromPostTitleNo: values?.FR_PositionTitle?.value,
  //   //   DateEntered: "",
  //   //   DateEdit: "",
  //   //   EnterBy: "",
  //   //   EditBy: "",
  //   //   ActionNo: values?.ActionNo,
  //   // };

  //   // static payload final
  //   if (
  //     values?.LegalAuthority == null ||
  //     values?.LegalAuthority == undefined ||
  //     values?.LegalAuthority == ""
  //   ) {
  //     let data = natureOfOptions.find((item) => {
  //       return item.value == values?.natureCode?.value;
  //     });
  //     setFieldValue("LegalAuthority", data?.authority);
  //   }
  //   console.log(
  //     "121212 payload ::: ",
  //     values?.TO_Rate,
  //     values?.TO_Salary,
  //     values?.EffDate,
  //     values?.Term_Date,
  //     values?.LegalAuthority
  //   );

  //   console.log("121212 values ::: ", values);
  //   let payload = {};
  //   try {
  //     payload = {
  //       ReferenceID: CheckValue(values?.hrControlNo) ? values?.hrControlNo : "",
  //       SocialSecurityNumber: values?.Social_Security_Number || "", //"10040534",
  //       ActionNo: values?.ActionNo || "",
  //       EnterBy: "",
  //       DateEntered: "",
  //       EditBy: "",
  //       DateEdit: "",
  //       EmployeeId:
  //         values?.natureCode?.value == "91" ? 0 : parseInt(values?.employeeID), // null before instead 0
  //       EmployeeSeq: "",
  //       HrControl: CheckValue(values?.hrControlNo) ? values?.hrControlNo : "",
  //       ActionDate: null,
  //       bbmrAnalyst: values?.bbmrAnalyst,
  //       // values.ActionDate != null &&
  //       // values.ActionDate != undefined &&
  //       // values.ActionDate != ""
  //       //   ? moment(values?.ActionDate).format("MM/DD/YYYY")
  //       //   : null,
  //       ActionEffectiveDate:
  //         values.EffDate != null &&
  //           values.EffDate != undefined &&
  //           values.EffDate != ""
  //           ? moment(values?.EffDate).format("MM/DD/YYYY")
  //           : null,
  //       BudgetAcctNo: values?.Budget_Account_Number,
  //       EmploymentContractNo: values?.EMP_Contract_NO,

  //       FromDepartment: values?.FR_Department?.label?.trim(), //values?.FR_Dept_Div_Sec?.label, //"GOV - EXECUTIVE DIRECTION",
  //       FromDeptKey: values?.FR_Department?.value, //"0201",
  //       ToDepartment: values?.TO_Department?.label?.trim(), // "GOV - EXECUTIVE DIRECTION",
  //       ToDeptKey: values?.TO_Department?.value, //"0201",
  //       FromDivision: values?.FR_Division?.label?.trim(),
  //       ToDivision: values?.TO_Division?.label?.trim(),

  //       FromDeptDivSec: values?.FR_Division
  //         ? values?.FR_Division?.label?.trim()
  //         : "", //"0201",
  //       ToDeptDivSec: values?.TO_Division
  //         ? values?.TO_Division?.label?.trim()
  //         : "", //"0201",

  //       FromDivisionKey: values?.FR_Division?.value || "",
  //       FromDivisionName: values?.FR_Division?.label?.trim() || "",
  //       ToDivisionKey: values?.TO_Division?.value || "",
  //       ToDivisionName: values?.TO_Division?.label?.trim() || "",

  //       FromFirstName: values?.FR_NAME_FIRST, //"MARCIA",
  //       FromMiddleName: values?.FR_NAME_MIDDLE, //"Z",
  //       FromLastName: values?.FR_NAME_LAST, //"RIVERA",
  //       ToFirstName: values?.TO_NAME_FIRST, //"",
  //       ToMiddleName: values?.TO_NAME_MIDDLE, //"",
  //       ToLastName: values?.TO_NAME_LAST, //"",
  //       FullName: `${values.TO_NAME_FIRST}  ${values.TO_NAME_MIDDLE}  ${values.TO_NAME_LAST}`, //"RIVERA,MARCIA Y",
  //       ToFullName: `${values.TO_NAME_FIRST}  ${values.TO_NAME_MIDDLE}  ${values.TO_NAME_LAST}`, //"    ",
  //       FromFteNo: values?.FR_FTE_Number, //"123",
  //       ToFteNo: values?.TO_FTE_Number, //"111",
  //       FteNo: "",
  //       FromPositionTitle: values?.FR_PositionTitle?.label?.trim(), //"CHIEF PUBLIC HLT DENTAL OFCR    ",
  //       FromPostTitleNo: values?.FR_PositionTitle?.value, //"0000008415",
  //       FromPositionTitlewithgrade:
  //         values?.FR_PositionTitle?.titleWithGrade?.trim(), // "CHIEF PUBLIC HLT DENTAL OFCR-Q",
  //       ToPositionTitle: values?.TO_PositionTitle?.label?.trim(), //"MEDICAL RECORDS CODER",
  //       ToPostTitleNo: values?.TO_PositionTitle?.value, //"0.212",
  //       ToPositionTitlewithgrade:
  //         values?.TO_PositionTitle?.titleWithGrade?.trim(), //"MEDICAL RECORDS CODER-J",
  //       FromNpositionNo: "",
  //       ToNpositionNo: "",
  //       FromPayGrade: values?.FR_Grade, //"H",
  //       ToPayGrade: values?.TO_Grade, //"J",
  //       FromRate: values?.FR_Rate, //13.23,
  //       ToRate: values?.TO_Rate, // 15.51,
  //       FromSalary: values?.FR_Salary, //27525,
  //       ToSalary: values?.TO_Salary, //32253,
  //       FromStep: values?.FR_Step == "0null" ? null : values?.FR_Step, //"02",
  //       ToStep: values?.TO_Step == "0null" ? null : values?.TO_Step, //"02",
  //       EvalType: values?.Evalution_Type?.value
  //         ? values?.Evalution_Type?.value
  //         : "", //"P",
  //       EvaluationTypeDescription: values?.Evalution_Type?.label?.trim()
  //         ? values?.Evalution_Type?.label?.trim()
  //         : "", //"PRESUMPTIVE",
  //       OverallEvaluation: values?.Evalution_Type?.value
  //         ? `${values?.Evalution_Type?.value
  //         }-${values?.Evalution_Type?.label?.trim()}`
  //         : "", //"P-PRESUMPTIVE",
  //       EvaluationDescription: values?.Evalution_Type?.label?.trim()
  //         ? values?.Evalution_Type?.label?.trim()
  //         : "", //"PRESUMPTIVE",
  //       RequestId: values?.RequestID, //"20-293",
  //       NatureOfActionCode: values?.natureCode?.value, // 31,
  //       NatureTitle: values?.natureCode?.label?.trim(), //"AMENDMENT",
  //       LegalAuthority: values?.LegalAuthority || "", // "PR&R",
  //       JobOrderNumber: values?.JOB_Order_Number, //values?.JOB_Order_Number?.value, //"2320 20 206-111/113",
  //       FromBudgetNo: "", //"123",
  //       ToBudgetNo: "", //"111",
  //       Dp1: "",
  //       Dp2: "",
  //       EmployeeDaysCount: 0,
  //       ActnNo: values?.ActionNo || "", // "",
  //       NextIncrementDate: values?.Next_INCR_date || null, //"2023-04-17T01:26:07",
  //       PayrollDate: values?.Payroll_Date || "", //"",
  //       ProbationDate: null, //values?.Probation_Date, //"2023-09-15",
  //       ProbationEndDate: null, //values?.Probation_Date, //"2023-09-15",
  //       TermDate: values?.Term_Date, //"2023-09-14",
  //       PostingDate: values?.Posting_Date || "", //"",
  //       ExpirationDate: values?.ExpirationDate ? values?.ExpirationDate : "",
  //       EmploymentDate: values?.EmploymentDate ? values?.EmploymentDate : "",
  //       TerminationDate: values?.Term_Date, //"2023-09-14",
  //       RetSs: values?.RetireSsCode || "", //" 7",
  //       RetireSsCode: values?.RetireSsCode || "", //"7",
  //       RetireSsCodeMaster: values?.RetireSsCode || "", //"7",
  //       RetSsDesc: values?.RetSsDesc?.trim() || "", //"DC  - DEFINED CONTRIBUTION DEDUCTION",
  //       RetSsDescMaster: values?.RetSsDesc?.trim() || "", //"DC  - DEFINED CONTRIBUTION DEDUCTION",
  //       RetirementCoverage: values?.Retirement_Coverage?.trim() || "", //" 1",
  //       CancelActn: "",
  //       HealthPlan: "",
  //       LifePlan: "",
  //       FinalPost: "", //values?.Final_Post || "N",
  //       PostingFlag: "", //values?.Posting_Flag ? values?.Posting_Flag : "N", //"N",
  //       ProcessId: 1,
  //       Remarks: values?.Remarks || "",
  //       StatusRemarks: statusRemark || "N/A",
  //       CurrentProcessStatus:
  //         values?.CurrentProcessStatus?.value == 6
  //           ? 7
  //           : values?.CurrentProcessStatus?.value == 338
  //             ? 342
  //             : values?.CurrentProcessStatus?.value, //18,
  //       TransactionStatus:
  //         values?.CurrentProcessStatus?.value == 18 ||
  //           values?.CurrentProcessStatus?.value == 6
  //           ? "Approved"
  //           : statusAction,
  //       NatureOfActionTitle: values?.natureCode?.label?.trim() || "",
  //       ContactNumber: values?.Contact_Number || "",
  //       ContactEmail: values?.Contact_Email || "",
  //       ContactDepartment: values?.Contact_Department?.label?.trim() || "",
  //       ContactPosition: values?.Contact_Position?.label?.trim() || "",
  //       ContactFullName: values?.Contact_FullName || "",
  //       RequestedByName: values?.RequestedBy_FullName || "",
  //       RequestedByPosition: values?.RequestedBy_Position?.label || "",
  //       DateOfBirth: values?.DOB || "",
  //       DateOfRequest: values?.DOR || "",
  //       EmploymentDuration: values?.Employment_Duration || 0,
  //       EmploymentDurationType:
  //         values?.Employment_Duration_Type?.label?.trim() || "Days",
  //       worK_SCH: CheckValue(values?.worK_SCH?.value)
  //         ? values?.worK_SCH?.value
  //         : "",
  //       TypeOfRecruitment: values?.recruitmentType?.label || "",
  //       AreaOfConsidration: values?.considerationArea?.label || "",
  //       RefAmendment: refHRforHistoryData || "",
  //       // batchData: bulkData
  //     };
  //   } catch (error) {
  //     console.log("121212 ::: err ", error);
  //   }

  //   console.log("121212 Payload ::: ", payload);

  //   if (
  //     payload !== null &&
  //     payload !== undefined &&
  //     values?.natureCode?.value !== ""
  //   ) {
  //     setIsloading(true);
  //     if ((hrControl && employeeID) ) {
  //       dispatch(transactionData({ payload, staus: false }))
  //         .then((response) => {
  //           if (
  //             response?.payload !== undefined &&
  //             response?.payload !== null &&
  //             response?.payload !== "" &&
  //             response?.payload?.data
  //           ) {
  //             setIsloading(false);
  //             // setFieldValue("CurrentProcessStatus", { value: 0, label: "" });
  //             // console.log("121212 response :::: ",response);
  //             clearToValues();
  //             if(role == "BBMR-ADMIN" || role == "BBMR-ANALYST" || role == "BBMR-SUPERVISOR" || role == "BBMR-DIRECTOR")
  //             {
  //               navigate(`/bbmr-gg1-tracking`);
  //             }else{
  //               navigate(`/gg1-tracking`);
  //             }
  //           } else {
  //             console.log("121212 in elseee error ::: ", response);
  //             setIsloading(false);
  //             setFieldValue("CurrentProcessStatus", localCurrentStatus);
  //             setProcessStatusChanged(false);
  //             if(response?.payload){
  //               ShowError(
  //                 response?.payload?.message
  //                   ? response?.payload?.message
  //                   : "Something went wrong!"
  //               );
  //             }
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("121212 error :::: ", error);
  //           setIsloading(false);
  //           setFieldValue("CurrentProcessStatus", localCurrentStatus);
  //           setProcessStatusChanged(false);
  //         });
  //     } else {
  //       dispatch(transactionData({ payload, staus: true }))
  //         .then((response) => {
  //           if (
  //             response?.payload !== undefined &&
  //             response?.payload !== null &&
  //             response?.payload !== "" &&
  //             response?.payload?.data
  //           ) {
  //             setIsloading(false);

  //             // navigate(`/gg1-tracking`);

  //             clearToValues();
  //           } else {
  //             console.log(
  //               "121212 Msg elsee res::: ",
  //               response,
  //               response?.payload?.message
  //             );
  //             setIsloading(false);
  //             setFieldValue("CurrentProcessStatus", localCurrentStatus);
  //             setProcessStatusChanged(false);
  //           }
  //         })
  //         .catch((error) => {
  //           console.log("121212 Msg ::: ", error);
  //           setFieldValue("CurrentProcessStatus", localCurrentStatus);
  //           setProcessStatusChanged(false);
  //           setIsloading(false);
  //         });
  //     }
  //   }
  // };

  const onTransactionChange = async () => {
    createSchemaRendom(values);
    // if(selectedIds?.length == 0){
    //   ShowError("Please select atleast one Applicant")
    //   return true
    // }
    if (values?.maxHours == 0 || values?.maxHours == "" || values?.maxHours == null) {
      ShowError("Max Authorized Hours cannot be blank or 0.")
      return false
    }
    let payload = [{
      "id": batchId || 0,

      "noOfHours": values?.maxHours,

      "effectiveDate": values?.EffDate ? moment(values?.EffDate).format("YYYY/MM/DD") : null,
      "dept": values?.TO_Department?.value,
      "divison": values?.TO_Division?.value,

      "positionNo": values?.TO_PositionTitle?.value,
      "positionTitle": values?.TO_PositionTitle?.label,
      "payGrade": values?.TO_Grade,
      "rate": values?.TO_Rate,
      "salary": values?.TO_Salary,
      "step": values?.TO_Step,
      "processId": 1,
      "bbmrAnalyst": 0,
      "remarks": values?.Remarks || initialValues?.Remarks,
      // "status": values?.CurrentProcessStatus?.value,
      // "hrcontrolNo": "",
      "workSchedule": CheckValue(values?.worK_SCH?.value) ? values?.worK_SCH?.value : "",
      "natureOfActionCode": values?.natureCode?.value,
      // "noOfHours": 0,
      "transactionStatus": values?.CurrentProcessStatus?.value == 18 || values?.CurrentProcessStatus?.value == 6
        ? "Default"
        : statusAction == "" ? "Update" : statusAction.includes("Return") ? "Return" : statusAction,
      "statusRemarks": statusRemark || "N/A",
      // StatusRemarks: statusRemark || "N/A",
      // "currentProcessStatus": values?.CurrentProcessStatus?.value,
      CurrentProcessStatus:
        values?.CurrentProcessStatus?.value == 6
          ? 7
          : values?.CurrentProcessStatus?.value == 338
            ? 342
            : values?.CurrentProcessStatus?.value,

      "terminationDate": values?.Term_Date ? moment(values?.Term_Date).format("YYYY/MM/DD") : null, //values?.Term_Date,
      "requestId": values?.RequestID ? values?.RequestID : "",
      "legalAuthority": values?.LegalAuthority || "",
      "bbmrAnalyst": values?.bbmrAnalyst,

      "fromDept": values?.FR_Department?.value,
      "fromDivison": values?.FR_Division?.value,
      "fromPositionNo": values?.FR_PositionTitle?.value,
      "fromPositionTitle": values?.FR_PositionTitle?.label,
      "fromPayGrade": values?.FR_Grade,
      "fromRate": values?.FR_Rate,
      "fromSalary": values?.FR_Salary,
      "fromStep": values?.FR_Step,

      "fteno": values?.TO_FTE_Number || "",
      "fromFteno": values?.FR_FTE_Number || "",

    }]

    // console.log("123123 payload : ",payload, values.RequestID,values?.Remarks, tempProcessStatus)
    // return true
    axios.defaults.headers.common['role'] = sessionStorage?.getItem("currentRole");
    await axios.put(`${process.env.REACT_APP_API_DOTNET_URL}/BlanketGG1/updateparent`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem(
            "jwt_access_token"
          )}`,
        },
      }
    ).then((response) => {
      console.log("Master timecode", response);
      if (response.data?.success === false) {
        const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
        ShowError(parts.length ? parts.join(' | ') : "Something went wrong. Please try again.");
        return;
      }
      ShowSucess("Records updated sucessfully!")
      setSelectedIds([]);
      setTimeout(() => {
        window.location.reload();
      }, 2000)

    })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      });
  }

  const onAssign = async () => {
    console.log("123123 values+++++ ", values, values.JOB_Order_Number)
    if (values?.natureCode?.label?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" && (!values?.JOB_Order_Number || values?.JOB_Order_Number == "")) {
      ShowError("Please Assign Job Order Number")
      return false
    }
    if (values?.natureCode?.label?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" && selectedIds?.length == 0) {
      ShowError("Please select atleast one Applicant")
      return false
    }
    let payload = {
      "id": selectedIds?.length ? selectedIds.join(",") : "",
      "budget_Acct_No": values?.Main_Account,
      "job_Order_Number": values.JOB_Order_Number,
      "dept": values?.TO_Department?.value,
      "nature_of_Action_Code": values?.natureCode?.value,
      "to_Position_Title": values?.TO_PositionTitle?.label,
      "to_Position_No": values?.TO_PositionTitle?.value,
      "effective_Date": values?.EffDate,
      "to_Dept": values?.TO_Department?.value,
      "to_Salary": values?.TO_Salary,
      "to_Rate": values?.TO_Rate,
      "remarks": values?.Remarks,
      "workPhoneNumber": "",
      "workSchedule": values?.worK_SCH?.value
    }

    console.log("123123 payload : ", payload)
    // return true
    axios.defaults.headers.common['role'] = sessionStorage?.getItem("currentRole");
    await axios.post(`${process.env.REACT_APP_API_DOTNET_URL}/BlanketGG1/bulkUpdateBlanket_gg1`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem(
            "jwt_access_token"
          )}`,
        },
      }
    ).then((response) => {
      console.log("Master timecode", response);
      if (response.data?.success === false) {
        const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
        ShowError(parts.length ? parts.join(' | ') : "Something went wrong. Please try again.");
        return;
      }
      ShowSucess("Records updated sucessfully!")
      setSelectedIds([]);
      setTimeout(() => {
        window.location.reload();
      }, 2000)

    })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      });
  }

  const CheckValue = (temp) => {
    if (temp !== null && temp !== undefined && temp !== "") {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (processStatusChanged) {
      console.log("121212 ::: changed...", processStatusChanged);
      // onSubmit();
      onTransactionChange();
    }
  }, [processStatusChanged]);

  // Update Transaction
  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    setFieldValue,
    validateForm,
  } = useFormik({
    enableReinitialze: true,
    initialValues: initialItem,
    innerRef: formikRef,
    // onSubmit,
    validationSchema: yup.object().shape(schema),
  });
  const { loadingTransaction, loadingEmployee } = useSelector((state) => {
    return state.employeeReducer;
  });

  // console.log(loadingTransaction,loadingEmployee,useSelector((state) => {
  //   return state.employeeReducer;
  // }),'loadingEmployee1221')

  useEffect(() => {
    console.log(
      "121212 ::: ",
      values?.ActionNo,
      values?.natureCode,
      updatedData?.natureOfActionTitle
    );
    if (
      values?.natureCode?.value == "91" ||
      updatedData?.natureOfActionCode == 91
    ) {
      dispatch(fetchGGTrackData(""));
    } else {
      dispatch(fetchGGTrackData(values?.ActionNo));
    }
  }, [values?.ActionNo]);

  // use effect to check wether loggedin user if from skip BBMR Agencies
  useEffect(() => {
    //  console.log("123123 ::: userdata ",userData, values?.FR_Department, autoGeneratedItem)
    if (userData?.profile?.DEPT_CODE && typeof userData?.profile?.DEPT_CODE == "string") {
      if (DeptCodesToSkipBBMR.includes(userData?.profile?.DEPT_CODE)) {
        setBBMRSkipLogin(true);
      }
    }
    else if (userData?.profile?.DEPT_CODE && Array.isArray(userData?.profile?.DEPT_CODE)) {
      if (values?.FR_Department) {
        userData?.profile?.DEPT_CODE?.map((item) => {
          if (DeptCodesToSkipBBMR.includes(item) && (DepartmentsToSkipBBMR.includes(values?.FR_Department?.label) || DepartmentsToSkipBBMR.includes(values?.FR_Department?.label))) {
            setBBMRSkipLogin(true);
            return
          }
        })
      }
    }
  }, [userData?.profile, values?.FR_Department])

  useEffect(() => {
    if (empID && !hrControl) {
      // dispatch(getDataBySSN(empID));
      if (values?.natureCode?.value != "91") {
        let payload = { empId: empID, NOA: noa || values?.natureCode?.value };
        // dispatch(GetAutoPopulate(empID));
        dispatch(GetAutoPopulate(payload));
      }
    }
  }, [empID, values?.natureCode?.value]);

  useEffect(() => {
    setItem(DataBySSN);
    if (DataBySSN && DataBySSN?.length > 0) {
      setIsloading(false);
    }
  }, [DataBySSN, empID]);

  // get BBMR analyst list

  useEffect(() => {
    dispatch(getBBMRAnalyst());
  }, []);

  useEffect(() => {
    if (BBMRAnalyst.length) {
      setBBMRList(
        BBMRAnalyst.map((item) => {
          return {
            label: item.EmployeeName_LFM,
            value: item.EmployeeID,
          };
        })
      );
    }
  }, [BBMRAnalyst]);
  // const setPreviousTransactionData = () => {
  //   // Other

  //   // setFieldValue("RequestID", LatestValue?.RequestId);
  //   // setFieldValue("ActionNo", LatestValue?.ActnNo);
  //   setFieldValue("Budget_Account_Number", LatestValue?.BudgetAcctNo);
  //   setFieldValue("JOB_Order_Number", LatestValue?.JobOrderNumber);
  //   setFieldValue("dp1", LatestValue?.Dp1);
  //   setFieldValue("dp2", LatestValue?.Dp2);
  //   setFieldValue("_empl_days_count", LatestValue?.EmployeeDaysCount);
  //   setFieldValue("EMP_Contract_NO", LatestValue?.EmploymentContractNo);
  //   setFieldValue("Evalution_Type",
  //     { value: LatestValue?.EvalType, label: LatestValue?.EvaluationTypeDescription });
  //   setFieldValue("Final_Post", LatestValue?.FinalPost);
  //   setFieldValue("hrControlNo", LatestValue?.HrControl);

  //   // FROM
  //   setFieldValue("FR_PositionTitle", {
  //     value: CheckValue(LatestValue?.FromPostTitleNo) ? LatestValue?.FromPostTitleNo : "",
  //     label: CheckValue(LatestValue?.FromPositionTitle) ? LatestValue?.FromPositionTitle : "",
  //     titleWithGrade: CheckValue(LatestValue?.FromPositionTitlewithgrade) ? LatestValue?.FromPositionTitlewithgrade : "",
  //     tdp: positionTitleOptions && positionTitleOptions?.length ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade)[0]?.tdp : false,
  //     isLawEnforcementPosition: positionTitleOptions && positionTitleOptions?.length > 0 ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade)[0]?.isLawEnforcementPosition : false,
  //   });
  //   console.log("121212 : FRPos ::: ",values?.FR_PositionTitle,LatestValue?.FromPostTitleNo)
  //   // setFieldValue("FR_Dept_Div_Sec", {
  //   //   value: LatestValue?.FromDepartment
  //   //     ? LatestValue?.FromDepartment.trim()
  //   //     : "",
  //   //   label: LatestValue?.fromDepartmentName
  //   //     ? LatestValue?.fromDepartmentName.trim()
  //   //     : "",
  //   //   division: LatestValue?.FromDivisionKey ? LatestValue?.FromDivisionKey?.trim() : "",
  //   // });
  //   setFieldValue("FR_Department", {
  //     value: LatestValue?.FromDeptKey,
  //     label: LatestValue?.FromDepartment,
  //   });
  //   setFieldValue("FR_Division", {
  //     value: LatestValue?.FromDivisionKey,
  //     label: LatestValue?.FromDivisionName,
  //   });
  //   setFieldValue("FR_Grade", LatestValue?.FromPayGrade);
  //   setFieldValue("FR_Step", LatestValue?.FromStep);
  //   setFieldValue("FR_Rate", LatestValue?.FromRate);
  //   setFieldValue("FR_Salary", LatestValue?.FromSalary);
  //   setFieldValue("FR_FTE_Number", LatestValue?.FromFteNo);

  //   // TO
  //   setFieldValue("TO_PositionTitle", {
  //     value: CheckValue(LatestValue?.ToPostTitleNo) ? LatestValue?.ToPostTitleNo : "",
  //     label: CheckValue(LatestValue?.ToPositionTitle) ? LatestValue?.ToPositionTitle : "",
  //     titleWithGrade: CheckValue(LatestValue?.ToPositionTitlewithgrade) ? LatestValue?.ToPositionTitlewithgrade : "",
  //     tdp: positionTitleOptions && positionTitleOptions?.length ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade)[0]?.tdp : false,
  //     isLawEnforcementPosition: positionTitleOptions && positionTitleOptions?.length > 0 ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade)[0]?.isLawEnforcementPosition : false,
  //   });
  //   setFieldValue("TO_Department", {
  //     value: LatestValue?.ToDeptKey,
  //     label: LatestValue?.ToDepartment,
  //   });
  //   setFieldValue("TO_Division", {
  //     value: LatestValue?.ToDivisionKey,
  //     label: LatestValue?.ToDivisionName,
  //   });
  //   // setFieldValue("TO_Dept_Div_Sec", {
  //   //   value: LatestValue?.ToDepartment,
  //   //   label: LatestValue?.ToDeptDivSec,
  //   //   division: LatestValue?.ToDivisionKey || "",
  //   // });
  //   setFieldValue("TO_Grade", LatestValue?.ToPayGrade?.trim());
  //   setFieldValue("TO_Step", LatestValue?.ToStep && LatestValue?.ToStep != null
  //     ? LatestValue?.ToStep?.toString()?.length < 2 && parseInt(LatestValue?.ToStep?.trim()) < 10
  //       ? `0${LatestValue?.ToStep?.trim()}`
  //       : LatestValue?.ToStep?.trim()
  //     : "");
  //   setFieldValue("TO_Rate", LatestValue?.ToRate);
  //   setFieldValue("TO_Salary", LatestValue?.ToSalary);
  //   setFieldValue("TO_FTE_Number", LatestValue?.ToFteNo);

  //   // Name
  //   setFieldValue("FR_NAME_FIRST", LatestValue?.FromFirstName ? LatestValue?.FromFirstName.trim() : "");
  //   setFieldValue("FR_NAME_MIDDLE", LatestValue?.FromMiddleName ? LatestValue?.FromMiddleName.trim() : "");
  //   setFieldValue("FR_NAME_LAST", LatestValue?.FromLastName ? LatestValue?.FromLastName.trim() : "");
  //   // setFieldValue("fullName", LatestValue?.To_Full_Name ? LatestValue?.To_Full_Name.trim() : "");

  //   setFieldValue("TO_NAME_FIRST", LatestValue?.ToFirstName ? LatestValue?.ToFirstName.trim() : "");
  //   setFieldValue("TO_NAME_MIDDLE", LatestValue?.ToMiddleName ? LatestValue?.ToMiddleName.trim() : "");
  //   setFieldValue("TO_NAME_LAST", LatestValue?.ToLastName ? LatestValue?.ToLastName.trim() : "");

  //   // Contact Detail
  //   setFieldValue("Contact_Department", LatestValue?.ContactDepartment);
  //   setFieldValue("Contact_Email", LatestValue?.ContactEmail);
  //   setFieldValue("Contact_FullName", LatestValue?.ContactFullName);
  //   setFieldValue("Contact_Number", LatestValue?.ContactNumber);
  //   setFieldValue("Contact_Position", LatestValue?.ContactPosition);

  //   // Date
  //   setFieldValue("EmploymentDate", LatestValue?.EmploymentDate);
  //   setFieldValue("ExpirationDate", LatestValue?.ExpirationDate);
  //   setFieldValue("ActionDate", LatestValue?.ActionDate);
  //   setFieldValue("EffDate", LatestValue?.ActionEffectiveDate);
  //   setFieldValue("Next_INCR_date", LatestValue?.NextIncrementDate);
  //   setFieldValue("ndate_increm", LatestValue?.NextIncrementDate);
  //   setFieldValue("date_term", LatestValue?.TermDate);
  //   setFieldValue("Term_Date", LatestValue?.TermDate || LatestValue?.TerminationDate);
  //   setFieldValue("DOB", LatestValue?.DateOfBirth);
  //   setFieldValue("DateOfRequest", LatestValue?.DateOfRequest);
  //   setFieldValue("empl_type", LatestValue?.EmployeeType);
  //   setFieldValue("empl_status", LatestValue?.EmployeeStatus);

  //   setAmendmentPerformed(true);
  //   // setIsloading(false);
  //   setTimeout(() => {
  //     setIsloading(false);
  //   }, 3000);
  // }
  const setPreviousTransactionData = (LatestValue12) => {
    // Other
    console.log("31 called  started +++++++++");
    setAmendmentPerformed(true);
    // let updatedInitialValue = {
    //   RequestID: LatestValue12?.RequestId
    // }
    // setValues((state) => {
    //   return {
    //     ...state,

    //     RequestID: LatestValue12?.RequestId
    //   }
    // })

    // values["RequestID"] = LatestValue12?.RequestId;
    // values["ActionNo"] = LatestValue12?.ActnNo;
    values["Budget_Account_Number"] = LatestValue12?.BudgetAcctNo || "";
    values["JOB_Order_Number"] = LatestValue12?.JobOrderNumber || "";
    // values["dp1"] = LatestValue12?.Dp1;
    // values["dp2"] = LatestValue12?.Dp2;
    // values["_empl_days_count"] = LatestValue12?.EmployeeDaysCount;
    values["EMP_Contract_NO"] = LatestValue12?.EmploymentContractNo;
    // values["Evalution_Type"] =
    //   { value: LatestValue12?.EvalType, label: LatestValue12?.EvaluationTypeDescription };
    // values["Final_Post"] = LatestValue12?.FinalPost;
    // values["hrControlNo"] = LatestValue12?.HrControl;

    // FROM
    values["FR_PositionTitle"] = {
      value: CheckValue(LatestValue12?.FromPostTitleNo)
        ? LatestValue12?.FromPostTitleNo
        : "",
      label: CheckValue(LatestValue12?.FromPositionTitle)
        ? LatestValue12?.FromPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue12?.FromPositionTitlewithgrade)
        ? LatestValue12?.FromPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue12?.FromPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue12?.FromPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    };
    console.log(
      "121212 : FRPos ::: ",
      values?.FR_PositionTitle,
      LatestValue12?.FromPostTitleNo
    );
    // values["FR_Dept_Div_Sec"] = {
    //   value: LatestValue12?.FromDepartment
    //     ? LatestValue12?.FromDepartment.trim()
    //     : "",
    //   label: LatestValue12?.fromDepartmentName
    //     ? LatestValue12?.fromDepartmentName.trim()
    //     : "",
    //   division: LatestValue12?.FromDivisionKey ? LatestValue12?.FromDivisionKey?.trim() : "",
    // };
    values["FR_Department"] = {
      value: LatestValue12?.FromDeptKey || "",
      label: LatestValue12?.FromDepartment || "",
    };
    values["FR_Division"] = {
      value: LatestValue12?.FromDivisionKey || "",
      label: LatestValue12?.FromDivisionName || "",
    };
    values["FR_Grade"] = LatestValue12?.FromPayGrade
      ? LatestValue12?.FromPayGrade?.trim()
      : "";
    values["FR_Step"] =
      LatestValue12?.FromStep && LatestValue12?.FromStep != null
        ? LatestValue12?.FromStep?.toString()?.length < 2 &&
          parseInt(LatestValue12?.FromStep?.trim()) < 10
          ? `0${LatestValue12?.FromStep?.trim()}`
          : LatestValue12?.FromStep?.trim()
        : ""; //LatestValue12?.FromStep;
    values["FR_FTE_Number"] = LatestValue12?.FromFteNo || "";
    values["FR_Rate"] = LatestValue12?.FromRate || "";
    values["FR_Salary"] = LatestValue12?.FromSalary || "";

    // TO
    values["TO_PositionTitle"] = {
      value: CheckValue(LatestValue12?.ToPostTitleNo)
        ? LatestValue12?.ToPostTitleNo
        : "",
      label: CheckValue(LatestValue12?.ToPositionTitle)
        ? LatestValue12?.ToPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue12?.ToPositionTitlewithgrade)
        ? LatestValue12?.ToPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue12?.ToPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue12?.ToPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    };
    values["TO_Department"] = {
      value: LatestValue12?.ToDeptKey || "",
      label: LatestValue12?.ToDepartment || "",
    };
    values["TO_Division"] = {
      value: LatestValue12?.ToDivisionKey || "",
      label: LatestValue12?.ToDivisionName || "",
    };
    // values["TO_Dept_Div_Sec"] = {
    //   value: LatestValue12?.ToDepartment,
    //   label: LatestValue12?.ToDeptDivSec,
    //   division: LatestValue12?.ToDivisionKey || "",
    // };
    values["TO_Grade"] = LatestValue12?.ToPayGrade
      ? LatestValue12?.ToPayGrade?.trim()
      : "";
    values["TO_Step"] =
      LatestValue12?.ToStep && LatestValue12?.ToStep != null
        ? LatestValue12?.ToStep?.toString()?.length < 2 &&
          parseInt(LatestValue12?.ToStep?.trim()) < 10
          ? `0${LatestValue12?.ToStep?.trim()}`
          : LatestValue12?.ToStep?.trim()
        : "";
    values["TO_FTE_Number"] = LatestValue12?.ToFteNo || "";
    values["TO_Rate"] = LatestValue12?.ToRate || "";
    values["TO_Salary"] = LatestValue12?.ToSalary || "";

    // Name
    values["FR_NAME_FIRST"] = LatestValue12?.FromFirstName
      ? LatestValue12?.FromFirstName?.trim()
      : "";
    values["FR_NAME_MIDDLE"] = LatestValue12?.FromMiddleName
      ? LatestValue12?.FromMiddleName?.trim()
      : "";
    values["FR_NAME_LAST"] = LatestValue12?.FromLastName
      ? LatestValue12?.FromLastName?.trim()
      : "";
    // values["fullName"] = LatestValue12?.To_Full_Name ? LatestValue12?.To_Full_Name.trim() : "";

    values["TO_NAME_FIRST"] = LatestValue12?.ToFirstName
      ? LatestValue12?.ToFirstName?.trim()
      : "";
    values["TO_NAME_MIDDLE"] = LatestValue12?.ToMiddleName
      ? LatestValue12?.ToMiddleName?.trim()
      : "";
    values["TO_NAME_LAST"] = LatestValue12?.ToLastName
      ? LatestValue12?.ToLastName?.trim()
      : "";

    // Contact Detail
    values["Contact_Department"] = LatestValue12?.ContactDepartment;
    values["Contact_Email"] = LatestValue12?.ContactEmail;
    values["Contact_FullName"] = LatestValue12?.ContactFullName;
    values["Contact_Number"] = LatestValue12?.ContactNumber;
    values["Contact_Position"] = LatestValue12?.ContactPosition;

    // Date
    values["EmploymentDate"] = LatestValue12?.EmploymentDate;
    values["ExpirationDate"] = LatestValue12?.ExpirationDate;
    values["ActionDate"] = LatestValue12?.ActionDate;
    values["EffDate"] = LatestValue12?.ActionEffectiveDate;
    values["Next_INCR_date"] = LatestValue12?.NextIncrementDate;
    values["ndate_increm"] = LatestValue12?.NextIncrementDate;
    values["date_term"] = LatestValue12?.NextIncrementDate;
    values["Term_Date"] =
      LatestValue12?.TermDate || LatestValue12?.TerminationDate;
    values["DOB"] = LatestValue12?.DateOfBirth;
    // values["DateOfRequest"] = LatestValue12?.DateOfRequest;
    // values["empl_type"] = LatestValue12?.EmployeeType;
    // values["empl_status"] = LatestValue12?.EmployeeStatus;
    setFieldValue(values);
    // console.log("31 called  end +++++++++");

    if (LatestValue12?.HrControl) {
      setRefHRforHistoryData(LatestValue12?.HrControl);
    }

    let stringNOA =
      typeof LatestValue12?.NatureOfActionCode == "number"
        ? JSON.stringify(LatestValue12?.NatureOfActionCode)
        : LatestValue12?.NatureOfActionCode;
    if (AppointmentNOAs?.includes(stringNOA)) {
      setFromFiledsBlank();
      setAmendedNOA(stringNOA);
    } else if (SeparationNOAs?.includes(stringNOA)) {
      setToFiledsBlank();
      setAmendedNOA(stringNOA);
    }
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  };

  const setPreviousTransactionDataForCancellation = () => {
    // Other
    // setFieldValue("RequestID", LatestValue?.RequestId);
    // setFieldValue("ActionNo", LatestValue?.ActnNo);
    setHistoryDataApplied(true);
    setFieldValue("Budget_Account_Number", LatestValue?.BudgetAcctNo || "");
    setFieldValue("JOB_Order_Number", LatestValue?.JobOrderNumber || "");
    // setFieldValue("dp1", LatestValue?.Dp1);
    // setFieldValue("dp2", LatestValue?.Dp2);
    // setFieldValue("_empl_days_count", LatestValue?.EmployeeDaysCount);
    // setFieldValue("EMP_Contract_NO", LatestValue?.EmploymentContractNo);
    // setFieldValue("Evalution_Type",
    //   { value: LatestValue?.EvalType, label: LatestValue?.EvaluationTypeDescription });
    // setFieldValue("Final_Post", LatestValue?.FinalPost);

    // setFieldValue("hrControlNo", LatestValue?.HrControl);

    // FROM
    // setFieldValue("FR_PositionTitle", {
    //   value: CheckValue(LatestValue?.FROM_POST_TITLE_NO) ? LatestValue?.FROM_POST_TITLE_NO : "",
    //   label: CheckValue(LatestValue?.FromPositionTitle) ? LatestValue?.FromPositionTitle : "",
    //   titleWithGrade: CheckValue(LatestValue?.FromPositionTitlewithgrade) ? LatestValue?.FromPositionTitlewithgrade : "",
    //   tdp: positionTitleOptions && positionTitleOptions?.length ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade)[0]?.tdp : false,
    //   isLawEnforcementPosition: positionTitleOptions && positionTitleOptions?.length > 0 ? positionTitleOptions.filter(i => i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade)[0]?.isLawEnforcementPosition : false,
    // });
    // // setFieldValue("FR_Dept_Div_Sec", {
    // //   value: LatestValue?.FromDepartment
    // //     ? LatestValue?.FromDepartment.trim()
    // //     : "",
    // //   label: LatestValue?.fromDepartmentName
    // //     ? LatestValue?.fromDepartmentName.trim()
    // //     : "",
    // //   division: LatestValue?.FromDivisionKey ? LatestValue?.FromDivisionKey?.trim() : "",
    // // });
    // setFieldValue("FR_Department", {
    //   value: LatestValue?.FromDeptKey,
    //   label: LatestValue?.FromDepartment,
    // });
    // setFieldValue("FR_Division", {
    //   value: LatestValue?.FromDivisionKey,
    //   label: LatestValue?.FromDivisionName,
    // });
    // setFieldValue("FR_Grade", LatestValue?.FromPayGrade);
    // setFieldValue("FR_Step", LatestValue?.FromStep);
    // setFieldValue("FR_Rate", LatestValue?.FromRate);
    // setFieldValue("FR_Salary", LatestValue?.FromSalary);
    // setFieldValue("FR_FTE_Number", LatestValue?.FromBudgetNo);

    // TO
    setFieldValue("TO_PositionTitle", {
      value: CheckValue(LatestValue?.FROM_POST_TITLE_NO)
        ? LatestValue?.FROM_POST_TITLE_NO
        : "",
      label: CheckValue(LatestValue?.FromPositionTitle)
        ? LatestValue?.FromPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue?.FromPositionTitlewithgrade)
        ? LatestValue?.FromPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    });
    setFieldValue("TO_Department", {
      value: LatestValue?.FromDeptKey || "",
      label: LatestValue?.FromDepartment || "",
    });
    setFieldValue("TO_Division", {
      value: LatestValue?.FromDivisionKey || "",
      label: LatestValue?.FromDivisionName || "",
    });
    // setFieldValue("TO_Dept_Div_Sec", {
    //   value: LatestValue?.ToDepartment,
    //   label: LatestValue?.ToDeptDivSec,
    //   division: LatestValue?.ToDivisionKey || "",
    // });
    setFieldValue("TO_Grade", LatestValue?.FromPayGrade);
    setFieldValue(
      "TO_Step",
      LatestValue?.FromStep && LatestValue?.FromStep != null
        ? LatestValue?.FromStep?.toString()?.length < 2 &&
          parseInt(LatestValue?.FromStep?.trim()) < 10
          ? `0${LatestValue?.FromStep?.trim()}`
          : LatestValue?.FromStep?.trim()
        : ""
    );
    setFieldValue("TO_Rate", LatestValue?.FromRate || "");
    setFieldValue("TO_Salary", LatestValue?.FromSalary || "");
    setFieldValue("TO_FTE_Number", LatestValue?.FromFteNo || "");

    // Name
    setFieldValue(
      "FR_NAME_FIRST",
      LatestValue?.FromFirstName ? LatestValue?.FromFirstName?.trim() : ""
    );
    setFieldValue(
      "FR_NAME_MIDDLE",
      LatestValue?.FromMiddleName ? LatestValue?.FromMiddleName?.trim() : ""
    );
    setFieldValue(
      "FR_NAME_LAST",
      LatestValue?.FromLastName ? LatestValue?.FromLastName?.trim() : ""
    );
    // setFieldValue("fullName", LatestValue?.To_Full_Name ? LatestValue?.To_Full_Name.trim() : "");

    setFieldValue(
      "TO_NAME_FIRST",
      LatestValue?.FromFirstName ? LatestValue?.FromFirstName?.trim() : ""
    );
    setFieldValue(
      "TO_NAME_MIDDLE",
      LatestValue?.FromMiddleName ? LatestValue?.FromMiddleName?.trim() : ""
    );
    setFieldValue(
      "TO_NAME_LAST",
      LatestValue?.FromLastName ? LatestValue?.FromLastName?.trim() : ""
    );

    // Contact Detail
    setFieldValue("Contact_Department", LatestValue?.ContactDepartment);
    setFieldValue("Contact_Email", LatestValue?.ContactEmail);
    setFieldValue("Contact_FullName", LatestValue?.ContactFullName);
    setFieldValue("Contact_Number", LatestValue?.ContactNumber);
    setFieldValue("Contact_Position", LatestValue?.ContactPosition);

    // Date
    setFieldValue("EmploymentDate", LatestValue?.EmploymentDate);
    setFieldValue("ExpirationDate", LatestValue?.ExpirationDate);
    setFieldValue("ActionDate", LatestValue?.ActionDate);
    setFieldValue("EffDate", LatestValue?.ActionEffectiveDate);
    setFieldValue("Next_INCR_date", LatestValue?.NextIncrementDate);
    setFieldValue("ndate_increm", LatestValue?.NextIncrementDate);
    setFieldValue("date_term", LatestValue?.TermDate);
    setFieldValue(
      "Term_Date",
      LatestValue?.TermDate || LatestValue?.TerminationDate
    );
    setFieldValue("DOB", LatestValue?.DateOfBirth);
    // setFieldValue("DateOfRequest", LatestValue?.DateOfRequest);
    // setFieldValue("empl_type", LatestValue?.EmployeeType);
    // setFieldValue("empl_status", LatestValue?.EmployeeStatus);

    if (LatestValue?.HrControl) {
      setRefHRforHistoryData(LatestValue?.HrControl);
    }
    setFromFiledsBlank();
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  };

  const setPreviousTransactionDataToFrom = () => {
    setHistoryDataApplied(true);
    // FROM
    setFieldValue("FR_FTE_Number", LatestValue?.FromFteNo || "");
    setFieldValue("TO_FTE_Number", LatestValue?.ToFteNo || "");

    setFieldValue("FR_PositionTitle", {
      value: CheckValue(LatestValue?.FromPostTitleNo)
        ? LatestValue?.FromPostTitleNo
        : "",
      label: CheckValue(LatestValue?.FromPositionTitle)
        ? LatestValue?.FromPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue?.FromPositionTitlewithgrade)
        ? LatestValue?.FromPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    });
    console.log(
      "121212 : FRPos ::: ",
      values?.FR_PositionTitle,
      LatestValue?.FromPostTitleNo
    );
    // setFieldValue("FR_Dept_Div_Sec", {
    //   value: LatestValue?.FromDepartment
    //     ? LatestValue?.FromDepartment.trim()
    //     : "",
    //   label: LatestValue?.fromDepartmentName
    //     ? LatestValue?.fromDepartmentName.trim()
    //     : "",
    //   division: LatestValue?.FromDivisionKey ? LatestValue?.FromDivisionKey?.trim() : "",
    // });
    setFieldValue("FR_Department", {
      value: LatestValue?.FromDeptKey || "",
      label: LatestValue?.FromDepartment || "",
    });
    setFieldValue("FR_Division", {
      value: LatestValue?.FromDivisionKey || "",
      label: LatestValue?.FromDivisionName || "",
    });
    setFieldValue(
      "FR_Grade",
      LatestValue?.FromPayGrade ? LatestValue?.FromPayGrade?.trim() : ""
    );
    setFieldValue(
      "FR_Step",
      LatestValue?.FromStep && LatestValue?.FromStep != null
        ? LatestValue?.FromStep?.toString()?.length < 2 &&
          parseInt(LatestValue?.FromStep?.trim()) < 10
          ? `0${LatestValue?.FromStep?.trim()}`
          : LatestValue?.FromStep?.trim()
        : ""
    );
    setFieldValue("FR_Rate", LatestValue?.FromRate || "");
    setFieldValue("FR_Salary", LatestValue?.FromSalary || "");

    // TO
    setFieldValue("TO_PositionTitle", {
      value: CheckValue(LatestValue?.ToPostTitleNo)
        ? LatestValue?.ToPostTitleNo
        : "",
      label: CheckValue(LatestValue?.ToPositionTitle)
        ? LatestValue?.ToPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue?.ToPositionTitlewithgrade)
        ? LatestValue?.ToPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    });
    setFieldValue("TO_Department", {
      value: LatestValue?.ToDeptKey || "",
      label: LatestValue?.ToDepartment || "",
    });
    setFieldValue("TO_Division", {
      value: LatestValue?.ToDivisionKey || "",
      label: LatestValue?.ToDivisionName || "",
    });
    // setFieldValue("TO_Dept_Div_Sec", {
    //   value: LatestValue?.ToDepartment,
    //   label: LatestValue?.ToDeptDivSec,
    //   division: LatestValue?.ToDivisionKey || "",
    // });
    setFieldValue(
      "TO_Grade",
      LatestValue?.ToPayGrade ? LatestValue?.ToPayGrade?.trim() : ""
    );
    setFieldValue(
      "TO_Step",
      LatestValue?.ToStep && LatestValue?.ToStep != null
        ? LatestValue?.ToStep?.toString()?.length < 2 &&
          parseInt(LatestValue?.ToStep?.trim()) < 10
          ? `0${LatestValue?.ToStep?.trim()}`
          : LatestValue?.ToStep?.trim()
        : ""
    );
    setFieldValue("TO_Rate", LatestValue?.ToRate || "");
    setFieldValue("TO_Salary", LatestValue?.ToSalary || "");

    setFieldValue("EffDate", LatestValue?.ActionEffectiveDate);

    if (LatestValue?.HrControl) {
      setRefHRforHistoryData(LatestValue?.HrControl);
    }
    /**** Bonus Calculation */
    if (values?.natureCode?.value == "80") {
      let bonus = (LatestValue?.ToSalary * 0.035)?.toFixed(2);
      // let bonus1 = (<div>EMPLOYEE ENTITLED TO A LUMP SUM BONUS OF $${bonus} WHICH IS EQUIVALENT TO 3.5% OF EMPLOYEE'S BASE SALARY BASED ON A SUPERIOR PERFORMANCE EVAULATION.   THIS MERIT BONUS IS IN ACCORDANCE WITH 4 GCA SUBSECTION 6203 AND IS LIMITED TO THE FISCAL YEAR IN WHICH THE SUPERIOR PERFORMANCE WAS RENDERED.</div>)
      let MeritBonusRemark = `EMPLOYEE ENTITLED TO A LUMP SUM BONUS OF $${bonus} WHICH IS EQUIVALENT TO 3.5% OF EMPLOYEE'S BASE SALARY BASED ON A SUPERIOR PERFORMANCE EVAULATION.   THIS MERIT BONUS IS IN ACCORDANCE WITH 4 GCA SUBSECTION 6203 AND IS LIMITED TO THE FISCAL YEAR IN WHICH THE SUPERIOR PERFORMANCE WAS RENDERED.`;
      setFieldValue("Remarks", MeritBonusRemark);
    }
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  };

  const setPreviousTransactionDataToFromReverse = () => {
    setHistoryDataApplied(true);
    // FROM
    setFieldValue("FR_PositionTitle", {
      value: CheckValue(LatestValue?.ToPostTitleNo)
        ? LatestValue?.ToPostTitleNo
        : "",
      label: CheckValue(LatestValue?.ToPositionTitle)
        ? LatestValue?.ToPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue?.ToPositionTitlewithgrade)
        ? LatestValue?.ToPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) => i?.titleWithGrade == LatestValue?.ToPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    });
    setFieldValue("FR_Department", {
      value: LatestValue?.ToDeptKey || "",
      label: LatestValue?.ToDepartment || "",
    });
    setFieldValue("FR_Division", {
      value: LatestValue?.ToDivisionKey || "",
      label: LatestValue?.ToDivisionName || "",
    });
    // setFieldValue("TO_Dept_Div_Sec", {
    //   value: LatestValue?.ToDepartment,
    //   label: LatestValue?.ToDeptDivSec,
    //   division: LatestValue?.ToDivisionKey || "",
    // });
    setFieldValue(
      "FR_Grade",
      LatestValue?.ToPayGrade ? LatestValue?.ToPayGrade?.trim() : ""
    );
    setFieldValue(
      "FR_Step",
      LatestValue?.ToStep && LatestValue?.ToStep != null
        ? LatestValue?.ToStep?.toString()?.length < 2 &&
          parseInt(LatestValue?.ToStep?.trim()) < 10
          ? `0${LatestValue?.ToStep?.trim()}`
          : LatestValue?.ToStep?.trim()
        : ""
    );
    setFieldValue("FR_Rate", LatestValue?.ToRate || "");
    setFieldValue("FR_Salary", LatestValue?.ToSalary || "");
    setFieldValue("FR_FTE_Number", LatestValue?.ToFteNo || "");

    // TO
    setFieldValue("TO_PositionTitle", {
      value: CheckValue(LatestValue?.FromPostTitleNo)
        ? LatestValue?.FromPostTitleNo
        : "",
      label: CheckValue(LatestValue?.FromPositionTitle)
        ? LatestValue?.FromPositionTitle
        : "",
      titleWithGrade: CheckValue(LatestValue?.FromPositionTitlewithgrade)
        ? LatestValue?.FromPositionTitlewithgrade
        : "",
      tdp:
        positionTitleOptions && positionTitleOptions?.length
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.tdp
          : false,
      isLawEnforcementPosition:
        positionTitleOptions && positionTitleOptions?.length > 0
          ? positionTitleOptions.filter(
            (i) =>
              i?.titleWithGrade == LatestValue?.FromPositionTitlewithgrade
          )[0]?.isLawEnforcementPosition
          : false,
    });
    setFieldValue("TO_Department", {
      value: LatestValue?.FromDeptKey || "",
      label: LatestValue?.FromDepartment || "",
    });
    setFieldValue("TO_Division", {
      value: LatestValue?.FromDivisionKey || "",
      label: LatestValue?.FromDivisionName || "",
    });
    setFieldValue(
      "TO_Grade",
      LatestValue?.FromPayGrade ? LatestValue?.FromPayGrade?.trim() : ""
    );
    setFieldValue(
      "TO_Step",
      LatestValue?.FromStep && LatestValue?.FromStep != null
        ? LatestValue?.FromStep?.toString()?.length < 2 &&
          parseInt(LatestValue?.FromStep?.trim()) < 10
          ? `0${LatestValue?.FromStep?.trim()}`
          : LatestValue?.FromStep?.trim()
        : ""
    );
    setFieldValue("TO_Rate", LatestValue?.FromRate || "");
    setFieldValue("TO_Salary", LatestValue?.FromSalary || "");
    setFieldValue("TO_FTE_Number", LatestValue?.FromFteNo || "");

    setFieldValue("EffDate", LatestValue?.ActionEffectiveDate);

    setFieldValue(
      "Term_Date",
      LatestValue?.TermDate || LatestValue?.TerminationDate
    );

    if (LatestValue?.HrControl) {
      setRefHRforHistoryData(LatestValue?.HrControl);
    }
    setDetailActionSelected(true);
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  };

  const setEditPermissionByRole = (processStatus) => {
    console.log("121212 userData ::: ", userData, role);
    // debugger

    let roleList = [
      "GG1",
      "AGENCY-DIRECTOR",
      "DEPT-ADMIN",
      "CERTIFYING-OFFICER",
      "SUPERVISOR-ADMIN",
      "BBMR-ANALYST",
      "BBMR-ADMIN",
      "BBMR-SUPERVISOR",
      "BBMR-DIRECTOR",
      "DOA-DIRECTOR",
      "SUPERVISOR-NON-ADMIN",
      "SUPER-USER"
    ];
    if (role == "user") {
      if (processStatus != 18 && processStatus != 6) {
        setCurrentStatus(true);
      } else {
        setCurrentStatus(false);
      }
    }
    // else if(role == "GG1" || role == "AGENCY-DIRECTOR" || role == "DEPT-ADMIN" || role == "CERTIFYING-OFFICER"){
    else if (roleList?.includes(role)) {
      let editorRole = userData?.profile?.GG1AccessLevel;
      if (
        editorRole &&
        Array.isArray(editorRole) &&
        editorRole?.find((item) => item == "all-editor")
      ) {
        setCurrentStatus(false);
      } else if (
        editorRole &&
        Array.isArray(editorRole) &&
        editorRole?.find((item) => item == "editor")
      ) {
        let process = userData?.profile?.GG1Process;
        if (process == "All") {
          setCurrentStatus(false);
        } else {
          let isArray = false;
          if (Array.isArray(process)) {
            isArray = true;
          } else {
            isArray = false;
          }
          console.log("123123 Editor...", process);
          if (processStatusList && processStatusList?.length) {
            let processItem;
            if (isArray) {
              processItem = process?.map((item) => {
                return processStatusList?.find(
                  (item1) => item1?.statusName == item
                );
              });
            } else {
              processItem = processStatusList?.find(
                (item) => item?.statusName == process
              );
            }
            console.log("123123 ::: ", processItem);
            if (Array.isArray(processItem)) {
              if (processItem.find((item) => item?.id == processStatus)) {
                setCurrentStatus(false);
              } else {
                setCurrentStatus(true);
              }
            } else {
              if (processItem?.id == processStatus) {
                setCurrentStatus(false);
              } else {
                setCurrentStatus(true);
              }
            }
          }
        }
      } else if (
        editorRole &&
        Array.isArray(editorRole) &&
        editorRole?.find((item) => item == "all-viewer" || item == "viewer")
      ) {
        setCurrentStatus(true);
      } else if (
        editorRole &&
        (editorRole == "all-viewer" || editorRole == "viewer")
      ) {
        setCurrentStatus(true);
      }
      if (role == "DEPT-ADMIN") {
        if ((maxState != 0 && maxState > 4) || (values?.natureCode?.value == "30" || values?.natureCode?.value == "58")) {
          if (
            values?.CurrentProcessStatus?.value == 18 ||
            values?.CurrentProcessStatus?.value == 6
          ) {
            setReviewDisable(false);
          } else {
            setReviewDisable(true);
          }
        } else {
          setReviewDisable(true);
        }
      } else if (role == "AGENCY-DIRECTOR") {
        if (values?.CurrentProcessStatus?.value == 133) {
          setReviewDisable(false);
        } else {
          setReviewDisable(true);
        }
      } else if (role == "CERTIFYING-OFFICER") {
        if (values?.CurrentProcessStatus?.value == 7) {
          setReviewDisable(false);
        } else {
          setReviewDisable(true);
        }
      }
      // else if(role == "SUPERVISOR-ADMIN" || role == "DEPT-ADMIN"){
      //   setReviewDisable(true);
      // }
      else if (role == "SUPERVISOR-ADMIN") {
        setReviewDisable(true);
      } else if (role == "BBMR-ADMIN") {
        // if(values?.CurrentProcessStatus?.value == 272){
        if (
          values?.CurrentProcessStatus?.value == 343 ||
          values?.CurrentProcessStatus?.value == 342 ||
          values?.CurrentProcessStatus?.value == 340
        ) {
          setCurrentStatus(false);
          setReviewDisable(false);
        } else {
          setReviewDisable(true);
          setCurrentStatus(true);
        }
      } else if (role == "BBMR-ANALYST") {
        // console.log("123123 BBMR ANalyst ::: ",values?.bbmrAnalyst,employeeID,empID, userData?.profile?.EmployeeID)
        // if (values?.CurrentProcessStatus?.value == 272) {
        if (values?.CurrentProcessStatus?.value == 272 && values?.bbmrAnalyst == userData?.profile?.EmployeeID) {
          setCurrentStatus(false);
          setReviewDisable(false);
        } else {
          setCurrentStatus(true);
          setReviewDisable(true);
        }
      } else if (role == "BBMR-SUPERVISOR") {
        if (values?.CurrentProcessStatus?.value == 339) {
          setCurrentStatus(false);
          setReviewDisable(false);
        } else {
          setCurrentStatus(true);
          setReviewDisable(true);
        }
      } else if (role == "BBMR-DIRECTOR") {
        if (
          values?.CurrentProcessStatus?.value == 8
          // values?.CurrentProcessStatus?.value == 272 ||
          // values?.CurrentProcessStatus?.value == 338 ||
          // values?.CurrentProcessStatus?.value == 339 ||
          // values?.CurrentProcessStatus?.value == 340 ||
          // values?.CurrentProcessStatus?.value == 342 
        ) {
          setCurrentStatus(false);
          setReviewDisable(false);
        } else {
          setCurrentStatus(true);
          setReviewDisable(true);
        }
      } else if (role == "DOA-DIRECTOR") {
        if (
          values?.CurrentProcessStatus?.value == 7 ||
          values?.CurrentProcessStatus?.value == 133 ||
          values?.CurrentProcessStatus?.value == 8 ||
          values?.CurrentProcessStatus?.value == 272
        ) {
          setReviewDisable(false);
        } else {
          setReviewDisable(true);
        }
      } else if (role == "SUPER-USER") {
        setCurrentStatus(false);
        setReviewDisable(false);
      }
    } else {
      setCurrentStatus(false);
    }
  };

  /****Get Batch data & set */
  const [batchData, setBatchData] = useState();
  const showSubWorkflow = true;

  const [auditTrailData, setAuditTrailData] = useState([]);
  const [auditTrailHistory, setAuditTrailHistory] = useState([]);


  const getAuditTrailData = (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    axios.get(`${newBaseURL}/BlanketGG1/${Id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
        Role: getUserRole(userData),
      },
    })
      .then((response) => {
        if (response.data?.success === false) {
          const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
          ShowError(parts.length ? parts.join(' | ') : "Failed to load audit trail data.");
          return;
        }
        // retrievedData = response.data.results;
        // setBatchData(retrievedData[0]);
        console.log("123123 audit response", response.data.processLogs)
        if (response.data.processLogs && response.data.processLogs.length > 0) {
          setAuditTrailData(response.data.processLogs);
        }

      })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      });
  }

  const getBatchInfo = (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      // tableName: "Blanket_gg1_parent",
      tableName: "vw_Blanket_gg1_parent",
      SearchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "Id ASC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `Id=${Id}`

    };
    let retrievedData = [];
    setBatchInfoLoader(true)
    axios
      .post(`${newBaseURL}/AdvanceSearch/global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        if (response.data?.success === false) {
          const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
          ShowError(parts.length ? parts.join(' | ') : "Failed to load batch info.");
          return;
        }
        retrievedData = response.data.results;
        setBatchData(retrievedData[0]);
        console.log("finalResponsexxx", retrievedData)

      })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      }).finally(() => {
        setBatchInfoLoader(false)
      })
  };
  useEffect(() => {
    if (batchId) {
      getBatchInfo(batchId)
      getAuditTrailData(batchId)
    }
  }, [batchId])

  const getAuditTrailHistoryData = (Id) => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      // tableName: "Blanket_gg1_parent",
      tableName: "vw_Blanket_gg1_parent_Auditlog",
      SearchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "logid desc",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `Id=${Id}`,
    };
    let retrievedData = [];
    axios
      .post(`${newBaseURL}/AdvanceSearch/global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        if (response.data?.success === false) {
          const parts = [response.data?.title, response.data?.message, response.data?.detail, response.data?.error, response.data?.description].filter(Boolean);
          ShowError(parts.length ? parts.join(' | ') : "Failed to load audit trail history.");
          return;
        }
        retrievedData = response.data.results;
        // setBatchData(retrievedData[0]);
        setAuditTrailHistory(response?.data?.results);
        console.log("123123 finalResponsexxx", retrievedData)

      })
      .catch((error) => {
        const msg = extractApiError(error);
        if (msg) ShowError(msg);
        console.warn("Cannot retrieve user data", error);
      });
  };

  useEffect(() => {
    if (batchId) {
      getAuditTrailHistoryData(batchId)
    }
  }, [batchId])



  useEffect(() => {
    if (batchData && Object.keys(batchData)?.length > 0) {
      let newBatchData = { ...batchData, Remarks: batchData?.Remarks ? batchData?.Remarks : initialValues?.Remarks };
      console.log("123123 ::: batchData new", batchData?.Remarks, initialValues?.Remarks, newBatchData)
      setUpdatedData(newBatchData);
      setRenderProcessFlow(true);
      // console.log("123123 ::: batchData", batchData, values?.TO_Rate, values?.TO_Salary)

      values.maxHours = batchData?.NoOfHours ? batchData?.NoOfHours
        : batchData?.Pay_Grade == "SDYA" ? 180
          : batchData?.Pay_Grade == "SDOL" ? 150
            : 180

      values.EffDate = batchData?.Effective_Date
      values.hrControlNo = batchData?.HRControlNo
      values.TO_Grade = batchData?.Pay_Grade ? batchData?.Pay_Grade : values?.TO_Grade;
      values.TO_PositionTitle = { value: batchData?.Position_No ? batchData?.Position_No : values?.TO_PositionTitle?.value, label: batchData?.Position_title ? batchData?.Position_title : values?.TO_PositionTitle?.label }
      values.Remarks = batchData?.Remarks || initialValues?.Remarks
      values.TO_Rate = batchData?.Rate ? batchData?.Rate : values?.TO_Rate
      values.TO_Step = batchData?.Step ? batchData?.Step : values?.TO_Step
      values.TO_Salary = batchData?.Salary ? batchData?.Salary : values?.TO_Salary

      values.worK_SCH = CheckValue(batchData?.WorkSchedule)
        ? workStatusOptions?.find((i) => i?.value == batchData?.WorkSchedule?.trim())
        : { value: "FULL-TIME", label: "Full-Time" }
      // : { value: "", label: "" }

      // values.CurrentProcessStatus = batchData?.CurrentProcessStatus
      //   ? batchData?.CurrentProcessStatus == 6
      //     ? 
      //       processStatusList &&
      //       processStatusList.find((item) => {
      //           return item.id == 7;
      //       })
      //     : processStatusList &&
      //       processStatusList.find((item) => {
      //         return item.id == batchData?.CurrentProcessStatus;
      //       })
      //   : { value: 0, label: "" };


      // console.log("123123 nature ::: ",natureOfOptions, departmentOptions, divisionOptions)
      // values.natureCode = {value: batchData?.Nature_of_Action_Code, label: natureOfOptions && natureOfOptions?.length ? natureOfOptions.find(item => 
      //   item.value == batchData?.Nature_of_Action_Code)?.label : "" }
      values.natureCode = { value: batchData?.Nature_of_Action_Code, label: batchData?.NATURE_TITLE?.trim() }

      values.RequestID = batchData?.RequestID || "";
      values.Term_Date = batchData?.TerminationDate || null;
      // values.legalAuthority = batchData?.LegalAuthority || "";
      values.bbmrAnalyst = batchData?.BBMR_Analyst || null;

      // values.TO_Department = {
      //   value: batchData?.Dept,
      //   label: departmentOptions.find(item => item?.value == batchData?.Dept)?.label,
      // };
      // console.log("123123 divisionOptions ::: ",divisionOptions.find(iem=>iem.value == batchData?.Division))
      // values.TO_Division = {
      //   value: batchData?.Division,
      //   label: divisionOptions.find(item => item?.value == batchData?.Division)?.label,
      // };

      values.TO_Department = {
        value: batchData?.Dept ? batchData?.Dept : values?.TO_Department?.value,
        label: batchData?.deptname ? batchData?.deptname : values?.TO_Department?.label,
      };

      values.TO_Division = {
        value: batchData?.Divison ? batchData?.Divison : values?.TO_Division?.value,
        label: batchData?.divname ? batchData?.divname : values?.TO_Division?.label,
      };
      values.TO_FTE_Number = batchData?.FTENO

      /******From values */
      values.FR_Grade = batchData?.From_Pay_Grade
      values.FR_PositionTitle = { value: batchData?.From_Position_No, label: batchData?.From_Position_title }
      values.FR_Rate = batchData?.From_Rate
      values.FR_Step = batchData?.From_Step
      values.FR_Salary = batchData?.From_Salary

      values.FR_Department = {
        value: batchData?.From_Dept,
        label: batchData?.frdeptname,
      };
      values.FR_Division = {
        value: batchData?.From_Divison,
        label: batchData?.frdivname
      };
      values.FR_FTE_Number = batchData?.From_FTENO
      /******* */

      values.CurrentProcessStatus = batchData?.CurrentProcessStatus ? batchData?.CurrentProcessStatus == 6
        ? { value: 7, label: "Cert Officer" }
        : values?.CurrentProcessStatus?.value == 338
          ? { value: 342, label: "Assign Analyst" }
          : { value: batchData?.CurrentProcessStatus, label: batchData?.CurrentProcessStatusName } : { value: 18, label: "Dept Admin" };

      if (batchData?.CurrentProcessStatus == 135) {
        setNpaStarted(true);
      } else {
        setNpaStarted(false);
      }

      if (
        batchData?.CurrentProcessStatus == 18 ||
        batchData?.CurrentProcessStatus == 6 ||
        batchData?.CurrentProcessStatus == 7 ||
        batchData?.CurrentProcessStatus == 133 ||
        batchData?.CurrentProcessStatus == 338 ||
        batchData?.CurrentProcessStatus == 342 ||
        batchData?.CurrentProcessStatus == 272 ||
        batchData?.CurrentProcessStatus == 339 ||
        batchData?.CurrentProcessStatus == 340 ||
        batchData?.CurrentProcessStatus == 8 ||
        batchData?.CurrentProcessStatus == 343 ||
        batchData?.CurrentProcessStatus == 9 ||
        batchData?.CurrentProcessStatus == 118 ||
        batchData?.CurrentProcessStatus == 10 ||
        batchData?.CurrentProcessStatus == 11 ||
        batchData?.CurrentProcessStatus == 19 ||
        props?.currentStatus?.value == 356 ||
        props?.currentStatus?.value == 134 ||
        props?.currentStatus?.value == 135
      ) {
        // setCurrentStatus(false);
        console.log("demo 122111222", role, userData);
        setEditPermissionByRole(batchData?.CurrentProcessStatus);
      } else {
        setCurrentStatus(true);
        if (!batchData?.CurrentProcessStatus) {
          setCurrentStatus(false);
        }
      }
      // console.log("123123 userData in edit ::: ", userData?.profile, role);
      if (npaStarted) {
        setCurrentStatus(true);
      }
      // if (batchData?.processseq != null) {
      //   setMaxState(batchData?.processseq);
      // }


      setFieldValue(values);

    }
  }, [batchData])

  useEffect(() => {
    if (!natureOfOptions?.length) {
      return false;
    }
    if (natureOfOptions && natureOfOptions?.length && batchData?.Nature_of_Action_Code) {
      let data = natureOfOptions.find((item) => {
        return item.value == batchData?.Nature_of_Action_Code;
      });
      console.log("123123 data ::: ", data)
      setNatureCode({ value: batchData?.Nature_of_Action_Code, label: data?.label });
      setFieldValue("natureCode", {
        value: batchData?.Nature_of_Action_Code,
        label: data?.label,
      });
      setFieldValue("NatureOf", {
        value: batchData?.Nature_of_Action_Code,
        label: data?.label,
      });
      setFieldValue("LegalAuthority", data?.authority);
      setOptionalMsgShown(false);
      // let newNOAs = natureOfOptions.filter((item)=>item.value != "30")
      // setNatureOptionsExceptSI(newNOAs);
    }
  }, [natureOfOptions, batchData])

  /********** */

  // useEffect(() => {
  //   let items = TransactionsBySSNAndAction && TransactionsBySSNAndAction;
  //   // console.log("121212 items ::: ", items);
  //   if (TransactionsBySSNAndAction && TransactionsBySSNAndAction?.length > 0) {
  //     setIsloading(false);
  //   }
  //   if (
  //     items?.natureOfActionCode == "80" ||
  //     items?.natureOfActionCode == "4" ||
  //     items?.natureOfActionCode == "73" ||
  //     items?.natureOfActionCode == "51"
  //   ) {
  //     setHistoryDataApplied(true);
  //   } else {
  //     setHistoryDataApplied(false);
  //   }
  //   if (items?.natureOfActionCode == "31") {
  //     setAmendmentPerformed(true);
  //   } else {
  //     setAmendmentPerformed(false);
  //   }

  //   if (items?.refAmendment) {
  //     setRefHRforHistoryData(items?.refAmendment);
  //   }
  //   // values from new api GG1 common
  //   // if (actionNo && items) {
  //   // if (items?.term_Date) {
  //   //   console.log("121212 items ifff :::: ", items);
  //   // }
  //   // console.log("121212 items:::: ", items);
  //   if (hrControl && items) {
  //     setUpdatedData(items);
  //     values.employeeID = empID == "recruitment" ? "" : empID;
  //     values.ActionNo = items?.actnNo; //actionNo;
  //     values.DP1 = items?.dp1;
  //     values.life = items?.lifePlan;

  //     values.Remarks = items?.remarks;
  //     values.Health = items?.healthPlan;
  //     values.Term_Date = items?.termDate || null;
  //     values.LegalAuthority = items?.legalAuthority || values?.LegalAuthority;
  //     values.RequestID = items?.requestId ? items?.requestId?.trim() : "";
  //     values.EffDate = items?.actionEffectiveDate;
  //     values.Next_INCR_date = items?.nextIncrementDate;
  //     values.EMP_Contract_NO = items?.employmentContractNo
  //       ? items?.employmentContractNo?.trim()
  //       : ""; //items?.empl_contract_no;
  //     values._empl_days_count = items?.employeeDaysCount;
  //     values.TO_Step =
  //       items?.toStep && items?.toStep != null
  //         ? items?.toStep?.toString()?.length < 2 &&
  //           parseInt(items?.toStep) < 10
  //           ? `0${items?.toStep}`
  //           : items?.toStep
  //         : "";
  //     values.TO_Rate = items?.toRate;
  //     values.TO_Salary = items?.toSalary;
  //     values.TO_Grade = items?.toPayGrade;
  //     values.TO_NAME_LAST = items?.toLastName;
  //     values.TO_NAME_FIRST = items?.toFirstName;
  //     values.TO_NAME_MIDDLE = items?.toMiddleName;
  //     values.TO_Dept_Div_Sec = {
  //       value: items?.toDeptKey,
  //       label: items?.toDepartment,
  //       division: items?.toDeptDivSec,
  //     };
  //     values.TO_Department = {
  //       value: items?.toDeptKey,
  //       label: items?.toDepartment,
  //     };
  //     values.TO_Division = {
  //       value: items?.toDivisionKey,
  //       label: items?.toDivisionName,
  //     };
  //     values.TO_PositionTitle = {
  //       value: items?.toPostTitleNo, //items?.to_Post_Title_No,
  //       label: items?.toPositionTitle,
  //       titleWithGrade: items?.toPositionTitlewithgrade
  //         ? items?.toPositionTitlewithgrade
  //         : items?.toPositionTitle,
  //       tdp:
  //         positionTitleOptions && positionTitleOptions?.length > 0
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == items?.toPositionTitlewithgrade
  //           )[0]?.tdp
  //           : false,
  //       isLawEnforcementPosition:
  //         positionTitleOptions && positionTitleOptions?.length > 0
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == items?.toPositionTitlewithgrade
  //           )[0]?.isLawEnforcementPosition
  //           : false,
  //     };
  //     // values.TO_ClassCode = items?.position_to_nposition_no;
  //     values.FR_Rate = items?.fromRate;
  //     values.FR_Step =
  //       items?.fromStep && items?.fromStep != null
  //         ? items?.fromStep?.toString()?.length < 2 &&
  //           parseInt(items?.fromStep) < 10
  //           ? `0${items?.fromStep}`
  //           : items?.fromStep
  //         : "";
  //     values.FR_Salary = items?.fromSalary;
  //     values.FR_Grade = items?.fromPayGrade;
  //     values.FR_NAME_LAST = items?.fromLastName;
  //     values.FR_NAME_FIRST = items?.fromFirstName;
  //     values.FR_NAME_MIDDLE = items?.fromMiddleName;
  //     values.fullName = items?.fullName ? items?.fullName?.trim() : "";
  //     //items?.name2 ? items?.name2?.trim() : "";
  //     values.FR_PositionTitle = {
  //       value: items?.fromPostTitleNo, //from_Post_Title_No,
  //       label: items?.fromPositionTitle,
  //       titleWithGrade: items?.fromPositionTitlewithgrade
  //         ? items?.fromPositionTitlewithgrade
  //         : items?.fromPositionTitle,
  //       tdp:
  //         positionTitleOptions && positionTitleOptions?.length
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == items?.toPositionTitlewithgrade
  //           )[0]?.tdp
  //           : false,
  //       isLawEnforcementPosition:
  //         positionTitleOptions && positionTitleOptions?.length > 0
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == items?.toPositionTitlewithgrade
  //           )[0]?.isLawEnforcementPosition
  //           : false,
  //     };
  //     values.FR_Dept_Div_Sec = {
  //       value: items?.fromDeptKey,
  //       label: items?.fromDepartment,
  //       division: items?.fromDeptDivSec,
  //     };
  //     values.FR_Department = {
  //       value: items?.fromDeptKey,
  //       label: items?.fromDepartment,
  //     };
  //     values.FR_Division = {
  //       value: items?.fromDivisionKey,
  //       label: items?.fromDivisionName,
  //     };

  //     // values.empl_type = items?.empl_type;
  //     // values.budge_pos_no = items?.budge_pos_no;
  //     values.dp1 = items?.dp1;
  //     values.ndate_increm = items?.ndate_increm || "";

  //     values.FR_FTE_Number = items?.fromFteNo;
  //     values.TO_FTE_Number = items?.toFteNo;
  //     // values._empl_days_count = items?.empl_days_count;
  //     values.hrControlNo = items?.hrControl;
  //     values.Probation_Date = items?.probationDate;
  //     values.JOB_Order_Number = items?.jobOrderNumber?.trim();
  //     if(items?.jobOrderNumber?.trim()){
  //       dispatch(getBBMRJobOrder(items?.jobOrderNumber?.trim()))
  //     }
  //     // CheckValue(items?.jobOrderNumber)
  //     //   ? {key: 0,value:items?.jobOrderNumber?.trim()} //items?.jobOrderNumber?.trim()
  //     //   : {key:0, value:""}; //"";
  //     values.Budget_Account_Number = items?.budgetAcctNo
  //       ? items?.budgetAcctNo?.trim()
  //       : "";
  //     values.Social_Security_Number = items?.socialSecurityNumber
  //       ? items?.socialSecurityNumber
  //       : empID;
  //     values.Retirement_Coverage = items?.retirementCoverage || ""; //retire_ss_code_master; //retire_ss_code; //items?.retirement_Amount;
  //     values.RetireSsCode = items?.retireSsCode || ""; //" 7",
  //     values.RetSsDesc = items?.retSsDesc || "";
  //     values.Payroll_Date = items?.payrollDate;
  //     values.Final_Post = items?.finalPost;
  //     values.Posting_Date = items?.postingDate;
  //     values.Posting_Flag = items?.postingFlag;

  //     values.Evalution_Type = {
  //       value: items?.evalType,
  //       label: items?.evaluationDescription,
  //     };
  //     values.ActionDate = items?.actionDate;
  //     values.EmploymentDate = items?.employmentDate
  //       ? items?.employmentDate
  //       : "";
  //     values.ExpirationDate = items?.expirationDate
  //       ? items?.expirationDate
  //       : "";
  //     values.Remarks = items?.remarks ? items?.remarks : "";
  //     values.NatureOfActionTitle = items?.natureOfActionTitle
  //       ? items?.natureOfActionTitle
  //       : "";
  //     values.Contact_Number = items?.contactNumber ? items?.contactNumber : "";
  //     values.Contact_Email = items?.contactEmail ? items?.contactEmail : "";
  //     values.Contact_Department = items?.contactDepartment
  //       ? {
  //         value: items?.contactDepartment, //DpDvOptions.find((i) => i.value == items?.contactDepartment)?.key,
  //         label: items?.contactDepartment,
  //       }
  //       : {
  //         value: "",
  //         label: "",
  //       };
  //     values.Contact_Position = items?.contactPosition
  //       ? {
  //         value: items?.contactPosition,
  //         label: items?.contactPosition,
  //       }
  //       : {
  //         value: "",
  //         label: "",
  //       };
  //     values.Contact_FullName = items?.contactFullName
  //       ? items?.contactFullName
  //       : "";
  //     values.RequestedBy_FullName = items?.requestedByName
  //       ? items?.requestedByName
  //       : "";
  //     values.RequestedBy_Position = items?.requestedByPosition
  //       ? {
  //         value: items?.requestedByPosition,
  //         label: items?.requestedByPosition,
  //       }
  //       : {
  //         value: "",
  //         label: "",
  //       };
  //     values.DOB = items?.dateOfBirth ? items?.dateOfBirth : "";
  //     values.DOR = items?.dateOfRequest ? items?.dateOfRequest : "";
  //     values.Employment_Duration = items?.employmentDuration
  //       ? items?.employmentDuration
  //       : 0;
  //     values.Employment_Duration_Type = items?.employmentDurationType
  //       ? durationList?.find((i) => i?.label == items?.employmentDurationType)
  //       : { value: 1, label: "Days" };

  //     values.worK_SCH = CheckValue(items?.worK_SCH)
  //       ? workStatusOptions?.find((i) => i?.value == items?.worK_SCH?.trim())
  //       : { value: "", label: "" };

  //     values.UserName = `${CheckValue(items?.enterByLastName) ? items?.enterByLastName : ""
  //       }, ${CheckValue(items?.enterByFirstName) ? items?.enterByFirstName : ""
  //       } ${CheckValue(items?.enterByMiddleName) ? items?.enterByMiddleName : ""
  //       }`;
  //     values.UserContactNo = CheckValue(items?.enterByCellPhone)
  //       ? items?.enterByCellPhone
  //       : "";
  //     values.recruitmentType = CheckValue(items?.typeOfRecruitment)
  //       ? recruitApptList.find(
  //         (item) => item?.label == items?.typeOfRecruitment
  //       )
  //       : { value: 0, label: "" };
  //     values.considerationArea = CheckValue(items?.areaOfConsidration)
  //       ? considerationList.find(
  //         (item) => item?.label == items?.areaOfConsidration
  //       )
  //       : { value: 0, label: "" };
  //     values.bbmrAnalyst = items?.bbmrAnalyst || null;

  //     // values.recruitmentType = CheckValue(AreaOfConsidration)
  //     // values.CurrentProcessStatus = items?.currentProcessStatus
  //     //   ? items?.currentProcessStatus == 6
  //     //     ? processStatusItems &&
  //     //       processStatusItems.find((item) => {
  //     //         return item.value == 7;
  //     //       })
  //     //     : processStatusItems &&
  //     //       processStatusItems.find((item) => {
  //     //         return item.value === items?.currentProcessStatus;
  //     //       })
  //     //   : { value: 0, label: "" };

  //     // if(items?.currentProcessStatus == 6){
  //     //   if(processStatusItems && processStatusItems?.length){
  //     //       let statusData = processStatusItems.find((item) => {
  //     //         return item.value == 7;
  //     //       })
  //     //       values?.CurrentProcessStatus = statusData || {value:0,label:""};
  //     //   }else{
  //     //     values.CurrentProcessStatus = items?.currentProcessStatus && processStatusItems ?
  //     //     processStatusItems.find((item) => {
  //     //       return item.value == items?.currentProcessStatus;
  //     //     })
  //     // : { value: 0, label: "" };
  //     //   }
  //     // }
  //   }
  //   if (
  //     items?.currentProcessStatus == 18 ||
  //     items?.currentProcessStatus == 6 ||
  //     items?.currentProcessStatus == 7 ||
  //     items?.currentProcessStatus == 133 ||
  //     items?.currentProcessStatus == 338 ||
  //     items?.currentProcessStatus == 342 ||
  //     items?.currentProcessStatus == 272 ||
  //     items?.currentProcessStatus == 339 ||
  //     items?.currentProcessStatus == 340 ||
  //     items?.currentProcessStatus == 8 ||
  //     items?.currentProcessStatus == 343 ||
  //     items?.currentProcessStatus == 9 ||
  //     items?.currentProcessStatus == 118 ||
  //     items?.currentProcessStatus == 10 ||
  //     items?.currentProcessStatus == 11 ||
  //     items?.currentProcessStatus == 19
  //   ) {
  //     // setCurrentStatus(false);
  //     console.log("demo 122111222", role, userData);
  //     setEditPermissionByRole(items?.currentProcessStatus);
  //   } else {
  //     setCurrentStatus(true);
  //     if (!items?.currentProcessStatus) {
  //       setCurrentStatus(false);
  //     }
  //   }
  //   // console.log("123123 userData in edit ::: ", userData?.profile, role);
  //   if (npaStarted) {
  //     setCurrentStatus(true);
  //   }
  //   if (items?.processseq != null) {
  //     setMaxState(items?.processseq);
  //   }
  //   // else{
  //   //   let maxSeq = getMaxStatusSeq();
  //   //   setMaxState(maxSeq)
  //   // }
  // }, [TransactionsBySSNAndAction, values?.natureCode?.value, npaStarted]);
  useEffect(() => {
    if (!natureOfOptions?.length) {
      return false;
    }
    let items = TransactionsBySSNAndAction
      ? TransactionsBySSNAndAction?.natureOfActionCode //natureAction //nature_actn
      : DataBySSN?.nature_code;

    let data = natureOfOptions.find((item) => {
      return item.value == items;
    });
    if (natureOfOptions && items && hrControl) {
      setNatureCode({ value: items, label: data?.label });
      setFieldValue("natureCode", {
        value: items,
        label: data?.label,
      });
      setFieldValue("NatureOf", {
        value: items,
        label: data?.label,
      });
    }
    // let newNOAs = natureOfOptions.filter((item)=>item.value != "30")
    // setNatureOptionsExceptSI(newNOAs);
  }, [natureOfOptions, TransactionsBySSNAndAction, DataBySSN]);

  // useEffect for processStatusList
  useEffect(() => {
    // dispatch(getProcessesStatusList(1));
    dispatch(
      getProcessesStatusListByNOA({ id: 1, noa: values?.natureCode?.value })
    );
    setOptionalMsgShown(false);
  }, [noa, values?.natureCode?.value, renderProcessFlow]);

  useEffect(() => {
    if (DpDvOptions?.length && TransactionsBySSNAndAction) {
      setIsloading(false);
    }
  }, [DpDvOptions, TransactionsBySSNAndAction]);

  useEffect(() => {
    // console.log("121212 nature outside::: ", showField);
    setShowField(showFieldInitialValues);
    setSysGenHighlight([]);
    setHighlight([]);
    setErrorHighLight([]);
    setErrorMessage([]);
    setOptionalMessages([]);

    // checkHideFields();
  }, [values?.natureCode?.value]);

  // useEffect(() => {
  //   setFieldValue("CurrentProcessStatus", { value: 0, label: "" });
  //   clearToValues();
  // }, []);

  useEffect(() => {
    if (hrControl) {
      if (empID == "recruitment" || empID == "null") {
        dispatch(getDataBySSNAndAction({ action: hrControl }))
          .then(() => {
            setIsloading(false);
          })
          .catch(() => {
            setIsloading(false);
          });
      } else {
        dispatch(
          getDataBySSNAndAction({ employeeID: empID, action: hrControl })
        )
          .then(() => {
            setIsloading(false);
          })
          .catch(() => {
            setIsloading(false);
          });
      }
    }
  }, [hrControl]);

  // useEffect(() => {
  //   let data;
  //   if (updatedData) {
  //     setRenderProcessFlow(true);
  //     let tempData = updatedData?.currentProcessStatus;
  //     if (updatedData?.currentProcessStatus == 6) {
  //       tempData = 7;
  //     }
  //     let recordsSeq = processStatusList
  //       ? processStatusList.find((item) => item?.id == 19)?.seq
  //       : 12;
  //     // data = processStatusItems.find((item) => {
  //     data = processStatusList.find((item) => {
  //       // return item.value === tempData;
  //       return item.id === tempData;
  //     });
  //     // console.log("121212 Dataaaaa ::: ", data);
  //     // if (data?.seq > 11) {
  //     if (data?.seq > recordsSeq) {
  //       setNpaStarted(true);
  //     } else {
  //       setNpaStarted(false);
  //     }
  //     // evlData = evalTypeItems.find((item) => {
  //     //   return item.value === TransactionsBySSNAndAction?.eval_type;
  //     // });
  //     // values.CurrentProcessStatus = data;
  //     // console.log("123123 CurrentProcessStatus ::: ", tempProcessStatus, data);

  //     if (tempProcessStatus?.value != 0) {
  //         setFieldValue("CurrentProcessStatus", tempProcessStatus);
  //     } else {
  //       // console.log(
  //       //   "123123 CurrentProcessStatus elseee ::: ",
  //       //   tempProcessStatus,
  //       //   data
  //       // );
  //       if (data) {
  //         setFieldValue("CurrentProcessStatus", {
  //           value: data?.id,
  //           label: data?.statusName,
  //         });
  //       }
  //     }
  //     // values.Evalution_Type = evlData;
  //   }
  //   // }, [processStatusItems, TransactionsBySSNAndAction, processStatusList]);
  // }, [updatedData, processStatusList]);

  // useEffect(() => {
  //   let data;
  //   if (pageStatus == "create") {
  //     if (!hrControl && processStatusItems) {
  //       data = processStatusItems.find((item) => {
  //         return item?.value == 18;
  //       });
  //       // values.CurrentProcessStatus = data;
  //       setFieldValue(
  //         "CurrentProcessStatus",
  //         data || { value: 18, label: "Dept Admin" }
  //       );
  //     } else {
  //       setFieldValue(
  //         "CurrentProcessStatus",
  //         initialValues?.CurrentProcessStatus
  //       );
  //     }
  //   }
  // }, [processStatusItems, pageStatus]);

  // useEffect(() => {
  //   if (TransactionsBySSNAndAction && TransactionsBySSNAndAction?.actnNo) {
  //     dispatch(
  //       getAuditHistoryData({
  //         employeeId: TransactionsBySSNAndAction?.employeeId,
  //         actionNo: TransactionsBySSNAndAction?.actnNo?.trim(),
  //       })
  //     );
  //   }
  // }, [TransactionsBySSNAndAction]);

  // Auto genrate  Feild values
  // useEffect(() => {
  //   setOpenAlert(false);
  //   let item = DataByAutoPopulate?.autoPopulate;
  //   // Create Time value
  //   if (item) {
  //     values.employeeID = empID == "recruitment" ? "" : empID;
  //     values.RequestID = item?.request_Id
  //       ? item?.request_Id?.trim()
  //       : item?.request_Id || ""; //item?.request_id;
  //     // values.LegalAuthority = item?.legal_Authority; //item?.LEGAL;
  //     values.ActionDate = item?.action_Date || null; //ACTN_DATE;
  //     values.FR_NAME_FIRST = item?.from_First_Name || "";
  //     values.FR_NAME_MIDDLE = item?.from_Middle_Name || "";
  //     values.FR_NAME_LAST = item?.from_Last_Name || "";
  //     values.FR_Salary = item?.from_Salary || "";
  //     values.FR_Grade = item?.from_Pay_Grade || "";
  //     values.FR_Step =
  //       item?.from_Step && item?.from_Step != null
  //         ? item?.from_Step?.toString()?.length < 2 &&
  //           parseInt(item?.from_Step?.trim()) < 10
  //           ? `0${parseInt(item?.from_Step)}`
  //           : item?.from_Step?.trim()
  //         : "";
  //     values.FR_Rate = item?.from_Rate || "";
  //     values.FR_PositionTitle = {
  //       value: CheckValue(item?.from_position_id) ? item?.from_position_id : "",
  //       label: CheckValue(item?.from_Position_Title)
  //         ? item?.from_Position_Title
  //         : "",
  //       titleWithGrade: CheckValue(item?.positionTitleWithGrade)
  //         ? item?.positionTitleWithGrade
  //         : "",
  //       tdp:
  //         positionTitleOptions && positionTitleOptions?.length
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == item?.positionTitleWithGrade
  //           )[0]?.tdp
  //           : false,
  //       isLawEnforcementPosition:
  //         positionTitleOptions && positionTitleOptions?.length > 0
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == item?.toPositionTitlewithgrade
  //           )[0]?.isLawEnforcementPosition
  //           : false,
  //     };
  //     values.FR_FTE_Number = item?.from_FTE_No ? item?.from_FTE_No : "";
  //     // values.FR_ClassCode = item?.nposition_no;
  //     // values.FR_Salary = item?.annual_salary;
  //     values.TO_Step =
  //       item?.to_Step && item?.to_Step != null
  //         ? item?.to_Step?.toString()?.length < 2 &&
  //           parseInt(item?.to_Step?.trim()) < 10
  //           ? `0${item?.to_Step?.trim()}`
  //           : item?.to_Step?.trim()
  //         : "";
  //     values.FR_Dept_Div_Sec = {
  //       value: item?.from_Department ? item?.from_Department?.trim() : "",
  //       label: item?.from_DepartmentName
  //         ? item?.from_DepartmentName?.trim()
  //         : "",
  //       division: item?.fromDivisionKey ? item?.fromDivisionKey?.trim() : "", //from_Division,
  //     };

  //     values.FR_Department = {
  //       value: item?.from_Department ? item?.from_Department?.trim() : "",
  //       label: item?.from_DepartmentName
  //         ? item?.from_DepartmentName?.trim()
  //         : "",
  //     };
  //     values.FR_Division = {
  //       value: item?.fromDivisionKey ? item?.fromDivisionKey?.trim() : "",
  //       label: item?.fromDivisionName ? item?.fromDivisionName?.trim() : "",
  //     };
  //     values.TO_Department = {
  //       value: item?.to_Department ? item?.to_Department?.trim() : "",
  //       label: item?.to_DepartmentName ? item?.to_DepartmentName : "",
  //     };
  //     values.TO_Division = {
  //       value: item?.fromDivisionKey ? item?.fromDivisionKey?.trim() : "",
  //       label: item?.fromDivisionName ? item?.fromDivisionName?.trim() : "",
  //     };

  //     values.Next_INCR_date = CheckValue(item?.nDateIncrem)
  //       ? moment(item?.nDateIncrem).format("MM/DD/YYYY")
  //       : null;
  //     values.budge_pos_no = item?.budgetPosNo || "";
  //     values.ndate_increm = item?.nDateIncrem || null;
  //     values.date_term = item?.dateTerm || null;
  //     values.Term_Date = item?.dateTerm || null;
  //     values.inactive_status = item?.inactiveStatus || ""; //inactive_status;
  //     values.worK_SCH = values.worK_SCH = CheckValue(item?.worK_SCH)
  //       ? workStatusOptions?.find((i) => i?.value == item?.worK_SCH?.trim())
  //       : { value: "", label: "" }; //item?.worK_SCH;
  //     // values._empl_days_count = ""; //CheckValue(item?.empl_days_count) ? item?.empl_days_count : "";
  //     values.dp2 = item?.dP2 || "";
  //     // values.reemploy_date = ""; //CheckValue(item?.reemploy_date) ? item?.reemploy_date : "";
  //     values.EMP_Contract_NO = item?.employmentContractNo || "";
  //     // values.description = ""; //CheckValue(item?.description) ? item?.description : "";
  //     values.fullName = item?.full_Name ? item?.full_Name?.trim() : ""; //item?.name2;
  //     values.JOB_Order_Number = item?.jobOrderNo?.trim();
  //     // CheckValue(item?.jobOrderNo)
  //     //   ? {key:0, value:item?.jobOrderNo?.trim()} //item?.jobOrderNo?.trim()
  //     //   : {key:0, value:""}; //""; //item?.job_order_no;
  //     values.Budget_Account_Number = item?.budgetAcctNo
  //       ? item?.budgetAcctNo?.trim()
  //       : ""; //item?.budget_acct_no;
  //     values.Social_Security_Number = item?.socialSecurityNumber || "";
  //     values.RetireSsCode = item?.retireSSCode || "";
  //     values.RetSsDesc = item?.retSSDescription || "";
  //     values.Retirement_Coverage = item?.retirement_Coverage || "";
  //     values.Payroll_Date = item?.payroll_Date || null;
  //     values.Final_Post = item?.final_Post || "";
  //     values.Posting_Date = item?.posting_Date || null;
  //     values.Posting_Flag = item?.posting_Flag || "";
  //     values.Evalution_Type = {
  //       value: item?.eval_type ? item?.eval_type : "",
  //       label: item?.eval_description ? item?.eval_description : "",
  //     };
  //     values.EmploymentDate = item?.employment_Date
  //       ? item?.employment_Date
  //       : "";
  //     // values.ExpirationDate =
  //     //   item?.expiration_Date != item?.employment_Date
  //     //     ? item?.expiration_Date
  //     //     : "";

  //     // For adding Min Max date for Effective date conditionally
  //     // values.EmploymentDate = "08/01/2023";
  //     // values.ExpirationDate = "10/01/2023";

  //     // values.Probation_Date = item?.probation_Date;
  //     values.TO_Dept_Div_Sec = {
  //       value: item?.to_Department ? item?.to_Department?.trim() : "",
  //       label: item?.to_DepartmentName ? item?.to_DepartmentName?.trim() : "",
  //       division: item?.fromDivisionKey || "",
  //     };
  //     values.TO_NAME_FIRST = item?.to_First_Name || "";
  //     values.TO_FTE_Number = item?.to_FTE_No || "";
  //     values.TO_NAME_LAST = item?.to_Last_Name || "";
  //     values.TO_NAME_MIDDLE = item?.to_Middle_Name || "";
  //     values.TO_Grade = item?.to_Pay_Grade || "";
  //     values.TO_PositionTitle = {
  //       value: CheckValue(item?.to_Position_id) ? item?.to_Position_id : "",
  //       label: CheckValue(item?.to_Position_Title)
  //         ? item?.to_Position_Title
  //         : "",
  //       titleWithGrade: CheckValue(item?.positionTitleWithGrade)
  //         ? item?.positionTitleWithGrade
  //         : "",
  //       tdp:
  //         positionTitleOptions && positionTitleOptions?.length
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == item?.positionTitleWithGrade
  //           )[0]?.tdp
  //           : false,
  //       isLawEnforcementPosition:
  //         positionTitleOptions && positionTitleOptions?.length > 0
  //           ? positionTitleOptions.filter(
  //             (i) => i?.titleWithGrade == item?.toPositionTitlewithgrade
  //           )[0]?.isLawEnforcementPosition
  //           : false,
  //     };
  //     values.TO_Rate = item?.to_Rate || values?.TO_Rate;
  //     values.TO_Salary = item?.to_Salary || values?.TO_Salary;
  //     values.Remarks = item?.remarks;

  //     // values.NatureOfActionTitle = item?.natureOfActionTitle
  //     //   ? item?.natureOfActionTitle
  //     //   : "";
  //     // values.Contact_Number = item?.contactNumber ? item?.contactNumber : "";
  //     // values.Contact_Email = item?.contactEmail ? item?.contactEmail : "";
  //     // values.Contact_Department = item?.contactDepartment
  //     //   ? item?.contactDepartment
  //     //   : "";
  //     // values.Contact_FullName = item?.contactFullName
  //     //   ? item?.contactFullName
  //     //   : "";
  //     values.DOB = item?.dateOfBirth ? item?.dateOfBirth : null;
  //     // values.DOR = item?.dateOfRequest ? item?.dateOfRequest : "";
  //     values.empl_type = item?.emplTypes;
  //     values.empl_status = item?.employee_Status;
  //     setFieldValue(values);
  //   }

  //   console.log("121212 Next Incr :::: ", values?.Next_INCR_date, userData);
  //   if (
  //     item &&
  //     item?.employee_Status == "A" &&
  //     CheckValue(values?.Next_INCR_date)
  //   ) {
  //     console.log("121212 Next Incr 111 :::: ", values?.Next_INCR_date);
  //     // let incrDate = moment(values?.Next_INCR_date)
  //     let currDate = moment();
  //     if (
  //       moment(values?.Next_INCR_date).isBefore(currDate) &&
  //       values?.natureCode?.value != "30" &&
  //       values?.natureCode?.value != "58"
  //     ) {
  //       console.log(
  //         "121212 Next Incr 222 :::: ",
  //         values?.Next_INCR_date,
  //         currDate
  //       );
  //       setAlertMsg(
  //         "This employee has an outstanding Performance Evaluation (PE) which must be finalized before any subsequent GG-1 is initiated."
  //       );
  //       setOpenAlert(true);
  //     }
  //   }
  //   if (
  //     (values?.natureCode?.value == "6" || values?.natureCode?.value == "14") &&
  //     item &&
  //     (item?.employee_Status != "A" || item?.emplTypes != "P")
  //   ) {
  //     if (values?.natureCode?.value == "6") {
  //       setAlertMsg(
  //         "Detail appointment is only allowed for the Existing Permanent Employee."
  //       );
  //     } else if (values?.natureCode?.value == "14") {
  //       setAlertMsg(
  //         "Suspension is only allowed for Active & Parmanent Employee."
  //       );
  //     }
  //     setOpenAlert(true);
  //   }
  //   if (
  //     values?.natureCode?.value == "33" &&
  //     item &&
  //     (item?.emplTypes != "P" ||
  //       item?.positionTitleWithGrade?.indexOf("-") == -1)
  //   ) {
  //     if (item?.emplTypes != "P") {
  //       setAlertMsg(
  //         "Transfer Demotion is only allowed for the Permanent Employee."
  //       );
  //     }
  //     if (item?.positionTitleWithGrade?.indexOf("-") == -1) {
  //       setAlertMsg(
  //         "Transfer Demotion is not allowed from Unclassified Position."
  //       );
  //     }
  //     setOpenAlert(true);
  //   }
  //   if (
  //     (values?.natureCode?.value == "17" || values?.natureCode?.value == "8") &&
  //     item &&
  //     item?.employee_Status != "A"
  //   ) {
  //     if (values?.natureCode?.value == "17") {
  //       setAlertMsg("Separation Death is only allowed for Active Employee.");
  //     } else if (values?.natureCode?.value == "8") {
  //       setAlertMsg("Transfer Lateral is only allowed for Active Employee.");
  //     }
  //     setOpenAlert(true);
  //   }

  //   if (item) {
  //     setAutoGeneratedItem(item);
  //   }
  // }, [DataByAutoPopulate, values?.natureCode?.value]);

  const CheckForHigherGrade = (action) => {
    let fromIndex = salaryItemsList.findIndex(
      (item) =>
        item.grade?.trim() == values?.FR_Grade?.trim() &&
        item.step == values?.FR_Step
    );
    let toIndex = salaryItemsList.findIndex(
      (item) =>
        item.grade?.trim() == values?.TO_Grade?.trim() &&
        item.step == values?.TO_Step
    );
    if (!CheckValue(values?.FR_Step)) {
      fromIndex = salaryItemsList.findIndex(
        (item) => item.grade?.trim() == values?.FR_Grade?.trim()
      );
    }
    if (
      !CheckValue(values?.TO_Step) ||
      salaryItemsList.findIndex(
        (item) =>
          item.grade?.trim() == values?.TO_Grade?.trim() &&
          item?.step == values?.TO_Step
      ) == -1
    ) {
      toIndex = salaryItemsList.findIndex(
        (item) => item.grade?.trim() == values?.TO_Grade?.trim()
      );
    }
    console.log("121212 Promote index ::: ", fromIndex, toIndex);
    if (action == "Promotion") {
      if (
        toIndex > fromIndex &&
        values?.TO_Grade?.trim() != values?.FR_Grade?.trim()
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (action == "Demotion") {
      if (
        toIndex < fromIndex &&
        values?.TO_Grade?.trim() != values?.FR_Grade?.trim()
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  function getObjectWithMaxValue(array, key) {
    if (array.length === 0) {
      return null; // Handle the case where the array is empty
    }

    return array.reduce((maxObject, currentObject) => {
      const currentValue = currentObject[key];
      const maxValue = maxObject[key];

      return currentValue > maxValue ? currentObject : maxObject;
    }, array[0]);
  }

  const CheckForHigherStep = (action, salaryItem) => {
    console.log("121212 ", salaryItem);
    if (action == "Promotion") {
      let FilteredArray = salaryItemsList.filter(
        (element) =>
          element.grade?.trim() == values?.TO_Grade?.trim() &&
          !isNaN(parseInt(element?.step))
      );
      let maxObj = getObjectWithMaxValue(FilteredArray, "nSalary");
      console.log("121212 ::: ", FilteredArray, maxObj);
      if (maxObj?.nSalary < salaryItem?.nSalary) {
        let percentToAdd = 3.1;
        if (values?.TO_PositionTitle?.isLawEnforcementPosition) {
          percentToAdd = 3.5;
        }
        while (maxObj?.nSalary < salaryItem?.nSalary) {
          let newSalary =
            maxObj?.nSalary + maxObj?.nSalary * (percentToAdd / 100);
          let newStep = parseInt(maxObj?.step) + 1;
          let newRate = newSalary / 2080;

          maxObj = {
            ...maxObj,
            step: newStep,
            nSalary: newSalary,
            nrate: newRate,
          };
        }
        return maxObj;
      } else {
        return salaryItem;
      }
    } else if (action == "Demotion") {
      let FilteredArray = salaryItemsList.filter(
        (element) =>
          element.grade?.trim() == values?.TO_Grade?.trim() &&
          !isNaN(parseInt(element?.step))
      );
      let maxObj = getObjectWithMaxValue(FilteredArray, "nSalary");
      console.log("121212 ::: ", FilteredArray, maxObj);
      if (maxObj?.nSalary < salaryItem?.nSalary) {
        let percentToAdd = 3.1;
        if (values?.TO_PositionTitle?.isLawEnforcementPosition) {
          percentToAdd = 3.5;
        }
        while (maxObj?.nSalary < salaryItem?.nSalary) {
          let newSalary =
            maxObj?.nSalary + maxObj?.nSalary * (percentToAdd / 100);
          let newStep = parseInt(maxObj?.step) + 1;
          let newRate = newSalary / 2080;
          if (newSalary > salaryItem?.nSalary) {
            break;
          }
          maxObj = {
            ...maxObj,
            step: newStep,
            nSalary: newSalary,
            nrate: newRate,
          };
        }
        return maxObj;
      } else {
        return salaryItem;
      }
    }
  };

  const StepIncrement = (stepIncremented) => {
    let to_new_grade = values?.TO_Grade;
    let newStep =
      stepIncremented && stepIncremented < 10
        ? `0${stepIncremented}`
        : `${stepIncremented}`;
    let SalaryItem = salaryItemsList.find(
      (item) =>
        item.grade?.trim() == values?.FR_Grade?.trim() && item.step == newStep
    );
    console.log("121212 Step Increment 000 ::: ", SalaryItem, to_new_grade);
    if (!SalaryItem) {
      SalaryItem = salaryItemsList.find(
        (item) => item.grade?.trim() == values?.TO_Grade?.trim()
      );
    }
    let _SalaryFilter = [];
    // let _SalaryFilter = salaryItemsList.filter((element, index) => {
    if (SalaryItem) {
      _SalaryFilter = salaryItemsList.filter((element, index) => {
        if (
          element.grade?.trim() == to_new_grade?.trim() &&
          element.nSalary > SalaryItem?.nSalary //values?.FR_Salary
        ) {
          return element;
        }
      });
    }
    console.log("121212 Step Increment ::: ", _SalaryFilter);
    if (_SalaryFilter && _SalaryFilter?.length) {
      return _SalaryFilter[0];
    } else {
      let newItem = CheckForHigherStep("Promotion", SalaryItem);
      if (CheckValue(newItem?.step)) {
        if (
          newItem &&
          salaryItemsList.findIndex(
            (item) =>
              item.grade?.trim() == newItem?.grade?.trim() &&
              item?.step == newItem?.step
          ) == -1
        ) {
          setFieldValue("TO_Rate", newItem?.nrate?.toFixed(2));
          setFieldValue("TO_Salary", newItem?.nSalary?.toFixed(1));
        }
        return newItem;
      } else {
        return SalaryItem;
      }
      // return CheckForHigherStep("Promotion",SalaryItem) || SalaryItem; //SalaryItem;
    }
  };

  // function findNearestValues(array, targetValue, propName) {
  //   return array.reduce((result, current) => {
  //     const currentDiff = current[propName] - targetValue;
  //     const resultDiff = result[propName] - targetValue;

  //     if (currentDiff <= 0 && currentDiff > resultDiff) {
  //       result.lower = current;
  //     } else if (currentDiff >= 0 && currentDiff < resultDiff) {
  //       result.higher = current;
  //     }

  //     return result;
  //   }, { lower: null, higher: null });
  // }

  // const checkForHigherStepDecre = (salaryItem) => {
  //   debugger
  //   let newSalaryItem = salaryItem;
  //   if(salaryItem?.nSalary + (salaryItem?.nSalary * 3.5 /100) < 31000)
  //   {
  //     newSalaryItem = {...newSalaryItem, nSalary:salaryItem?.nSalary + (salaryItem?.nSalary * 3.5 /100), step: parseInt(salaryItem?.step) + 1}
  //     checkForHigherStepDecre(newSalaryItem)
  //   }
  //   else{
  //     return newSalaryItem
  //   }
  // }

  const StepDecrement = (stepDecremented) => {
    let to_new_grade = values?.TO_Grade;
    let newStep =
      stepDecremented == 0
        ? "01"
        : stepDecremented && stepDecremented < 10
          ? `0${stepDecremented}`
          : `${stepDecremented}`;
    console.log("121212 in decre :: ", to_new_grade, newStep, stepDecremented);
    let SalaryItem = salaryItemsList.find(
      (item) =>
        item.grade?.trim() == values?.FR_Grade?.trim() && item.step == newStep
    );
    console.log("121212 Step Decre 000 ::: ", SalaryItem, to_new_grade);
    if (!SalaryItem) {
      SalaryItem = salaryItemsList.find(
        (item) => item.grade?.trim() == values?.TO_Grade?.trim()
      );
    }
    console.log("121212 Step Decre 111 ::: ", SalaryItem, to_new_grade);
    let _SalaryFilter = [];
    if (SalaryItem) {
      _SalaryFilter = salaryItemsList.filter((element, index) => {
        if (
          element.grade?.trim() == to_new_grade?.trim() &&
          !isNaN(parseInt(element?.step)) &&
          element.nSalary < SalaryItem?.nSalary //values?.FR_Salary
        ) {
          return element;
        }
        // else {
        //   // return false;
        // }
      });
    }
    // const nearestValues = findNearestValues(_SalaryFilter?.length ? _SalaryFilter : [], SalaryItem?.nSalary, "nSalary")
    // console.log("121212 Nearest ::: ",nearestValues,findNearestValues(_SalaryFilter,SalaryItem?.nSalary,'nSalary'), SalaryItem?.nSalary)
    console.log("121212 Step Decte 222 ::: ", _SalaryFilter);
    if (_SalaryFilter && _SalaryFilter?.length) {
      let newFilter = _SalaryFilter.reverse();
      console.log("121212 reverse array ::: ", newFilter);
      let newSalaryItem = newFilter[0];
      return newFilter[0]; // _SalaryFilter[_SalaryFilter?.length - 1];
      // debugger
      // let newItem = CheckForHigherStep("Demotion",SalaryItem);
      // if(CheckValue(newItem?.step)){
      //   if(newItem && salaryItemsList.findIndex((item) =>item.grade?.trim() == newItem?.grade?.trim() && item?.step == newItem?.step) == -1){
      //     setFieldValue("TO_Rate", newItem?.nrate?.toFixed(2));
      //     setFieldValue("TO_Salary", newItem?.nSalary?.toFixed(1));
      //   }
      //   return newItem;
      // }else{
      //   return newFilter[0];
      // }
    } else {
      // let newItem = CheckForHigherStep("Demotion",SalaryItem);
      // if(CheckValue(newItem?.step)){
      //   if(newItem && salaryItemsList.findIndex((item) =>item.grade?.trim() == newItem?.grade?.trim() && item?.step == newItem?.step) == -1){
      //     setFieldValue("TO_Rate", newItem?.nrate?.toFixed(2));
      //     setFieldValue("TO_Salary", newItem?.nSalary?.toFixed(1));
      //   }
      //   return newItem;
      // }else{
      //   return SalaryItem;
      // }
      return SalaryItem;
    }
  };

  const addWorkingDays = (startDate, daysToAdd) => {
    let newDate = moment(startDate).format("MM/DD/YYYY");
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      newDate = moment(newDate).add(1, "day").format("MM/DD/YYYY");
      if (moment(newDate).day() !== 0 && moment(newDate).day() !== 6) {
        // Check if the day is not a Sunday (0) or Saturday (6)
        addedDays++;
      }
    }
    return newDate;
  };

  useEffect(() => {
    let infoHighLight = [];
    let infoMsgs = [];
    // if (values?.natureCode?.value == "50") {
    //   setFieldValue("worK_SCH", values.worK_SCH);
    //   setOpen50(true);
    // }
    if (
      values?.natureCode?.value == "6" ||
      values?.natureCode?.value == "2" ||
      values?.natureCode?.value == "1" ||
      values?.natureCode?.value == "32"
    ) {
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        let IncrementedSalaryItem = StepIncrement(
          parseInt(values?.FR_Step) + 2
        );
        let ToNewStep = IncrementedSalaryItem
          ? parseInt(IncrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) + 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
    }

    if (values?.natureCode?.value == "59") {
      // if (
      //   values.TO_PositionTitle == "" ||
      //   values.TO_PositionTitle == null ||
      //   values.TO_PositionTitle == null ||
      //   values.TO_PositionTitle == undefined
      // ) {
      // } else {
      //   let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
      //   if (_res[0] == "1" && _res[1] == "1") {
      //     let grade_from_position = _res[2]?.trim();
      //     let _to_new_grade = values?.TO_Grade?.trim();
      //     if (
      //       _to_new_grade?.trim() != "" &&
      //       _to_new_grade?.trim() != null &&
      //       _to_new_grade != grade_from_position
      //     ) {
      //       let to_new_grade = grade_from_position;
      //       let to_step = "01";
      //       setFieldValue("TO_Grade", grade_from_position);
      //       setFieldValue("TO_Step", to_step);

      //       let _SalaryFilter = salaryItemsList.map((element, index) => {
      //         if (
      //           element.grade?.trim() == to_new_grade?.trim() &&
      //           element.step?.trim() == values?.TO_Step
      //         ) {
      //           return element;
      //         }
      //       });
      //       if (_SalaryFilter?.length > 0) {
      //         values.TO_Rate = _SalaryFilter[0]?.nrate;
      //         values.TO_Salary = _SalaryFilter[0]?.nSalary;

      //         setFieldValue("TO_Rate", _SalaryFilter[0]?.nrate);
      //         setFieldValue("TO_Salary", _SalaryFilter[0]?.nSalary);
      //       }
      //     }
      //   } else {
      //   }
      // }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (values?.natureCode?.value == "68") {
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "To Grade cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "To Grade cannot be blank.",
        });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "To Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (values?.natureCode?.value == "69") {
      values.TO_Grade = values?.FR_Grade;
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "To Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
      }

      if (values?.FR_Step < 20 && values?.FR_Step != 0) {
        let to_step = values?.FR_Step + 1;
        let strto_step = to_step;
        if (to_step != 0 && to_step < 10) {
          strto_step = "0" + strto_step;
        }

        values.TO_Step = strto_step;
        let _SalaryFilter = salaryItemsList.map((element, index) => {
          let _to_new_grade = values?.TO_Grade;
          if (
            element.grade?.trim() == _to_new_grade?.trim() &&
            element.step?.trim() == values?.TO_Step
          ) {
            return element;
          }
        });
        if (_SalaryFilter?.length > 0) {
          values.TO_Rate = _SalaryFilter[0]?.nrate;
          values.TO_Salary = _SalaryFilter[0]?.nSalary;
        } else {
        }
      } else {
        if (values?.FR_Step == 20 || values?.FR_Step == 0) {
          values.TO_Step = "00";
        }
        let fr_salary = parseFloat(values?.TO_Salary);
        let $99 = fr_salary * 1.035;
        $99 = $99 * 1.0;
        let to_salary = $99.toFixed(2);
        let $98 = to_salary / 2080;
        let to_rate = $98.toFixed(2);
        values.TO_Rate = to_rate;
        values.TO_Salary = to_salary;
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    // if (values?.natureCode?.value == "74") {
    //   if (
    //     values?.TO_PositionTitle?.value !== undefined ||
    //     values?.TO_PositionTitle?.value !== "" ||
    //     values?.TO_PositionTitle?.value !== null
    //   ) {
    //     infoHighLight.push({
    //       TO_PositionTitle: "Required",
    //     });
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
    //     if (_res[0] == "0") {
    //     }

    //     if (_res[1] == "0") {
    //       if (
    //         values.TO_Salary == "" ||
    //         values.TO_Salary == null ||
    //         values.TO_Salary == undefined
    //       ) {
    //         infoHighLight.push({
    //           TO_Salary: "Required",
    //         });

    //         infoMsgs.push({
    //           id: "TO_Salary",
    //           msg: "Position must have an assigned grade or User inputs the salary.",
    //         });
    //       } else {
    //         let to_rate = parseFloat(values?.TO_Salary) / 2080;
    //         to_rate = to_rate.toFixed(2);

    //         values.TO_Rate = to_rate;
    //         values.TO_Grade = "";
    //         values.TO_Step = "";
    //       }
    //     } else {
    //       let grade_from_position = _res[2]?.trim();
    //       let _to_new_grade = values?.TO_Grade;
    //       if (
    //         _to_new_grade != "" &&
    //         _to_new_grade != null &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         values.TO_Grade = grade_from_position;
    //       }
    //       let _SalaryFilter = salaryItemsList.map((element, index) => {
    //         if (
    //           element.grade?.trim() == _to_new_grade?.trim() &&
    //           element.step?.trim() == values?.TO_Step
    //         ) {
    //           return element;
    //         }
    //       });

    //       if (_SalaryFilter?.length > 0) {
    //         values.TO_Rate = _SalaryFilter[0]?.nrate;
    //         values.TO_Salary = _SalaryFilter[0]?.nSalary;
    //       }
    //     }
    //   }
    //   if (
    //     values.TO_FTE_Number == null ||
    //     values.TO_FTE_Number == "" ||
    //     values.TO_FTE_Number == undefined
    //   ) {
    //     // window.confirm("FTE position_no is blank, Stop Posting, Continue");
    //   }
    // }
    // if (values?.natureCode?.value == "31") {
    //   // acrroding to new validation sheet
    //   if (
    //     values?.TO_PositionTitle?.value !== "" ||
    //     values?.TO_PositionTitle?.value !== null ||
    //     values?.TO_PositionTitle?.value !== undefined
    //   ) {
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
    //     if (_res[0] == "0") {
    //       return;
    //     }
    //     if (_res[1] == "1") {
    //       let grade_from_position = _res[2]?.trim();
    //       let _to_new_grade = values.TO_Grade;
    //       if (
    //         _to_new_grade !== null &&
    //         _to_new_grade !== undefined &&
    //         _to_new_grade !== "" &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         _to_new_grade = grade_from_position;
    //         setFieldValue("TO_Grade", grade_from_position);
    //       }
    //       let _ToStep = values.TO_Step;
    //       if (_ToStep == "" || _ToStep == null || _ToStep == undefined) {
    //       } else {
    //         if (parseInt(_ToStep) > 10) {
    //           if (parseInt(values?.TO_Step) > 10) {
    //             ShowError("To Step Must be Smaller then 10");
    //           }
    //         }
    //       }

    //       let FromStep = values.FR_Step;
    //       let ToNewStep = parseFloat(FromStep) + 1;
    //       let strToNewStep = ToNewStep.toString();
    //       if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
    //         strToNewStep = `0${ToNewStep}`;
    //       }
    //       // if (values.FR_Step !== values.TO_Step) {
    //       //   setFieldValue("TO_Step", strToNewStep);
    //       // }
    //       // let $1 = values.TO_Grade;
    //       // let $2 = strToNewStep;
    //       let _SalaryFilter = salaryItemsList.filter((element, index) => {
    //         if (
    //           element.grade?.trim() == values?.TO_Grade &&
    //           element.step == values?.TO_Step
    //         ) {
    //           return element;
    //         }
    //       });
    //       if (_SalaryFilter?.length > 0) {
    //         values.TO_Rate = _SalaryFilter[0]?.nrate;
    //         values.TO_Salary = _SalaryFilter[0]?.nSalary;
    //       }
    //     } else {
    //       let _tosalary = values.TO_Salary;
    //       if (_tosalary == "" || _tosalary == null || _tosalary == undefined) {
    //       } else {
    //         let _floatToSalary = parseFloat(_tosalary);
    //         let floatToRate = _floatToSalary / 2080;
    //         floatToRate = floatToRate.toFixed(2);
    //         setFieldValue("TO_Salary", floatToRate);
    //       }
    //     }
    //   }
    // }
    // if (values?.natureCode?.value == "35") {
    //   if (values.EffDate != null && values.EffDate !== undefined) {
    //     setFieldValue("Term_Date", moment(values.EffDate).add(89, "days"));
    //   }
    // }

    if (values?.natureCode?.value == "4") {
      if (
        values.empl_type !== "L" &&
        values.empl_type !== "T" &&
        values.empl_type !== "H"
      ) {
      }
    }
    // if (values?.natureCode?.value == "22") {
    //   setFieldValue("TO_Grade", values.FR_Grade);
    //   setFieldValue("TO_Step", values.TO_Step);

    //   if (values.TO_Rate == "" || values.FR_Salary == "") {
    //     if (
    //       window.confirm(
    //         "Master file Rate/Annual Salary is blank. Continue?"
    //       ) == false
    //     ) {
    //     } else {
    //       setFieldValue("TO_Rate", values.FR_Rate);
    //       setFieldValue("TO_Salary", values.FR_Salary);
    //     }
    //   }
    // }
    // if (values?.natureCode?.value == "27") {
    //   ShowError("Nature of Action 27 - Participants is OBSOLETE.");
    // }
    // if (values?.natureCode?.value == "29") {
    //   ShowError("Nature of Action 29 - Reclassification is OBSOLETE.");
    // }

    // if (values?.natureCode?.value == "39") {
    //   ShowError("Nature of Action 39 - Renewal of Contract is OBSOLETE.");
    // }
    // if (values?.natureCode?.value == "72") {
    //   let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
    //   if (_res[0] == "0") {
    //     return false;
    //   }
    //   if (_res[1] == "0") {
    //     if (
    //       values.TO_Salary == "" ||
    //       values.TO_Salary == null ||
    //       values.TO_Salary == undefined
    //     ) {
    //     } else {
    //       let to_rate = parseFloat(values?.TO_Salary) / 2080;
    //       to_rate = to_rate.toFixed(2);
    //       setFieldValue("TO_Rate", to_rate);
    //     }
    //   } else {
    //     let grade_from_position = _res[2]?.trim();

    //     let _to_new_grade = values?.TO_Grade;
    //     if (
    //       _to_new_grade != "" &&
    //       _to_new_grade != null &&
    //       _to_new_grade != grade_from_position
    //     ) {
    //     }

    //     if (
    //       values.TO_Step == "" ||
    //       values.TO_Step == null ||
    //       values.TO_Step == undefined
    //     ) {
    //     } else {
    //     }
    //     let _deptFirstTwoChar;
    //     if (
    //       values.TO_Step > 10 &&
    //       _deptFirstTwoChar != "02" &&
    //       values.empl_type == "X"
    //     ) {
    //       ShowError("Only the Governors Office can appoint above Step 10.");
    //     }
    //     let _SalaryFilter = salaryItemsList.filter((element, index) => {
    //       if (
    //         (element.grade?.trim() == _to_new_grade?.trim()) ==
    //         values?.TO_Step
    //       ) {
    //         return element;
    //       }
    //     });

    //     if (_SalaryFilter?.length > 0) {
    //       setFieldValue("TO_Rate", _SalaryFilter[0]?.nrate);
    //       setFieldValue("TO_Salary", _SalaryFilter[0]?.nSalary);
    //     }
    //   }
    // }

    /******** New  */
    // console.log("12121212 NOA :::  ", noa, values.natureCode);
    if (values?.natureCode?.value == "30") {
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        let ToNewStep = parseInt(values?.FR_Step) + 1;
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
    }

    if (values?.natureCode?.value == "15") {
      /***** New Validation */
      setFieldValue("TO_Dept_Div_Sec", { value: "", label: "", division: "" });
      setFieldValue("TO_Department", { value: "", label: "" });
      setFieldValue("TO_Division", { value: "", label: "" });
      setFieldValue("TO_FTE_Number", "");
      setFieldValue("TO_Grade", "");
      setFieldValue("TO_PositionTitle", {
        value: "",
        label: "",
        range_next: "",
        titleWithGrade: "",
      });
      setFieldValue("TO_Rate", "");
      setFieldValue("TO_Salary", "");
      setFieldValue("TO_Step", "");
    }
    if (values?.natureCode?.value == "16") {
      setFieldValue("TO_Dept_Div_Sec", { value: "", label: "", division: "" });
      setFieldValue("TO_Department", { value: "", label: "" });
      setFieldValue("TO_Division", { value: "", label: "" });
      setFieldValue("TO_FTE_Number", "");
      setFieldValue("TO_Grade", "");
      setFieldValue("TO_PositionTitle", {
        value: "",
        label: "",
        range_next: "",
        titleWithGrade: "",
      });
      setFieldValue("TO_Rate", "");
      setFieldValue("TO_Salary", "");
      setFieldValue("TO_Step", "");
      setFieldValue("Probation_Date", "");
    }
    // if (
    //   values?.natureCode?.value == "3" ||
    //   values?.natureCode?.value =="28" ||
    //   values?.natureCode?.value == "25" ||
    //   values?.natureCode?.value == "38" ||
    //   values?.natureCode?.value == "7" ||
    //   values?.natureCode?.value == "6" ||
    //   values?.natureCode?.value == "20" ||
    //   values?.natureCode?.value == "47" ||
    //   values?.natureCode?.value == "24" ||
    //   values?.natureCode?.value == "76" ||
    //   values?.natureCode?.value == "52"
    // ) {
    //   setFieldValue("FR_Dept_Div_Sec", { value: "", label: "", division: "" });
    //   setFieldValue("FR_Department", { value: "", label: "" });
    //   setFieldValue("FR_Division", { value: "", label: "" });
    //   setFieldValue("FR_FTE_Number", "");
    //   setFieldValue("FR_Grade", "");
    //   setFieldValue("FR_PositionTitle", {
    //     value: "",
    //     label: "",
    //     range_next: "",
    //     titleWithGrade: "",
    //   });
    //   setFieldValue("FR_Rate", "");
    //   setFieldValue("FR_Salary", "");
    //   setFieldValue("FR_Step", "");
    // }
    // if (
    //   values?.natureCode?.value == "10" ||
    //   values?.natureCode?.value == "14" ||
    //   values?.natureCode?.value == "15" ||
    //   values?.natureCode?.value == "16" ||
    //   values?.natureCode?.value == "17" ||
    //   values?.natureCode?.value == "18" ||
    //   values?.natureCode?.value == "40" ||
    //   values?.natureCode?.value == "41" ||
    //   values?.natureCode?.value == "42" ||
    //   values?.natureCode?.value == "45" ||
    //   values?.natureCode?.value == "48" ||
    //   values?.natureCode?.value == "49" ||
    //   // values?.natureCode?.value == "55" ||
    //   // values?.natureCode?.value == "64" ||
    //   values?.natureCode?.value == "71" ||
    //   values?.natureCode?.value == "79" ||
    //   values?.natureCode?.value == "83"
    // ) {
    //   setFieldValue("TO_Dept_Div_Sec", { value: "", label: "", division: "" });
    //   setFieldValue("TO_Department", { value: "", label: "" });
    //   setFieldValue("TO_Division", { value: "", label: "" });
    //   setFieldValue("TO_FTE_Number", "");
    //   setFieldValue("TO_Grade", "");
    //   setFieldValue("TO_PositionTitle", {
    //     value: "",
    //     label: "",
    //     range_next: "",
    //     titleWithGrade: "",
    //   });
    //   setFieldValue("TO_Rate", "");
    //   setFieldValue("TO_Salary", "");
    //   setFieldValue("TO_Step", "");
    // }
    setOptionalMsgShown(false);
  }, [values?.natureCode?.value, noa]);

  useEffect(() => {
    if (noa == 30) {
      // console.log("121212 in NOA useEffect ::: ", noa);
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        let ToNewStep = parseInt(values?.FR_Step) + 1;
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
    }
  }, [noa]);

  /***** For Evaluation Types values */
  // useEffect(() => {
  //   let evalData = [];
  //   if (values?.natureCode?.value == "30") {
  //     evalData = evalTypeItems.filter((item) => {
  //       return item.value == "S" || item.value == "O";
  //     });
  //     // console.log("121212 evalData ::: ", evalData);
  //     setEvalTypes(evalData);
  //   }
  // }, [values?.natureCode?.value]);

  /******** For Check Eff Date Range */
  const CheckMinMax = () => {
    if (
      values?.natureCode?.value == "15" ||
      values?.natureCode?.value == "32"
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    // if (
    //   CheckValue(values?.TO_PositionTitle?.tdp) &&
    //   values?.TO_PositionTitle?.tdp == true &&
    //   values?.natureCode?.value != "24"
    // ) {
    //   ShowWarning(`Effective date is contingent on the passing of a Drug Test`);
    // }

    // if (values?.natureCode?.value == "16") {
    //   //  Not send in api
    //   if (
    //     values.Evalution_Type?.value !== undefined ||
    //     values.Evalution_Type?.value !== "" ||
    //     values.Evalution_Type?.value !== null
    //   ) {
    //     setFieldValue("Evalution_Type", { value: "", label: "" });
    //   }
    //   if (
    //     values.Probation_Date !== undefined ||
    //     values.Probation_Date !== "" ||
    //     values.Probation_Date !== null
    //   ) {
    //     setFieldValue("Probation_Date", null);
    //   }
    //   if (
    //     values.Next_INCR_date !== undefined ||
    //     values.Next_INCR_date !== "" ||
    //     values.Next_INCR_date !== null
    //   ) {
    //     setFieldValue("Next_INCR_date", null);
    //   }
    // }
    // if (values?.natureCode?.value == "21") {
    //   let TOGrade = parseInt(values.TO_Grade);
    //   let FromGrade = parseInt(values.FR_Grade);
    //   if (TOGrade < FromGrade) {
    //     let $1 = values.TO_Grade;
    //     let $2 = values.TO_Salary;
    //   } else {
    //     if (gp_make2step() == false) {
    //     }
    //   }
    // }

    // if (values?.natureCode?.value == "26") {
    //   if (
    //     values?.TO_PositionTitle?.value == "" ||
    //     values?.TO_PositionTitle?.value == null ||
    //     values?.TO_PositionTitle?.value == undefined
    //   ) {
    //   } else {
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
    //     if (_res[0] == "1" && _res[1] == "1") {
    //       let grade_from_position = _res[2]?.trim();
    //       let _to_new_grade = grade_from_position;

    //       setFieldValue("TO_Grade", _to_new_grade);
    //     } else {
    //     }
    //     if (
    //       values.TO_Step == undefined ||
    //       values.TO_Step == "" ||
    //       values.TO_Step == null
    //     ) {
    //     }
    //     let _SalFilter = salaryItemsList.filter((element, index) => {
    //       if (
    //         element.grade?.trim() == _res[2]?.trim() &&
    //         element.step == values.TO_Step
    //       ) {
    //         return element;
    //       }
    //     });
    //     if (_SalFilter?.length > 0) {
    //       setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
    //       setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
    //     }
    //   }
    // }
    if (values?.natureCode?.value == "41") {
      // / not send in API
      if (
        values.Term_Date !== undefined ||
        values.Term_Date !== "" ||
        values.Term_Date !== null
      ) {
        setFieldValue("Term_Date", null);
      }
      if (
        values.Evalution_Type?.value !== undefined ||
        values.Evalution_Type?.value !== "" ||
        values.Evalution_Type?.value !== null
      ) {
        setFieldValue("Evalution_Type", { value: "", label: "" });
      }
      if (
        values.Probation_Date !== undefined ||
        values.Probation_Date !== "" ||
        values.Probation_Date !== null
      ) {
        setFieldValue("Probation_Date", null);
      }
    }

    if (values?.natureCode?.value == "33") {
      // if (
      //   values?.TO_PositionTitle?.value == "" ||
      //   values?.TO_PositionTitle?.value == "N/A" ||
      //   values?.TO_PositionTitle?.value == null ||
      //   values?.TO_PositionTitle?.value == undefined
      // ) {
      // } else {
      //   let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
      //   if (_res[0] == "1" && _res[1] == "1") {
      //     let grade_from_position = _res[2]?.trim();
      //     let _FromGrade = values.FR_Grade?.trim();
      //     if (grade_from_position >= _FromGrade) {
      //     } else {
      //     }
      //   }
      // }
      // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
      //   ShowError("To Step Must be Smaller then From Step");
      // }
    }

    if (values?.natureCode?.value == "38") {
      // if (
      //   values?.TO_PositionTitle?.value == "" ||
      //   values?.TO_PositionTitle?.value == "N/A" ||
      //   values?.TO_PositionTitle?.value == null ||
      //   values?.TO_PositionTitle?.value == undefined
      // ) {
      // } else {
      //   let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
      //   if (_res[0] == "1" && _res[1] == "1") {
      //     let grade_from_position = _res[2]?.trim();
      //     let _to_new_grade = values.TO_Grade?.trim();
      //     if (
      //       _to_new_grade != "" &&
      //       _to_new_grade != "N/A" &&
      //       _to_new_grade != grade_from_position
      //     ) {
      //       let to_new_grade = grade_from_position;
      //       let to_step = "01";
      //       values.TO_Grade = to_new_grade;
      //       values.TO_Step = to_step;
      //       setFieldValue("TO_Grade", to_new_grade);
      //       setFieldValue("TO_Step", to_step);
      //       let _SalFilter = salaryItemsList?.filter((element, index) => {
      //         if (
      //           element.grade?.trim() == _to_new_grade?.trim() &&
      //           element.step?.trim() == to_step
      //         ) {
      //           return element;
      //         }
      //       });
      //       if (_SalFilter?.length > 0) {
      //         values.TO_Rate = _SalFilter[0]?.nrate;
      //         values.TO_Salary = _SalFilter[0]?.nSalary;
      //         setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
      //         setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
      //       }
      //     }
      //   } else {
      //   }
      // }
    }
  }, [values?.TO_PositionTitle?.value]);
  useEffect(() => {
    // if (values?.natureCode?.value == "24") {
    //   if (values.EffDate !== null && values.EffDate !== undefined) {
    //     let term_date = moment(values.EffDate);
    //     term_date = term_date.add(48, "months");
    //     term_date = term_date.add(-1, "days");

    //     setFieldValue("Term_Date", term_date.format("MM-DD-YYYY"));
    //   }
    // }

    // if (values?.natureCode?.value == "38") {
    //   if (values.EffDate != null && values.EffDate !== undefined && values.EffDate != "") {
    //     setFieldValue("Term_Date", moment(values.EffDate).add(89, "days"));
    //   }
    // }
    if (values?.natureCode?.value == "30") {
      if (
        values.EffDate !== undefined &&
        values.EffDate !== null &&
        values.EffDate !== ""
      ) {
        gp_makeincrem();
      }
    }
    if (values?.natureCode?.value == "58") {
      if (
        values.EffDate !== undefined &&
        values.EffDate !== null &&
        values.EffDate !== ""
      ) {
        gp_makeincrem();
      }
    }

    if (values?.natureCode?.value == "60") {
      if (
        values.EffDate != null &&
        values.EffDate != undefined &&
        values.EffDate != ""
      ) {
        setFieldValue(
          "Term_Date",
          moment(values.EffDate).add(12, "months").subtract(1, "days")
        );
      }
    }
    // if (
    //   values?.natureCode?.value == "30" ||
    //   values?.natureCode?.value == "32" ||
    //   values?.natureCode?.value == "1 " ||
    //   values?.natureCode?.value == "2 "
    // ) {
    //   if (
    //     values.EffDate !== undefined &&
    //     values.EffDate !== null &&
    //     values.EffDate !== ""
    //   ) {
    //     gp_makeincrem();
    //   }
    // }
    if (values?.natureCode?.value == "15") {
      if (
        values.EffDate !== undefined &&
        values.EffDate !== null &&
        values.EffDate !== ""
      ) {
        setFieldValue("Term_Date", values?.EffDate);
      }
    }
    if (
      values?.natureCode?.value == "41" ||
      values?.natureCode?.value == "16"
    ) {
      if (
        values.Term_Date == undefined ||
        values.Term_Date == "" ||
        values.Term_Date == null
      ) {
        setFieldValue("Term_Date", values?.EffDate);
      }
    }
  }, [values?.EffDate]);

  useEffect(() => {
    let infoHighLight = [];
    let infoMsgs = [];
    // if (values?.natureCode?.value == "54") {
    //   // if (
    //   //   values.TO_FTE_Number == null ||
    //   //   values.TO_FTE_Number == "" ||
    //   //   values.TO_FTE_Number == undefined
    //   // ) {
    //   //   infoHighLight.push({
    //   //     TO_FTE_Number: "FTE position_no is blank.",
    //   //   });
    //   //   if (
    //   //     window.confirm("FTE position_no is blank, Stop Posting, Continue") ==
    //   //     false
    //   //   ) {
    //   //     infoHighLight.push({
    //   //       TO_FTE_Number: "FTE position_no is blank.",
    //   //     });
    //   //   } else {
    //   //     infoHighLight.push({
    //   //       TO_FTE_Number: "FTE position_no is blank.",
    //   //     });
    //   //   }
    //   // } else {
    //   //   infoHighLight.push({
    //   //     TO_FTE_Number: "FTE position_no is blank.",
    //   //   });
    //   // }
    //   if (
    //     values?.TO_PositionTitle?.value == undefined ||
    //     values?.TO_PositionTitle?.value == "" ||
    //     values?.TO_PositionTitle?.value == null
    //   ) {
    //   } else {
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
    //     if (_res[0] == "1" && _res[1] == "1") {
    //       let grade_from_position = _res[2]?.trim();
    //       let _to_new_grade = values?.TO_Grade?.trim();
    //       if (
    //         _to_new_grade?.trim() != "" &&
    //         _to_new_grade?.trim() != null &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         values.TO_Grade = grade_from_position;
    //         let to_step = "01";
    //         values.TO_Grade = grade_from_position;
    //         values.TO_Step = to_step;
    //         let _SalaryFilter = salaryItemsList.map((element, index) => {
    //           if (
    //             element.grade?.trim() == _to_new_grade?.trim() &&
    //             element.step?.trim() == values?.TO_Step
    //           ) {
    //             return element;
    //           }
    //         });

    //         if (_SalaryFilter?.length > 0) {
    //         }
    //       }
    //     } else {
    //     }
    //   }
    //   // let ActEffDate = moment(values?.EffDate);
    //   // let term_date = moment().format("DD-MM-YYYY");
    //   // if (
    //   //   values?.EffDate !== undefined &&
    //   //   values?.EffDate !== null &&
    //   //   values?.EffDate !== ""
    //   // ) {
    //   //   if (
    //   //     window.confirm(
    //   //       "Select the 2% Employment employment Period:  120 Working Days, One Year"
    //   //     ) == false
    //   //   ) {
    //   //     term_date = moment(ActEffDate, "DD-MM-YYYY").add(167, "days");

    //   //     if (moment(term_date).day() == 5) {
    //   //       term_date = moment(term_date, "DD-MM-YYYY").subtract(1, "days");
    //   //     }
    //   //     if (moment(term_date).day() == 6) {
    //   //       term_date = moment(term_date, "DD-MM-YYYY").subtract(2, "days");
    //   //     }
    //   //   } else {
    //   //     term_date = moment(ActEffDate, "DD-MM-YYYY")
    //   //       .add("months", 12)
    //   //       .subtract(1, "days");
    //   //   }
    //   //   values.Term_Date = ConvertToBlankOrDateString(term_date);
    //   // }
    //   setErrorHighLight(infoHighLight);
    //   setHighlight(infoHighLight);
    //   setErrorMessage(infoMsgs);
    // }

    // if (values?.natureCode?.value == "25") {
    //   let _SalFilter = salaryItemsList.filter((element, index) => {
    //     if (
    //       element.grade?.trim() == values?.TO_Grade?.trim() &&
    //       element.step == values?.TO_Step
    //     ) {
    //       return element;
    //     }
    //   });
    //   if (_SalFilter?.length > 0) {
    //     setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
    //     setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
    //   }
    //   if (
    //     values.TO_Step !== undefined &&
    //     values.TO_Step !== "" &&
    //     values.TO_Step !== null
    //   ) {
    //     if (values?.TO_Step != 1) {
    //       // ShowError("TO Step value must be 1.");
    //       setFieldValue("TO_Step", "01");
    //     }
    //   }
    // } else
    if (
      // values?.natureCode?.value == "28" ||
      // values?.natureCode?.value == "3" ||
      values?.natureCode?.value == "25" ||
      values?.natureCode?.value == "38" ||
      values?.natureCode?.value == "7" ||
      // values?.natureCode?.value == "6" ||
      // values?.natureCode?.value == "20" ||
      // values?.natureCode?.value == "47" ||
      values?.natureCode?.value == "24" ||
      // values?.natureCode?.value == "76" ||
      // values?.natureCode?.value == "52" ||
      values?.natureCode?.value == "54" ||
      values?.natureCode?.value == "57"
    ) {
      if (
        values.TO_Step !== undefined &&
        values.TO_Step !== "" &&
        values.TO_Step !== null
      ) {
        if (values?.TO_Step != 1) {
          // ShowError("TO Step value must be 1.");
          setFieldValue("TO_Step", "01");
        }
      }
      let _SalFilter = salaryItemsList.filter((element, index) => {
        if (
          element.grade?.trim() == values?.TO_Grade?.trim() &&
          element.step == values?.TO_Step
        ) {
          return element;
        }
      });
      if (_SalFilter?.length > 0) {
        setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
        setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
      }
    } else if (values?.natureCode?.value == "30") {
      if (salaryItemsList && salaryItemsList?.length) {
        let _SalFilter = salaryItemsList.filter((element, index) => {
          if (
            element.grade?.trim() == values?.TO_Grade?.trim() &&
            element.step == values?.TO_Step
          ) {
            return element;
          }
        });
        if (_SalFilter?.length > 0) {
          setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
          setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
        }
      }
    }
    // else {
    //   let _SalFilter = salaryItemsList.filter((element, index) => {
    //     if (
    //       element.grade?.trim() == values?.TO_Grade?.trim() &&
    //       element.step == values?.TO_Step
    //     ) {
    //       return element;
    //     }
    //   });
    //   if (_SalFilter?.length > 0) {
    //     setFieldValue("TO_Rate", _SalFilter[0]?.nrate);
    //     setFieldValue("TO_Salary", _SalFilter[0]?.nSalary);
    //   }
    // }
    console.log(
      "demo 123 to step useEffect ::: ",
      values?.TO_Step,
      values?.TO_Rate,
      values?.TO_Salary
    );
  }, [
    values.natureCode?.value,
    values?.TO_PositionTitle?.value,
    values?.TO_Step,
  ]);
  const renderLoader = () => {
    return (
      <Row>
        <Col className="text-center">
          <Spinner />
        </Col>
      </Row>
    );
  };
  const hilightChanges = (value, newValue) => {
    return value !== newValue ? "hilight-change" : "";
  };
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => { },
    documentTitle: `eHRP-report-${moment().format("MM-DD-YY-HH:mm:ss")}`,
  });

  useEffect(() => {
    let infoHighLight = [{}];
    let infoMsgs = [];
    // if (values?.natureCode?.value == "1") {
    //   // not send in API
    //   // if (
    //   //   values.Term_Date !== undefined ||
    //   //   values.Term_Date !== "" ||
    //   //   values.Term_Date !== null
    //   // ) {
    //   //   setFieldValue("Term_Date", null);
    //   // }
    //   // if (
    //   //   values.Evalution_Type?.value !== undefined ||
    //   //   values.Evalution_Type?.value !== "" ||
    //   //   values.Evalution_Type?.value !== null
    //   // ) {
    //   //   setFieldValue("Evalution_Type", { value: "", label: "" });
    //   // }
    //   // if (
    //   //   values.Probation_Date !== undefined ||
    //   //   values.Probation_Date !== "" ||
    //   //   values.Probation_Date !== null
    //   // ) {
    //   //   setFieldValue("Probation_Date", null);
    //   // }
    //   let FromGrade = values?.FR_Grade;
    //   let FromStep = values?.FR_Step;
    //   if (
    //     FromGrade?.trim() == "" ||
    //     FromGrade == null ||
    //     (FromGrade == undefined && FromStep == "") ||
    //     FromStep == null ||
    //     FromStep == undefined
    //   ) {
    //   } else {
    //     let ToGrade = FromGrade;
    //     if (parseInt(FromStep) < 20 && parseInt(FromStep) != 0) {
    //       let ToNewStep = parseInt(FromStep) + 2;

    //       let strToNewStep = ToNewStep.toString();
    //       if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
    //         strToNewStep = `0${ToNewStep}`;
    //       }
    //       if (values.FR_Step == values.TO_Step) {
    //         setFieldValue("TO_Step", strToNewStep);
    //       }
    //       let $1 = values?.TO_Grade;
    //       let $2 = strToNewStep;

    //       let _SalFilter = salaryItemsList.filter((element, index) => {
    //         if (
    //           element.grade?.trim() == values?.TO_Grade?.trim() &&
    //           element.step?.trim() == values?.TO_Step
    //         ) {
    //           return element;
    //         }
    //       });
    //       if (_SalFilter?.length > 0) {
    //         values.TO_Rate = _SalFilter[0]?.nrate;
    //         values.TO_Salary = _SalFilter[0]?.nSalary;
    //       } else {
    //       }
    //     } else {
    //       if (FromStep == "20" || FromStep == "00") {
    //         values.TO_Step = "00";
    //       }
    //       let fromSalary = values?.FR_Salary?.trim();
    //       let $99 = parseFloat(fromSalary) * 1.035;
    //       $99 = $99 * 1.0;
    //       let to_salary = $99.toFixed(2);
    //       let $98 = to_salary / 2080;
    //       let to_rate = $98.toFixed(2);

    //       setFieldValue("TO_Rate", to_rate);
    //       setFieldValue("TO_Salary", to_salary);
    //     }
    //     setFieldValue("TO_Grade", ToGrade);

    //     // if (
    //     //   values.EffDate !== undefined &&
    //     //   values.EffDate !== null &&
    //     //   values.EffDate !== ""
    //     // ) {
    //     //   // gp_makeincrem();
    //     // }
    //   }
    // }

    // if (values?.natureCode?.value == "2") {
    //   // not send in API
    //   if (
    //     values.Term_Date !== undefined ||
    //     values.Term_Date !== "" ||
    //     values.Term_Date !== null
    //   ) {
    //     setFieldValue("Term_Date", null);
    //   }
    //   if (
    //     values.Evalution_Type?.value !== undefined ||
    //     values.Evalution_Type?.value !== "" ||
    //     values.Evalution_Type?.value !== null
    //   ) {
    //     setFieldValue("Evalution_Type", { value: "", label: "" });
    //   }
    //   if (
    //     values.Probation_Date !== undefined ||
    //     values.Probation_Date !== "" ||
    //     values.Probation_Date !== null
    //   ) {
    //     setFieldValue("Probation_Date", null);
    //   }
    //   let FromGrade = values?.FR_Grade;
    //   let FromStep = values?.FR_Step;
    //   if (
    //     FromGrade?.trim() == "" ||
    //     FromGrade == null ||
    //     (FromGrade == undefined && FromStep == "") ||
    //     FromStep == null ||
    //     FromStep == undefined
    //   ) {
    //   } else {
    //     let ToGrade = FromGrade;
    //     if (parseInt(FromStep) < 20 && parseInt(FromStep) != 0) {
    //       let IncrementedSalaryItem = StepIncrement(
    //         parseInt(values?.FR_Step) + 2
    //       );
    //       let ToNewStep = IncrementedSalaryItem
    //         ? parseInt(IncrementedSalaryItem?.step)
    //         : parseInt(values?.FR_Step) + 1; // + 2

    //       let strToNewStep = ToNewStep.toString();
    //       if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
    //         strToNewStep = `0${ToNewStep}`;
    //       }
    //       if (values.FR_Step !== values.TO_Step) {
    //         setFieldValue("TO_Step", strToNewStep);
    //       }
    //       let $1 = values?.TO_Grade;
    //       let $2 = strToNewStep;

    //       let _SalFilter = salaryItemsList.filter((element, index) => {
    //         if (
    //           element.grade?.trim() == values?.TO_Grade?.trim() &&
    //           element.step?.trim() == values?.TO_Step
    //         ) {
    //           return element;
    //         }
    //       });
    //       if (_SalFilter?.length > 0) {
    //         values.TO_Rate = _SalFilter[0]?.nrate;
    //         values.TO_Salary = _SalFilter[0]?.nSalary;
    //       } else {
    //       }
    //     } else {
    //       if (FromStep == "20" || FromStep == "00") {
    //         values.TO_Step = "00";
    //       }
    //       let fromSalary = values?.FR_Salary;
    //       let $99 = parseFloat(fromSalary) * 1.035;
    //       $99 = $99 * 1.0;
    //       let to_salary = $99.toFixed(2);
    //       let $98 = to_salary / 2080;
    //       let to_rate = $98.toFixed(2);

    //       setFieldValue("TO_Rate", to_rate);
    //       setFieldValue("TO_Salary", to_salary);
    //     }
    //     setFieldValue("TO_Grade", ToGrade);
    //   }
    // }

    // if (values?.natureCode?.value == "7") {
    //   if (
    //     values?.TO_PositionTitle?.value == "" ||
    //     values?.TO_PositionTitle?.value == null ||
    //     values?.TO_PositionTitle?.value == undefined
    //   ) {
    //   } else {
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);

    //     if (_res[0] == "1" && _res[1] == "1") {
    //       let grade_from_position = _res[2]?.trim();

    //       let _to_new_grade = values.TO_Grade;
    //       if (
    //         _to_new_grade != "" &&
    //         _to_new_grade != null &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         let _to_new_grade = grade_from_position;
    //         let _to_new_step = "01";

    //         values.TO_Grade = _to_new_grade;
    //         values.TO_Step = _to_new_step;
    //         let _SalFilter = salaryItemsList.filter((element, index) => {
    //           if (
    //             element.grade?.trim() == _to_new_grade?.trim() &&
    //             element.step == _to_new_step
    //           ) {
    //             return element;
    //           }
    //         });
    //         if (_SalFilter?.length > 0) {
    //           values.TO_Rate = _SalFilter[0]?.nrate;
    //           values.TO_Salary = _SalFilter[0]?.nSalary;
    //         }
    //       }
    //     } else {
    //     }
    //   }
    // }
  }, [values?.natureCode?.value, values?.TO_PositionTitle?.value]);
  useEffect(() => {
    let infoHighLight = [];
    let infoMsgs = [];
    if (values?.natureCode?.value == "20") {
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
      } else {
        let tosalary = parseFloat(values.TO_Salary);
        let to_rate = tosalary / 2080;
        to_rate = to_rate.toFixed(2);
        values.TO_Rate = to_rate;
      }
    }
    // if (values?.natureCode?.value == "3") {
    //   if (
    //     values?.TO_PositionTitle?.value == "" ||
    //     values?.TO_PositionTitle?.value == null ||
    //     values?.TO_PositionTitle?.value == undefined
    //   ) {
    //   } else {
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);

    //     if (_res[0] == "0") {
    //     }

    //     if (_res[1] == "0") {
    //       var _tosalary = values?.TO_Salary;
    //       if (_tosalary == "" || _tosalary == null || _tosalary == undefined) {
    //         infoHighLight.push({ TO_Salary: "Required" });
    //       } else {
    //         infoHighLight.push({ TO_Salary: "Required" });
    //         infoHighLight.push({ TO_Rate: "Required" });

    //         let to_rate = parseFloat(_tosalary) / 2080;
    //         to_rate = to_rate.toFixed(2);
    //         values.TO_Rate = to_rate;
    //       }
    //     } else {
    //       let grade_from_position = _res[2]?.trim();
    //       let _to_new_grade = values.TO_Grade?.trim();
    //       if (
    //         _to_new_grade != "" &&
    //         _to_new_grade != null &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         infoHighLight.push({ TO_Grade: "Required" });

    //         infoMsgs.concat([
    //           {
    //             id: "TO_Grade",
    //             msg: "Position Grade does not match the user input grade, resetting to appropriate grade.",
    //           },
    //         ]);
    //       }
    //       let _ToStep = values?.TO_Step;
    //       if (_ToStep == "" || _ToStep == null) {
    //         infoHighLight.push({ TO_Step: "Required" });

    //         infoMsgs.concat([
    //           {
    //             id: "TO_Step",
    //             msg: "Grade found but Step cannot be blank.",
    //           },
    //         ]);
    //       } else {
    //         if (
    //           values?.TO_Dept_Div_Sec?.value == undefined ||
    //           values?.TO_Dept_Div_Sec?.value == "" ||
    //           values?.TO_Dept_Div_Sec?.value == null
    //         ) {
    //           infoHighLight.push({ TO_Dept_Div_Sec: "required" });
    //           infoMsgs.push({
    //             id: "TO_Dept_Div_Sec",
    //             msg: "To Department cannot be blank.",
    //           });
    //         } else {
    //           infoHighLight.push({ TO_Dept_Div_Sec: "required" });
    //           let _deptFirstTwoChar = values?.TO_Dept_Div_Sec?.value
    //             .toString()
    //             .substring(0, 2);
    //           let to_step = parseInt(_ToStep);
    //           if (to_step > 10 && _deptFirstTwoChar != "02") {
    //           }
    //           let _SalFilter = salaryItemsList.filter((element, index) => {
    //             if (element.grade?.trim() == _to_new_grade?.trim()) {
    //               return element;
    //             }
    //           });
    //           if (_SalFilter?.length > 0) {
    //             values.TO_Rate = _SalFilter[0]?.nrate;
    //             values.TO_Salary = _SalFilter[0]?.nSalary;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    if (values?.natureCode?.value == "47") {
      if (
        values.TO_Salary == "" ||
        values.TO_Salary == null ||
        values.TO_Salary == undefined
      ) {
      } else {
        let to_salary = parseFloat(values.TO_Salary);
        let to_rate = to_salary / 2080;
        to_rate = to_rate.toFixed(2);
        values.TO_Rate = to_rate;
      }
    }

    if (
      values.TO_Salary == "" ||
      values.TO_Salary == null ||
      values.TO_Salary == undefined
    ) {
    } else {
      let to_salary = parseFloat(values.TO_Salary);
      let to_rate = to_salary / 2080;
      to_rate = to_rate.toFixed(2);
      values.TO_Rate = to_rate;
    }

    // if (values?.natureCode?.value == "76") {
    //   if (
    //     values?.TO_PositionTitle?.value == "" ||
    //     values?.TO_PositionTitle?.value == null ||
    //     values?.TO_PositionTitle?.value == undefined
    //   ) {
    //   } else {
    //     infoHighLight.push({
    //       TO_PositionTitle: "Required",
    //     });
    //     let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);

    //     if (_res[0] == "1" && _res[1] == "1") {
    //       let grade_from_position = _res[2]?.toString()?.trim();
    //       let _to_new_grade = values?.TO_Grade?.toString()?.trim();

    //       if (
    //         _to_new_grade !== "" &&
    //         _to_new_grade !== null &&
    //         _to_new_grade != grade_from_position
    //       ) {
    //         let to_new_grade = grade_from_position;
    //         let to_step = "01";
    //         values.TO_Grade = to_new_grade;
    //         values.TO_Step = to_step;
    //         let _SalFilter = salaryItemsList.filter((element, index) => {
    //           if ((element.grade?.trim() == _to_new_grade?.trim()) == to_step) {
    //             return element;
    //           }
    //         });
    //         if (_SalFilter?.length > 0) {
    //           values.TO_Rate = _SalFilter[0]?.nrate;
    //           values.TO_Salary = _SalFilter[0]?.nSalary;
    //         }
    //       }
    //     } else {
    //     }
    //   }
    //   setErrorHighLight(infoHighLight);
    //   setHighlight(infoHighLight);
    //   setErrorMessage(infoMsgs);
    // }
  }, [
    values?.natureCode?.value,
    values?.TO_PositionTitle?.value,
    values?.TO_Salary,
  ]);
  // useEffect(() => {
  //   if (values?.natureCode?.value == "52") {
  //     if (
  //       values?.TO_PositionTitle?.value == "" ||
  //       values?.TO_PositionTitle?.value == null ||
  //       values?.TO_PositionTitle?.value == undefined
  //     ) {
  //     } else {
  //       let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
  //       if (_res[0] == "1" && _res[1] == "1") {
  //         let grade_from_position = _res[2]?.trim();
  //         values.TO_Grade = grade_from_position;
  //       } else {
  //       }
  //     }
  //     let txtToStep = values?.TO_Step;
  //     if (txtToStep == "" || txtToStep == null || txtToStep == undefined) {
  //     } else {
  //       let to_step = parseInt(txtToStep);
  //       if (to_step > 10) {
  //       }

  //       let txtToGrade = values?.TO_Grade;

  //       let _SalFilter = salaryItemsList.map((element, index) => {
  //         if (element.grade == txtToGrade && element.step == txtToStep) {
  //           return element;
  //         }
  //       });
  //       if (_SalFilter?.length > 0 && _SalFilter !== undefined) {
  //         values.TO_Rate = _SalFilter[0]?.nrate;
  //         values.TO_Salary = _SalFilter[0]?.nSalary;
  //       }
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (values?.natureCode?.value) {
      // console.log("456456 ::: ", values?.natureCode, values);
      setErrorHighLight([]);
      setErrorMessage([]);
      setSysGenHighlight([]);
      setOptionalMessages([]);
      createSchemaRendom(values);
    }
  }, [values?.natureCode?.value, values, hrControl]);
  const createSchemaRendom = (data, e) => {
    if (errorMessage?.length) {
      setErrorHighLight([]);
      setErrorMessage([]);
    }

    let nature_code = values?.natureCode?.value;
    let schemaObj = {
      // employeeID: yup.string().required("Enter EmployeeID"),
      natureCode: yup.object().nullable().required("Required"),
      NatureOf: yup.object().nullable().required("Required"),
    };
    let infoHighLight = [
      // { employeeID: "EmployeeID Required" },
      // {
      //   LegalAuthority: "LegalAuthority is Required",
      // },
      { EffDate: "effdate is required" },
      { Remarks: "Remarks" },
      // { Contact_Department: "Contact_Department is required" },
      { Contact_Position: "Contact_Position is required" },
      { Contact_FullName: "Contact_FullName is required" },
      { RequestedBy_FullName: "RequestedBy_FullName is required" },
      { RequestedBy_Position: "RequestedBy_Position is required" },
      { Contact_Number: "Contact_Number is required" },
      { Contact_Email: "Contact_Email is required" },
      // { natureCode: "required" },
      { natureOf: "required" },
      { Budget_Account_Number: "required" },
    ];
    let infoMsgs = [];
    let optionalMsgs = [];

    // if (
    //   values?.EffDate == null ||
    //   values?.EffDate == "" ||
    //   values?.EffDate == undefined
    // ) {
    //   infoMsgs.push({
    //     id: "EffDate",
    //     msg: "Eff Date cannot be the blank",
    //   });
    // }

    if (
      values?.EffDate == null ||
      values?.EffDate == "" ||
      values?.EffDate == undefined
    ) {
      infoHighLight.push({
        EffDate: "Eff Date is required.",
      });
      // infoMsgs.push({
      //   id: "EffDate",
      //   msg: "Eff Date cannot be the blank",
      // });
    } else {
      infoHighLight.push({
        EffDate: "Eff Date is required.",
      });
    }

    // console.log("121212 databyssn ::: ",autoGeneratedItem?.employee_Status, autoGeneratedItem)
    if (autoGeneratedItem && autoGeneratedItem?.employee_Status != "I") {
      if (
        CheckValue(values.EffDate) &&
        CheckValue(values?.Next_INCR_date) &&
        moment(values?.EffDate).isAfter(moment(values?.Next_INCR_date))
      ) {
        infoMsgs.push({
          id: "EffDate",
          msg: `Eff Date cannot be greater than Next Increment Date (${values?.Next_INCR_date})`,
        });
      }
    }

    if (
      values.natureCode.value == "" ||
      values.natureCode.label == "" ||
      values.natureCode.value == undefined ||
      values.natureCode.label == undefined ||
      values.natureCode.value == null ||
      values.natureCode.label == null
    ) {
      infoHighLight.push({ natureCode: "required" });
    }
    // if (
    //   values.NatureOf.value == "" ||
    //   values.NatureOf.label == "" ||
    //   values.NatureOf.value == undefined ||
    //   values.NatureOf.label == undefined ||
    //   values.NatureOf.value == null ||
    //   values.NatureOf.label == null
    // ) {
    //   infoHighLight.push({ NatureOf: "required" });
    //   infoMsgs.push({
    //     id: "NatureOf",
    //     msg: `Please Select Nature of Action`,
    //   });
    // } else {
    //   infoHighLight.push({ NatureOf: "required" });
    // }
    if (values?.natureCode?.value != "30") {
      if (
        values?.JOB_Order_Number == null ||
        values?.JOB_Order_Number == "" ||
        values?.JOB_Order_Number == undefined
      ) {
        infoHighLight.push({ JOB_Order_Number: "required" });
      } else {
        infoHighLight.push({ JOB_Order_Number: "required" });
      }
    }

    // optional FTE msg for all
    if (
      values?.TO_FTE_Number == "" ||
      values?.TO_FTE_Number == null ||
      values?.TO_FTE_Number == undefined
    ) {
      infoHighLight.push({ TO_FTE_Number: "Required" });
      optionalMsgs.push({
        id: "TO_FTE_Number",
        msg: "Please verify OPTIONAL entry of the FTE Number.",
      })
    } else {
      infoHighLight.push({ TO_FTE_Number: "Required" });
    }

    if (nature_code == "2") {
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        // console.log("121212 Step Incre ::: ", values?.FR_Step);
        let IncrementedSalaryItem = StepIncrement(
          parseInt(values?.FR_Step) + 2
        );
        // let ToNewStep = parseInt(values?.FR_Step) + 2;
        let ToNewStep = IncrementedSalaryItem
          ? parseInt(IncrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) + 1;
        // StepIncrement(values?.FR_Step);
        // console.log("121212 Step Incre ::: ", ToNewStep);
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Retirement_Coverage: "Retirement_Coverage" },
      // ]);
    }

    if (nature_code == "1") {
      /***** New */
      //sys generated
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        // console.log("121212 Step Incre ::: ", values?.FR_Step);
        let IncrementedSalaryItem = StepIncrement(
          parseInt(values?.FR_Step) + 2
        );
        // let ToNewStep = parseInt(values?.FR_Step) + 2;
        let ToNewStep = IncrementedSalaryItem
          ? parseInt(IncrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) + 1;
        // StepIncrement(values?.FR_Step);
        // console.log("121212 Step Incre ::: ", ToNewStep);
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      console.log("121212 error msg::: ", errorMessage);
      if (!CheckForHigherGrade("Promotion")) {
        console.log("121212 lower grade::: ", values?.TO_Grade);
        infoMsgs.push({
          id: "TO_Grade",
          msg: "To Position and Grade must be higher than the from values for Promotion.",
        });
      }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });

        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }

      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }

    if (nature_code == "3") {
      // System Generated
      // setSysGenHighlight([
      //   { natureCode: "natureCode" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { ActionDate: "Action Date Required" },
      //   { Next_INCR_date: "Term Date Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Final_Post: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { Posting_Date: "Required" },
      //   { Term_Date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);

      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }

      if (
        values.Term_Date !== undefined ||
        values.Term_Date !== "" ||
        values.Term_Date !== null
      ) {
        setFieldValue("Term_Date", null);
      }
      // if (
      //   values.Next_INCR_date !== undefined ||
      //   values.Next_INCR_date !== "" ||
      //   values.Next_INCR_date !== null
      // ) {
      //   setFieldValue("Next_INCR_date", null);
      // }
      // User Input
      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }

      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });
        // infoMsgs.push({
        //   id: "TO_Salary",
        //   msg: "To Salary cannot be blank.",
        // });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
      // console.log("121212 info msgs ::: ", infoMsgs);
    }

    if (nature_code == "4") {
      // System Generated
      // setSysGenHighlight([
      //   { natureCode: "natureCode" },
      //   { Budget_Account_Number: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { ActionDate: "Action Date Required" },
      //   { Term_Date: "Term Date Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { TO_NAME_FIRST: "Required" },
      //   { TO_NAME_MIDDLE: "Required" },
      //   { TO_NAME_LAST: "Required" },
      //   { TO_FTE_Number: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { fullName: "Required" },

      //   { FR_Dept_Div_Sec: "Required" },
      //   { TO_Dept_Div_Sec: "Required" },
      //   { FR_Grade: "Required" },
      //   { TO_Grade: "Required" },
      //   { FR_Step: "Required" },
      //   { TO_Step: "Required" },
      //   { FR_Rate: "Required" },
      //   { TO_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { TO_Salary: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { TO_PositionTitle: "Required" },
      //   { Evalution_Type: "Required" },
      //   { Social_Security_Number: "Required" },
      //   { Retirement_Coverage: "Required" },
      //   { RequestID: "Required" },
      //   { EMP_Contract_NO: "Required" },
      //   { Probation_Date: "Required" },
      //   { JOB_Order_Number: "Required" },

      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Final_Post: "Required" },
      //   { Posting_Date: "Required" },
      //   { Next_INCR_date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);

      // User Input
      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "6") {
      /****** New */
      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }
      // console.log("121212 ::: in detail::: ",autoGeneratedItem)
      // if(autoGeneratedItem && autoGeneratedItem?.employee_Status == "A" && autoGeneratedItem?.emplTypes == "P"){

      // }else{
      // detail appointment is allowed only for active & parmanent employee
      // }
      // if (CheckValue(autoGeneratedItem) && CheckValue(autoGeneratedItem?.employee_Status) && CheckValue(autoGeneratedItem?.emplTypes) && autoGeneratedItem?.employee_Status != "A" && autoGeneratedItem?.emplTypes != "P") {
      //   setAlertMsg("Detail appointment is only allowed for Existing Permanent Employee.");
      //   setOpenAlert(true);
      // }
      // debugger
      // if(values)
      // {
      // if(values?.empl_status === "A" && values?.empl_type === "P")
      // {
      // setOpenAlert(false);
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
        // if (values?.TO_Step != 1) {
        //   // ShowError("TO Step value must be 1.");
        //   setFieldValue("TO_Step", "01");
        // }
        setFieldValue("TO_Step", "03"); // If no FR_Step so we need to add 1 + 2 step increase = 3
      } else {
        // let ToNewStep = parseInt(values?.FR_Step) + 2;
        let IncrementedSalaryItem = StepIncrement(
          parseInt(values?.FR_Step) + 2
        );
        let ToNewStep = IncrementedSalaryItem
          ? parseInt(IncrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) + 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
        console.log("456456  111 ::: ", values?.FR_Step, ToNewStep);
      }

      // newly added as per requirement for NPA
      if (
        values.EffDate != undefined &&
        values.EffDate != "" &&
        values.EffDate != null
      ) {
        setFieldValue(
          "Term_Date",
          moment(values?.EffDate).add(89, "days").format("MM/DD/YYYY")
        );
      }
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO FTE Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Salary is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      // }
      // else{
      //   debugger
      // console.log("121212 in before 666 ::: ",Object.keys(autoGeneratedItem).length)
      // if(Object.keys(autoGeneratedItem).length > 0 && (values?.empl_status != "A" || values?.empl_type != "P")){
      //     console.log("121212 in elseee 666 ::: ",values?.empl_status, values?.empl_type,values,autoGeneratedItem)
      //     setAlertMsg("Detail appointment is only allowed for Existing Permanent Employee.");
      //     setOpenAlert(true);
      //   }
      // }

      // }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "7") {
      if (values?.TO_Step != 1) {
        // ShowError("TO Step value must be 1.");
        setFieldValue("TO_Step", "01");
      }
      if (
        values?.Term_Date == null ||
        values?.Term_Date == "" ||
        values?.Term_Date == undefined
      ) {
        infoHighLight.push({
          Term_Date: "Required",
        });
        // infoMsgs.push({
        //   id: "Term_Date",
        //   msg: "TO Rate is Required",
        // });
      } else {
        infoHighLight.push({
          Term_Date: "Required",
        });
      }
      if (
        values?.EffDate != "" &&
        values?.EffDate != null &&
        values?.EffDate != undefined
      ) {
        let newTermDate = addWorkingDays(values?.EffDate, 120);
        setFieldValue("Term_Date", newTermDate);
      }
      // else {
      //   setFieldValue("Term_Date", "");
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      // user input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }

    if (nature_code == "8") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Budget_Account_Number: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);

      // User Input
      // if (
      //   values?.TO_PositionTitle?.value == "" ||
      //   values?.TO_PositionTitle?.value == null ||
      //   values?.TO_PositionTitle?.value == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_PositionTitle: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_PositionTitle",
      //     msg: "Position Number cannot be blank",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_PositionTitle: "Required",
      //   });
      // }
      // if (
      //   values?.TO_Grade == "" ||
      //   values?.TO_Grade == null ||
      //   values?.TO_Grade == undefined
      // ) {
      //   infoHighLight.push({ TO_Grade: "Required" });
      //   if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
      //     infoMsgs.push({
      //       id: "TO_Grade",
      //       msg: "To Grade cannot be blank",
      //     });
      //   }
      // } else {
      //   infoHighLight.push({ TO_Grade: "Required" });
      // }
      if (
        values.FR_Step == null ||
        values.FR_Step == "" ||
        values.FR_Step == undefined
      ) {
        setFieldValue("TO_Step", values?.FR_Step);
      }

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "9") {
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      // user input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "10") {
      // System Generated
      // setSysGenHighlight([
      //   { TermDate: "Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // From fields can not be edited in separations NOA
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_PositionTitle",
      //     msg: "From Position cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }

      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "11") {
      // if (
      //   values.EffDate !== undefined &&
      //   values.EffDate !== null &&
      //   values.EffDate !== ""
      // ) {
      //   gp_makeincrem();
      // }

      /***** New */
      //system generated set values

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "To Position Title cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }
      // if (
      //   values?.TO_Step !== "" ||
      //   values?.TO_Step !== null ||
      //   values?.TO_Step !== undefined
      // ) {
      //   if (parseInt(values?.TO_Step) > parseInt(values?.FR_Step)) {
      //     ShowError("To Step Must be Smaller then From Step");
      //   }
      // }

      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }
        let stepToCheck =
          CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade
            ? parseInt(values?.FR_Step) - 1
            : parseInt(values?.FR_Step) - 1;
        let DecrementedSalaryItem = StepDecrement(stepToCheck);
        // let DecrementedSalaryItem = StepDecrement(
        //   parseInt(values?.FR_Step) - 1
        // );
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      }

      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }

    if (nature_code == "12") {
      // User  Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values.TO_Grade == null ||
        values.TO_Grade == "" ||
        values.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Requierd",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be the blank",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Requierd",
        });
      }

      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }

      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }
        // let stepToCheck = CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade ? parseInt(values?.FR_Step) : parseInt(values?.FR_Step) - 1;
        // let DecrementedSalaryItem = StepDecrement(stepToCheck);
        let DecrementedSalaryItem = StepDecrement(parseInt(values?.FR_Step));
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "13") {
      /***** New */

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
        //   infoMsgs.push({
        //     id: "TO_Grade",
        //     msg: "Grade cannot be blank.",
        //   });
        // }
      } else {
        // infoHighLight.push({ TO_Grade: "Required" });
        // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") == -1) {
        //   infoMsgs.push({
        //     id: "TO_Grade",
        //     msg: "Grade cannot be blank.",
        //   });
        // }
      }
      if (
        values.TO_PositionTitle?.value == undefined ||
        values.TO_PositionTitle?.value == "" ||
        values.TO_PositionTitle?.value == null
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO_PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }

      // if (
      //   values?.TO_Step !== "" ||
      //   values?.TO_Step !== null ||
      //   values?.TO_Step !== undefined
      // ) {
      //   if (parseInt(values?.TO_Step) > parseInt(values?.FR_Step)) {
      //     ShowError("To Step Must be Smaller then From Step");
      //   }
      // }
      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }

        // let DecrementedSalaryItem = StepDecrement(
        //   parseInt(values?.FR_Step) - 1
        // );
        // let stepToCheck = CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade ? parseInt(values?.FR_Step) : parseInt(values?.FR_Step) - 1;
        // let DecrementedSalaryItem = StepDecrement(stepToCheck);
        let DecrementedSalaryItem = StepDecrement(parseInt(values?.FR_Step));
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }

    if (nature_code == "14") {
      // System Genrated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      //  User Input

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "15") {
      // setSysGenHighlight([
      // { natureCode: "natureCode" },
      // {
      //   LegalAuthority: "LegalAuthority is Required",
      // },
      // { ActionDate: "Action Date Required" },
      // { Term_Date: "Term Date Required" },
      // { Payroll_Date: "Next Increment Date cannot be blank." },
      // { Final_Post: "Required" },
      // { Posting_Date: "Required" },
      // { Posting_Flag: "Required" },
      // { NatureOf: "NatureOf" },
      // ]);

      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }
      if (CheckValue(values?.EffDate)) {
        setFieldValue("Term_Date", values?.EffDate);
      }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Optional" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Optional" });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "From Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "From Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "16") {
      // if (
      //     values?.EffDate == null ||
      //     values?.EffDate == "" ||
      //     values?.EffDate == undefined
      //   ) {
      //     infoHighLight.push({
      //       EffDate: "Eff Date cannot be blank.",
      //     });
      //     infoMsgs.push({
      //       id: "EffDate",
      //       msg: "Eff Date cannot be the blank",
      //     });
      //   }else {
      //     infoHighLight.push({
      //       EffDate: "Eff Date cannot be blank.",
      //     });
      //   }

      if (CheckValue(values?.EffDate)) {
        setFieldValue("Term_Date", values?.EffDate);
      }
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_PositionTitle",
      //     msg: "From Position cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "From Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "From Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      // { ActionDate: "ActionDate" },
      // { Final_Post: "Required" },
      // { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      // { FR_NAME_FIRST: "FR_NAME_FIRST" },
      // { FR_FTE_Number: "FR_FTE_Number" },
      // { FR_NAME_LAST: "FR_NAME_LAST" },
      // { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      // { FR_Grade: "FR_Grade" },
      // { FR_PositionTitle: "FR_PositionTitle" },
      // { FR_Rate: "FR_Rate" },
      // { FR_Salary: "FR_Salary" },
      // { FR_Step: "FR_Step" },
      // { LegalAuthority: "LegalAuthority" },
      // { natureCode: "natureCode" },
      // { Payroll_Date: "Payroll_Date" },
      // { Posting_Date: "required" },
      // { Posting_Flag: "Required" },
      // { Term_Date: "Term_Date" },
      // { NatureOf: "NatureOf" },
      // ]);
    }

    if (nature_code == "17") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Action Date Required" },
      // ]);

      // Auto Populate from Master

      // User Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        CheckValue(values?.EffDate) &&
        CheckValue(values?.EmploymentDate) &&
        moment(values?.EffDate).isBefore(moment(values?.EmploymentDate))
      ) {
        infoMsgs.push({
          id: "Eff_Date",
          msg: `Effective Date can not be prior to the Employment Date(${moment(
            values?.EmploymentDate
          ).format("MM/DD/YYYY")}).`,
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "18") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Term_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);

      // User Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "19") {
      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "EFf Date is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     EffDate: "Required",
      //   });
      // }
      // ShowSucess("Nature of Action 19 - Meritorious Increment is OBSOLETE.");
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "20") {
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { Term_Date: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }

      if (
        values.EffDate != undefined &&
        values.EffDate != "" &&
        values.EffDate != null
      ) {
        if (
          values?.Employment_Duration > 0 &&
          (values?.Employment_Duration_Type?.label == "Months" ||
            values?.Employment_Duration_Type?.label == "Years")
        ) {
          setFieldValue(
            "Term_Date",
            moment(values?.EffDate)
              .subtract(1, "days")
              .add(
                values?.Employment_Duration,
                `${values?.Employment_Duration_Type?.label?.toLowerCase()}`
              )
              .format("MM/DD/YYYY")
          );
        } else {
          setFieldValue(
            "Term_Date",
            moment(values?.EffDate)
              .add(
                values?.Employment_Duration,
                `${values?.Employment_Duration_Type?.label?.toLowerCase()}`
              )
              .format("MM/DD/YYYY")
          );
        }
      } else {
        setFieldValue("Term_Date", null);
      }

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          // infoMsgs.push({
          //   id: "TO_Grade",
          //   msg: "Grade cannot be blank.",
          // });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          // infoMsgs.push({
          //   id: "TO_Step",
          //   msg: "Step cannot be blank.",
          // });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
        // infoMsgs.push({
        //   id: "TO_Salary",
        //   msg: "Salary cannot be blank (Salary is set by contract).",
        // });
      } else {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values.EMP_Contract_NO == undefined ||
        values.EMP_Contract_NO == "" ||
        values.EMP_Contract_NO == null
      ) {
        infoHighLight.push({
          EMP_Contract_NO: "Required",
        });
        infoMsgs.push({
          id: "EMP_Contract_NO",
          msg: "Employee Contract no is Required",
        });
      } else {
        infoHighLight.push({
          EMP_Contract_NO: "Required",
        });
      }
      if (
        values?.Employment_Duration == undefined ||
        values?.Employment_Duration == "" ||
        values?.Employment_Duration == null
      ) {
        infoHighLight.push({
          Employment_Duration: "Required",
        });
      } else {
        infoHighLight.push({
          Employment_Duration: "Required",
        });
      }
      if (
        values?.Employment_Duration_Type == undefined ||
        values?.Employment_Duration_Type == "" ||
        values?.Employment_Duration_Type == null
      ) {
        infoHighLight.push({
          Employment_Duration_Type: "Required",
        });
      } else {
        infoHighLight.push({
          Employment_Duration_Type: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      // let _empl_days_count = values?._empl_days_count;
      // let _DP1 = values?.DP1;
      // if (
      //   values._empl_days_count == null ||
      //   values._empl_days_count == "" ||
      //   values._empl_days_count == undefined
      // ) {
      // }
      // if (_DP1 == "CD" || _DP1 == "WD") {
      // }
      // let $1 = 0;
      // let empl_days_count = parseFloat(values?._empl_days_count);

      // if (_DP1 == "M") {
      //   $1 = empl_days_count;
      // }
      // if (_DP1 == "Y") {
      //   $1 = empl_days_count * 12;
      // }
      // let actn_eff_date =
      //   values?.EffDate !== undefined && values.EffDate !== null
      //     ? values.EffDate
      //     : moment().format();
      // if (actn_eff_date != null) {
      //   let term_date = moment(actn_eff_date).add($1, "months");
      //   term_date = moment(term_date).add(-1, "days");

      //   values.Term_Date = moment(term_date).format("MM-DD-YYYY");
      // }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
    }

    if (nature_code == "21") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);

      // Auto populate from master

      // User Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "22") {
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });

        // let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
        // if (_res[0] == "1" && _res[1] == "1") {
        //   let grade_from_position = _res[2]?.trim();
        //   values.TO_Grade = grade_from_position;

        //   let _FromGrade = values.FR_Grade;
        //   if (grade_from_position >= _FromGrade) {
        //   }
        // } else {
        // }
      }

      // if (values?.FR_PositionTitle?.value == values?.TO_PositionTitle?.value) {
      //   infoHighLight.push({
      //     TO_PositionTitle: "Position Number must change!",
      //   });
      //   infoMsgs.push({
      //     id: "TO_PositionTitle",
      //     msg: "To Position Number must be changed!",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "23") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_NAME_LAST == null ||
        values?.TO_NAME_LAST == "" ||
        values?.TO_NAME_LAST == undefined
      ) {
        infoHighLight.push({
          TO_NAME_LAST: "Required",
        });
        infoMsgs.push({
          id: "TO_NAME_LAST",
          msg: "To Last Name is Required",
        });
      } else {
        infoHighLight.push({
          TO_NAME_LAST: "Required",
        });
      }
      if (
        values?.TO_NAME_FIRST == null ||
        values?.TO_NAME_FIRST == "" ||
        values?.TO_NAME_FIRST == undefined
      ) {
        infoHighLight.push({
          TO_NAME_FIRST: "Required",
        });
        infoMsgs.push({
          id: "TO_NAME_FIRST",
          msg: "To Last Name is Required",
        });
      } else {
        infoHighLight.push({
          TO_NAME_FIRST: "Required",
        });
      }
      if (
        values?.TO_NAME_MIDDLE == null ||
        values?.TO_NAME_MIDDLE == "" ||
        values?.TO_NAME_MIDDLE == undefined
      ) {
        infoHighLight.push({
          TO_NAME_MIDDLE: "Required",
        });
        infoMsgs.push({
          id: "TO_NAME_MIDDLE",
          msg: "To Middle Name is Required",
        });
      } else {
        infoHighLight.push({
          TO_NAME_MIDDLE: "Required",
        });
      }

      //auto populate
      // if (
      //   values?.TO_Dept_Div_Sec?.value == undefined ||
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null
      // ) {
      //   setFieldValue("TO_Dept_Div_Sec", values.FR_Dept_Div_Sec);
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        setFieldValue("TO_Department", values.FR_Department);
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        setFieldValue("TO_Division", values.FR_Division);
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        setFieldValue("TO_FTE_Number", values.FR_FTE_Number);
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        setFieldValue("TO_Grade", values.FR_Grade);
      }
      if (
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        setFieldValue("TO_PositionTitle", values.FR_PositionTitle);
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        setFieldValue("TO_Rate", values.FR_Rate);
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        setFieldValue("TO_Salary", values.FR_Salary);
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        setFieldValue("TO_Step", values.FR_Step);
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        // optionalMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // })
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "24") {
      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   // setFieldValue("TO_Step", "01");
      //   infoMsgs.push({
      //     id: "TO_Step",
      //     msg: "TO Step value must be 1.",
      //   });
      // }
      // User Input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE Number cannot be the blank",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Step cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.Term_Date == null ||
        values?.Term_Date == "" ||
        values?.Term_Date == undefined
      ) {
        infoHighLight.push({
          Term_Date: "Required",
        });
        // infoMsgs.push({
        //   id: "Term_Date",
        //   msg: "TO Rate is Required",
        // });
      } else {
        infoHighLight.push({
          Term_Date: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
      // if (
      //   values.TO_Salary == "" ||
      //   values.TO_Salary == null ||
      //   values.TO_Salary == undefined
      // ) {
      //   infoHighLight.push({ TO_Salary: "Salary cannot be blank." });
      //   infoMsgs.push({
      //     id: "TO_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Salary: "Salary cannot be blank" });

      //   let floatToSalary = parseFloat(values.TO_Salary);
      //   let floatToRate = floatToSalary / 2080;
      //   floatToRate = floatToRate.toFixed(2);
      //   values.TO_Rate = floatToRate;
      //   setFieldValue("TO_Rate", floatToRate);
      // }
      // let _deptFirstTwoChar = "";

      // if (
      //   values?.TO_Dept_Div_Sec?.value == undefined ||
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null
      // ) {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "required" });
      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Department/Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "required" });

      //   let _deptFirstTwoChar = values?.TO_Dept_Div_Sec?.value
      //     .toString()
      //     .substring(0, 2);
      //   if (_deptFirstTwoChar != "02" && _deptFirstTwoChar != "28") {
      //   }
      // }

      // // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Required" },
      //   { Final_Post: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "Required",
      //   },
      //   { natureCode: "Required" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Required" },
      //   { TO_Salary: "Required" },
      // ]);
    }
    if (nature_code == "25") {
      // System Generated
      setSysGenHighlight([
        // { ActionDate: "Action Date Required" },
        // { Final_Post: "Required" },
        // { FR_Dept_Div_Sec: "Required" },
        // { FR_NAME_FIRST: "Required" },
        // { FR_FTE_Number: "Required" },
        // { FR_NAME_LAST: "Required" },
        // { FR_NAME_MIDDLE: "Required" },
        // { FR_Grade: "Required" },
        // { FR_PositionTitle: "Required" },
        // { FR_Rate: "Required" },
        // { FR_Salary: "Required" },
        // { FR_Step: "Required" },
        // {
        //   LegalAuthority: "LegalAuthority is Required",
        // },
        // { natureCode: "natureCode" },
        // { Next_INCR_date: "Term Date Required" },
        // { Payroll_Date: "Required" },
        // { Posting_Date: "Required" },
        // { Posting_Flag: "Required" },
        // { Probation_Date: "Required" },
        // { TO_Salary: "Required" },
        // { NatureOf: "NatureOf" },
      ]);

      // Auto Populate from Master

      // if (
      //   values?.EffDate != null &&
      //   values?.EffDate != undefined &&
      //   values?.EffDate != ""
      // ) {
      //   values.Next_INCR_date =
      //     moment(values.EffDate).add(12, "months").format("MM/DD/YYYY") || null;
      // }
      // if (
      //   values.Posting_Flag == undefined ||
      //   values.Posting_Flag == "" ||
      //   values.Posting_Flag == null
      // ) {
      //   setFieldValue("Posting_Flag", "N");
      // }

      if (
        values.TO_Salary == undefined ||
        values.TO_Salary == "" ||
        values.TO_Salary == null
      ) {
        setFieldValue("TO_Salary", values.FR_Salary);
      }

      // if (
      //   values.ActionDate == undefined ||
      //   values.ActionDate == "" ||
      //   values.ActionDate == null
      // ) {
      //   setFieldValue("ActionDate", date);
      // }

      setFieldValue("TO_Step", "01");

      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });

        // infoMsgs.push({
        //   id: "Budget_Account_Number",
        //   msg: "Budget_Account_Number cannot be blank.",
        // });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });

        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_Step != 1) {
          // infoMsgs.push({
          //   id: "TO_Step",
          //   msg: "To Step must be 1.",
          // });
          setFieldValue("TO_Step", "01");
        }
      }

      // if (
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == "N/A" ||
      //   values?.TO_Dept_Div_Sec?.value == null ||
      //   values?.TO_Dept_Div_Sec?.value == undefined
      // ) {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Dept/Div section cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }

      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        infoMsgs.push({
          id: "TO_Salary",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);
    }

    if (nature_code == "26") {
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { TO_Step: "Rewuired" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   { TO_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      // Auto Populate from Master
      // if (
      //   values.ActionDate == undefined ||
      //   values.ActionDate == "" ||
      //   values.ActionDate == null
      // ) {
      //   setFieldValue("ActionDate", Todaydate);
      // }
      // if (
      //   values.Payroll_Date == undefined ||
      //   values.Payroll_Date == "" ||
      //   values.Payroll_Date == null
      // ) {
      //   setFieldValue("Payroll_Date", Todaydate);
      // }

      // if (
      //   values.Posting_Date == undefined ||
      //   values.Posting_Date == "" ||
      //   values.Posting_Date == null
      // ) {
      //   setFieldValue("Posting_Date", Todaydate);
      // }

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }

      // if (
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null ||
      //   values?.TO_Dept_Div_Sec?.value == undefined
      // ) {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Dept/Div section cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }

      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        // if (
        //   values.TO_Step == undefined ||
        //   values.TO_Step == "" ||
        //   values.TO_Step == null
        // ) {
        //   infoHighLight.push({
        //     TO_Step: "To step cannot be blank.",
        //   });
        //   infoMsgs.push({
        //     id: "TO_Step",
        //     msg: "To step cannot be blank.",
        //   });
        // }
      }
      if (
        values.TO_Step == undefined ||
        values.TO_Step == "" ||
        values.TO_Step == null
      ) {
        infoHighLight.push({
          TO_Step: "To step cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "To step cannot be blank." });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "27") {
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "28") {
      if (values?.TO_Step != 1) {
        // ShowError("TO Step value must be 1.");
        setFieldValue("TO_Step", "01");
      }
      // System Generated
      setSysGenHighlight([
        // { TermDate: "Required" },
        // { FR_Dept_Div_Sec: "Required" },
        // { FR_NAME_FIRST: "Required" },
        // { FR_FTE_Number: "Required" },
        // { FR_NAME_LAST: "Required" },
        // { FR_NAME_MIDDLE: "Required" },
        // { FR_Grade: "Required" },
        // { FR_PositionTitle: "Required" },
        // { FR_Rate: "Required" },
        // { FR_Salary: "Required" },
        // { FR_Step: "Required" },
        // {
        //   LegalAuthority: "LegalAuthority is Required",
        // },
        // { Next_INCR_date: "Required" },
        // { Payroll_Date: "Required" },
        // { Posting_Date: "Required" },
        // { Posting_Flag: "Required" },
        // { natureCode: "required" },
        // { NatureOf: "NatureOf" },
      ]);

      // if (
      //   values.Term_Date !== undefined ||
      //   values.Term_Date !== "" ||
      //   values.Term_Date !== null
      // ) {
      //   setFieldValue("Term_Date", null);
      // }

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "Step cannot be blank.",
          });
        }
        // if (values?.TO_Step != 1) {
        //   // ShowError("TO Step value must be 1.");
        //   setFieldValue("TO_Step", "01");
        // }
      } else {
        infoHighLight.push({ TO_Step: "Required" });

        // if (parseInt(values?.TO_Step) > 10) {
        //   ShowError("To Step Must be Smaller then 10");
        // }
        // if (parseInt(values?.TO_Step) < 10) {
        //   setFieldValue("Next_INCR_date", null);
        // }
        // // setFieldValue("TO_Step", "10");
        // if (parseInt(values?.TO_Step) == 10) {
        //   var startdate = values?.EffDate;
        //   var newDate = moment(startdate).add(2, "years").format("MM/DD/YYYY");
        //   setFieldValue("Next_INCR_date", newDate);
        // }

        // if (values?.TO_Step != 1) {
        //   // ShowError("TO Step value must be 1.");
        //   setFieldValue("TO_Step", "01");
        // }
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        // infoHighLight.push({ TO_Salary: "Required" });
        // setFieldValue("TO_Step", null);

        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }


      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        // infoMsgs.push({
        //   id: "TO_Salary",
        //   msg: "Salary cannot be blank.",
        // });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }

      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
        // let salVal = values?.TO_Salary;
        // if (salVal !== "" && salVal !== null && salVal !== undefined) {
        //   let ans = Math.round(salVal / 2080);
        //   setFieldValue("TO_Rate", ans);
        // }
        // // To_Rate = To_Salary/2080
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "To Position cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      // if (
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == "N/A" ||
      //   values?.TO_Dept_Div_Sec?.value == undefined ||
      //   values?.TO_Dept_Div_Sec?.value == null
      // ) {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Department/Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Select Department.",
      //   });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      console.log("123123 :: ", values?.TO_Division)
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }

      // if (
      //   values?.Final_Post == "" ||
      //   values?.Final_Post == undefined ||
      //   values?.Final_Post == null
      // ) {
      //   setShowField({
      //     ...showField,
      //     EMP_Contract_NO: false,
      //   });
      // }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      // setOptionalMessages(optionalMsgs);
    }

    if (nature_code == "29") {
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "30") {
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   infoMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "FTE cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }

      // if (
      //   values?.TO_Step == "" ||
      //   values?.TO_Step == null ||
      //   values?.TO_Step == undefined
      // ) {
      //   infoHighLight.push({ TO_Step: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Step: "Required" });
      // }
      // if (
      //   values?.TO_Rate == "" ||
      //   values?.TO_Rate == null ||
      //   values?.TO_Rate == undefined
      // ) {
      //   infoHighLight.push({ TO_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Rate",
      //     msg: "TO Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Rate: "Required" });
      // }

      // if (
      //   values?.TO_Salary == "" ||
      //   values?.TO_Salary == null ||
      //   values?.TO_Salary == undefined
      // ) {
      //   infoHighLight.push({ TO_Salary: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Salary",
      //     msg: "TO Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Salary: "Required" });
      // }

      // if (
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == "N/A" ||
      //   values?.TO_Dept_Div_Sec?.value == null ||
      //   values?.TO_Dept_Div_Sec?.value == undefined
      // ) {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Dept/Div section cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Dept_Div_Sec: "Required" });
      // }
      // if (
      //   values?.TO_PositionTitle?.value == undefined ||
      //   values?.TO_PositionTitle?.value == "" ||
      //   values?.TO_PositionTitle?.value == null
      // ) {
      //   infoHighLight.push({
      //     TO_PositionTitle: "Position Number cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_PositionTitle",
      //     msg: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_PositionTitle: "Position Number cannot be blank",
      //   });
      // }

      if (
        values.EffDate !== undefined &&
        values.EffDate !== null &&
        values.EffDate !== ""
      ) {
        gp_makeincrem();
      }

      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        let ToNewStep = parseInt(values?.FR_Step) + 1;
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      // if (
      //   values?.Evalution_Type?.value == "" ||
      //   values?.Evalution_Type?.value == null ||
      //   values?.Evalution_Type?.value == undefined
      // ) {
      //   infoHighLight.push({ Evalution_Type: "Required" });
      //   infoMsgs.push({
      //     id: "Evalution_Type",
      //     msg: "Evaluation Type is required.",
      //   });

      // } else {
      //   infoHighLight.push({ Evalution_Type: "Required" });
      // }
      // if (
      //   values?.Evalution_Type?.label == "" ||
      //   values?.Evalution_Type?.label == null ||
      //   values?.Evalution_Type?.label == undefined
      // ) {
      //   infoHighLight.push({ Evalution_Type: "Required" });
      //   infoMsgs.push({
      //     id: "Evalution_Type",
      //     msg: "Evaluation Type is required.",
      //   });

      // } else {
      //   infoHighLight.push({ Evalution_Type: "Required" });
      // }
      if (
        values?.Evalution_Type?.value == "" ||
        values?.Evalution_Type?.value == null ||
        values?.Evalution_Type?.value == undefined
      ) {
        infoHighLight.push({
          Evalution_Type: "Evaluation Type Cannot be blank.",
        });
        infoMsgs.push({
          id: "Evalution_Type",
          msg: "Evaluation Type Cannot be blank.",
        });
      } else {
        infoHighLight.push({
          Evalution_Type: "Evaluation Type Cannot be blank.",
        });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Required" },
      //   { LegalAuthority: "LegalAuthority is Required" },
      //   { natureCode: "Required" },
      //   // { NatureOf: "Required" },
      //   { Next_INCR_date: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      //   { TO_Rate: "Required" },
      //   { TO_Salary: "Required" },
      // ]);

      // if (
      //   values.FR_Step == undefined ||
      //   values.FR_Step == "" ||
      //   values.FR_Step == null
      // ) {
      // } else {
      //   let ToNewStep = parseInt(values?.FR_Step) + 1;
      //   setFieldValue("TO_Step", ToNewStep);
      // }
    }

    if (nature_code == "31") {
      // User Input
      if (
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        // if(!SeparationNOAs.includes(amendedNOA)){
        //   infoMsgs.push({
        //     id: "TO_Department",
        //     msg: "To Department cannot be blank.",
        //   });
        // }
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        // if(!SeparationNOAs.includes(amendedNOA)){
        //   infoMsgs.push({
        //     id: "TO_Division",
        //     msg: "To Division cannot be blank.",
        //   });
        // }
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        // if (!SeparationNOAs.includes(amendedNOA) && values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
        //   infoMsgs.push({
        //     id: "TO_Grade",
        //     msg: "To Grade cannot be blank",
        //   });
        // }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        // if (!SeparationNOAs.includes(amendedNOA) && values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
        //   infoMsgs.push({
        //     id: "TO_Step",
        //     msg: "TO_Step cannot be blank.",
        //   });
        // }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        // if(!SeparationNOAs.includes(amendedNOA)){
        //   infoMsgs.push({
        //     id: "TO_Rate",
        //     msg: "TO Rate is Required",
        //   });
        // }
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        // if(!SeparationNOAs.includes(amendedNOA)){
        //   infoMsgs.push({
        //     id: "TO_Salary",
        //     msg: "TO Salary is Required",
        //   });
        // }
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }

      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
        // if(!SeparationNOAs.includes(amendedNOA)){
        //   infoMsgs.push({
        //     id: "TO_PositionTitle",
        //     msg: "Position Number cannot be blank.",
        //   });
        // }
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
      }

      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });

        // optionalMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // })
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }

      if (amendmentPerformed) {
        // if (CheckValue(values?.FR_Department?.value) == false)
        if (CheckValue(values?.FR_Department?.label) == false) {
          infoHighLight.push({
            FR_Department: "Select Department.",
          });
          // infoMsgs.push({
          //   id: "FR_Department",
          //   msg: "From Department cannot be blank.",
          // });
        } else {
          infoHighLight.push({
            FR_Department: "Select Department.",
          });
        }
        // if (CheckValue(values?.FR_Division?.value) == false)
        if (CheckValue(values?.FR_Division?.label) == false) {
          infoHighLight.push({
            FR_Division: "Select Division.",
          });
          // infoMsgs.push({
          //   id: "FR_Division",
          //   msg: "From Division cannot be blank.",
          // });
        } else {
          infoHighLight.push({
            FR_Division: "Select Division.",
          });
        }
        if (CheckValue(values?.FR_Grade) == false) {
          infoHighLight.push({ FR_Grade: "Required" });
          // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          //   infoMsgs.push({
          //     id: "FR_Grade",
          //     msg: "From Grade cannot be blank",
          //   });
          // }
        } else {
          infoHighLight.push({ FR_Grade: "Required" });
        }

        if (CheckValue(values?.FR_Step) == false) {
          infoHighLight.push({ FR_Step: "Required" });
          // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          //   infoMsgs.push({
          //     id: "FR_Step",
          //     msg: "From Step cannot be blank.",
          //   });
          // }
        } else {
          infoHighLight.push({ FR_Step: "Required" });
        }
        if (CheckValue(values?.FR_Rate) == false) {
          infoHighLight.push({
            FR_Rate: "Required",
          });
          // infoMsgs.push({
          //   id: "FR_Rate",
          //   msg: "From Rate is Required",
          // });
        } else {
          infoHighLight.push({
            FR_Rate: "Required",
          });
        }
        if (CheckValue(values?.FR_Salary) == false) {
          infoHighLight.push({
            FR_Salary: "Required",
          });
          // infoMsgs.push({
          //   id: "FR_Salary",
          //   msg: "From Salary is Required",
          // });
        } else {
          infoHighLight.push({
            FR_Salary: "Required",
          });
        }
        if (CheckValue(values?.FR_PositionTitle?.value) == false) {
          infoHighLight.push({
            FR_PositionTitle: "Position Number cannot be blank.",
          });
          // infoMsgs.push({
          //   id: "FR_PositionTitle",
          //   msg: "From Position Title cannot be blank.",
          // });
        } else {
          infoHighLight.push({
            FR_PositionTitle: "Position Number cannot be blank.",
          });
        }
        infoHighLight.push({ FR_FTE_Number: "Required" });
      }

      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "32") {
      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }
      if (
        values.FR_Step == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null
      ) {
      } else {
        // let ToNewStep = parseInt(values?.FR_Step) + 2;
        let IncrementedSalaryItem = StepIncrement(
          parseInt(values?.FR_Step) + 2
        );
        let ToNewStep = IncrementedSalaryItem
          ? parseInt(IncrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) + 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);

      // validation
      // if (
      //   values?.EffDate != null &&
      //   values?.EffDate != undefined &&
      //   values?.EffDate != ""
      // ) {
      //   values.Next_INCR_date = moment(values.EffDate)
      //     .add(12, "months")
      //     .format("MM/DD/YYYY");
      // }

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO FTE Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      // if (
      //   values?.TO_Rate == null ||
      //   values?.TO_Rate == "" ||
      //   values?.TO_Rate == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Rate: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Rate",
      //     msg: "TO Rate is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Rate: "Required",
      //   });
      // }
      // if (
      //   values?.TO_Salary == null ||
      //   values?.TO_Salary == "" ||
      //   values?.TO_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Salary: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Salary",
      //     msg: "TO Salary is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Salary: "Required",
      //   });
      // }
      // if (
      //   values?.TO_Step == null ||
      //   values?.TO_Step == "" ||
      //   values?.TO_Step == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Step: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Step",
      //     msg: "TO Step is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Step: "Required",
      //   });
      // }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "33") {
      /***** New */

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
        // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") == -1) {
        //   infoMsgs.push({
        //     id: "TO_PositionTitle",
        //     msg: "You can not do Transfer Demotion with Unclassified Position, please select Classified Position.",
        //   });
        // }
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_Step !== "" ||
        values?.TO_Step !== null ||
        values?.TO_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   ShowError("To Step Must be Smaller then From Step");
        // }
      }
      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }

        // let DecrementedSalaryItem = StepDecrement(
        //   parseInt(values?.FR_Step) - 1
        // );
        // let stepToCheck = CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade ? parseInt(values?.FR_Step) : parseInt(values?.FR_Step) - 1;
        // let DecrementedSalaryItem = StepDecrement(stepToCheck);
        let DecrementedSalaryItem = StepDecrement(parseInt(values?.FR_Step));
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }

      if (!CheckForHigherGrade("Demotion")) {
        console.log("121212 Demotion::: ", values?.TO_Grade);
        infoMsgs.push({
          id: "TO_Grade",
          msg: "To Position and Grade must be lower than the from values for Transfer Demotion.",
        });
      } else {
        if (values?.TO_Salary > values?.FR_Salary) {
          infoMsgs.push({
            id: "TO_Salary",
            msg: "The To Salary must be less than the From Salary.",
          });
        }
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }

    if (nature_code == "34") {
      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      // if (
      //   values.TO_Grade == "" ||
      //   values.TO_Grade == null ||
      //   values.TO_Grade == undefined
      // ) {
      //   infoHighLight.push({ TO_Grade: "Required" });
      //   infoHighLight.push({ TO_Step: "Required" });
      //   infoHighLight.push({ TO_Salary: "Required" });

      //   infoMsgs.push({
      //     id: "TO_Grade",
      //     msg: "TO Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_Grade: "Required" });
      // }
      if (
        values.TO_Step == "" ||
        values.TO_Step == null ||
        values.TO_Step == undefined
      ) {
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoHighLight.push({ TO_Step: "Required" });
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step cannot be blank.",
          });
        } else {
          infoHighLight.push({ TO_Rate: "Required" });
          if (!CheckValue(values?.TO_Rate)) {
            infoMsgs.push({
              id: "TO_Rate",
              msg: "TO Rate cannot be blank.",
            });
          }
          infoHighLight.push({ TO_Salary: "Required" });
          if (!CheckValue(values?.TO_Salary)) {
            infoMsgs.push({
              id: "TO_Salary",
              msg: "TO Salary cannot be blank.",
            });
          }
        }
      } else {
        if (
          values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1 &&
          CheckValue(values?.TO_Grade)
        ) {
          infoHighLight.push({ TO_Step: "Required" });
        } else {
          infoHighLight.push({ TO_Rate: "Required" });
          if (!CheckValue(values?.TO_Rate)) {
            infoMsgs.push({
              id: "TO_Rate",
              msg: "TO Rate cannot be blank.",
            });
          }
          infoHighLight.push({ TO_Salary: "Required" });
          if (!CheckValue(values?.TO_Salary)) {
            infoMsgs.push({
              id: "TO_Salary",
              msg: "TO Salary cannot be blank.",
            });
          }
        }
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority is Required" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "35") {
      /***** New */

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      // if (
      //   values?.TO_Grade == null ||
      //   values?.TO_Grade == "" ||
      //   values?.TO_Grade == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Grade: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Grade",
      //     msg: "TO Grade is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Grade: "Required",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "36") {
      // auto popoulate from Master

      // user input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_PositionTitle == null ||
        values?.TO_PositionTitle == "" ||
        values?.TO_PositionTitle == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        infoHighLight.push({ TO_Salary: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO_Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      /****** For duration of contract extention - Extension of Contract */
      if (
        values.EffDate != undefined &&
        values.EffDate != "" &&
        values.EffDate != null
      ) {
        if (
          values?.Employment_Duration > 0 &&
          (values?.Employment_Duration_Type?.label == "Months" ||
            values?.Employment_Duration_Type?.label == "Years")
        ) {
          setFieldValue(
            "Term_Date",
            moment(values?.EffDate)
              .subtract(1, "days")
              .add(
                values?.Employment_Duration,
                `${values?.Employment_Duration_Type?.label?.toLowerCase()}`
              )
              .format("MM/DD/YYYY")
          );
        } else {
          setFieldValue(
            "Term_Date",
            moment(values?.EffDate)
              .add(
                values?.Employment_Duration,
                `${values?.Employment_Duration_Type?.label?.toLowerCase()}`
              )
              .format("MM/DD/YYYY")
          );
        }
      } else {
        setFieldValue("Term_Date", null);
      }

      if (
        values.EMP_Contract_NO == undefined ||
        values.EMP_Contract_NO == "" ||
        values.EMP_Contract_NO == null
      ) {
        infoHighLight.push({
          EMP_Contract_NO: "Required",
        });
        infoMsgs.push({
          id: "EMP_Contract_NO",
          msg: "Employee Contract no is Required",
        });
      } else {
        infoHighLight.push({
          EMP_Contract_NO: "Required",
        });
      }
      if (
        values?.Employment_Duration == undefined ||
        values?.Employment_Duration == "" ||
        values?.Employment_Duration == null
      ) {
        infoHighLight.push({
          Employment_Duration: "Required",
        });
      } else {
        infoHighLight.push({
          Employment_Duration: "Required",
        });
      }
      if (
        values?.Employment_Duration_Type == undefined ||
        values?.Employment_Duration_Type == "" ||
        values?.Employment_Duration_Type == null
      ) {
        infoHighLight.push({
          Employment_Duration_Type: "Required",
        });
      } else {
        infoHighLight.push({
          Employment_Duration_Type: "Required",
        });
      }

      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "37") {
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      // if (
      //   values?.TO_PositionTitle?.value == "" ||
      //   values?.TO_PositionTitle?.value == null ||
      //   values?.TO_PositionTitle?.value == undefined
      // ) {
      //   infoHighLight.push({ TO_PositionTitle: "Required" });

      //   infoMsgs.push({
      //     id: "TO_PositionTitle",
      //     msg: "TO PositionTitle cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ TO_PositionTitle: "Required" });
      // }
      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date is required.",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "38") {
      /****** New */
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
      //sys generated

      if (values?.TO_Step != 1) {
        // ShowError("TO Step value must be 1.");
        setFieldValue("TO_Step", "01");
      }
      if (
        values?.Term_Date == null ||
        values?.Term_Date == "" ||
        values?.Term_Date == undefined
      ) {
        infoHighLight.push({
          Term_Date: "Required",
        });
        // infoMsgs.push({
        //   id: "Term_Date",
        //   msg: "TO Rate is Required",
        // });
      } else {
        infoHighLight.push({
          Term_Date: "Required",
        });
      }
      if (
        values.EffDate != undefined &&
        values.EffDate != "" &&
        values.EffDate != null
      ) {
        setFieldValue(
          "Term_Date",
          moment(values?.EffDate)
            .subtract(1, "days")
            .add(1, "years")
            .format("MM/DD/YYYY")
        );
      }
      setFieldValue("Next_INCR_date", null);
      // else {
      //   setFieldValue("Term_Date", null);
      // }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE Number cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });

        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle == "" ||
        values?.TO_PositionTitle == null ||
        values?.TO_PositionTitle == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "To PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        infoMsgs.push({
          id: "TO_Salary",
          msg: "To Step cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.FR_NAME_LAST == "" ||
        values?.FR_NAME_LAST == null ||
        values?.FR_NAME_LAST == undefined
      ) {
        infoHighLight.push({ FR_NAME_LAST: "Required" });
      } else {
        infoHighLight.push({ FR_NAME_LAST: "Required" });
      }
      if (
        values?.FR_NAME_FIRST == "" ||
        values?.FR_NAME_FIRST == null ||
        values?.FR_NAME_FIRST == undefined
      ) {
        infoHighLight.push({ FR_NAME_FIRST: "Required" });
      } else {
        infoHighLight.push({ FR_NAME_FIRST: "Required" });
      }
      if (
        values?.FR_NAME_MIDDLE == "" ||
        values?.FR_NAME_MIDDLE == null ||
        values?.FR_NAME_MIDDLE == undefined
      ) {
        infoHighLight.push({ FR_NAME_MIDDLE: "Required" });
      } else {
        infoHighLight.push({ FR_NAME_MIDDLE: "Required" });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "39") {
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "40") {
      /********** New */
      //system generated set values

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      // ]);
    }
    if (nature_code == "41") {
      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }

      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Term_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "42") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Action Date Required" },
      // ]);

      //User Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "43") {
      //   // System Generated
      //   setSysGenHighlight([
      //     { ActionDate: "Action Date Required" },
      //     { Final_Post: "Required" },
      //     { FR_Dept_Div_Sec: "Required" },
      //     { FR_NAME_FIRST: "Required" },
      //     { FR_FTE_Number: "Required" },
      //     { FR_NAME_LAST: "Required" },
      //     { FR_NAME_MIDDLE: "Required" },
      //     { FR_Grade: "Required" },
      //     { FR_PositionTitle: "Required" },
      //     { FR_Rate: "Required" },
      //     { FR_Step: "Required" },
      //     { FR_Salary: "Required" },
      //     {
      //       LegalAuthority: "LegalAuthority is Required",
      //     },
      //     { natureCode: "natureCode" },
      //     { Posting_Date: "Required" },
      //     { Payroll_Date: "Next Increment Date cannot be blank." },
      //     { Posting_Flag: "Required" },
      //   ]);
      // User Input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        setFieldValue("TO_Step", values?.FR_Step);
      }
      if (parseInt(values?.TO_Step) <= parseInt(values?.FR_Step)) {
        let newStep = parseInt(values?.FR_Step) + 1;
        let newStepStr = newStep < 10 ? `0${newStep}` : newStep;
        setFieldValue("TO_Step", newStepStr);
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "44") {
      // ShowSucess("Nature of Action 44 - 700 Hours Program is OBSOLETE.");
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "45") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Term_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "46") {
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE Number cannot be the blank",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
      }
      if (values?.TO_FTE_Number === values?.FR_FTE_Number) {
        infoMsgs.push({
          id: "TO_FTE_Number",
          msg: "To FTE Number & From FTE Number cannot be same.",
        });
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "47") {
      /******* New */
      //sys generated

      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }
      if (
        values.EffDate != undefined &&
        values.EffDate != "" &&
        values.EffDate != null
      ) {
        setFieldValue(
          "Term_Date",
          moment(values?.EffDate).add(89, "days").format("MM/DD/YYYY")
        );
      }
      // else {
      //   setFieldValue("Term_Date", null);
      // }
      if (
        values?.Term_Date == null ||
        values?.Term_Date == "" ||
        values?.Term_Date == undefined
      ) {
        infoHighLight.push({
          Term_Date: "Required",
        });
        // infoMsgs.push({
        //   id: "Term_Date",
        //   msg: "TO Rate is Required",
        // });
      } else {
        infoHighLight.push({
          Term_Date: "Required",
        });
      }
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE Number cannot be the blank",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE Number cannot be the blank",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });

        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Step cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "48") {
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Required" },
      // ]);
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "50") {
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { TO_Salary: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      // Auto Poplulate from Master

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.worK_SCH?.value == null ||
        values?.worK_SCH?.value == "" ||
        values?.worK_SCH?.value == undefined
      ) {
        infoHighLight.push({
          worK_SCH: "Required",
        });
        infoMsgs.push({
          id: "worK_SCH",
          msg: "Work status Must be Required",
        });
      } else {
        infoHighLight.push({
          worK_SCH: "Required",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "51") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (detailActionSelected) {
        if (
          values.EffDate != undefined &&
          values.EffDate != "" &&
          values.EffDate != null
        ) {
          setFieldValue(
            "Term_Date",
            moment(values?.EffDate).add(89, "days").format("MM/DD/YYYY")
          );
        }
      }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   // optionalMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "49") {
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term DAte" },
      // ]);

      // User  Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setHighlight(infoHighLight);
      setErrorHighLight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "53") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "52") {
      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO_FTE_Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO_Grade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle == null ||
        values?.TO_PositionTitle == "" ||
        values?.TO_PositionTitle == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO_PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO_Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO_Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO_Salary is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);
    }
    if (nature_code == "54") {
      if (values?.TO_Step != 1) {
        // ShowError("TO Step value must be 1.");
        setFieldValue("TO_Step", "01");
      }
      if (
        values?.TO_PositionTitle?.value == undefined ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });

        let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);
        if (_res[0] == "1" && _res[1] == "1") {
          let grade_from_position = _res[2]?.trim();
          let _to_new_grade = values?.TO_Grade?.trim();
          if (
            _to_new_grade?.trim() != "" &&
            _to_new_grade?.trim() != null &&
            _to_new_grade != grade_from_position
          ) {
            values.TO_Grade = grade_from_position;
            let to_step = "01";
            values.TO_Grade = grade_from_position;
            // values.TO_Step = to_step;
            // setFieldValue("TO_Step", "01");
            let _SalaryFilter = salaryItemsList.map((element, index) => {
              if (
                element.grade?.trim() == _to_new_grade?.trim() &&
                element.step?.trim() == values?.TO_Step
              ) {
                return element;
              }
            });

            if (_SalaryFilter?.length > 0) {
            }
          }
        } else {
        }
      }

      /***** New */
      //system generated set values
      // if (
      //   values.ActionDate == undefined ||
      //   values.ActionDate == "" ||
      //   values.ActionDate == null
      // ) {
      //   setFieldValue("ActionDate", Todaydate);
      // }
      // if (
      //   values.Payroll_Date == undefined ||
      //   values.Payroll_Date == "" ||
      //   values.Payroll_Date == null
      // ) {
      //   setFieldValue("Payroll_Date", Todaydate);
      // }
      // if (
      //   values.Posting_Date == undefined ||
      //   values.Posting_Date == "" ||
      //   values.Posting_Date == null
      // ) {
      //   setFieldValue("Posting_Date", Todaydate);
      // }
      // if (
      //   values.Term_Date == undefined ||
      //   values.Term_Date == "" ||
      //   values.Term_Date == null
      // ) {
      //   setFieldValue("Term_Date", Todaydate);
      // }
      // if (
      //   values.TO_Salary == undefined ||
      //   values.TO_Salary == "" ||
      //   values.TO_Salary == null
      // ) {
      //   setFieldValue("TO_Salary", values.FR_Salary);
      // }

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO FTE Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO PayGrade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Step is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      setOptionalMessages(optionalMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "55") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);

      // User  Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });
      //   if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
      //     infoMsgs.push({
      //       id: "FR_Grade",
      //       msg: "Grade cannot be blank.",
      //     });
      //   }
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });
      //   if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
      //     infoMsgs.push({
      //       id: "FR_Step",
      //       msg: "Step cannot be blank.",
      //     });
      //   }
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "56") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO PayGrade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      // if (
      //   values?.TO_Rate == null ||
      //   values?.TO_Rate == "" ||
      //   values?.TO_Rate == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Rate: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Rate",
      //     msg: "TO Rate is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Rate: "Required",
      //   });
      // }
      // if (
      //   values?.TO_Step == null ||
      //   values?.TO_Step == "" ||
      //   values?.TO_Step == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Step: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Step",
      //     msg: "TO Step is Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Step: "Required",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "57") {
      if (values?.TO_Step != 1) {
        // ShowError("TO Step value must be 1.");
        setFieldValue("TO_Step", "01");
      }
      // if (values.empl_type != "P") {
      // }
      /***** New */
      //system generated set values
      // if (
      //   values.ActionDate == undefined ||
      //   values.ActionDate == "" ||
      //   values.ActionDate == null
      // ) {
      //   setFieldValue("ActionDate", Todaydate);
      // }
      // if (
      //   values.Payroll_Date == undefined ||
      //   values.Payroll_Date == "" ||
      //   values.Payroll_Date == null
      // ) {
      //   setFieldValue("Payroll_Date", Todaydate);
      // }
      // if (
      //   values.Posting_Date == undefined ||
      //   values.Posting_Date == "" ||
      //   values.Posting_Date == null
      // ) {
      //   setFieldValue("Posting_Date", Todaydate);
      // }
      // if (
      //   values.TO_Salary == undefined ||
      //   values.TO_Salary == "" ||
      //   values.TO_Salary == null
      // ) {
      //   setFieldValue("TO_Salary", values.FR_Salary);
      // }

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO FTE Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO PayGrade is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }

      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Salary is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "58") {
      if (
        values.EffDate !== undefined &&
        values.EffDate !== null &&
        values.EffDate !== ""
      ) {
        gp_makeincrem();
      }
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "To Position Title cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Evalution_Type: "Evalution_Type" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { TO_Rate: "TO_Rate" },
      // ]);
    }
    if (nature_code == "59") {
      if (
        values.TO_PositionTitle == "" ||
        values.TO_PositionTitle == null ||
        values.TO_PositionTitle == null ||
        values.TO_PositionTitle == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank (Salary is set by contract).",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
      }
      // if (
      //   (values?.TO_Dept_Div_Sec?.value == undefined &&
      //     values?.TO_Dept_Div_Sec?.label == undefined) ||
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null
      // ) {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Department/Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "60") {
      // System Generated
      // setSysGenHighlight([
      //   { natureCode: "natureCode" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { ActionDate: "Action Date Required" },
      //   { Next_INCR_date: "Term Date Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { Final_Post: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);

      // User Input
      if (
        values.TO_PositionTitle == "" ||
        values.TO_PositionTitle == null ||
        values.TO_PositionTitle == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank.",
        });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });

        infoMsgs.push({
          id: "Budget_Account_Number",
          msg: "Budget_Account_Number cannot be blank.",
        });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank (Salary is set by contract).",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Salary cannot be blank (Salary is set by contract).",
        });
      }

      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
      }
      if (values.empl_type != "P") {
      }

      // if (
      //   values.EffDate != null &&
      //   values.EffDate != undefined &&
      //   values.EffDate != ""
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Required",
      //   });
      // } else {
      //   infoHighLight.push({
      //     EffDate: "Required",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "EFf Date is Required",
      //   });
      // }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "61") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);

      // User  Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }

      if (
        values?.TO_Department?.value != "" ||
        values?.TO_Department?.value != "N/A" ||
        values?.TO_Department?.value != undefined ||
        values?.TO_Department?.value != null
      ) {
        getFilteredDivisons();
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "62") {
      values.FR_PositionTitle = values?.TO_PositionTitle;
      values.FR_Grade = values?.TO_Grade;
      values.FR_Step = values.TO_Step;
      values.FR_Rate = values?.TO_Rate;
      values.FR_Salary = values?.TO_Salary;
      values.FR_FTE_Number = values?.TO_FTE_Number;

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "63") {
      if (values.empl_type != "P") {
      }

      values.FR_PositionTitle = values?.TO_PositionTitle;
      values.FR_Grade = values?.TO_Grade;
      values.FR_Step = values?.TO_Step;
      values.FR_Rate = values?.TO_Rate;
      values.FR_Salary = values?.TO_Salary;
      values.FR_FTE_Number = values?.TO_FTE_Number;

      // if (
      //   values?.TO_Dept_Div_Sec?.value == undefined ||
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null
      // ) {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Department/Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      var _toDeptKeyFirstTwoChar = values?.TO_Dept_Div_Sec?.value
        .toString()
        .substring(0, 2);
      if (
        values.FR_Dept_Div_Sec == undefined ||
        values.FR_Dept_Div_Sec == "" ||
        values.FR_Dept_Div_Sec == null
      ) {
      } else {
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    // if (nature_code == "64") {
    //   // System Generated
    //   // setSysGenHighlight([
    //   //   { ActionDate: "Action Date" },
    //   //   { Final_Post: "Final_Post" },
    //   //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
    //   //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
    //   //   { FR_FTE_Number: "FR_FTE_Number" },
    //   //   { FR_NAME_LAST: "FR_NAME_LAST" },
    //   //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
    //   //   { FR_Grade: "FR_Grade" },
    //   //   { FR_PositionTitle: "FR_PositionTitle" },
    //   //   { FR_Rate: "FR_Rate" },
    //   //   { FR_Salary: "FR_Salary" },
    //   //   { FR_Step: "FR_Step" },
    //   //   { LegalAuthority: "LegalAuthority" },
    //   //   { natureCode: "natureCode" },
    //   //   { Payroll_Date: "Payroll_Date" },
    //   //   { Posting_Date: "Posting_Date" },
    //   //   { Posting_Flag: "Posting_Flag" },
    //   // ]);

    //   // User  Input
    //   // if (
    //   //   values.EffDate == undefined ||
    //   //   values.EffDate == "" ||
    //   //   values.EffDate == null
    //   // ) {
    //   //   infoHighLight.push({
    //   //     EffDate: "Required",
    //   //   });
    //   //   infoMsgs.push({
    //   //     id: "EffDate",
    //   //     msg: "Eff Date is Required",
    //   //   });
    //   // } else {
    //   //   infoHighLight.push({
    //   //     EffDate: "Required",
    //   //   });
    //   // }
    //   if (
    //     values?.Budget_Account_Number == null ||
    //     values?.Budget_Account_Number == "" ||
    //     values?.Budget_Account_Number == undefined
    //   ) {
    //     infoHighLight.push({
    //       Budget_Account_Number: "Required",
    //     });
    //     // infoMsgs.push({
    //     //   id: "Budget_Account_Number",
    //     //   msg: "Budget Account Number is Required",
    //     // });
    //   } else {
    //     infoHighLight.push({
    //       Budget_Account_Number: "Required",
    //     });
    //   }

    //   if (
    //     values?.FR_PositionTitle?.value == "" ||
    //     values?.FR_PositionTitle?.value == null ||
    //     values?.FR_PositionTitle?.value == undefined
    //   ) {
    //     infoHighLight.push({
    //       FR_PositionTitle: "Position Number cannot be blank",
    //     });

    //     infoMsgs.push({
    //       id: "FR_PositionTitle",
    //       msg: "from Position cannot be blank",
    //     });
    //   } else {
    //     infoHighLight.push({
    //       FR_PositionTitle: "Position Number cannot be blank",
    //     });
    //   }
    //   if (
    //     values?.FR_Grade == "" ||
    //     values?.FR_Grade == null ||
    //     values?.FR_Grade == undefined
    //   ) {
    //     infoHighLight.push({ FR_Grade: "Required" });
    //     infoMsgs.push({
    //       id: "FR_Grade",
    //       msg: "Grade cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ FR_Grade: "Required" });
    //   }
    //   if (
    //     values?.FR_Rate == "" ||
    //     values?.FR_Rate == null ||
    //     values?.FR_Rate == undefined
    //   ) {
    //     infoHighLight.push({ FR_Rate: "Required" });

    //     infoMsgs.push({
    //       id: "FR_Rate",
    //       msg: "Rate cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ FR_Rate: "Required" });
    //   }
    //   if (
    //     values?.FR_Step == "" ||
    //     values?.FR_Step == null ||
    //     values?.FR_Step == undefined
    //   ) {
    //     infoHighLight.push({ FR_Step: "Required" });

    //     infoMsgs.push({
    //       id: "FR_Step",
    //       msg: "Step cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ FR_Step: "Required" });
    //   }
    //   if (
    //     values?.FR_Salary == "" ||
    //     values?.FR_Salary == null ||
    //     values?.FR_Salary == undefined
    //   ) {
    //     infoHighLight.push({ FR_Salary: "Required" });

    //     infoMsgs.push({
    //       id: "FR_Salary",
    //       msg: "Salary cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ FR_Salary: "Required" });
    //   }

    //   if (
    //     values?.FR_Department?.value == "" ||
    //     values?.FR_Department?.value == "N/A" ||
    //     values?.FR_Department?.value == undefined ||
    //     values?.FR_Department?.value == null
    //   ) {
    //     infoHighLight.push({
    //       FR_Department: "Select Department.",
    //     });
    //     infoMsgs.push({
    //       id: "FR_Department",
    //       msg: "From Department cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({
    //       FR_Department: "Select Department.",
    //     });
    //   }
    //   if (
    //     values?.FR_Division?.value == "" ||
    //     values?.FR_Division?.value == "N/A" ||
    //     values?.FR_Division?.value == undefined ||
    //     values?.FR_Division?.value == null
    //   ) {
    //     infoHighLight.push({
    //       FR_Division: "Select Division.",
    //     });
    //     infoMsgs.push({
    //       id: "FR_Division",
    //       msg: "From Division cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({
    //       FR_Division: "Select Division.",
    //     });
    //   }
    //   if (
    //     values.FR_FTE_Number == null ||
    //     values.FR_FTE_Number == "" ||
    //     values.FR_FTE_Number == undefined
    //   ) {
    //     infoHighLight.push({ FR_FTE_Number: "Required" });

    //     infoMsgs.push({
    //       id: "FR_FTE_Number",
    //       msg: "FTE position_no cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ FR_FTE_Number: "Required" });
    //   }

    //   // auto popoulate from Master
    //   if (
    //     values.ActionDate == undefined ||
    //     values.ActionDate == "" ||
    //     values.ActionDate == null
    //   ) {
    //     setFieldValue("ActionDate", Todaydate);
    //   }
    //   if (
    //     values.Payroll_Date == undefined ||
    //     values.Payroll_Date == "" ||
    //     values.Payroll_Date == null
    //   ) {
    //     setFieldValue("Payroll_Date", Todaydate);
    //   }
    //   if (
    //     values.Posting_Date == undefined ||
    //     values.Posting_Date == "" ||
    //     values.Posting_Date == null
    //   ) {
    //     setFieldValue("Posting_Date", Todaydate);
    //   }
    //   if (
    //     values?.Retirement_Coverage == "" ||
    //     values?.Retirement_Coverage == null ||
    //     values?.Retirement_Coverage == undefined
    //   ) {
    //     setFieldValue("Retirement_Coverage", 1);
    //   }
    //   if (
    //     values?.TO_Dept_Div_Sec == "" ||
    //     values?.TO_Dept_Div_Sec == null ||
    //     values?.TO_Dept_Div_Sec == undefined
    //   ) {
    //     setFieldValue("TO_Dept_Div_Sec", values.FR_Dept_Div_Sec);
    //   }
    //   if (
    //     values?.TO_FTE_Number == "" ||
    //     values?.TO_FTE_Number == null ||
    //     values?.TO_FTE_Number == undefined
    //   ) {
    //     setFieldValue("TO_FTE_Number", values.FR_FTE_Number);
    //   }
    //   if (
    //     values?.TO_Grade == "" ||
    //     values?.TO_Grade == null ||
    //     values?.TO_Grade == undefined
    //   ) {
    //     setFieldValue("TO_Grade", values.FR_Grade);
    //   }
    //   if (
    //     values?.TO_PositionTitle == "" ||
    //     values?.TO_PositionTitle == null ||
    //     values?.TO_PositionTitle == undefined
    //   ) {
    //     setFieldValue("TO_PositionTitle", values.FR_PositionTitle);
    //   }
    //   if (
    //     values?.TO_Step == "" ||
    //     values?.TO_Step == null ||
    //     values?.TO_Step == undefined
    //   ) {
    //     setFieldValue("TO_Step", values.FR_Step);
    //   }
    //   if (
    //     values?.TO_Rate == "" ||
    //     values?.TO_Rate == null ||
    //     values?.TO_Rate == undefined
    //   ) {
    //     setFieldValue("TO_Rate", values.FR_Rate);
    //   }
    //   if (
    //     values?.TO_Salary == "" ||
    //     values?.TO_Salary == null ||
    //     values?.TO_Salary == undefined
    //   ) {
    //     setFieldValue("TO_Salary", values.FR_Salary);
    //   }
    //   setErrorHighLight(infoHighLight);
    //   setHighlight(infoHighLight);
    //   setErrorMessage(infoMsgs);
    // }
    if (nature_code == "64") {
      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);

      // User  Input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values.FR_PositionTitle == "" ||
        values.FR_PositionTitle == null ||
        values.FR_PositionTitle == null ||
        values.FR_PositionTitle == undefined
      ) {
        infoHighLight.push({
          FR_PositionTitle: "Position Number cannot be blank.",
        });
      } else {
        infoHighLight.push({
          FR_PositionTitle: "Position Number cannot be blank.",
        });
      }

      if (
        values?.FR_Grade == "" ||
        values?.FR_Grade == null ||
        values?.FR_Grade == undefined
      ) {
        infoHighLight.push({ FR_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "FR_Grade",
            msg: "Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ FR_Grade: "Required" });
      }
      if (
        values?.FR_Step == "" ||
        values?.FR_Step == null ||
        values?.FR_Step == undefined
      ) {
        infoHighLight.push({ FR_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "FR_Step",
            msg: "Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ FR_Step: "Required" });
      }
      if (
        values?.FR_Rate == "" ||
        values?.FR_Rate == null ||
        values?.FR_Rate == undefined
      ) {
        infoHighLight.push({ FR_Rate: "Required" });

        infoMsgs.push({
          id: "FR_Rate",
          msg: "Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({ FR_Rate: "Required" });
      }
      if (
        values?.FR_Salary == "" ||
        values?.FR_Salary == null ||
        values?.FR_Salary == undefined
      ) {
        infoHighLight.push({
          FR_Salary: "Salary cannot be blank.",
        });
        infoMsgs.push({
          id: "FR_Salary",
          msg: "Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({
          FR_Salary: "Salary cannot be blank.",
        });
      }

      if (
        values?.FR_Department?.value == "" ||
        values?.FR_Department?.value == "N/A" ||
        values?.FR_Department?.value == undefined ||
        values?.FR_Department?.value == null
      ) {
        infoHighLight.push({
          FR_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "FR_Department",
          msg: "Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          FR_Department: "Select Department.",
        });
      }
      if (
        values?.FR_Division?.value == "" ||
        values?.FR_Division?.value == "N/A" ||
        values?.FR_Division?.value == undefined ||
        values?.FR_Division?.value == null
      ) {
        infoHighLight.push({
          FR_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "FR_Division",
          msg: "Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          FR_Division: "Select Division.",
        });
      }
      if (
        values.FR_FTE_Number == null ||
        values.FR_FTE_Number == "" ||
        values.FR_FTE_Number == undefined
      ) {
        infoHighLight.push({
          FR_FTE_Number: "FTE position_no is blank.",
        });
        // infoMsgs.push({
        //   id: "FR_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "FR_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          FR_FTE_Number: "FTE position_no is blank.",
        });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "65") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "66") {
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
        infoMsgs.push({
          id: "Budget_Account_Number",
          msg: "Budget Account Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "67") {
      if (values.empl_type != "P") {
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "68") {
      // if (values.empl_type !== "N") {
      // }
      if (
        values?.TO_PositionTitle?.value == undefined ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "To Grade cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "To Grade cannot be blank.",
        });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "To Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "69") {
      if (values.empl_type !== "P" && values.empl_type !== "U") {
        infoMsgs.push({
          id: "empl_type",
          msg: "Only ATTORNEYS are eligible for Increments!",
        });
      }
      if (values.empl_type !== "U" && values.step_actual < 10) {
        infoMsgs.push({
          id: "step_actual",
          msg: "Unclassified Employee with a step less than 10 CANNOT receive increments! (Inappropiate Action).",
        });
      }

      if (
        values.FR_Grade == "" ||
        values.FR_Grade == null ||
        values.FR_Grade == null ||
        values.FR_Grade == undefined ||
        values.FR_Step == "" ||
        values.FR_Step == null ||
        values.FR_Step == null ||
        values.FR_Step == undefined
      ) {
      }

      if (
        values?.TO_PositionTitle?.value == undefined ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "To Step cannot be blank.",
        });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "To Rate cannot be blank.",
        });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "To Salary cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "To Salary cannot be blank.",
        });
      }

      // if (
      //   values?.TO_Dept_Div_Sec?.value == "" ||
      //   values?.TO_Dept_Div_Sec?.value == null ||
      //   values?.TO_Dept_Div_Sec?.value == undefined
      // ) {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Dept_Div_Sec",
      //     msg: "Department/Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Dept_Div_Sec: "Department/Division cannot be blank.",
      //   });
      // }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Budget FTE number cannot be blank.",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Budget FTE number cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Budget FTE number cannot be blank.",
        });
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "70") {
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "71") {
      //system generated set values

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank (Salary is set by contract).",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      // ]);
    }
    if (nature_code == "72") {
      // User Input

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_PositionTitle?.value == undefined ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "To Position cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "FTE position_no is blank.",
        });
      }

      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }

        // let DecrementedSalaryItem = StepDecrement(
        //   parseInt(values?.FR_Step) - 1
        // );
        // let stepToCheck = CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade ? parseInt(values?.FR_Step) : parseInt(values?.FR_Step) - 1;
        // let DecrementedSalaryItem = StepDecrement(stepToCheck);
        let DecrementedSalaryItem = StepDecrement(parseInt(values?.FR_Step));
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }

      // Accorind to sheet  in "HR System Modification 11/21/2023" - slide 4
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });

        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Salary is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { ActionDate: "Action Date Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }
    if (nature_code == "73") {
      // System Generated
      // setSysGenHighlight([
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      //   { ActionDate: "Action Date Required" },
      // ]);

      if (
        values.TO_Step == undefined ||
        values.TO_Step == "" ||
        values.TO_Step == null
      ) {
        setFieldValue("TO_Step", values.FR_Step);
      }

      // User Input
      if (
        values.Budget_Account_Number == null ||
        values.Budget_Account_Number == "" ||
        values.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }

    if (nature_code == "74") {
      /***** New */

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "TO Grade cannot be blank.",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }

      if (
        values?.FR_Step !== "" ||
        values?.FR_Step !== null ||
        values?.FR_Step !== undefined
      ) {
        // if (parseInt(values?.TO_Step) >= parseInt(values?.FR_Step)) {
        //   let ToNewStep = parseInt(values?.FR_Step) - 1;
        //   let strToNewStep = ToNewStep.toString();
        //   if (ToNewStep != 0 && ToNewStep > 0 && ToNewStep < 10) {
        //     strToNewStep = `0${ToNewStep}`;
        //   }
        //   setFieldValue("TO_Step", strToNewStep);
        // }

        // let DecrementedSalaryItem = StepDecrement(
        //   parseInt(values?.FR_Step) - 1
        // );
        // let stepToCheck = CheckValue(values?.TO_Grade) && values?.TO_Grade != values?.FR_Grade ? parseInt(values?.FR_Step) : parseInt(values?.FR_Step) - 1;
        // let DecrementedSalaryItem = StepDecrement(stepToCheck);
        let DecrementedSalaryItem = StepDecrement(parseInt(values?.FR_Step));
        let ToNewStep = DecrementedSalaryItem
          ? parseInt(DecrementedSalaryItem?.step)
          : parseInt(values?.FR_Step) - 1; // + 2
        if (ToNewStep < 10) {
          setFieldValue("TO_Step", `0${ToNewStep}`);
        } else {
          let tempVal = parseInt(ToNewStep, 10).toString();
          if (tempVal?.length <= 2) {
            setFieldValue("TO_Step", tempVal);
          }
        }
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "75") {
      /***** New */
      //system generated set values

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
        infoMsgs.push({
          id: "Budget_Account_Number",
          msg: "Budget Account Number is Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({ TO_PositionTitle: "Required" });

        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle cannot be blank.",
        });
      } else {
        infoHighLight.push({ TO_PositionTitle: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Next_INCR_date: "Next_INCR_date" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { TO_Rate: "TO_Rate" },
      //   { TO_Salary: "TO_Salary" },
      //   { TO_Step: "TO_Step" },
      // ]);
    }

    if (nature_code == "76") {
      // if (values?.TO_Step != 1) {
      //   // ShowError("TO Step value must be 1.");
      //   setFieldValue("TO_Step", "01");
      // }

      // let _res = pmrcl_getpos(values?.TO_PositionTitle?.value);

      // if (_res[0] == "1" && _res[1] == "1") {
      //   let grade_from_position = _res[2]?.trim();
      //   let _to_new_grade = values?.TO_Grade?.trim();

      //   if (
      //     _to_new_grade !== "" &&
      //     _to_new_grade !== null &&
      //     _to_new_grade != grade_from_position
      //   ) {
      //     let _NotifyMessage =
      //       "Grade does not match the user input grade, resetting to appropriate grade.";
      //     let to_new_grade = grade_from_position;
      //     let to_step = "01";
      //     values.TO_Grade = values?.to_new_grade;
      //     values.TO_Step = to_step;
      //     infoHighLight.push({
      //       TO_Step: "TO_Step",
      //     });
      //     infoHighLight.push({
      //       TO_Grade: "TO_Grade",
      //     });

      //     let _SalFilter = salaryItemsList.filter((element, index) => {
      //       if ((element.grade?.trim() == _to_new_grade?.trim()) == to_step) {
      //       }
      //     });
      //     if (_SalFilter?.length > 0) {
      //       values.TO_Rate = _SalFilter[0]?.nrate;
      //       values.TO_Salary = _SalFilter[0]?.nSalary;
      //       infoHighLight.push({
      //         TO_Rate: "TO_Rate",
      //       });
      //       infoHighLight.push({
      //         TO_Salary: "TO_Salary",
      //       });
      //     }
      //   }
      // } else {
      //   // infoHighLight.push({
      //   //   TO_Step: "TO_Step",
      //   // });
      //   // infoHighLight.push({
      //   //   TO_Rate: "TO_Rate",
      //   // });
      //   // infoHighLight.push({
      //   //   TO_Grade: "TO_Grade",
      //   // });
      //   // infoHighLight.push({
      //   //   TO_Salary: "TO_Salary",
      //   // });
      // }

      if (
        values?.Term_Date == null ||
        values?.Term_Date == "" ||
        values?.Term_Date == undefined
      ) {
        infoHighLight.push({
          Term_Date: "Required",
        });
        // infoMsgs.push({
        //   id: "Term_Date",
        //   msg: "TO Rate is Required",
        // });
      } else {
        if (
          CheckValue(values?.Term_Date) &&
          CheckValue(values?.EffDate) &&
          moment(values?.Term_Date).isBefore(moment(values?.EffDate))
        ) {
          infoMsgs.push({
            id: "Term_Date",
            msg: "Term Date must be greater than Effective Date.",
          });
        }
        infoHighLight.push({
          Term_Date: "Required",
        });
      }
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "TO FTE Number is Required",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({
          TO_FTE_Number: "Required",
        });
      }
      if (
        values?.TO_Grade == null ||
        values?.TO_Grade == "" ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({
          TO_Grade: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({
          TO_Grade: "Required",
        });
      }
      if (
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "TO PositionTitle is Required",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Required",
        });
      }
      if (
        values?.TO_Rate == null ||
        values?.TO_Rate == "" ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({
          TO_Rate: "Required",
        });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "TO Rate is Required",
        });
      } else {
        infoHighLight.push({
          TO_Rate: "Required",
        });
      }
      if (
        values?.TO_Step == null ||
        values?.TO_Step == "" ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Required",
        });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "TO Step is Required",
          });
        }
      } else {
        infoHighLight.push({
          TO_Step: "Required",
        });
      }
      if (
        values?.TO_Salary == null ||
        values?.TO_Salary == "" ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({
          TO_Salary: "Required",
        });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "TO Salary is Required",
        });
      } else {
        infoHighLight.push({
          TO_Salary: "Required",
        });
      }

      /******** Name Change for Appointment of InActive Employee */
      if (autoGeneratedItem?.employee_Status == "I") {
        if (
          values?.TO_NAME_LAST == null ||
          values?.TO_NAME_LAST == "" ||
          values?.TO_NAME_LAST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_LAST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_LAST: "Required",
          });
        }
        if (
          values?.TO_NAME_FIRST == null ||
          values?.TO_NAME_FIRST == "" ||
          values?.TO_NAME_FIRST == undefined
        ) {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_FIRST",
            msg: "To Last Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_FIRST: "Required",
          });
        }
        if (
          values?.TO_NAME_MIDDLE == null ||
          values?.TO_NAME_MIDDLE == "" ||
          values?.TO_NAME_MIDDLE == undefined
        ) {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
          infoMsgs.push({
            id: "TO_NAME_MIDDLE",
            msg: "To Middle Name is Required",
          });
        } else {
          infoHighLight.push({
            TO_NAME_MIDDLE: "Required",
          });
        }
      }

      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      //   { Term_Date: "Term_Date" },
      //   { TO_Salary: "TO_Salary" },
      // ]);
    }
    if (nature_code == "77") {
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "78") {
      /***** New */
      //system generated set values

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }

      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_Step: "Position Number cannot be blank",
        });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      // if (
      //   values?.TO_Division?.value == "" ||
      //   values?.TO_Division?.value == "N/A" ||
      //   values?.TO_Division?.value == undefined ||
      //   values?.TO_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     TO_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "TO_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     TO_Division: "Select Division.",
      //   });
      // }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "ActionDate" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "FR_Dept_Div_Sec" },
      //   { FR_NAME_FIRST: "FR_NAME_FIRST" },
      //   { FR_FTE_Number: "FR_FTE_Number" },
      //   { FR_NAME_LAST: "FR_NAME_LAST" },
      //   { FR_NAME_MIDDLE: "FR_NAME_MIDDLE" },
      //   { FR_Grade: "FR_Grade" },
      //   { FR_PositionTitle: "FR_PositionTitle" },
      //   { FR_Rate: "FR_Rate" },
      //   { FR_Salary: "FR_Salary" },
      //   { FR_Step: "FR_Step" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "natureCode" },
      //   { Payroll_Date: "Payroll_Date" },
      //   { Posting_Date: "Posting_Date" },
      //   { Posting_Flag: "Posting_Flag" },
      // ]);
    }
    if (nature_code == "79") {
      // User Input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values.FR_PositionTitle == "" ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == null ||
      //   values.FR_PositionTitle == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_PositionTitle: "Position Number cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Grade == "" ||
      //   values?.FR_Grade == null ||
      //   values?.FR_Grade == undefined
      // ) {
      //   infoHighLight.push({ FR_Grade: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Grade",
      //     msg: "Grade cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Grade: "Required" });
      // }
      // if (
      //   values?.FR_Step == "" ||
      //   values?.FR_Step == null ||
      //   values?.FR_Step == undefined
      // ) {
      //   infoHighLight.push({ FR_Step: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Step",
      //     msg: "Step cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Step: "Required" });
      // }
      // if (
      //   values?.FR_Rate == "" ||
      //   values?.FR_Rate == null ||
      //   values?.FR_Rate == undefined
      // ) {
      //   infoHighLight.push({ FR_Rate: "Required" });

      //   infoMsgs.push({
      //     id: "FR_Rate",
      //     msg: "Rate cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({ FR_Rate: "Required" });
      // }
      // if (
      //   values?.FR_Salary == "" ||
      //   values?.FR_Salary == null ||
      //   values?.FR_Salary == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Salary",
      //     msg: "Salary cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Salary: "Salary cannot be blank.",
      //   });
      // }

      // if (
      //   values?.FR_Department?.value == "" ||
      //   values?.FR_Department?.value == "N/A" ||
      //   values?.FR_Department?.value == undefined ||
      //   values?.FR_Department?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Department",
      //     msg: "To Department cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Department: "Select Department.",
      //   });
      // }
      // if (
      //   values?.FR_Division?.value == "" ||
      //   values?.FR_Division?.value == "N/A" ||
      //   values?.FR_Division?.value == undefined ||
      //   values?.FR_Division?.value == null
      // ) {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_Division",
      //     msg: "To Division cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_Division: "Select Division.",
      //   });
      // }
      // if (
      //   values.FR_FTE_Number == null ||
      //   values.FR_FTE_Number == "" ||
      //   values.FR_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      //   infoMsgs.push({
      //     id: "FR_FTE_Number",
      //     msg: "FTE position_no cannot be blank.",
      //   });
      // } else {
      //   infoHighLight.push({
      //     FR_FTE_Number: "FTE position_no is blank.",
      //   });
      // }

      // System Generated
      // setSysGenHighlight([
      //   { ActionDate: "Action Date Required" },
      //   { Final_Post: "Required" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Step: "Required" },
      //   { FR_Salary: "Required" },
      //   {
      //     LegalAuthority: "LegalAuthority is Required",
      //   },
      //   { natureCode: "natureCode" },
      //   { Posting_Date: "Required" },
      //   { Term_Date: "Required" },
      //   { Payroll_Date: "Next Increment Date cannot be blank." },
      //   { Posting_Flag: "Required" },
      // ]);
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    if (nature_code == "80") {
      // user input
      if (
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      } else {
        infoHighLight.push({ Budget_Account_Number: "Required" });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { LegalAuthority: "LegalAuthority is Required" },
      //   { natureCode: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);
    }
    if (nature_code == "81") {
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
    }
    // if (nature_code == "82") {
    //   /***** New */

    //   // user input
    //   if (
    //     values?.Budget_Account_Number == null ||
    //     values?.Budget_Account_Number == "" ||
    //     values?.Budget_Account_Number == undefined
    //   ) {
    //     infoHighLight.push({
    //       Budget_Account_Number: "Required",
    //     });
    //   } else {
    //     infoHighLight.push({
    //       Budget_Account_Number: "Required",
    //     });
    //   }

    //   setErrorHighLight(infoHighLight);
    //   setHighlight(infoHighLight);
    //   setErrorMessage(infoMsgs);

    //   // system generated Highlights
    //   // setSysGenHighlight([
    //   //   { ActionDate: "Action Date" },
    //   //   { Final_Post: "Final_Post" },
    //   //   { FR_Dept_Div_Sec: "Required" },
    //   //   { FR_NAME_FIRST: "Required" },
    //   //   { FR_FTE_Number: "Required" },
    //   //   { FR_NAME_LAST: "Required" },
    //   //   { FR_NAME_MIDDLE: "Required" },
    //   //   { FR_Grade: "Required" },
    //   //   { FR_PositionTitle: "Required" },
    //   //   { FR_Rate: "Required" },
    //   //   { FR_Salary: "Required" },
    //   //   { FR_Step: "Required" },
    //   //   { LegalAuthority: "LegalAuthority" },
    //   //   { natureCode: "Required" },
    //   //   { Payroll_Date: "Required" },
    //   //   { Posting_Date: "Required" },
    //   //   { Posting_Flag: "Required" },
    //   // ]);
    // }
    if (nature_code == "82") {
      /**** New */

      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }

      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values?.TO_FTE_Number == "" ||
        values?.TO_FTE_Number == null ||
        values?.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "Please verify OPTIONAL entry of the FTE Number.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      // ]);
    }
    if (nature_code == "83" || nature_code == "92") {
      /***** New */

      // if (
      //   values?.EffDate == null ||
      //   values?.EffDate == "" ||
      //   values?.EffDate == undefined
      // ) {
      //   infoHighLight.push({
      //     EffDate: "Eff Date cannot be blank.",
      //   });
      //   infoMsgs.push({
      //     id: "EffDate",
      //     msg: "Eff Date cannot be the blank",
      //   });
      // }else {
      //   infoHighLight.push({
      //     EffDate: "Eff Date cannot be blank.",
      //   });
      // }

      if (CheckValue(values?.EffDate)) {
        setFieldValue("Term_Date", values?.EffDate);
      }
      // user input
      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      // if (
      //   values?.TO_FTE_Number == "" ||
      //   values?.TO_FTE_Number == null ||
      //   values?.TO_FTE_Number == undefined
      // ) {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });

      //   // infoMsgs.push({
      //   //   id: "TO_FTE_Number",
      //   //   msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   // });
      //   optionalMsgs.push({
      //     id: "TO_FTE_Number",
      //     msg: "Please verify OPTIONAL entry of the FTE Number.",
      //   })
      // } else {
      //   infoHighLight.push({ TO_FTE_Number: "Required" });
      // }
      // setOptionalMessages(optionalMsgs);
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);

      // system generated Highlights
      // setSysGenHighlight([
      //   { ActionDate: "Action Date" },
      //   { Final_Post: "Final_Post" },
      //   { FR_Dept_Div_Sec: "Required" },
      //   { FR_NAME_FIRST: "Required" },
      //   { FR_FTE_Number: "Required" },
      //   { FR_NAME_LAST: "Required" },
      //   { FR_NAME_MIDDLE: "Required" },
      //   { FR_Grade: "Required" },
      //   { FR_PositionTitle: "Required" },
      //   { FR_Rate: "Required" },
      //   { FR_Salary: "Required" },
      //   { FR_Step: "Required" },
      //   { LegalAuthority: "LegalAuthority" },
      //   { natureCode: "Required" },
      //   { Payroll_Date: "Required" },
      //   { Posting_Date: "Required" },
      //   { Posting_Flag: "Required" },
      //   { Term_Date: "Term_Date" },
      // ]);
    }
    if (nature_code == "91") {
      if (values?.recruitmentType?.value == 1) {
        setFieldValue("TO_Step", "01");
        if (
          values.TO_Step !== undefined &&
          values.TO_Step !== "" &&
          values.TO_Step !== null
        ) {
          if (values?.TO_Step != 1) {
            setFieldValue("TO_Step", "01");
          }
        }
      }
      if (values?.recruitmentType?.value == 2) {
        if (
          values.TO_Step !== undefined &&
          values.TO_Step !== "" &&
          values.TO_Step !== null
        ) {
          if (values?.TO_Step > 10) {
            infoMsgs.push({
              id: "TO_Step",
              msg: "To Step can only be set between 1 and 10 for Competitive Limited Term Appointment Recruitment.",
            });
          }
        }
      }
      // if (
      //   values?.DOB == "" ||
      //   values?.DOB == "N/A" ||
      //   values?.DOB == undefined ||
      //   values?.DOB == null
      // ) {
      //   infoHighLight.push({
      //     DOB: "Required.",
      //   });
      //   // infoMsgs.push({
      //   //   id: "TO_Department",
      //   //   msg: "To Department cannot be blank.",
      //   // });
      // } else {
      //   infoHighLight.push({
      //     DOB: "Required.",
      //   });
      // }
      // if (
      //   values?.FR_NAME_LAST == "" ||
      //   values?.FR_NAME_LAST == "N/A" ||
      //   values?.FR_NAME_LAST == undefined ||
      //   values?.FR_NAME_LAST == null
      // ) {
      //   infoHighLight.push({
      //     FR_NAME_LAST: "Required.",
      //   });
      //   // infoMsgs.push({
      //   //   id: "TO_Department",
      //   //   msg: "To Department cannot be blank.",
      //   // });
      // } else {
      //   infoHighLight.push({
      //     FR_NAME_LAST: "Required.",
      //   });
      // }
      // if (
      //   values?.FR_NAME_FIRST == "" ||
      //   values?.FR_NAME_FIRST == "N/A" ||
      //   values?.FR_NAME_FIRST == undefined ||
      //   values?.FR_NAME_FIRST == null
      // ) {
      //   infoHighLight.push({
      //     FR_NAME_FIRST: "Required.",
      //   });
      //   // infoMsgs.push({
      //   //   id: "TO_Department",
      //   //   msg: "To Department cannot be blank.",
      //   // });
      // } else {
      //   infoHighLight.push({
      //     FR_NAME_FIRST: "Required.",
      //   });
      // }
      // if (
      //   values?.FR_NAME_MIDDLE == "" ||
      //   values?.FR_NAME_MIDDLE == "N/A" ||
      //   values?.FR_NAME_MIDDLE == undefined ||
      //   values?.FR_NAME_MIDDLE == null
      // ) {
      //   infoHighLight.push({
      //     FR_NAME_MIDDLE: "Required.",
      //   });
      //   // infoMsgs.push({
      //   //   id: "TO_Department",
      //   //   msg: "To Department cannot be blank.",
      //   // });
      // } else {
      //   infoHighLight.push({
      //     FR_NAME_MIDDLE: "Required.",
      //   });
      // }
      if (
        values?.recruitmentType?.value == "" ||
        values?.recruitmentType?.value == "N/A" ||
        values?.recruitmentType?.value == undefined ||
        values?.recruitmentType?.value == null
      ) {
        infoHighLight.push({
          recruitmentType: "Required.",
        });
        // infoMsgs.push({
        //   id: "TO_Department",
        //   msg: "To Department cannot be blank.",
        // });
      } else {
        infoHighLight.push({
          recruitmentType: "Required.",
        });
      }
      if (
        values?.considerationArea?.value == "" ||
        values?.considerationArea?.value == "N/A" ||
        values?.considerationArea?.value == undefined ||
        values?.considerationArea?.value == null
      ) {
        infoHighLight.push({
          considerationArea: "Required.",
        });
        // infoMsgs.push({
        //   id: "TO_Department",
        //   msg: "To Department cannot be blank.",
        // });
      } else {
        infoHighLight.push({
          considerationArea: "Required.",
        });
      }

      if (
        values?.TO_Department?.value == "" ||
        values?.TO_Department?.value == "N/A" ||
        values?.TO_Department?.value == undefined ||
        values?.TO_Department?.value == null
      ) {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
        infoMsgs.push({
          id: "TO_Department",
          msg: "To Department cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Department: "Select Department.",
        });
      }
      if (
        values?.TO_Division?.value == "" ||
        values?.TO_Division?.value == "N/A" ||
        values?.TO_Division?.value == undefined ||
        values?.TO_Division?.value == null
      ) {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
        infoMsgs.push({
          id: "TO_Division",
          msg: "To Division cannot be blank.",
        });
      } else {
        infoHighLight.push({
          TO_Division: "Select Division.",
        });
      }
      if (
        values.TO_FTE_Number == null ||
        values.TO_FTE_Number == "" ||
        values.TO_FTE_Number == undefined
      ) {
        infoHighLight.push({ TO_FTE_Number: "Required" });

        // infoMsgs.push({
        //   id: "TO_FTE_Number",
        //   msg: "FTE position_no cannot be blank.",
        // });
        optionalMsgs.push({
          id: "TO_FTE_Number",
          msg: "Please verify OPTIONAL entry of the FTE Number.",
        });
      } else {
        infoHighLight.push({ TO_FTE_Number: "Required" });
      }
      if (
        values?.TO_Step == "" ||
        values?.TO_Step == null ||
        values?.TO_Step == undefined
      ) {
        infoHighLight.push({ TO_Step: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Step",
            msg: "To Step cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Step: "Required" });
      }
      if (
        values?.TO_Grade == "" ||
        values?.TO_Grade == null ||
        values?.TO_Grade == undefined
      ) {
        infoHighLight.push({ TO_Grade: "Required" });
        if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") != -1) {
          infoMsgs.push({
            id: "TO_Grade",
            msg: "To Grade cannot be blank",
          });
        }
      } else {
        infoHighLight.push({ TO_Grade: "Required" });
      }
      if (
        values?.TO_Salary == "" ||
        values?.TO_Salary == null ||
        values?.TO_Salary == undefined
      ) {
        infoHighLight.push({ TO_Salary: "Required" });
        infoMsgs.push({
          id: "TO_Salary",
          msg: "Salary cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Salary: "Required" });
      }
      if (
        values?.TO_Rate == "" ||
        values?.TO_Rate == null ||
        values?.TO_Rate == undefined
      ) {
        infoHighLight.push({ TO_Rate: "Required" });
        infoMsgs.push({
          id: "TO_Rate",
          msg: "To Rate cannot be blank",
        });
      } else {
        infoHighLight.push({ TO_Rate: "Required" });
      }
      if (
        values?.TO_PositionTitle?.value == "" ||
        values?.TO_PositionTitle?.value == null ||
        values?.TO_PositionTitle?.value == undefined
      ) {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
        infoMsgs.push({
          id: "TO_PositionTitle",
          msg: "Position Number cannot be blank",
        });
      } else {
        infoHighLight.push({
          TO_PositionTitle: "Position Number cannot be blank",
        });
      }

      if (
        values?.Budget_Account_Number == null ||
        values?.Budget_Account_Number == "" ||
        values?.Budget_Account_Number == undefined
      ) {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      } else {
        infoHighLight.push({
          Budget_Account_Number: "Required",
        });
      }
      setErrorHighLight(infoHighLight);
      setHighlight(infoHighLight);
      setErrorMessage(infoMsgs);
      setOptionalMessages(optionalMsgs);
    }

    // For BBMR user inputs
    // if (values?.CurrentProcessStatus?.value == 8) {
    //   infoHighLight = [];
    //   infoMsgs = [];

    //   if (
    //     values?.Budget_Account_Number == "" ||
    //     values?.Budget_Account_Number == null ||
    //     values?.Budget_Account_Number == undefined
    //   ) {
    //     infoHighLight.push({ Budget_Account_Number: "Required" });
    //   } else {
    //     infoHighLight.push({ Budget_Account_Number: "Required" });
    //   }
    //   if (
    //     values?.EffDate == null ||
    //     values?.EffDate == "" ||
    //     values?.EffDate == undefined
    //   ) {
    //     infoHighLight.push({ EffDate: "Required" });
    //     infoMsgs.push({
    //       id: "EffDate",
    //       msg: "Eff Date cannot be the blank",
    //     });
    //   } else {
    //     infoHighLight.push({ EffDate: "Required" });
    //   }
    //   if (
    //     values?.TO_Step == null ||
    //     values?.TO_Step == "" ||
    //     values?.TO_Step == undefined
    //   ) {
    //     infoHighLight.push({ TO_Step: "Required" });
    //     infoMsgs.push({
    //       id: "TO_Step",
    //       msg: "To step cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ TO_Step: "Required" });
    //   }
    //   if (
    //     values?.TO_Salary == null ||
    //     values?.TO_Salary == "" ||
    //     values?.TO_Salary == undefined
    //   ) {
    //     infoHighLight.push({ TO_Salary: "Required" });
    //     infoMsgs.push({
    //       id: "TO_Salary",
    //       msg: "To Salary cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ TO_Salary: "Required" });
    //   }
    //   if (
    //     values?.TO_Rate == null ||
    //     values?.TO_Rate == "" ||
    //     values?.TO_Rate == undefined
    //   ) {
    //     infoHighLight.push({ TO_Rate: "Required" });
    //     infoMsgs.push({
    //       id: "TO_Rate",
    //       msg: "To Rate cannot be blank.",
    //     });
    //   } else {
    //     infoHighLight.push({ TO_Rate: "Required" });
    //   }
    //   setErrorHighLight(infoHighLight);
    //   setHighlight(infoHighLight);
    //   setErrorMessage(infoMsgs);
    // }

    let schemedata = schemaObj;
    // if(Object.keys(values?.TO_PositionTitle))
    // console.log(
    //   "121212 innnnnnnnn ::: ",
    //   values?.TO_PositionTitle,
    //   infoMsgs,
    //   errorMessage
    // );
    // setErrorHighLight(infoHighLight);
    // setHighlight(infoHighLight);
    setErrorMessage(infoMsgs);

    // if (values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") == -1) {
    //   checkUnclassifiedPositions("to", infoMsgs);
    // }
    // if (values?.FR_PositionTitle?.titleWithGrade.indexOf("-") == -1) {
    //   checkUnclassifiedPositions("from");
    // }

    setTimeout(() => {
      setSetSchema(schemedata);
      validateForm();
    }, 100);
  };

  const pmrcl_getpos = ($99) => {
    let nposition_no = $99;
    let $98 = "";
    let IsSuccess = "1";
    let IsGradeAssigned = "1";
    let _PositionKeyValue = positionTitleOptions;
    let _Filter = _PositionKeyValue.filter((element, index) => {
      return element?.value?.trim() == nposition_no;
    });
    if (_Filter?.length > 0) {
      let range_next = _Filter[0]?.range_next ? _Filter[0].range_next : "";

      if (range_next ? range_next?.trim() : "" == "") {
        IsGradeAssigned = "0";
      } else {
        $98 = range_next;
      }
    } else {
      IsSuccess = "0";
    }
    return [IsSuccess, IsGradeAssigned, $98];
  };

  const pmrcl_getsalary = ($1, $2) => {
    let grade = $1;
    let step = $2;
    let $3;
    let $4;
    let IsSuccess = "1";
    let _SalaryObj = salaryItemsList;
    let _SalaryFilter = _SalaryObj.filter((element, index) => {
      if (
        element?.grade?.trim() == grade?.trim() &&
        element.step?.trim() == step
      ) {
        return element;
      }
    });

    if (_SalaryFilter?.length == 0) {
      IsSuccess = "0";
    } else {
      $3 = _SalaryFilter[0]?.nrate;
      $4 = _SalaryFilter[0]?.nSalary;
    }
    return [IsSuccess, $3, $4];
  };
  const pmrcl_getstep = ($4, $98) => {
    let _SalaryObj = salaryItemsList;
    let _SalaryFilter = _SalaryObj.filter((element, index) => {
      if (element.grade?.trim() == $98?.trim()) {
        return element;
      }
    });
    let IsSuccess = "1";

    let $target_salary$ = $4;
    let $target_step$ = 1;
    let $found$ = 0;

    let $50;
    let $51;
    let $52;

    let $new_salary$;
    let _SalaryFilterByStep;

    if (_SalaryFilter?.length > 0) {
      for ($target_step$; $target_step$ <= 20; $target_step$ += 1) {
        _SalaryFilterByStep = _SalaryFilter.filter((element, index) => {
          if (element.step?.trim() == $target_step$) {
            return element;
          }
        });

        if (_SalaryFilterByStep?.length > 0) {
          if (
            parseFloat(_SalaryFilterByStep[0]?.nSalary) >
            parseFloat($target_salary$)
          ) {
            $found$ = 1;
          }
        }
      }

      if ($found$ == 1) {
        $50 = _SalaryFilterByStep[0].step;
        $51 = _SalaryFilterByStep[0]?.nrate;
        $52 = _SalaryFilterByStep[0]?.nSalary;
      } else {
        let _SalaryFilterByStep = _SalaryFilter.filter((element, index) => {
          if (element.step?.trim() == 20) {
            return element;
          }
        });

        if (_SalaryFilterByStep?.length > 0) {
          $new_salary$ = parseFloat(_SalaryFilterByStep[0]?.nSalary) * 1.035;
          $new_salary$ = $new_salary$.toFixed(2);
          for ($new_salary$; $new_salary$ < parseFloat($4);) {
            $new_salary$ = $new_salary$ * 1.035;
            $new_salary$ = $new_salary$.toFixed();
          }
          $50 = "00";
          $51 = $new_salary$ / 2080;
          $51 = parseFloat(_SalaryFilterByStep[0]?.nrate).toFixed(2);
          $52 = $new_salary$;
        } else {
          IsSuccess = "0";
        }
      }
    } else {
      IsSuccess = "0";
    }
    return [IsSuccess, $50, $51, $52];
  };
  const gp_makedemo = ($2, $1) => {
    let IsSuccess = "1";
    let $50 = "";
    let $51 = "";
    let $52 = "";

    let res = pmrcl_getlowstep($2, $1);

    if (res?.length > 0) {
      if (res[0] == "1") {
        $50 = res[1];
        $51 = res[2];
        $52 = res[3];
      } else {
        IsSuccess = "0";
      }
    }
    if ($50 == "" || $51 == "" || $52 == "") {
      IsSuccess = "0";
    } else {
      setFieldValue("TO_Step", $50);
      setFieldValue("TO_Rate", values.FR_Rate);
      setFieldValue("TO_Salary", values.FR_Salary);
    }
    return IsSuccess;
  };

  const pmrcl_getlowstep = ($2, $1) => {
    let _SalaryObj = salaryItemsList;
    let _SalaryFilter = _SalaryObj.filter((element, index) => {
      if (element.grade?.trim() == $1) {
        return element;
      }
    });
    let IsSuccess = "1";

    let $target_salary$ = $2;
    let $target_step$ = 20;
    let $found$ = 0;
    let $Salaryfound$ = true;

    let $50;
    let $51;
    let $52;

    let $new_salary$;
    let _SalaryFilterByStep;

    if (_SalaryFilter?.length > 0) {
      for ($target_step$; $target_step$ > 0; $target_step$ -= 1) {
        _SalaryFilterByStep = _SalaryFilter.filter((element, index) => {
          return element.step?.trim() == $target_step$;
        });

        if (_SalaryFilterByStep?.length > 0) {
          if (
            parseFloat(_SalaryFilterByStep[0]?.nSalary) <
            parseFloat($target_salary$)
          ) {
            $found$ = 1;
          }
        }
      }
    } else {
      $Salaryfound$ = false;
    }
    if ($found$ == 1) {
      $50 = _SalaryFilterByStep[0].step;
      $51 = _SalaryFilterByStep[0]?.nrate;
      $52 = _SalaryFilterByStep[0]?.nSalary;
    } else {
      if ($Salaryfound$ == false && $1 !== null && $1 !== undefined) {
      } else {
        if (
          $52 !== null &&
          $52 !== undefined &&
          $1 !== null &&
          $1 !== undefined &&
          $target_salary$ !== null &&
          $target_salary$ !== undefined
        ) {
        }
      }
      IsSuccess = "0";
    }
    return [IsSuccess, $50, $51, $52];
  };
  const gp_make2step = () => {
    let $1 =
      values.FR_Grade !== null &&
        values.FR_Grade !== undefined &&
        values.FR_Grade !== ""
        ? values.FR_Grade
        : "";
    let $98 =
      values.TO_Grade !== null &&
        values.TO_Grade !== undefined &&
        values.TO_Grade !== ""
        ? values.TO_Grade
        : "";
    let txtFromStep =
      values.FR_Step !== null &&
        values.FR_Step !== undefined &&
        values.FR_Step !== ""
        ? values.FR_Step
        : 0;
    var $2;
    var $4;

    if ($1?.trim() == "" || $1?.trim() == null) {
      return false;
    }
    let FromStep = parseInt(txtFromStep);
    if ((FromStep < 20) & (FromStep != 0)) {
      if (FromStep < 19) $2 = FromStep + 2;
      else $2 = 20;

      let res = pmrcl_getsalary($1, $2);
      if (res[0] == "0") {
      }
      var $4;
      if (res[2] != "") {
        $4 = parseFloat(res[2]);
        if (FromStep == 19) {
          $4 = $4 * 1.035;
        }
      } else {
      }
    } else {
      let txtfromsalary = values.FR_Salary ? values.FR_Salary : 1;
      let fr_salary = parseFloat(txtfromsalary);
      $4 = fr_salary * 1.035;
      $4 = $4.toFixed(2);
      $4 = $4 * 1.035;
    }

    $4 = $4.toFixed(2);
    let to_pos_title_no = values?.TO_PositionTitle?.label;
    let txtToGrade = values.TO_Grade;
    let _NotifyMessage = `Posn No, Grade, Target Salary: ${to_pos_title_no}, ${txtToGrade} , ${$4}`;

    let $50 = "";
    let $51 = 0;
    let $52 = 0;
    let res = pmrcl_getstep($4, $98);
    if (res?.length > 3) {
      if (res[0] == "1") {
        $50 = res[1];
        $51 = res[2];
        $52 = res[3];
      }
    }
    if ($50 == "" || $51 == "" || $52 == "") {
    } else {
      setFieldValue("TO_Step", $50 ? $50 : "");
      setFieldValue("TO_Rate", $51 ? $51 : "");
      setFieldValue("TO_Salary", $52 !== "NaN" ? $52 : "");
    }
    return true;
  };
  const ConvertToBlankOrDateString = (date) => {
    if (date === undefined || !date) {
      return "";
    } else {
      return date;
    }
  };
  const gp_makeincrem = () => {
    let txtToStep = values.TO_Step;
    let to_step = parseInt(txtToStep);
    let txtActEffDate = values?.EffDate;
    let ActEffDate = txtActEffDate;
    if (to_step > 0 && to_step < 7) {
      ActEffDate = moment(txtActEffDate).add(12, "months").format("MM-DD-YYYY");
    } else {
      if (to_step >= 7 && to_step <= 9) {
        ActEffDate = moment(txtActEffDate)
          .add(18, "months")
          .format("MM-DD-YYYY");
      } else {
        ActEffDate = moment(txtActEffDate)
          .add(24, "months")
          .format("MM-DD-YYYY");
      }
    }
    let strActEffDate = ConvertToBlankOrDateString(ActEffDate);
    let _NotifyMessage = `Next increment date is: ${strActEffDate}`;
    values.Next_INCR_date = strActEffDate ? strActEffDate : null;
  };
  const gp_makename = () => {
    let ToLastName = values.TO_NAME_LAST;
    let ToFirstName = values.TO_NAME_FIRST;

    let ToMiddleName = values.TO_NAME_MIDDLE;
    if (ToLastName != "" && ToFirstName != "") {
      var FullName = ToLastName + ", " + ToFirstName + " " + ToMiddleName;

      setFieldValue("fullName", FullName);
      values.fullName = FullName;
    }
  };

  useEffect(() => {
    if (
      values?.natureCode?.value == 23 ||
      (autoGeneratedItem?.employee_Status == "I" &&
        (values?.natureCode?.value == "3" ||
          values?.natureCode?.value == "7" ||
          values?.natureCode?.value == "20" ||
          values?.natureCode?.value == "24" ||
          values?.natureCode?.value == "25" ||
          values?.natureCode?.value == "28" ||
          values?.natureCode?.value == "38" ||
          values?.natureCode?.value == "47" ||
          values?.natureCode?.value == "52" ||
          values?.natureCode?.value == "54" ||
          values?.natureCode?.value == "57" ||
          values?.natureCode?.value == "76"))
    ) {
      gp_makename();
    }
  }, [values?.TO_NAME_LAST, values?.TO_NAME_FIRST, values?.TO_NAME_MIDDLE]);

  const CalculateTermDateForNA6 = () => {
    let TermDate = null;
    if (
      values.EffDate == null ||
      values.EffDate == undefined ||
      values.EffDate == ""
    ) {
      let txtActEffDate = values.EffDate;
      let ActEffDate = txtActEffDate;
      if (ActEffDate !== null) {
        TermDate = moment(txtActEffDate).add(89, "days").format("MM-DD-YYYY");
      }
    }
    return TermDate;
  };
  // const CustomDateSelectFun = (datect1) => {
  //   if (
  //     values.EffDate == null ||
  //     values.EffDate == undefined ||
  //     values.EffDate == ""
  //   ) {
  //     let nature_code = values?.natureCode?.value;

  //     if (nature_code == "6") {
  //       let TermDateCalculated = CalculateTermDateForNA6();
  //       if (values.Term_Date == "" && TermDateCalculated != null) {
  //         values.Term_Date = ConvertToBlankOrDateString(TermDateCalculated);
  //       }
  //     }
  //   }
  // };
  const handleValidateSSN = () => {
    getData();

    let schemaObj;

    if (values.employeeID === "") {
      schemaObj = {
        ...schemaObj,
        employeeID: yup.string().required("employeeID is Required"),
        // LegalAuthority: yup.string().required("employeeID is Required"),
        // EffDate: yup.string().required("Eff Date cannot be the blank"),
      };
    } else {
      if (values.employeeID !== "") {
      }
    }
    let schemedata = schemaObj;

    setTimeout(() => {
      setSetSchema(schemedata);
      validateForm();
    }, 100);
  };
  const getData = () => {
    if (values.employeeID !== "") {
      // dispatch(getDataBySSN(values.employeeID)).then(() => {
      //   setEmpID(values.employeeID);
      // });
      dispatch(GetAutoPopulate);
    }
  };
  const clearToValues = () => {
    // setBulkData([]);
    // setFieldValue("natureCode", { value: "", label: "" });
    // setFieldValue("NatureOf", { value: "", label: "" });
    setFieldValue("TO_NAME_LAST", "");
    setFieldValue("LegalAuthority", "");
    setFieldValue("EffDate", null);
    setFieldValue("TO_NAME_FIRST", "");
    setFieldValue("TO_NAME_MIDDLE", "");
    setFieldValue("TO_PositionTitle", { value: "", label: "" });
    setFieldValue("TO_Salary", 0);
    setFieldValue("TO_Grade", "");
    setFieldValue("TO_Step", "");
    setFieldValue("TO_Rate", 0);
    setFieldValue("TO_FTE_Number", "");
    setFieldValue("TO_Dept_Div_Sec", { value: "", label: "" });
    setFieldValue("TO_Department", { value: "", label: "" });
    setFieldValue("TO_Division", { value: "", label: "" });
    setFieldValue("TO_ClassCode", "");
    setFieldValue("Term_Date", null);
    setFieldValue("Next_INCR_date", null);
    setShowField(showFieldInitialValues);
    // setUpdatedData([]);
  };
  // const copyFromValues = () => {
  //   setFieldValue("TO_NAME_LAST", values.FR_NAME_LAST);
  //   setFieldValue("TO_NAME_LAST", values.FR_NAME_LAST);
  //   setFieldValue("TO_NAME_FIRST", values.FR_NAME_FIRST);
  //   setFieldValue("TO_NAME_MIDDLE", values.FR_NAME_MIDDLE);
  //   setFieldValue("TO_PositionTitle", values.FR_PositionTitle);
  //   setFieldValue("TO_Salary", values.FR_Salary);
  //   setFieldValue("TO_Grade", values.FR_Grade);
  //   setFieldValue("TO_Step", values.FR_Step);
  //   setFieldValue("TO_Rate", values.FR_Rate);
  //   setFieldValue("TO_Salary", values.FR_Salary);
  //   setFieldValue("TO_FTE_Number", values.FR_FTE_Number);
  //   setFieldValue("TO_Dept_Div_Sec", values.FR_Dept_Div_Sec);
  //   setFieldValue("TO_ClassCode", values.FR_ClassCode);
  //   setFieldValue("Evalution_Type", { value: "", label: "" });
  // };
  const copyFromValues = () => {
    setFieldValue("TO_NAME_LAST", values.FR_NAME_LAST);
    setFieldValue("TO_NAME_FIRST", values.FR_NAME_FIRST);
    setFieldValue("TO_NAME_MIDDLE", values.FR_NAME_MIDDLE);
    setFieldValue("TO_PositionTitle", values.FR_PositionTitle);
    setFieldValue("TO_Salary", values.FR_Salary);
    setFieldValue("TO_Grade", values.FR_Grade);
    setFieldValue("TO_Step", values.FR_Step);
    setFieldValue("TO_Rate", values.FR_Rate);
    setFieldValue("TO_FTE_Number", values.FR_FTE_Number);
    setFieldValue("TO_Dept_Div_Sec", values.FR_Dept_Div_Sec);
    setFieldValue("TO_Department", values?.FR_Department);
    setFieldValue("TO_Division", values?.FR_Division);
  };
  const checkOnlyHighlight = (id) => {
    if (highlight?.length) {
      let get = highlight.find((item) => item[id]);
      if (get) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const checkHighlight = (id) => {
    if (
      errorHighLight?.length &&
      id != "" &&
      (id != undefined) & (id != null)
    ) {
      let get = errorHighLight.find((item) => item[id]);
      // {
      //   console.log(
      //     "  values?.Contact_Department",
      //     values?.Contact_Department,
      //     errorHighLight,
      //     get,
      //     id
      //   );
      // }
      if (get) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  // const checkSysGenHighlight = (id) => {
  //   if (sysGenHighlight?.length) {
  //     let get = sysGenHighlight.find((item) => item[id]);
  //     if (get) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // };

  // const checkHighlight = (id) => {
  //   if (errorHighLight?.length && id !== "" && id !== undefined && id !== null) {
  //     let get = errorHighLight.filter((item) => {
  //       for (const key in item) {
  //         if (key == id) {
  //           return key;
  //         }
  //       }
  //     });

  //     if (get?.length) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // };
  const checkSysGenHighlight = (id) => {
    if (id !== undefined) {
      if (sysGenHighlight?.length) {
        let get = sysGenHighlight.find((item) => item[id]);
        if (get) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  };
  // const checkOnlyOptional = (id) => {
  //   if (optionalMessages?.length) {
  //     let get = highlight.find((item) => item[id]);
  //     if (get) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // };
  useEffect(() => {
    let items = TransactionsBySSNAndAction && TransactionsBySSNAndAction;
    // console.log("121212 items?.toStep ::: ", items?.toStep?.length);
    values.TO_Step =
      items?.toStep && items?.toStep != null
        ? items?.toStep?.toString()?.length < 2 && parseInt(items?.toStep) < 10
          ? `0${items?.toStep}`
          : items?.toStep
        : "";
  }, [TransactionsBySSNAndAction?.toStep]);
  useEffect(() => {
    let stringNOA =
      typeof values?.natureCode?.value == "number"
        ? JSON.stringify(values?.natureCode?.value)
        : values?.natureCode?.value;
    if (values?.FR_Grade || values?.FR_Step) {
      if (
        !SeparationNOAs.includes(stringNOA) &&
        !amendmentPerformed &&
        !historyDataApplied
      ) {
        if (
          TransactionsBySSNAndAction &&
          (TransactionsBySSNAndAction?.fromStep != values?.FR_Step ||
            TransactionsBySSNAndAction?.fromPayGrade != values?.FR_Grade)
        ) {
          getFRSalaryGradeFromStep();
        } else if (
          autoGeneratedItem &&
          (autoGeneratedItem?.from_Step != values?.FR_Step ||
            autoGeneratedItem?.from_Pay_Grade != values?.FR_Grade)
        ) {
          getFRSalaryGradeFromStep();
        }
      }
    }
    if (values?.TO_Grade || values?.TO_Step) {
      if (
        !SeparationNOAs.includes(stringNOA) &&
        !amendmentPerformed &&
        !historyDataApplied
      ) {
        if (
          TransactionsBySSNAndAction &&
          (TransactionsBySSNAndAction?.toStep != values?.TO_Step ||
            TransactionsBySSNAndAction?.toPayGrade != values?.TO_Grade)
        ) {
          getSalaryGradeFromStep();
        } else if (
          autoGeneratedItem &&
          (autoGeneratedItem?.to_Step != values?.TO_Step ||
            autoGeneratedItem?.to_Pay_Grade != values?.TO_Grade)
        ) {
          getSalaryGradeFromStep();
        }
      }
    }
  }, [
    values.TO_Grade,
    values.FR_Grade,
    values.TO_Step,
    values.FR_Step,
    TransactionsBySSNAndAction,
  ]);

  useEffect(() => {
    console.log("121212 ::: ", typeof values?.natureCode?.value);
    let stringNOA =
      typeof values?.natureCode?.value == "number"
        ? JSON.stringify(values?.natureCode?.value)
        : values?.natureCode?.value;
    if (values?.natureCode?.value && SeparationNOAs.includes(stringNOA)) {
      setToFiledsBlank();
    }
  }, [autoGeneratedItem, values?.natureCode?.value, noa]);

  const getSalaryGradeFromStep = (e) => {
    // console.log("456456 ::: in salary func ",values?.TO_Step)
    const step = e ? e : values?.TO_Step;
    const grade = values?.TO_Grade;
    // console.log("demo 123", e, values?.TO_Grade);
    let newStep =
      step?.toString()?.length < 2 && parseInt(step?.trim()) < 10
        ? `0${step?.trim()}`
        : step?.trim();
    setFieldValue("TO_Step", newStep);
    let getfromStep;
    if (
      grade !== null &&
      grade !== undefined &&
      grade !== "" &&
      newStep !== null &&
      newStep !== undefined &&
      newStep !== ""
    ) {
      getfromStep =
        salaryItemsList?.length &&
        salaryItemsList.filter((item) => {
          // console.log("demo 123123 11", step, grade, item.step, item.grade);
          // console.log(
          //   "demo 123 items123123231",
          //   item,
          //   item.step?.trim() == step && item.grade?.trim() == grade?.trim()
          // );
          return (
            item?.step?.trim() == newStep &&
            item?.grade?.trim() == grade?.trim()
          );
        });
      // console.log("demo 456456", getfromStep);

      if (getfromStep && getfromStep.length) {
        setFieldValue("TO_Salary", getfromStep[0]?.nSalary);
        setFieldValue("TO_Rate", getfromStep[0]?.nrate);
      }
    }
  };

  const getFRSalaryGradeFromStep = (e) => {
    const step = e ? e : values?.FR_Step;
    const grade = values?.FR_Grade;
    console.log("demo 123", e);
    let newStep =
      step?.toString()?.length < 2 && parseInt(step?.trim()) < 10
        ? `0${step?.trim()}`
        : step?.trim();
    setFieldValue("TO_Step", newStep);
    // setFieldValue("FR_Step", step);
    let getfromStep;

    if (
      grade !== null &&
      grade !== undefined &&
      grade !== "" &&
      newStep !== null &&
      newStep !== undefined &&
      newStep !== ""
    ) {
      // console.log("demo 123123 11", step, grade, item.step, item.grade);
      getfromStep = salaryItemsList.find((item) => {
        return (
          item.step?.trim() == newStep && item.grade?.trim() == grade?.trim()
        );
      });
      // console.log("demo 123123", getfromStep);

      if (getfromStep) {
        setFieldValue("FR_Salary", getfromStep?.nSalary);
        setFieldValue("FR_Rate", getfromStep?.nrate);
      }
    }
  };

  useEffect(() => {
    if (
      values?.CurrentProcessStatus?.value !== null &&
      values?.CurrentProcessStatus?.value !== undefined &&
      values?.CurrentProcessStatus?.value !== 0
    ) {
      if (
        (values?.CurrentProcessStatus?.value == 18 ||
          values?.CurrentProcessStatus?.value == 6) &&
        pageStatus == "create"
      ) {
        setDisabledNature(false);
        if (values?.natureCode?.value == "91" || noa == "91") {
          setDisabledNature(true);
        }
      } else if (
        (values?.CurrentProcessStatus?.value == 18 ||
          values?.CurrentProcessStatus?.value == 6) &&
        pageStatus == "update"
      ) {
        setDisabledNature(true);
      } else if (currentStatus) {
        setDisabledNature(true);
        // if (values?.CurrentProcessStatus?.value != 8) {
        setTimeout(() => {
          setErrorHighLight([]);
        }, 1000);
        // }
      }

      // else if (currentStatus) {
      //   setDisabledNature(true);
      //   if (
      //     values?.CurrentProcessStatus?.value == 8 ||
      //     values?.natureCode?.value == "66"
      //   ) {
      //     // setErrorHighLight([{ Budget_Account_Number: "Required" }]);
      //   } else {
      //     // setTimeout(() => {
      //     //   setErrorHighLight([]);
      //     // }, 1000);
      //   }
      // }
    }
    if (
      values?.CurrentProcessStatus?.value != 18 &&
      values?.CurrentProcessStatus?.value != 6
    ) {
      // console.log("121212 call blank ::: ");
      if (
        values?.natureCode?.value == "3" ||
        values?.natureCode?.value == "28" ||
        values?.natureCode?.value == "25" ||
        values?.natureCode?.value == "38" ||
        values?.natureCode?.value == "7" ||
        // values?.natureCode?.value == "6" ||
        values?.natureCode?.value == "20" ||
        values?.natureCode?.value == "47" ||
        values?.natureCode?.value == "24" ||
        values?.natureCode?.value == "76" ||
        values?.natureCode?.value == "52" ||
        values?.natureCode?.value == "54" ||
        values?.natureCode?.value == "57"
      ) {
        setFromFiledsBlank();
      }
      // if (
      //   values?.natureCode?.value == "10" ||
      //   values?.natureCode?.value == "14" ||
      //   values?.natureCode?.value == "15" ||
      //   values?.natureCode?.value == "16" ||
      //   values?.natureCode?.value == "17" ||
      //   values?.natureCode?.value == "18" ||
      //   values?.natureCode?.value == "40" ||
      //   values?.natureCode?.value == "41" ||
      //   values?.natureCode?.value == "42" ||
      //   values?.natureCode?.value == "45" ||
      //   values?.natureCode?.value == "48" ||
      //   values?.natureCode?.value == "49" ||
      //   // values?.natureCode?.value == "55" ||
      //   values?.natureCode?.value == "64" ||
      //   values?.natureCode?.value == "71" ||
      //   values?.natureCode?.value == "79" ||
      //   values?.natureCode?.value == "83" ||
      //   values?.natureCode?.value == "92"
      // ) {
      //   setToFiledsBlank();
      // }

      // Separation NOAs is a list of separation NOAs To fields are blanked in those.
      let stringNOA =
        typeof values?.natureCode?.value == "number"
          ? JSON.stringify(values?.natureCode?.value)
          : values?.natureCode?.value;
      if (SeparationNOAs.includes(stringNOA)) {
        setToFiledsBlank();
      }
    } else {
      // if(values?.natureCode?.value == "64"){
      //   setToFiledsBlank();
      // }
      let stringNOA =
        typeof values?.natureCode?.value == "number"
          ? JSON.stringify(values?.natureCode?.value)
          : values?.natureCode?.value;
      if (SeparationNOAs.includes(stringNOA)) {
        setToFiledsBlank();
      }
    }
  }, [values.CurrentProcessStatus, values?.natureCode?.value, noa]);

  useEffect(() => {
    if (pageStatus == "create") {
      setDisabledNature(false);
    } else {
      setDisabledNature(true);
    }
  }, [updatedData?.currentProcessStatus, pageStatus]);

  useEffect(() => {
    let deptOptions = DpDvOptions.filter((item) => item.deptDiv == "");
    setDepartmentOptions(deptOptions);
    let divOptions = DpDvOptions.filter((item) => item.deptDiv != "");
    setDivisionOptions(divOptions);
  }, [DpDvOptions]);

  useEffect(() => {
    let deptOptions = positionTitleOptions.filter(
      (item) => item?.titleWithGrade?.indexOf("-") != -1
    );
    setClassifiedPositionOption(deptOptions);
    // let divOptions = positionTitleOptions.filter((item) => item.deptDiv != "");
    // setClassifiedPosiitonOption(divOptions);
  }, [positionTitleOptions]);

  useEffect(() => {
    if (divisionOptions?.length) {
      // setFieldValue("TO_Division", { value: "", label: "" });
      let newDivisions = divisionOptions.filter(
        (item) => item?.deptNo == values?.TO_Department?.value
      );

      setFilteredDivisionOptions(newDivisions);
    }
  }, [
    values?.TO_Department?.value,
    noa,
    values?.natureCode?.value,
    divisionOptions,
  ]);

  const getFilteredDivisons = () => {
    if (divisionOptions?.length) {
      // setFieldValue("TO_Division", { value: "", label: "" });
      let newDivisions = divisionOptions.filter(
        (item) => item?.deptNo == values?.TO_Department?.value
      );

      setFilteredDivisionOptions(newDivisions);
    }
  };

  useEffect(() => {
    if (divisionOptions?.length) {
      // setFieldValue("FR_Division", { value: "", label: "" });
      let newFromDivisions = divisionOptions.filter(
        (item) => item?.deptNo == values?.FR_Department?.value
      );

      setFilteredDivisionFromOptions(newFromDivisions);
    }
  }, [values?.FR_Department?.value, divisionOptions]);

  const [newExtraPosition, setNewExtraPosition] = useState();
  const handleInputChange = (event, newInputValue) => {
    setNewExtraPosition(newInputValue);
  };

  const setFromFiledsBlank = () => {
    setFieldValue("FR_Dept_Div_Sec", {
      value: "",
      label: "",
      division: "",
    });
    setFieldValue("FR_Department", { value: "", label: "" });
    setFieldValue("FR_Division", { value: "", label: "" });
    setFieldValue("FR_FTE_Number", "");
    setFieldValue("FR_Grade", "");
    setFieldValue("FR_PositionTitle", {
      value: "",
      label: "",
      range_next: "",
      titleWithGrade: "",
    });
    setFieldValue("FR_Rate", "");
    setFieldValue("FR_Salary", "");
    setFieldValue("FR_Step", "");
  };
  const setToFiledsBlank = () => {
    setFieldValue("TO_Dept_Div_Sec", { value: "", label: "", division: "" });
    setFieldValue("TO_Department", { value: "", label: "" });
    setFieldValue("TO_Division", { value: "", label: "" });
    setFieldValue("TO_FTE_Number", "");
    setFieldValue("TO_Grade", "");
    setFieldValue("TO_PositionTitle", {
      value: "",
      label: "",
      range_next: "",
      titleWithGrade: "",
    });
    setFieldValue("TO_Rate", "");
    setFieldValue("TO_Salary", "");
    setFieldValue("TO_Step", "");
  };

  const checkUnclassifiedPositions = (pos, errMsgs) => {
    if (
      pos == "from" &&
      values?.FR_PositionTitle?.titleWithGrade.indexOf("-") == -1
    ) {
      let newArray = [];
      let newArray1 = [];
      let newArray2 = [];

      // newArray = errorHighLight.filter((i) => {
      //   return !i["FR_Grade"] && !i["FR_Step"];
      // });
      if (errMsgs && errMsgs?.length) {
        newArray1 = errMsgs.filter(
          (i) => i.id != "FR_Grade" && i.id != "FR_Step"
        );
      }
      // newArray2 = highlight.filter((i) => {
      //   return !i["FR_Grade"] && !i["FR_Step"];
      // });
      // console.log(
      //   "121212 unclassified Poss useeffect 456 ::: ",
      //   newArray,
      //   newArray1,
      //   newArray2
      // );
      // setErrorHighLight(newArray);
      setErrorMessage(newArray1);
      // setHighlight(newArray2);
    }
    // console.log(
    //   "121212 unclassified TO Grade key1 : ",
    //   values?.TO_PositionTitle?.titleWithGrade?.indexOf("-"),
    //   values?.TO_Grade
    // );
    if (
      pos == "to" &&
      values?.TO_PositionTitle?.titleWithGrade?.indexOf("-") == -1
      // values?.TO_PositionTitle?.range_next &&
      // values?.TO_PositionTitle?.range_next?.trim() == ""
    ) {
      let newArray = [];
      let newArray1 = [...errorMessage];
      let newArray2 = [];

      // newArray = errorHighLight.filter((i) => {
      //   const key1 = Object.keys(i);
      //   console.log("121212 unclassified TO Grade key1 : ", key1);
      //   return key1[0] != "TO_Grade" && key1[0] != "TO_Step";
      // });
      // console.log("121212 unclassified TO Grade 000 ::: ", errorMessage);
      if (errMsgs && errMsgs?.length) {
        newArray1 = errMsgs.filter(
          (i) => i.id != "TO_Grade" && i.id != "TO_Step"
        );
      }
      // newArray2 = highlight.filter((i, j) => {
      //   // return !i.TO_Grade && !i.TO_Step;
      //   return !i["FR_Grade"] && !i["FR_Step"];
      //   // return !i?.TO_Grade;
      // });

      // setErrorHighLight(newArray);
      setErrorMessage(newArray1);
      // setHighlight(newArray2);
      // console.log("121212 unclassified TO Grade after set ::: ", newArray1);
    }
  };

  // useEffect(() => {
  //   checkUnclassifiedPositions();
  // }, [values?.TO_PositionTitle, values?.FR_PositionTitle]);
  // useEffect(() => {
  //   let newArray = [];
  //   let newArray1 = [];
  //   let newArray2 = [];
  //   console.log(
  //     "121212 unclassified Poss useeffect ::: ",
  //     values?.FR_PositionTitle,
  //     values?.TO_PositionTitle
  //   );
  //   if (values?.FR_PositionTitle?.range_next?.trim() == "") {
  //     setFieldValue("FR_Grade", "");
  //     setFieldValue("FR_Step", "");
  //     newArray = errorHighLight.filter((i) => {
  //       return !i["FR_Grade"] && !i["FR_Step"];
  //     });
  //     newArray1 = errorMessage.filter(
  //       (i) => i.id != "FR_Grade" && i.id != "FR_Step"
  //     );
  //     newArray2 = highlight.filter((i) => {
  //       return !i["FR_Grade"] && !i["FR_Step"];
  //     });
  //     console.log(
  //       "121212 unclassified Poss useeffect ::: ",
  //       newArray,
  //       newArray1
  //     );
  //     setErrorHighLight(newArray);
  //     setErrorMessage(newArray1);
  //   }
  //   if (
  //     values?.TO_PositionTitle?.range_next?.trim() == "" ||
  //     values?.TO_PositionTitle?.range_next == null ||
  //     values?.TO_PositionTitle?.range_next == "undefined"
  //   ) {
  //     let newArray = [];
  //     let newArray1 = [];
  //     setFieldValue("TO_Grade", "");
  //     setFieldValue("TO_Step", "");
  //     newArray = errorHighLight.filter((i) => {
  //       return !i["TO_Grade"] && !i["TO_Step"];
  //     });
  //     newArray1 = errorMessage.filter(
  //       (i) => i.id != "TO_Grade" && i.id != "TO_Step"
  //     );
  //     newArray2 = highlight.filter((i) => {
  //       return !i["TO_Grade"] && !i["TO_Step"];
  //     });
  //     console.log("121212 unclassified TO Grade ::: ", newArray, newArray1);
  //     setErrorHighLight(newArray);
  //     setErrorMessage(newArray1);
  //     setHighlight(newArray2);
  //   }

  //   console.log(
  //     "121212 unclassified Poss useeffect ::: ",
  //     errorHighLight,
  //     errorMessage
  //   );
  // }, [values?.FR_PositionTitle?.value, values?.TO_PositionTitle?.value]);

  const getMaxStatusSeq = (transactionProcessStatuses, processArray) => {
    if (transactionProcessStatuses?.length && processArray?.length) {
      // let filteredStatuses = transactionProcessStatuses.filter((item)=>item?.transactionProcessStatus?.status?.includes("Approved To")

      let lastApprovedTransaction = transactionProcessStatuses.filter(
        (transaction) =>
          transaction.transactionProcessStatus.status
            .toLowerCase()
            .includes("approved")
      );
      let lastStatustStrArray = lastApprovedTransaction.map((i) =>
        i.transactionProcessStatus?.status?.split("Approved To")[1]?.trim()
      );
      let newArrayforMax = processArray.filter((obj) =>
        lastStatustStrArray.includes(obj.statusName)
      );
      let maxSeq = newArrayforMax.reduce(
        (max, obj) => (obj.seq > max.seq ? obj : max),
        newArrayforMax[0]
      );

      setMaxState(maxSeq?.seq);
    }
  };
  const [approvedData, setApprovedData] = useState([]);
  useEffect(() => {
    // debugger
    // let BBMRStatuses = [8,339,272,342,338]
    let BBMRStatuses = ["BBMR", "Assign Analyst", "Analyst Review", "Supervisor Review", "Director Review"]
    if (auditTrailData && auditTrailData?.length) {
      console.log("123123 audit trail ::: ", auditTrailData)
      let newArray = [];
      auditTrailData.map((item, i) => {
        console.log("123123 Items in Process ", item, i);
        // if (item?.processStatusId == 7 && item?.status == "Approved") {
        if (
          item?.statusName == "Cert Officer" &&
          item?.finalStatus?.startsWith(
            "Transmitted for"
          )
        ) {
          newArray.push({
            performedBy: item?.peformedByName || item?.performedBy,
            statusId: 7, //item?.transactionProcessStatus?.processStatusId,
            performedOn: item?.dateCompleted
              ? dayjs(item?.dateCompleted).format(
                "MM/DD/YYYY hh:mm A"
              )
              : "",
          });
        }
        if (
          item?.statusName == "Agency Director" &&
          item?.finalStatus?.startsWith(
            "Transmitted for"
          )
        ) {
          newArray.push({
            performedBy: item?.peformedByName || item?.performedBy,
            statusId: 133, // item?.transactionProcessStatus?.processStatusId,
            performedOn: item?.dateCompleted
              ? dayjs(item?.dateCompleted).format(
                "MM/DD/YYYY hh:mm A"
              )
              : "",
          });
        }
        // if (
        //     (item?.transactionProcessStatus?.processStatusId == 8 ||
        //     item?.transactionProcessStatus?.processStatusId == 339 || 
        //     item?.transactionProcessStatus?.processStatusId == 272 || 
        //     item?.transactionProcessStatus?.processStatusId == 342 || 
        //     item?.transactionProcessStatus?.processStatusId == 338) ||
        //       (item?.transactionProcessStatus?.status?.includes("Transaction Approved To Director Review") ||
        //       item?.transactionProcessStatus?.status?.includes("Transaction Approved To Supervisor Review") || 
        //       item?.transactionProcessStatus?.status?.includes("Transaction Approved To Analyst Review") || 
        //       item?.transactionProcessStatus?.status?.includes("Transaction Approved To Assign Analyst") || 
        //       item?.transactionProcessStatus?.status?.includes("Transaction Approved To BBMR"))
        //     && item?.transactionProcessStatus?.status?.startsWith("Transaction Approved To")
        // ) {
        if (
          (BBMRStatuses?.includes(item?.statusName) ||
            // || BBMRStatuses?.includes(item?.transactionProcessStatus?.targetProcessStatusId)) ||
            (item?.status?.includes("Transaction Approved To Director Review") ||
              item?.status?.includes("Transaction Approved To Supervisor Review") ||
              item?.status?.includes("Transaction Approved To Analyst Review") ||
              item?.status?.includes("Transaction Approved To Assign Analyst") ||
              item?.status?.includes("Transaction Approved To BBMR")))
          && item?.status?.startsWith("Transaction Approved To")
        ) {
          newArray.push({
            bbmr: true,
            performedBy: item?.peformedByName || item?.performedBy,
            statusId: processStatusList.find(data => data?.statusName == item?.statusName).id,
            performedOn: item?.dateCompleted
              ? dayjs(item?.dateCompleted).format(
                "MM/DD/YYYY hh:mm A"
              )
              : "",
          });
        }
      });
      console.log("123123 newArray::: ", newArray, processStatusList);
      setApprovedData(newArray?.reverse());
      // if(maxState == 0){
      // getMaxStatusSeq(auditTrailData, processStatusList);
      // }
    }
  }, [auditTrailData]);

  useEffect(() => {
    if (BBMRJobOrdersNo) {

      setFieldValue("JOB_Order_Number", BBMRJobOrdersNo['Job_Number'])
      setFieldValue("Main_Account", BBMRJobOrdersNo['D365_Account_No'])
      setFieldValue("Account_Description", BBMRJobOrdersNo['Description'])
      setFieldValue("Description", BBMRJobOrdersNo['Main_Account_Description'])
      setFieldValue("AS400_Account_No", BBMRJobOrdersNo['AS400_Account_No'])
      setFieldValue("Fund_Dimension", BBMRJobOrdersNo['Fund_Dimension'])
      setFieldValue("Year_Dimension", BBMRJobOrdersNo['Year_Dimension'])

      // setFieldValue("D365_Account_No",BBMRJobOrdersNo['D365_Account_No'])

    }
  }, [BBMRJobOrdersNo])

  const customsubmitBtn = <Btn
    type='button'
    attrBtn={{
      color: "primary",
      type: "submit",
      style: {
        marginRight: "4px",
      },
      onClick: (e) => {
        // e.stopPropagation();
        onAssign()

      },
      disabled: npaStarted
        ? true
        : false,
    }}

  >
    <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="save" />
    Submit Data
  </Btn>

  const getFileData = async (e) => {
    console.log("123123 ::: ", e)
    // setIsLoading(true)
    // setDeletedItemIdsMannual([])
    // setDeletedItemIdsUpload([])
    // setDeletedItemIdsOld([])
    // setFileErrors([]);
    try {


      // let leaveData = rowsData.filter((i) => ["2", "3"].includes(i.code));
      // if (rowsData.length) {
      //   let deletedItem = rowsData.filter(
      //     (i) => i.ID && !["2", "3"].includes(i.code)
      //   );
      //   let oldids = [...deletedItemIdsOld]
      //   deletedItem = deletedItem?.map((i) =>
      //     oldids.push(i.ID)
      //   );

      //   setDeletedItemIdsOld(oldids);
      // }

      const fileType = e.target.files[0].type;
      console.log('Matrix 123123 `Uploaded File - ${e.target.files[0].name}`', e.target.files[0].name);

      // setUploadFileName(`Uploaded File - ${e.target.files[0].name}`);
      if (
        fileType !== "application/vnd.ms-excel.sheet.macroEnabled.12" &&
        fileType !== "application/vnd.ms-excel.sheet.macroenabled.12" &&
        fileType !== "application/vnd.ms-excel" &&
        fileType !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        toast.error("Please upload valid file");
        return false;
      }
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = async (event) => {
        const data = new Uint8Array(event.target.result);
        // data;
        console.log("Matrix 123123 ", data)
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let jsonData = XLSX.utils.sheet_to_json(worksheet, {
          // header: 1,
          raw: false,
          cellDates: true,
          dateNF: "yyyy-mm-dd",
          defval: "",
        });
        jsonData = jsonData.filter((i) => i["Date of Birth"] != "");
        jsonData = jsonData.map((obj) => {
          for (const key in obj) {
            if (key.startsWith("__EMPTY")) {
              delete obj[key];
            }
          }
          return obj;
        });
        console.log("jsonData", jsonData);
        let applicantData = [];
        if (jsonData.length) {

          jsonData.map((k) => {
            let newObj = {
              "FirstName": k["First Name"],
              "LastName": k["Last Name"],
              "MiddleName": k["Middle Name"],
              "DOB": k["Date of Birth"],
              "SSN": k["SSN"],
            }
            applicantData.push(newObj)
          })
        }
        // setBulkData(applicantData);
        console.log("applicantData", applicantData);
        // let collectItem = [];
        // const excelKeys = Object.keys(jsonData[0])
        // if (excelKeys.includes('Date') && excelKeys.includes('Week')) {
        //   ShowError("Please verify excel sheet")
        //   return false
        // }
        // if (excelKeys.includes('Date')) {
        //   jsonData = jsonData.sort((a, b) => {
        //     // First, compare the dates
        //     if (a.Date < b.Date) return -1;
        //     if (a.Date > b.Date) return 1;
        //     return 0;
        //   });

        // }


        // // const modifiedData = jsonData.map((item, i) => {
        // let modifiedData = jsonData.map((item, i) => {

        //   // keyData.map(async (k) => {
        //   //   if (k.type == "time_from") {
        //   //     item[k.type] = addPad(item[k.labal]?.trim());
        //   //     delete item[k.labal];
        //   //   } else if (k.type == "On Compound") {
        //   //     item["OnCompound"] = item[k.labal];
        //   //     delete item[k.type];
        //   //   } else if (k.type == "Ambulance") {
        //   //     item["Ambulance"] = item[k.labal];
        //   //   } else if (k.type == "RDO") {
        //   //     item["RDO"] = ["1", true, "TRUE", "Y"].includes(item[k.labal]) ? "1" : '';
        //   //   }
        //   //   else if (k.type == "Exposed") {
        //   //     item["Exposed"] = item[k.labal];
        //   //   } else if (k.type == "From") {
        //   //     item["time_from"] = addPad(item[k.labal]?.trim());
        //   //     delete item[k.labal];
        //   //   } else if (k.type == "To") {
        //   //     item["time_to"] = addPad(item[k.labal]?.trim());
        //   //     delete item[k.labal];
        //   //   } else if (k.type == "Date") {
        //   //     item["Date"] = moment(item[k.labal]).format("YYYY-MM-DD");
        //   //     // delete item[k.labal];
        //   //   } else if (k.type == "Week" && item?.Week) {
        //   //     // item["OnCompound"] = item[k.labal];

        //   //     item["date"] = payPeriodDate.find(
        //   //       (i) => i.week == item.Week && i.day == item.Day
        //   //     )?.date; // await getPPEDATEFROMDAYANDWEEK(item.Day ,item.week)

        //   //     // delete item[k.type]
        //   //   } else if (k.type == "time_to") {
        //   //     item[k.type] = addPad(item[k.labal]);
        //   //     delete item[k.labal];
        //   //   }  else {
        //   //     item["EmployeeID"] = userId;
        //   //   }
        //   // });

        //   item["jobtype"] = item["jobtype"] ? item["jobtype"] : "REG";


        //   // item["Date"]=
        //   item["rowstatus"] = "Confirm";
        //   item["EmployeeID"] = item["EmployeeID"] ? item["EmployeeID"] : empID;
        //   item["ole2"] = false;
        //   item["ole1"] = false;
        //   item["isNew"] = true;

        //   item["submitType"] = "excel";
        //   item["holiday"] = checkIsHoliday(
        //     holidaysData,
        //     moment(item["date"]).format("YYYY-MM-DD")
        //   )?.status;
        //   // item["holidayID"] = checkIsHoliday(
        //   //   holidaysData,
        //   //   moment(item["date"]).format("YYYY-MM-DD")
        //   // )?.ID;

        //   item["date"] = moment(item["date"]).format("YYYY-MM-DD");

        //   item["payAmount"] = payInfo;
        //   collectItem.push(item);
        //   let itemcopy = { ...item };

        // });
        // modifiedData = collectItem;
        // if (!modifiedData.length) {
        //   setRowsData(modifiedData)
        //   setIsLoading(false)
        //   return false
        // }
        // if (modifiedData?.length && Object.keys(modifiedData[0]).includes("Pay Code")) {
        //   modifiedData = modifiedData?.map((i) => {
        //     const rate = getRateForDate(amountArray, i["date"], price);
        //     let payInfo = getCalculatedAmtMin(
        //       i.mn + i.mn1,
        //       paytimeCode?.find((item) => item.code == i["Pay Code"])?.label,
        //       rate?.price
        //     );
        //     if (["46", "105", "110", "111", "112", "113", "114", "115"].includes(i["Pay Code"])) {
        //       payInfo = payInfo * 1.5
        //     }
        //     return { ...i, code: i["Pay Code"], jobtype: paytimeCode?.find((item) => item.code == i["Pay Code"])?.label, payAmount: payInfo }
        //   })
        //   setRowsData(modifiedData)
        //   setIsLoading(false)
        // } else {
        //   //add split and appl
        //   if (isApply8to5) {
        //     modifiedData = split8to5AllData(modifiedData)
        //     modifiedData = sortingDataCommon(modifiedData)
        //   }
        //   modifiedData = await addHOLforRDO(modifiedData, ["REG"]);
        //   modifiedData = await addHOLRow(modifiedData, ["REG"]);


        //   let InfomodifiedData = await UpdateTimesheetRulesAfterLoad(modifiedData);
        // }
      }
      reader.readAsArrayBuffer(file);
    } catch (error) {
      // setIsLoading(false)
    }


  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [additionalWheresN, setAdditionalWheresN] = useState('');
  const [additionalWheresN2, setAdditionalWheresN2] = useState('');

  const handleCloseSummaryModal = () => {
    setOpenBBMRSummary(false);
  }

  // console.log = console.warn = console.error = () => {}; 
  return (
    <Fragment>
      {(rolesArray.includes(role?.toLowerCase()) || ["DEPT-ADMIN", "SUPER-USER", "CERTIFYING-OFFICER", "AGENCY-DIRECTOR", "BBMR-ADMIN", "BBMR-ANALYST", "BBMR-SUPERVISOR", "BBMR-DIRECTOR"].includes(role)) && userData?.profile?.GG1_BLANKET_ALLOWED && userData?.profile?.GG1_BLANKET_ALLOWED?.toLowerCase()?.trim() == 'yes' ?
        <Container fluid={true}>
          <>
            {" "}
            {isloading || loding || batchInfoLoader || roleLoader ? loadingPanel() : null}
            {/* {loadingPanel} */}
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (
                  values?.natureCode?.value != "" &&
                  values?.natureCode?.label != "" &&
                  values?.CurrentProcessStatus?.value != 0
                ) {
                  // handleSubmit();
                  onTransactionChange();
                }
              }}
            >
              {/* <Row className="">
             */}
              {/* <Breadcrumbs
              mainTitle={
                <Typography variant="h5">
                  <Icon
                    style={{ fontSize: "25px", margin: "10px" }}
                    name="list-latin-small"
                  />
                  {employeeID && hrControl ? (
                    <>Update GG1 Batch Transactions</>
                  ) : (
                    "Create GG1 Batch Transactions"
                  )}
                </Typography>
              }
              parent={
                employeeID && !hrControl ? (
                  isAllowedURL("/employee-master", userData) ? (
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/employee-master`}
                      className="font-light"
                    >
                      Employee Master
                    </NavLink>
                  ) : undefined
                ) : isAllowedURL("/transactionlist", userData) ? (
                  <NavLink
                    to={role == "BBMR-ADMIN" || role == "BBMR-ANALYST" || role == "BBMR-SUPERVISOR" || role == "BBMR-DIRECTOR" ? `${process.env.PUBLIC_URL}/bbmr-gg1-tracking` : `${process.env.PUBLIC_URL}/gg1-tracking`}
                    className="font-light"
                  >
                    GG1 Tracking
                  </NavLink>
                ) : undefined
              }
              title={
                hrControl
                  ? values?.fullName && values?.natureCode?.label
                    ? ` ${values?.natureCode?.label}- ${values?.fullName}`
                    : "Details"
                  : "New"
              }
            /> */}

              <CardHeader>
                <div
                  className={` w-100`}
                  style={{
                    height: "auto",
                    borderRadius: "5px",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="mt-2 mr-3   d-flex justify-content-end bd-highlight "
                    style={{ paddingRight: "3rem", paddingBottom: "1rem" }}
                  >
                    <div className="mr-2">
                      {/* <Btn
                      attrBtn={{
                        color: "primary",
                        type: "submit",
                        style: {
                          marginRight: "4px",
                          marginBottom: "5px",
                        },
                        onClick: () => {
                          {
                            employeeID && hrControl
                              ? role == "BBMR-ADMIN" || role == "BBMR-ANALYST" || role == "BBMR-SUPERVISOR" || role == "BBMR-DIRECTOR"
                                ? navigate("/bbmr-gg1-tracking")
                                : navigate("/gg1-tracking")
                              : navigate("/employee-master");
                          }
                        },
                      }}
                    >
                      {employeeID && hrControl ? (
                        <>
                          {" "}
                          <Icon
                            style={{ fontSize: "18px" }}
                            name="arrow-left"
                          />
                          Back to GG1 Tracking
                        </>
                      ) : (
                        <>
                          <Icon
                            style={{ fontSize: "18px" }}
                            name="arrow-left"
                          />
                          Back To Employee Master
                        </>
                      )}
                    </Btn>
                    {employeeID && hrControl ? null : (
                      <Btn
                        attrBtn={{
                          color: "primary",
                          style: { marginRight: "3px" },
                          style: {
                            marginRight: "4px",
                            marginBottom: "5px",
                          },
                          onClick: () => {
                            handleValidateSSN();
                          },
                        }}
                      >
                        <Icon style={{ fontSize: "18px" }} name="download" />
                        Get Data
                      </Btn>
                    )} */}

                      {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/transaction" + empID, {
                        replace: true,
                      });
                    }}
                  >
                    Other Transactions
                  </Button>{" "} */}
                      {/* <Btn
                      attrBtn={{
                        color: "primary",
                        type: "submit",
                        style: {
                          marginRight: "4px",
                          marginBottom: "5px",
                        },
                        disabled:
                          role == "user" &&
                            values?.CurrentProcessStatus?.value != 18 &&
                            values?.CurrentProcessStatus?.value != 6
                            ? true
                            : false,
                      }}

                      onClick={() => onAssign()}
                    >
                      <Icon style={{ fontSize: "18px", marginRight:"10px" }} name="save" />
                      Submit Data
                    </Btn> */}
                      <Btn
                        attrBtn={{
                          color: "primary",
                          style: { marginLeft: "3px", marginBottom: "5px" },

                          onClick: () => {
                            console.log("123123 clicked...")
                            setOpenBBMRSummary(true)
                            // onTransactionChange();
                          },
                        }}
                      >
                        <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="grid" />
                        Budget Summary
                      </Btn>
                      {resetEnable ?
                        <Btn
                          attrBtn={{
                            color: "primary",
                            style: { marginLeft: "3px", marginBottom: "5px" },

                            onClick: () => {
                              console.log("123123 ::: clicked...")
                              setOpenResetModal(true)
                            },
                          }}
                        >
                          <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="reset" />
                          Reset Blanket
                        </Btn>
                        : null}
                      <Btn
                        attrBtn={{
                          color: "primary",
                          style: { marginLeft: "3px", marginBottom: "5px" },

                          onClick: () => {
                            // clearToValues();
                            // handleSubmit()
                            onTransactionChange();
                          },
                        }}

                      >
                        <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="save" />
                        Save Transaction
                      </Btn>
                      {/* <Btn
                      attrBtn={{
                        color: "primary",

                        style: { marginLeft: "3px", marginBottom: "5px" },
                        onClick: () => {
                          copyFromValues();
                        },
                      }}
                    >
                      <Icon style={{ fontSize: "18px" }} name="copy" />
                      Copy From
                    </Btn> */}
                      {/* {showReload ? 
                      <Btn
                      type="button"
                      attrBtn={{
                        color: "primary",

                        style: { marginLeft: "3px", marginBottom: "5px" },
                        onClick: () => {
                          window.location.href=""
                        },
                      }}
                    >
                      <Icon style={{ fontSize: "18px" }} name="reload" />
                      Reload Data
                    </Btn>
                  :null
                    } */}
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </CardHeader>
              {showReload ?
                <Row>
                  <Col md="12" sm="12" className="p-3" style={{ alignItems: "center" }}>
                    <Alert severity="error">
                      {"Please  "}
                      <Link href="" underline="hover" onClick={() => { window.location.href = "" }}>
                        refresh
                      </Link>
                      {" this page again."}
                    </Alert>
                  </Col>
                </Row>
                : null}
              <Row>
                <Col
                  sm="12"
                // style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}
                >
                  <Card>
                    <CardBody>
                      <div
                        style={{
                          display: "flex ",
                          justifyContent: "end",
                          marginBottom: "1rem",
                        }}
                      >
                        {/* <CustomLegand /> */}
                        {
                          // employeeID &&
                          // hrControl &&
                          values?.CurrentProcessStatus?.value && //(values?.CurrentProcessStatus?.value != 18 && values?.CurrentProcessStatus?.value != 6) &&
                            renderProcessFlow ? (
                            <>
                              <div className="d-flex float-right">
                                {/* {values?.CurrentProcessStatus?.value == 18 ||
                              values?.CurrentProcessStatus?.value == 6 ||
                              values?.CurrentProcessStatus?.value == 7 ||
                              values?.CurrentProcessStatus?.value == 133 ? (
                              <Btn
                                attrBtn={{
                                  className: "m-1",
                                  color: "primary",
                                  onClick: () => {
                                    console.log("Cancel GG1");
                                    // handlePrint()
                                    if (
                                      window.confirm(
                                        "Are you sure to cancel the request?"
                                      )
                                    ) {
                                      let payload = {
                                        ActionNo: values?.ActionNo,
                                        isCancel: true,
                                      };
                                      dispatch(deleteGG1Action(payload));
                                      // setTimeout(() => {
                                      //   navigate(`/gg1-tracking`);
                                      // }, 500);
                                    }
                                  },
                                }}
                              >
                                Cancel
                              </Btn>
                            ) : null} */}
                                <Btn
                                  attrBtn={{
                                    className: "m-1",
                                    color: "primary",
                                    onClick: () => handlePrint(),
                                    disabled: updatedData?.Rate ? false : true,
                                  }}
                                >
                                  <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="print" />
                                  Print
                                </Btn>

                                <Btn
                                  attrBtn={{
                                    className: "m-1",
                                    color: "primary",
                                    onClick: () => {
                                      setViewForm(true);
                                    },
                                    disabled: updatedData?.Rate ? false : true
                                  }}
                                >
                                  <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="file" />
                                  View Blanket GG-1
                                </Btn>
                              </div>
                            </>
                          ) : null}
                      </div>

                      {/*                     

                    {employeeID &&
                    actionNo &&
                    values?.CurrentProcessStatus?.value &&
                    renderProcessFlow ? (
                      <Row className="mb-3">
                        <GG1Workflow
                          currentValue={values?.CurrentProcessStatus?.value}
                          ProcessID={1}
                          setRenderProcessFlow={setRenderProcessFlow}
                        />
                      </Row>
                    ) : null} */}

                      {/* {console.log(
                      "323232 ::: ",
                      values?.CurrentProcessStatus?.value,
                      renderProcessFlow,
                      hrControl,
                      employeeID
                    )} */}

                      {
                        // employeeID &&
                        //   hrControl &&
                        values?.CurrentProcessStatus?.value
                          // && renderProcessFlow 
                          ? (
                            <>
                              {/* <div className="d-flex justify-content-end m-4 ">
                          <Btn
                            attrBtn={{
                              className: "m-1",
                              color: "primary",
                              onClick: () => handlePrint(),
                            }}
                          >
                            Print
                          </Btn>

                          <Btn
                            attrBtn={{
                              className: "m-1",
                              color: "primary",
                              onClick: () => {
                                setViewForm(true);
                              },
                            }}
                          >
                            View GG-1
                          </Btn>
                        </div> */}

                              <>
                                <Row className="mb-3">
                                  <Col
                                    md={npaStarted ? 11 : 12}
                                    sm={npaStarted ? 11 : 12}
                                    lg={npaStarted ? 11 : 12}
                                    xs={npaStarted ? 11 : 12}
                                    xl={npaStarted ? 11 : 12}
                                  >
                                    <GG1WorkflowBlanket
                                      currentValue={
                                        npaStarted
                                          ? 135 //19
                                          : values?.CurrentProcessStatus?.value
                                      }
                                      ProcessID={1}
                                      setRenderProcessFlow={setRenderProcessFlow}
                                      noa={values?.natureCode?.value}
                                      // evaluation={values?.Evalution_Type}
                                      toGrade={values?.TO_Grade}
                                      // fromGrade={values?.FR_Grade}
                                      toDepartment={values?.TO_Department?.label}
                                      // BBMRSkipLogin = {BBMRSkipLogin}
                                      role={role}
                                    // Blanket={true}
                                    />
                                  </Col>
                                  {npaStarted && (
                                    <Col
                                      md={1}
                                      style={{
                                        display: "flex",
                                        textAlign: "center",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <IconButton size="small">
                                        <FontAwesomeIcon
                                          icon={faDatabase}
                                          size="xl"
                                        />
                                      </IconButton>
                                      <span>NPA Processed</span>
                                    </Col>
                                  )}
                                </Row>
                                {showSubWorkflow ?
                                  <>
                                    {
                                      (values?.CurrentProcessStatus?.value == "338" ||
                                        (processStatusList?.length > 0 &&
                                          processStatusList?.find(
                                            (i) =>
                                              i?.id ==
                                              values?.CurrentProcessStatus?.value
                                          )?.parentId == "338")) && (
                                        // {(values?.CurrentProcessStatus?.value == "338" ) &&

                                        <Row className="mb-3">
                                          <Col>
                                            <GG1SubWorkflowBlanket
                                              currentValue={
                                                npaStarted
                                                  ? 135 //19
                                                  : values?.CurrentProcessStatus?.value
                                              }
                                              ProcessID={1}
                                              setRenderProcessFlow={
                                                setRenderProcessFlow
                                              }
                                              noa={values?.natureCode?.value}
                                              evaluation={values?.Evalution_Type}
                                              toGrade={values?.TO_Grade}
                                              fromGrade={values?.FR_Grade}
                                            />
                                          </Col>
                                        </Row>
                                      )
                                      // : <></>
                                    }
                                  </>
                                  : null}
                              </>
                            </>
                          )
                          // values?.CurrentProcessStatus?.value &&
                          //   renderProcessFlow && !DepartmentsToSkipBBMR.includes(values?.TO_Department?.label) &&
                          //   (values?.natureCode?.value == "30" ||
                          //     values?.natureCode?.value == "58") ? (
                          //   <Row className="mb-3">
                          //     <Col
                          //       md={npaStarted ? 11 : 12}
                          //       sm={npaStarted ? 11 : 12}
                          //       lg={npaStarted ? 11 : 12}
                          //       xs={npaStarted ? 11 : 12}
                          //       xl={npaStarted ? 11 : 12}
                          //     >
                          //       <GG1Workflow
                          //         currentValue={
                          //           npaStarted
                          //             ? 19
                          //             : values?.CurrentProcessStatus?.value
                          //         }
                          //         ProcessID={1}
                          //         setRenderProcessFlow={setRenderProcessFlow}
                          //         noa={values?.natureCode?.value}
                          //         evaluation={values?.Evalution_Type}
                          //         role={role}
                          //       />
                          //     </Col>
                          //     {/* {npaStarted && (
                          //       <Col
                          //         md={1}
                          //         style={{
                          //           display: "flex",
                          //           textAlign: "center",
                          //           justifyContent: "center",
                          //           alignItems: "center",
                          //         }}
                          //       >
                          //         <IconButton size="small">
                          //           <FontAwesomeIcon icon={faDatabase} size="xl" />
                          //         </IconButton>
                          //         <span>NPA Processed</span>
                          //       </Col>
                          //     )} */}
                          //   </Row>
                          // ) 
                          : null}

                      <div style={{ display: "none" }}>
                        <ComponentToPrint
                          ref={componentRef}
                          // data={values}
                          data={updatedData}
                          approvedData={approvedData?.length ? approvedData : []}
                          transactionProcessStatuses={auditTrailData}
                          totalEmployees={totalEmployees}
                        />
                      </div>
                      {viewForm && (
                        <PreviewModal
                          isOpen={viewForm}
                          handleClose={() => setViewForm(false)}
                          handlePrint={handlePrint}
                          // data={values}
                          data={updatedData}
                          approvedData={approvedData?.length ? approvedData : []}
                        />
                      )}

                      <Accordion expanded={transactionView}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          onClick={() => setTransactionView(!transactionView)}
                        >
                          <div className="w-100 ">
                            <Row>
                              {" "}
                              <Col xs={12} lg={batchData?.IsAmended ? 4 : 6} md={batchData?.IsAmended ? 4 : 6} sm={12}>
                                <Typography variant="h6">
                                  <FontAwesomeIcon
                                    className="m-r-10 font-primary"
                                    icon={faFaceSmile}
                                    size="lg"
                                  />{" "}
                                  Transaction Details
                                </Typography>
                              </Col>
                              <Col xs={12} lg={batchData?.IsAmended ? 4 : 6} md={batchData?.IsAmended ? 4 : 6} sm={12}>
                                {/* {hrControl &&
                                employeeID &&
                                TransactionsBySSNAndAction ? (
                                values?.hrControlNo !== null &&
                                  values?.hrControlNo !== undefined &&
                                  values.hrControlNo !== "" ?  */}
                                {values?.hrControlNo && batchData && Object.keys(batchData)?.length ?
                                  (
                                    <Row className="align-items-center">
                                      <Typography
                                        // variant="subtitle1 " // text-dark text-14 mt-1
                                        className="text-14 mt-1"
                                      >
                                        <b> HR Control No:-</b>{" "}
                                        {values?.hrControlNo}
                                      </Typography>
                                    </Row>
                                  ) : (
                                    ""
                                  )
                                  // ) : (
                                  //   " "
                                  // )
                                }
                              </Col>
                              {batchData?.IsAmended ? (
                                <Col xs={12} lg={4} md={4} sm={12}>
                                  <span
                                    style={{
                                      border: "2px solid #fab065",
                                      color: "#fab065",
                                      background: "#fff",
                                      padding: "2px 10px",
                                      borderRadius: "4px",
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Amended To {batchData?.AmendedToHRControlNo}
                                  </span>
                                </Col>
                              ) : null}

                            </Row>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          {loadingEmployee ? (
                            renderLoader()
                          ) : (
                            <Container fluid>

                              <Row className="mt-1">
                                {showField.DOR === true && (
                                  <Col>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DesktopDatePicker
                                        label="Date Of Request"
                                        inputFormat="MM/DD/YYYY"
                                        name="DOR"
                                        onChange={(value) => {
                                          const formatDate = value?.$d;
                                          if (formatDate) {
                                            let date1 =
                                              moment(formatDate).format(
                                                "MM-DD-YYYY"
                                              );
                                            setFieldValue("DOR", date1);
                                          } else {
                                            setFieldValue("DOR", date);
                                          }
                                        }}
                                        // className={
                                        //   checkHighlight("DOR") ? "isHL" : ""
                                        // }
                                        // error={checkHighlight("DOR")}
                                        // disabled={
                                        //   checkHighlight("DOR") ? false : true
                                        // }
                                        disabled={true}
                                        value={values.DOR}
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            sx={{
                                              "& .MuiInputBase-input.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                              "& .MuiFormLabel-root.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                            }}
                                            fullWidth
                                            autoComplete="off"
                                            name="DOR"
                                            margin="dense"
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "12px",
                                              },
                                            }}
                                            {...params}
                                          // error={checkHighlight("DOR")}
                                          // className={
                                          //   checkOnlyHighlight("DOR")
                                          //     ? "isHL"
                                          //     : ""
                                          // }
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  </Col>
                                )}

                                {showField.RequestID === true && (
                                  <Col xs={4}>
                                    {" "}
                                    <CustomTextField
                                      label="Request ID"
                                      name="RequestID"
                                      value={values.RequestID}
                                      // value={
                                      //   values?.RequestID?.replace("-", "")
                                      //     ?.length <= 6 &&
                                      //   `DOA-HR-${values?.RequestID?.replace(
                                      //     "-",
                                      //     ""
                                      //   )}`
                                      // }
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      // onChange={(e) => {
                                      //   let temp = e.target.value.replace(
                                      //     "-",
                                      //     ""
                                      //   );
                                      //   // temp += parseInt(temp);
                                      //   if (parseInt(temp) < 6) {
                                      //     setFieldValue(
                                      //       "RequestID",
                                      //       `DOA-HR-0${temp}`
                                      //     );
                                      //   } else {
                                      //     if ((temp?.length = 6)) {
                                      //       setFieldValue(
                                      //         "RequestID",
                                      //         `DOA-HR-${temp}`
                                      //       );
                                      //     }
                                      //   }
                                      // }}
                                      // className={
                                      //   checkHighlight("RequestID") ? "isHL" : ""
                                      // }
                                      id="RequestID"
                                      shrink={true}
                                      // hasError={
                                      //   checkHighlight("RequestID") ? true : false
                                      // }
                                      // checkHighlightForTextBox={checkOnlyHighlight(
                                      //   "RequestID"
                                      // )}
                                      // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      //   "RequestID"
                                      // )}
                                      disabled={npaStarted ? true : false}
                                      forceEnable={npaStarted ? false : true}
                                    />
                                    {errors.RequestID && (
                                      <p className="hasErrorLbl">
                                        {errors.RequestID}
                                      </p>
                                    )}
                                  </Col>
                                )}

                                {/* {showField.DOB === true && (
                                <Col>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DesktopDatePicker
                                      label="Date Of Birth"
                                      inputFormat="MM/DD/YYYY"
                                      name="DOB"
                                      onChange={(value) => {
                                        const formatDate = value?.$d;
                                        if (formatDate) {
                                          let date1 =
                                            moment(formatDate).format(
                                              "MM/DD/YYYY"
                                            );
                                          setFieldValue("DOB", date1);
                                        } else {
                                          setFieldValue("DOB", null);
                                        }
                                      }}
                                      maxDate={moment()}
                                      className={
                                        checkHighlight("DOB") ? "isHL" : ""
                                      }
                                      error={checkHighlight("DOB")}
                                      // className={"isHLOptional"}
                                      disabled={
                                        checkHighlight("DOB") ? false : true
                                      }
                                      value={values.DOB}
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-input.Mui-disabled":
                                            {
                                              WebkitTextFillColor:
                                                "#00000092",
                                            },
                                            "& .MuiFormLabel-root.Mui-disabled":
                                            {
                                              WebkitTextFillColor:
                                                "#00000092",
                                            },
                                          }}
                                          fullWidth
                                          autoComplete="off"
                                          name="DOB"
                                          margin="dense"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "12px",
                                            },
                                          }}
                                          {...params}
                                          error={checkHighlight("DOB")}
                                          className={
                                            checkOnlyHighlight("DOB")
                                              ? "isHL"
                                              : ""
                                          }
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                </Col>
                              )} */}
                                {showField.CurrentProcessStatus === true && (
                                  <>
                                    <Col style={{ marginTop: "7px" }}>
                                      <Autocomplete
                                        isOptionEqualToValue={(option, value) =>
                                          option.value === value.value
                                        }
                                        size="small"
                                        name="CurrentProcessStatus"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        readOnly={values?.natureCode?.value == 0 || values?.natureCode?.label == "" || !values?.natureCode ?
                                          true
                                          :
                                          values?.natureCode?.value == "30" ||
                                            values?.natureCode?.value == "58"
                                            ? true
                                            : values?.CurrentProcessStatus
                                              ?.value == 18 ||
                                              values?.CurrentProcessStatus
                                                ?.value == 6
                                              ? false
                                              : true
                                        }
                                        disabled={values?.natureCode?.value == 0 || values?.natureCode?.label == "" || !values?.natureCode ?
                                          true
                                          :
                                          values?.natureCode?.value == "30" ||
                                            values?.natureCode?.value == "58"
                                            ? true
                                            : values?.CurrentProcessStatus
                                              ?.value == 18 ||
                                              values?.CurrentProcessStatus
                                                ?.value == 6
                                              ? false
                                              : true
                                        }
                                        defaultValue={{
                                          value: 18,
                                          label: "Dept Admin",
                                        }}
                                        id="CurrentProcessStatus"
                                        className={
                                          errors.CurrentProcessStatus
                                            ? "hasErrorInput"
                                            : null
                                        }
                                        disableClearable={true}
                                        value={
                                          values?.natureCode ?
                                            values?.CurrentProcessStatus?.value
                                              ? values?.CurrentProcessStatus
                                              : processStatusItems?.length ?? {
                                                value: 18,
                                                label: "Dept Admin",
                                              } //processStatusItems[0]
                                            : {
                                              value: 18,
                                              label: "Dept Admin",
                                            }
                                        }
                                        options={processStatusItems}
                                        getOptionLabel={(option) =>
                                          option.label
                                            ? option.label?.toString()
                                            : ""
                                        }
                                        onChange={(e, v) => {
                                          if (
                                            v.label == "Dept Admin" ||
                                            v.label == "Submitted"
                                          ) {
                                            setFieldValue(
                                              "CurrentProcessStatus",
                                              v
                                            );
                                            setStatusAction("Approved");
                                            setTempProcessStatus(v);
                                          } else {
                                            setNewProcessStatus(v);
                                            setOpenStatusChange(true);
                                          }
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            label="Status"
                                          />
                                        )}
                                      />
                                    </Col>

                                    {(values?.CurrentProcessStatus?.value != 0 &&
                                      values?.CurrentProcessStatus?.value != 18 &&
                                      values?.CurrentProcessStatus?.value != 6) ||
                                      values?.natureCode?.value == "30" ||
                                      values?.natureCode?.value == "58" ||
                                      (maxState != 0 &&
                                        maxState != null &&
                                        maxState > 4) ? (
                                      <Col md="auto" sm="auto" xs="auto">
                                        <Btn
                                          attrBtn={{
                                            color: "primary",

                                            onClick: () => {
                                              // if(values?.CurrentProcessStatus?.value == 342 && !CheckValue(values?.bbmrAnalyst)){
                                              //   ShowError("Please Assign Any BBMR Analyst")
                                              //   return false
                                              // }

                                              // if (optionalMessages?.length && !optionalMsgShown) {
                                              //   optionalMessages.map((item) => {
                                              //     ShowError(item?.msg);
                                              //   });
                                              //   let highlightArray = [...errorHighLight];
                                              //   highlightArray.push({
                                              //     bbmrAnalyst: "bbmr Analyst cannot be blank."
                                              //   });
                                              //   setErrorHighLight(highlightArray);
                                              //   setOptionalMessages([]);
                                              //   setOptionalMsgShown(true);
                                              // }
                                              // setOptionalMessages([]);
                                              setOpenStatusChange(true);
                                            },
                                            style: {
                                              width: "100%",
                                              marginTop: "7px",
                                            },
                                            // disabled: (values?.natureCode?.value == "30" || values?.natureCode?.value == "58" || maxState != 0) ? false :
                                            //   values?.CurrentProcessStatus
                                            //     ?.value == 18 ||
                                            //   values?.CurrentProcessStatus
                                            //     ?.value == 6 ||
                                            //   npaStarted  // || currentStatus
                                            //     ? true
                                            //     : role == "user" && (values?.CurrentProcessStatus
                                            //       ?.value != 18 &&
                                            //     values?.CurrentProcessStatus
                                            //       ?.value != 6) ? true : reviewDisable ? reviewDisable :
                                            //     false,
                                            disabled:
                                              // values?.natureCode?.value == "30" ||
                                              //   values?.natureCode?.value == "58"
                                              //   ? false
                                              //   : 
                                              npaStarted // || currentStatus
                                                ? true
                                                : role == "user" &&
                                                  values?.CurrentProcessStatus
                                                    ?.value != 18 &&
                                                  values?.CurrentProcessStatus
                                                    ?.value != 6
                                                  ? true
                                                  : reviewDisable
                                                    ? reviewDisable
                                                    : false,
                                          }}
                                        >
                                          Review
                                        </Btn>
                                      </Col>
                                    ) : null}
                                  </>
                                )}
                              </Row>

                              {/* <Row className="mt-1">
                              {showField.FR_NAME_LAST === true && (
                                <Col xs={3}>
                                  <CustomTextField
                                    label="Last Name"
                                    shrink={true}
                                    name="FR_NAME_LAST"
                                    onChange={(e) => handleChange(e)}
                                    id="FR_NAME_LAST"
                                    value={values.FR_NAME_LAST}
                                    // className={
                                    //   errors.FR_NAME_LAST ? "input-error" : null
                                    // }
                                    className={
                                      values?.natureCode?.value == 38
                                        ? checkHighlight("FR_NAME_LAST")
                                          ? "isHLOptional"
                                          : "isHL"
                                        : ""
                                    }
                                    hasError={
                                      values?.natureCode?.value == 38
                                        ? false
                                        : checkHighlight("FR_NAME_LAST")
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "FR_NAME_LAST"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "FR_NAME_LAST"
                                    )}
                                  />
                                </Col>
                              )}
                              {showField.FR_NAME_FIRST === true && (
                                <Col xs={3}>
                                  <CustomTextField
                                    label="First Name"
                                    shrink={true}
                                    name="FR_NAME_FIRST"
                                    onChange={(e) => handleChange(e)}
                                    id="FR_NAME_FIRST"
                                    value={values.FR_NAME_FIRST}
                                    // className={
                                    //   errors.FR_NAME_FIRST
                                    //     ? "input-error"
                                    //     : null
                                    // }
                                    // className={
                                    //   checkHighlight("FR_NAME_FIRST")
                                    //     ? "isHL"
                                    //     : ""
                                    // }
                                    // hasError={
                                    //   checkHighlight("FR_NAME_FIRST")
                                    //     ? true
                                    //     : false
                                    // }
                                    className={
                                      values?.natureCode?.value == 38
                                        ? checkHighlight("FR_NAME_FIRST")
                                          ? "isHLOptional"
                                          : "isHL"
                                        : ""
                                    }
                                    hasError={
                                      values?.natureCode?.value == 38
                                        ? false
                                        : checkHighlight("FR_NAME_FIRST")
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "FR_NAME_FIRST"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "FR_NAME_FIRST"
                                    )}
                                  />
                                </Col>
                              )}
                              {showField.FR_NAME_MIDDLE && (
                                <Col xs={3}>
                                  <CustomTextField
                                    label="Middle Name"
                                    shrink={true}
                                    name="FR_NAME_MIDDLE"
                                    onChange={(e) => handleChange(e)}
                                    id="FR_NAME_MIDDLE"
                                    value={values.FR_NAME_MIDDLE}
                                    // className={
                                    //   errors.FR_NAME_MIDDLE
                                    //     ? "input-error"
                                    //     : null
                                    // }
                                    // hasError={checkHighlight("FR_NAME_MIDDLE")}
                                    className={
                                      values?.natureCode?.value == 38
                                        ? checkHighlight("FR_NAME_MIDDLE")
                                          ? "isHLOptional"
                                          : "isHL"
                                        : ""
                                    }
                                    hasError={
                                      values?.natureCode?.value == 38
                                        ? false
                                        : checkHighlight("FR_NAME_MIDDLE")
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "FR_NAME_MIDDLE"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "FR_NAME_MIDDLE"
                                    )}
                                  />
                                </Col>
                              )}
                              {showField.EmployeeID === true && (
                                <Col xs={3}>
                                  <CustomTextField
                                    name="EmployeeID"
                                    value={values.employeeID}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    label="Employee ID"
                                    id="email"
                                    shrink={true}
                                    className={
                                      errors.employeeID && touched.employeeID
                                        ? "input-error"
                                        : null
                                    }
                                    hasError={
                                      errors.employeeID && touched.employeeID
                                        ? true
                                        : false
                                    }
                                  />
                                  {errors.employeeID && (
                                    <p className="hasErrorLbl">
                                      {errors.employeeID}
                                    </p>
                                  )}
                                </Col>
                              )}
                            </Row> */}

                              {/****** Hide because not in new sheet - Dipen. */}
                              {/* {showField.ActionNo === true && (
                                <Col xs={6}>
                                  <TextField
                                    name="ActionNo"
                                    label="Action No"
                                    value={values.ActionNo}
                                    disabled={checkHighlight("ActionNo")}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    style={{ width: "100%", marginTop: "8px" }}
                                    size="small"
                                    inputProps={{
                                      style: {
                                        fontSize: "14px",
                                        paddingTop: "10px",
                                        width: "100%",
                                      },
                                      className: `flex w-full mx-10 ${
                                        errors.ActionNo ? "hasErrorInput" : ""
                                      }`,
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                    id="ActionNo"
                                    // className={
                                    //   errors.ActionNo && touched.ActionNo
                                    //     ? "input-error"
                                    //     : null
                                    // }

                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "ActionNo"
                                    )}
                                  />
                                  {errors.ActionNo && (
                                    <p className="hasErrorLbl">
                                      {errors.ActionNo}
                                    </p>
                                  )}
                                </Col>
                              )} */}

                              {/* {showField.LegalAuthority && (
                                <Col xs={6} style={{ marginTop: "7px" }}>
                                  <CustomTextField
                                    label="Legal Authority"
                                    name="LegalAuthority"
                                    value={values.LegalAuthority}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    id="LegalAuthority"
                                    shrink={true}
                                    className={
                                      errors.LegalAuthority
                                        ? "input-error"
                                        : null
                                    }
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "LegalAuthority"
                                    )}
                                    hasError={checkHighlight("LegalAuthority")}
                                    disabled={
                                      checkHighlight("LegalAuthority")
                                        ? false
                                        : true
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "LegalAuthority"
                                    )}
                                  />
                                </Col>
                              )} */}
                              {/* {showField.JOB_Order_Number === true && (
                                <Col xs={6} style={{ marginTop: "7px" }}>
                                  <CustomTextField
                                    name="JOB_Order_Number"
                                    value={values.JOB_Order_Number}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    label="Job Order Number"
                                    id="JOB_Order_Number"
                                    shrink={true}
                                    className={
                                      checkHighlight("JOB_Order_Number")
                                        ? "isHL"
                                        : ""
                                    }
                                    hasError={
                                      checkHighlight("JOB_Order_Number")
                                        ? true
                                        : false
                                    }
                                    disabled={
                                      checkHighlight("JOB_Order_Number")
                                        ? false
                                        : true
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "JOB_Order_Number"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "JOB_Order_Number"
                                    )}
                                  />
                                  {errors.JOB_Order_Number && (
                                    <p className="hasErrorLbl">
                                      {errors.JOB_Order_Number}
                                    </p>
                                  )}
                                </Col>
                              )} */}
                              {/* {showField.Budget_Account_Number === true && (
                                <Col xs={6} style={{ marginTop: "7px" }}>
                                  <CustomTextField
                                    name="Budget_Account_Number"
                                    value={values.Budget_Account_Number}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    label="Budget Account Number"
                                    id="Budget_Account_Number"
                                    shrink={true}
                                    className={
                                      checkHighlight("Budget_Account_Number")
                                        ? "isHL"
                                        : ""
                                    }
                                    hasError={
                                      checkHighlight("Budget_Account_Number")
                                        ? true
                                        : false
                                    }
                                    disabled={
                                      checkHighlight("Budget_Account_Number")
                                        ? false
                                        : true
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "Budget_Account_Number"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "Budget_Account_Number"
                                    )}
                                  />
                                  {errors.Budget_Account_Number && (
                                    <p className="hasErrorLbl">
                                      {errors.Budget_Account_Number}
                                    </p>
                                  )}
                                </Col>
                              )} */}
                              {/* {showField.ActionDate === true && (
                                <Col xs={6} style={{ marginTop: "7px" }}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DesktopDatePicker
                                      label="Action Date"
                                      inputFormat="MM/DD/YYYY"
                                      name="ActionDate"
                                      onChange={(value) => {
                                        const formatDate = value?.$d;
                                        if (formatDate) {
                                          let date1 =
                                            moment(formatDate).format(
                                              "MM/DD/YYYY"
                                            );
                                          setFieldValue("ActionDate", date1);
                                        } else {
                                          setFieldValue("ActionDate", null);
                                        }
                                      }}
                                      className={
                                        checkHighlight("ActionDate")
                                          ? "isHL"
                                          : checkSysGenHighlight("ActionDate")
                                          ? "isHL1"
                                          : ""
                                      }
                                      error={checkHighlight("ActionDate")}
                                      disabled={
                                        checkHighlight("ActionDate")
                                          ? false
                                          : true
                                      }
                                      value={values.ActionDate}
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-input.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                            "& .MuiFormLabel-root.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                          }}
                                          fullWidth
                                          autoComplete="off"
                                          name="ActionDate"
                                          margin="dense"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "12px",
                                            },
                                          }}
                                          {...params}
                                          error={checkHighlight("ActionDate")}
                                          className={
                                            checkHighlight("ActionDate")
                                              ? "isHL"
                                              : checkSysGenHighlight(
                                                  "ActionDate"
                                                )
                                              ? "isHL1"
                                              : ""
                                          }
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                </Col>
                              )} */}
                              <Row className="mt-1">
                                {/* {showField.RequestID === true && (
                                <Col xs={3}>
                                  {" "}
                                  <CustomTextField
                                    label="Request ID"
                                    name="RequestID"
                                    value={values.RequestID}
                                    // value={
                                    //   values?.RequestID?.replace("-", "")
                                    //     ?.length <= 6 &&
                                    //   `DOA-HR-${values?.RequestID?.replace(
                                    //     "-",
                                    //     ""
                                    //   )}`
                                    // }
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    // onChange={(e) => {
                                    //   let temp = e.target.value.replace(
                                    //     "-",
                                    //     ""
                                    //   );
                                    //   // temp += parseInt(temp);
                                    //   if (parseInt(temp) < 6) {
                                    //     setFieldValue(
                                    //       "RequestID",
                                    //       `DOA-HR-0${temp}`
                                    //     );
                                    //   } else {
                                    //     if ((temp?.length = 6)) {
                                    //       setFieldValue(
                                    //         "RequestID",
                                    //         `DOA-HR-${temp}`
                                    //       );
                                    //     }
                                    //   }
                                    // }}
                                    className={
                                      checkHighlight("RequestID") ? "isHL" : ""
                                    }
                                    id="RequestID"
                                    shrink={true}
                                    hasError={
                                      checkHighlight("RequestID") ? true : false
                                    }
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "RequestID"
                                    )}
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "RequestID"
                                    )}
                                  />
                                  {errors.RequestID && (
                                    <p className="hasErrorLbl">
                                      {errors.RequestID}
                                    </p>
                                  )}
                                </Col>
                              )} */}
                                {/* <Col
                                xs={values?.natureCode?.value == "91" ? 3 : 3}
                                style={{ marginTop: "7px" }}
                              >
                                <Autocomplete
                                  isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                  }
                                  size="small"
                                  disablePortal
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  id="bbmr_analyst"
                                  name="bbmrAnalyst"
                                  disabled={values?.CurrentProcessStatus?.value == 342 ? false : true}
                                  value={
                                    (BBMRList &&
                                      BBMRList.find(
                                        (i) => i.value == values?.bbmrAnalyst
                                      )) ||
                                    null
                                  }
                                  options={BBMRList}
                                  // options={natureOptionsExceptSI}
                                  getOptionLabel={(option) =>
                                    option.label ? option.label?.toString() : ""
                                  }
                                  onChange={(e, v) => {
                                    setFieldValue("bbmrAnalyst", v?.value);
                                  }}
                                  hasError={errors.bbmrAnalyst ? true : false}
                                  renderOption={(props, option, index) => {
                                    const key = `listItem-${index?.index}-${option.id}`;
                                    return (
                                      <li {...props} key={key}>
                                        {option["label"]}
                                      </li>
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      // error={errors.NatureOf ? true : false}
                                      label="BBMR Analyst"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    className={`flex w-full mx-10 ${
                                      // checkSysGenHighlight("NatureOf")
                                      //   ? "isHL1"
                                      //   : ""
                                      checkOnlyHighlight("bbmrAnalyst")
                                        ? "isHL"
                                        : ""
                                      } `}
                                    />
                                  )}
                                />
                              </Col> */}

                                {showField.EffDate === true && (
                                  <Col
                                    xs={3}
                                  >
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DesktopDatePicker
                                        label="Eff Date"
                                        inputFormat="MM/DD/YYYY"
                                        name="EffDate"
                                        minDate={
                                          values?.natureCode?.value == "17"
                                            ? values?.EmploymentDate
                                              ? moment(values?.EmploymentDate)
                                              : ""
                                            : ""
                                        }
                                        // maxDate={
                                        //   CheckMinMax()
                                        //     ? values?.ExpirationDate
                                        //     : ""
                                        // }
                                        maxDate={
                                          values?.natureCode?.value == "17"
                                            ? moment()
                                            : autoGeneratedItem?.employee_Status ==
                                              "A" && values?.Next_INCR_date
                                              ? moment(values?.Next_INCR_date)
                                              : ""
                                        }
                                        onChange={(value) => {
                                          const formatDate = value?.$d;
                                          if (formatDate) {
                                            let date1 =
                                              moment(formatDate).format(
                                                "MM/DD/YYYY"
                                              );
                                            setFieldValue("EffDate", date1);
                                          } else {
                                            setFieldValue("EffDate", null);
                                          }
                                        }}
                                        disabled={npaStarted ? true : false}

                                        // className={
                                        //   (values?.natureCode?.value == 15 || values?.natureCode?.value == 16) ?
                                        //   checkHighlight("EffDate") ? "isHL" : ""
                                        //   :
                                        //   checkHighlight("EffDate")
                                        //     ? "isHLOptional"
                                        //     : ""
                                        // }
                                        // error={checkHighlight("EffDate")}
                                        // disabled={
                                        //   checkHighlight("EffDate") ? false : true
                                        // }
                                        value={values.EffDate}
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            sx={{
                                              "& .MuiInputBase-input.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                              "& .MuiFormLabel-root.Mui-disabled":
                                              {
                                                WebkitTextFillColor:
                                                  "#00000092",
                                              },
                                            }}
                                            fullWidth
                                            autoComplete="off"
                                            name="EffDate"
                                            margin="dense"
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "12px",
                                              },
                                            }}
                                            {...params}
                                          // error={
                                          //   values?.natureCode?.value == 15 ||
                                          //     values?.natureCode?.value == 16 ||
                                          //     values?.natureCode?.value == 34 ||
                                          //     values?.natureCode?.value == 32 ||
                                          //     values?.natureCode?.value == 1 ||
                                          //     values?.natureCode?.value == 37 ||
                                          //     values?.natureCode?.value == 2
                                          //     ? checkHighlight("EffDate")
                                          //     : false
                                          // }
                                          // className={
                                          //   values?.natureCode?.value == 15 ||
                                          //     values?.natureCode?.value == 16 ||
                                          //     values?.natureCode?.value == 34 ||
                                          //     values?.natureCode?.value == 32 ||
                                          //     values?.natureCode?.value == 1 ||
                                          //     values?.natureCode?.value == 37 ||
                                          //     values?.natureCode?.value == 2
                                          //     ? checkHighlight("EffDate")
                                          //       ? "isHL"
                                          //       : ""
                                          //     : checkHighlight("EffDate")
                                          //       ? "isHLOptional"
                                          //       : ""
                                          // }
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  </Col>
                                )}

                                {/* {values?.natureCode?.value == "76" ||
                                values?.natureCode?.value == "7" ||
                                values?.natureCode?.value == "38" ||
                                values?.natureCode?.value == "24" ||
                                values?.natureCode?.value == "47" ||
                                (detailActionSelected &&
                                  values?.natureCode?.value == "51") ?  */}
                                {showField.Term_Date === true && (
                                  <Col xs={3}>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        name="Term_Date"
                                        label="Term Date"
                                        value={values?.Term_Date}
                                        // readOnly={
                                        //   values?.natureCode?.value == "76" ||
                                        //     values?.natureCode?.value == "24"
                                        //     ? false
                                        //     : true
                                        // }
                                        onChange={
                                          // values?.natureCode?.value == "76" ||
                                          //   values?.natureCode?.value == "24"
                                          //   ? (value) => {
                                          (value) => {
                                            const formatDate = value?.$d;
                                            if (formatDate) {
                                              const date =
                                                moment(formatDate).format(
                                                  "MM/DD/YYYY"
                                                );
                                              setFieldValue(
                                                "Term_Date",
                                                date
                                              );
                                            } else {
                                              setFieldValue(
                                                "Term_Date",
                                                null
                                              );
                                            }
                                          }
                                          // }
                                          // : () => { }
                                        }
                                        // className={
                                        //   checkHighlight("Term_Date")
                                        //     ? "isHLOptional"
                                        //     : ""
                                        // }
                                        // hasError={
                                        //   checkHighlight("Term_Date")
                                        //     ? true
                                        //     : false
                                        // }
                                        // disabled={
                                        //   checkHighlight("Term_Date")
                                        //     ? false
                                        //     : true
                                        // }
                                        // disabled={false}
                                        disabled={npaStarted ? true : false}
                                        minDate={
                                          values?.natureCode?.value == "76" &&
                                            CheckValue(values?.EffDate)
                                            ? values?.EffDate
                                            : ""
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            size="small"
                                            fullWidth
                                            margin="dense"
                                            autoComplete="off"
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            inputProps={{
                                              style: {
                                                fontSize: "12px",
                                              },
                                            }}
                                            {...params}
                                          // className={
                                          //   checkHighlight("Term_Date")
                                          //     ? "isHLOptional"
                                          //     : ""
                                          // }
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  </Col>
                                )}
                                {showField.natureCode === true && (
                                  <Col
                                    xs={values?.natureCode?.value == "91" ? 3 : 3}
                                    style={{ marginTop: "7px" }}
                                  >
                                    <Autocomplete
                                      isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                      }
                                      size="small"
                                      disablePortal
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      id="NatureOf"
                                      name="NatureOf"
                                      // disabled={disabledNature}
                                      disabled={true}
                                      value={
                                        values?.natureCode?.label !== null
                                          ? values.natureCode
                                          : { value: "", label: "" }
                                      }
                                      options={natureOfOptions}
                                      // options={natureOptionsExceptSI}
                                      getOptionLabel={(option) =>
                                        option.label
                                          ? option.label?.toString()
                                          : ""
                                      }
                                      onChange={(e, v) => {
                                        setFieldValue("natureCode", v);
                                        setFieldValue("NatureOf", v);
                                        if (v?.authority) {
                                          setFieldValue(
                                            "LegalAuthority",
                                            v?.authority
                                          );
                                          // console.log(
                                          //   "121212 on changed Authority ifff ::: ",
                                          //   v,
                                          //   values?.LegalAuthority
                                          // );
                                        } else {
                                          setFieldValue("LegalAuthority", "");
                                        }
                                        if (!v) {
                                          setFieldValue(
                                            "CurrentProcessStatus",
                                            {
                                              value: 18,
                                              label: "Dept Admin",
                                            }
                                          );
                                        }
                                        setTempProcessStatus({
                                          value: 18,
                                          label: "Dept Admin",
                                        });
                                      }}
                                      // hasError={errors.NatureOf ? true : false}
                                      renderOption={(props, option, index) => {
                                        const key = `listItem-${index?.index}-${option.id}`;
                                        return (
                                          <li {...props} key={key}>
                                            {option["label"]}
                                          </li>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          // error={errors.NatureOf ? true : false}
                                          label="Nature Of Action"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                        // className={`flex w-full mx-10 ${
                                        //   // checkSysGenHighlight("NatureOf")
                                        //   //   ? "isHL1"
                                        //   //   : ""
                                        //   checkOnlyHighlight("NatureOf")
                                        //     ? "isHL"
                                        //     : ""
                                        //   } `}
                                        />
                                      )}
                                    />
                                  </Col>
                                )}

                                {showField.natureCode === true &&
                                  values?.natureCode?.value == "91" ? (
                                  <Col xs={3} style={{ marginTop: "7px" }}>
                                    {console.log(
                                      "121212 current Status ::: ",
                                      currentStatus
                                    )}
                                    <Autocomplete
                                      isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                      }
                                      size="small"
                                      disablePortal
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      id="recruitmentType"
                                      name="recruitmentType"
                                      // disabled={disabledNature}
                                      value={values?.recruitmentType}
                                      options={recruitApptList}
                                      getOptionLabel={(option) =>
                                        option.label
                                          ? option.label?.toString()
                                          : ""
                                      }
                                      onChange={(e, v) => {
                                        setFieldValue("recruitmentType", v);
                                      }}
                                      disabled={currentStatus}
                                      // hasError={errors.recruitmentType ? true : false}
                                      // hasError={!checkOnlyHighlight("recruitmentType")}
                                      renderOption={(props, option, index) => {
                                        const key = `listItem-${index?.index}-${option.value}`;
                                        return (
                                          <li {...props} key={key}>
                                            {option["label"]}
                                          </li>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          // error={!checkOnlyHighlight("recruitmentType")}
                                          label="Recruitment Type"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                        // className={`flex w-full mx-10 ${
                                        //   // checkSysGenHighlight("NatureOf")
                                        //   //   ? "isHL1"
                                        //   //   : ""
                                        //   checkOnlyHighlight("recruitmentType")
                                        //     ? "isHL"
                                        //     : ""
                                        //   } `}
                                        />
                                      )}
                                    />
                                  </Col>
                                ) : null}
                                {showField.LegalAuthority && (
                                  <Col xs={3}
                                    style={{ marginTop: "-4px" }}
                                  >
                                    <CustomTextField
                                      label="Legal Authority"
                                      name="LegalAuthority"
                                      value={values.LegalAuthority}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                      id="LegalAuthority"
                                      shrink={true}
                                      className={
                                        errors.LegalAuthority
                                          ? "input-error"
                                          : null
                                      }
                                      // checkHighlightForTextBox={checkOnlyHighlight(
                                      //   "LegalAuthority"
                                      // )}
                                      // hasError={checkHighlight("LegalAuthority")}
                                      // disabled={
                                      //   checkHighlight("LegalAuthority")
                                      //     ? false
                                      //     : true
                                      // }
                                      disabled={true}
                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                    //   "LegalAuthority"
                                    // )}
                                    // forceEnable= {true}
                                    />
                                  </Col>
                                )}
                                {/* </Row>
                            <Row> */}
                                {showSubWorkflow ?
                                  <Col
                                    xs={values?.natureCode?.value == "91" ? 3 : 3}
                                    style={{ marginTop: "7px" }}
                                  >
                                    <Autocomplete
                                      isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                      }
                                      size="small"
                                      disablePortal
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      id="bbmr_analyst"
                                      name="bbmrAnalyst"
                                      disabled={values?.CurrentProcessStatus?.value == 342 ? false : true}
                                      value={
                                        (BBMRList &&
                                          BBMRList.find(
                                            (i) => i.value == values?.bbmrAnalyst
                                          )) ||
                                        null
                                      }
                                      options={BBMRList}
                                      // options={natureOptionsExceptSI}
                                      getOptionLabel={(option) =>
                                        option.label ? option.label?.toString() : ""
                                      }
                                      onChange={(e, v) => {
                                        setFieldValue("bbmrAnalyst", v?.value);
                                      }}
                                      hasError={errors.bbmrAnalyst ? true : false}
                                      renderOption={(props, option, index) => {
                                        const key = `listItem-${index?.index}-${option.id}`;
                                        return (
                                          <li {...props} key={key}>
                                            {option["label"]}
                                          </li>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          // error={errors.NatureOf ? true : false}
                                          label="BBMR Analyst"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                        // className={`flex w-full mx-10 ${
                                        //   // checkSysGenHighlight("NatureOf")
                                        //   //   ? "isHL1"
                                        //   //   : ""
                                        //   checkOnlyHighlight("bbmrAnalyst")
                                        //     ? "isHL"
                                        //     : ""
                                        //   } `}
                                        />
                                      )}
                                    />
                                  </Col>
                                  : null}
                              </Row>
                              {/* {showField.EMP_Contract_NO === true &&
                              (values?.natureCode?.value == "20" ||
                                values?.natureCode?.value == "36") ? (
                              <Row className="mt-1">
                                <Col xs={6}>
                                  <CustomTextField
                                    name="EMP_Contract_NO"
                                    label="Emp Contract No."
                                    shrink={true}
                                    value={values.EMP_Contract_NO}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    style={{
                                      height: "16px",
                                      marginTop: "7px",
                                    }}
                                    id="EMP_Contract_NO"
                                    className={
                                      errors.EMP_Contract_NO
                                        ? "input-error"
                                        : null
                                    }
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "EMP_Contract_NO"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "EMP_Contract_NO"
                                    )}
                                    disabled={
                                      checkHighlight("EMP_Contract_NO")
                                        ? false
                                        : true
                                    }
                                    hasError={checkHighlight("EMP_Contract_NO")}
                                  />
                                </Col>
                                <Col xs={2}>
                                  <CustomTextField
                                    name="Employment_Duration"
                                    type="number"
                                    label="Employment Duration"
                                    shrink={true}
                                    value={values.Employment_Duration}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    style={{
                                      height: "16px",
                                      marginTop: "7px",
                                    }}
                                    id="EMP_Contract_NO"
                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                    //   "Employment_Duration"
                                    // )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "Employment_Duration"
                                    )}
                                    // disabled={
                                    //   checkHighlight("Employment_Duration")
                                    //     ? false
                                    //     : true
                                    // }
                                    // hasError={checkHighlight(
                                    //   "Employment_Duration"
                                    // )}
                                    className={
                                      checkHighlight("Employment_Duration")
                                        ? "isHLOptional"
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col xs={2} style={{ marginTop: "7px" }}>
                                  <Autocomplete
                                    isOptionEqualToValue={(option, value) =>
                                      option.value === value.value
                                    }
                                    size="small"
                                    name="duration_type"
                                    disablePortal
                                    disableClearable
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    // disabled={!checkHighlight("TO_Grade")}
                                    // hasError={checkHighlight("TO_Grade")}
                                    id="Employment_Duration_Type"
                                    value={values?.Employment_Duration_Type}
                                    options={durationList}
                                    getOptionLabel={(option, i) =>
                                      option?.label
                                    }
                                    className={
                                      checkHighlight("Employment_Duration_Type")
                                        ? "isHLOptional"
                                        : ""
                                    }
                                    onChange={(e, v, reason) => {
                                      // setFieldValue("TO_Grade", v);
                                      setDurationType(v);
                                      setFieldValue(
                                        "Employment_Duration_Type",
                                        v
                                      );
                                    }}
                                    renderOption={(props, option, index) => {
                                      const key = `listItem-${index?.index}`;
                                      return (
                                        <li {...props} key={key}>
                                          {option.label}
                                        </li>
                                      );
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        sx={{
                                          "& .MuiInputBase-input.Mui-disabled":
                                          {
                                            WebkitTextFillColor: "#00000092",
                                          },
                                          "& .MuiFormLabel-root.Mui-disabled": {
                                            WebkitTextFillColor: "#00000092",
                                          },
                                        }}
                                        // label="Grade"
                                        className={
                                          checkHighlight(
                                            "Employment_Duration_Type"
                                          )
                                            ? "isHLOptional"
                                            : ""
                                        }
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      // error={checkHighlight(
                                      //   "Employment_Duration_Type"
                                      // )}
                                      />
                                    )}
                                  />
                                </Col>
                                <Col xs={2}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DesktopDatePicker
                                      inputFormat="MM/DD/YYYY"
                                      name="Term_Date"
                                      label="Term Date"
                                      // onChange={(value) => {
                                      //   const formatDate = value?.$d;
                                      //   if (formatDate) {
                                      //     const date =
                                      //       moment(formatDate).format(
                                      //         "MM/DD/YYYY"
                                      //       );
                                      //     setFieldValue("Term_Date", date);
                                      //   } else {
                                      //     setFieldValue("Term_Date", null);
                                      //   }
                                      // }}
                                      className={
                                        checkHighlight("Term_Date")
                                          ? "isHL"
                                          : checkSysGenHighlight("Term_Date")
                                            ? "isHL1"
                                            : ""
                                      }
                                      hasError={
                                        checkHighlight("Term_Date")
                                          ? true
                                          : false
                                      }
                                      disabled={
                                        checkHighlight("Term_Date")
                                          ? false
                                          : true
                                      }
                                      value={values?.Term_Date}
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          fullWidth
                                          margin="dense"
                                          autoComplete="off"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "12px",
                                            },
                                          }}
                                          {...params}
                                          className={
                                            checkHighlight("Term_Date")
                                              ? "isHL"
                                              : checkSysGenHighlight(
                                                "Term_Date"
                                              )
                                                ? "isHL1"
                                                : ""
                                          }
                                          error={
                                            checkHighlight("Term_Date")
                                              ? true
                                              : false
                                          }
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                </Col>
                              </Row>
                            ) : null}
                            {values?.natureCode?.value == "50" ? (
                              <Col xs={6} style={{ marginTop: "7px" }}>
                                <Autocomplete
                                  disablePortal
                                  disableClearable
                                  size="small"
                                  name="Change Work Status"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  hasError={checkHighlight("worK_SCH")}
                                  id="worK_SCH"
                                  // defaultValue={""}
                                  value={values?.worK_SCH}
                                  options={workStatusOptions}
                                  getOptionLabel={(option) => option["label"]}
                                  className={
                                    checkHighlight("worK_SCH") ? "isHL" : ""
                                  }
                                  onChange={(e, v) => {
                                    setFieldValue("worK_SCH", v);
                                  }}
                                  renderOption={(props, option, index) => {
                                    const key = `listItem-${index?.index}`;
                                    return (
                                      <li {...props} key={key}>
                                        {option["label"]}
                                      </li>
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{
                                        "& .MuiInputBase-input.Mui-disabled": {
                                          WebkitTextFillColor: "#00000092",
                                        },
                                        "& .MuiFormLabel-root.Mui-disabled": {
                                          WebkitTextFillColor: "#00000092",
                                        },
                                      }}
                                      label="Change Work Status"
                                      className={
                                        checkHighlight("worK_SCH") ? "isHL" : ""
                                      }
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      error={checkHighlight("worK_SCH")}
                                    />
                                  )}
                                />
                              </Col>
                            ) : null} */}
                              {/* </Row> */}


                            </Container>
                          )}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion expanded={jobView}>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          onClick={() => setJobView(!jobView)}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <Typography variant="h6">
                              <FontAwesomeIcon
                                icon={faUsers}
                                size="lg"
                                className="m-r-10 font-primary"
                              />{" "}
                              Job Details
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>

                          {loadingTransaction ? (
                            renderLoader()
                          ) : (
                            <table className="table">
                              <tbody>
                                {values?.natureCode?.label?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" && (
                                  <Row>
                                    <Col
                                      xs={6}
                                      style={{
                                        padding: "0px",
                                      }}
                                    >
                                      <Card>
                                        <CardHeader className="bg-primary">
                                          <Typography className="text-center">
                                            {" "}
                                            FROM
                                          </Typography>
                                        </CardHeader>
                                        <CardBody>
                                          <div
                                            className="table table-striped table-bordered mt-2"
                                            style={{
                                              marginRight: "2px",
                                            }}
                                          >
                                            {showField.FR_PositionTitle ===
                                              true && (
                                                <Row>
                                                  {/* <Col>
                                                                      <Autocomplete
                                                                        size="small"
                                                                        name="FR_PositionTitle"
                                                                        InputLabelProps={{
                                                                          shrink: true,
                                                                        }}
                                                                        id="FR_PositionTitle"
                                                                        disabled={
                                                                          !checkHighlight(
                                                                            "FR_PositionTitle"
                                                                          )
                                                                        }
                                                                        className={
                                                                          checkSysGenHighlight(
                                                                            "FR_PositionTitle"
                                                                          )
                                                                            ? "isHL1"
                                                                            : ""
                                                                        }
                                                                        defaultValue={""}
                                                                        options={positionTitleOptions}
                                                                        getOptionLabel={(option) =>
                                                                          option.label
                                                                            ? option.label?.toString()
                                                                            : ""
                                                                        }
                                                                        onChange={(e, v) => {
                                                                          setFieldValue(
                                                                            "FR_PositionTitle",
                                                                            v
                                                                          );
                                                                          setFieldValue(
                                                                            "FR_ClassCode",
                                                                            v?.value?.trim()
                                                                          );
                                                                          setFieldValue(
                                                                            "FR_Grade",
                                                                            v?.range_next?.trim()
                                                                          );
                                                                        }}
                                                                        renderInput={(params) => (
                                                                          <TextField
                                                                            {...params}
                                                                            sx={{
                                                                              "& .MuiInputBase-input.Mui-disabled":
                                                                                {
                                                                                  WebkitTextFillColor:
                                                                                    "#00000092",
                                                                                },
                                                                              "& .MuiFormLabel-root.Mui-disabled":
                                                                                {
                                                                                  WebkitTextFillColor:
                                                                                    "#00000092",
                                                                                },
                                                                            }}
                                                                            className={
                                                                              //checkHighlight(
                                                                              checkOnlyHighlight(
                                                                                "FR_PositionTitle"
                                                                              )
                                                                                ? "isHL"
                                                                                : checkSysGenHighlight(
                                                                                    "FR_PositionTitle"
                                                                                  )
                                                                                ? "isHL1"
                                                                                : ""
                                                                            }
                                                                            error={checkHighlight(
                                                                              "FR_PositionTitle"
                                                                            )}
                                                                            InputLabelProps={{
                                                                              shrink: true,
                                                                            }}
                                                                            label="Position"
                                                                          />
                                                                        )}
                                                                        value={
                                                                          values?.FR_PositionTitle
                                                                            ? values.FR_PositionTitle
                                                                            : { value: "", label: "" }
                                                                        }
                                                                      />
                                                                      {errors.FR_PositionTitle && (
                                                                        <p className="hasErrorLbl">
                                                                          {errors.FR_PositionTitle
                                                                            ? errors.FR_PositionTitle
                                                                                .value ||
                                                                              errors.FR_PositionTitle
                                                                            : errors.FR_PositionTitle}
                                                                        </p>
                                                                      )}
                                                                    </Col> */}
                                                  <Col>
                                                    <Autocomplete
                                                      isOptionEqualToValue={(
                                                        option,
                                                        value
                                                      ) =>
                                                        option.value === value.value
                                                      }
                                                      size="small"
                                                      name="FR_PositionTitle"
                                                      disablePortal
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      id="FR_PositionTitle"
                                                      value={
                                                        values?.FR_PositionTitle
                                                          ? values.FR_PositionTitle
                                                          : { value: "", label: "" }
                                                      }
                                                      options={positionTitleOptions}
                                                      getOptionLabel={(option) =>
                                                        // option.label
                                                        //   ? option.label?.toString()
                                                        //   : ""
                                                        option?.titleWithGrade ||
                                                          option?.label
                                                          ? option?.label?.toString()
                                                          : ""
                                                      }
                                                      onChange={(e, v, reason) => {
                                                        // console.log(
                                                        //   "121212 post value",
                                                        //   v
                                                        // );
                                                        if (
                                                          v != undefined ||
                                                          v != null
                                                        ) {
                                                          if (
                                                            v?.range_next?.trim() ==
                                                            ""
                                                          ) {
                                                            setFieldValue(
                                                              "FR_PositionTitle",
                                                              v
                                                            );
                                                            setFieldValue(
                                                              "FR_Grade",
                                                              ""
                                                            );
                                                            setFieldValue(
                                                              "FR_Step",
                                                              ""
                                                            );
                                                            checkUnclassifiedPositions(
                                                              "from"
                                                            );
                                                          } else {
                                                            // console.log(
                                                            //   "121212 ::: ",
                                                            //   v?.range_next
                                                            // );
                                                            if (
                                                              v?.range_next?.trim()
                                                            ) {
                                                              setFieldValue(
                                                                "FR_Grade",
                                                                v?.range_next?.trim()
                                                              );
                                                            }
                                                          }
                                                          setFieldValue(
                                                            "FR_PositionTitle",
                                                            v
                                                          );
                                                          setFieldValue(
                                                            "FR_ClassCode",
                                                            v?.value?.trim()
                                                          );
                                                        }
                                                      }}
                                                      disabled={
                                                        isFromEditable ? false :
                                                          !checkHighlight(
                                                            "FR_PositionTitle"
                                                          )
                                                      }
                                                      hasError={
                                                        isFromEditable ? false :
                                                          checkHighlight(
                                                            "FR_PositionTitle"
                                                          )}
                                                      renderOption={(
                                                        props,
                                                        option,
                                                        index
                                                      ) => {
                                                        const key = `listItem-${index?.index}-${option["value"]}`;
                                                        return (
                                                          <li {...props} key={key}>
                                                            {/* {option["label"]} */}
                                                            {option["titleWithGrade"]}
                                                          </li>
                                                        );
                                                      }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          sx={{
                                                            "& .MuiInputBase-input.Mui-disabled":
                                                            {
                                                              WebkitTextFillColor:
                                                                "#00000092",
                                                            },
                                                            "& .MuiFormLabel-root.Mui-disabled":
                                                            {
                                                              WebkitTextFillColor:
                                                                "#00000092",
                                                            },
                                                          }}
                                                          label="Position"
                                                          // className={
                                                          //   checkOnlyHighlight(
                                                          //     "FR_PositionTitle"
                                                          //   )
                                                          //     ? "isHL"
                                                          //     : checkSysGenHighlight(
                                                          //       "FR_PositionTitle"
                                                          //     )
                                                          //       ? "isHL1"
                                                          //       : ""
                                                          // }
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                        // error={checkHighlight(
                                                        //   "FR_PositionTitle"
                                                        // )}
                                                        />
                                                      )}
                                                    />
                                                  </Col>
                                                </Row>
                                              )}
                                            {/****** Hide because not in new sheet - Dipen. */}
                                            {/* {showField.FR_ClassCode === true && (
                                                                  <Row className="mt-3 mb-2">
                                                                    <Col>
                                                                      <CustomTextField
                                                                        name="FR_ClassCode"
                                                                        label="Class Code"
                                                                        value={values.FR_ClassCode}
                                                                        onChange={(e) => {
                                                                          handleChange(e);
                                                                        }}
                                                                        checkHighlightForTextBox={checkOnlyHighlight(
                                                                          "FR_ClassCode"
                                                                        )}
                                                                        shrink={true}
                                                                        id="FR_ClassCode"
                                                                        hasError={checkHighlight(
                                                                          "FR_ClassCode"
                                                                        )}
                                                                      />
                                                                    </Col>
                                                                  </Row>
                                                                )} */}

                                            <Row className="mt-1">
                                              {showField.FR_Grade === true && (
                                                <Col style={{ marginTop: "8px" }}>
                                                  {/* <CustomTextField
                                                                        name="FR_Grade"
                                                                        label="Grade"
                                                                        value={values.FR_Grade}
                                                                        onChange={(e) => {
                                                                          handleChange(e);
                                                                        }}
                                                                        shrink={true}
                                                                        id="FR_Grade"
                                                                        className={
                                                                          errors.FR_Grade
                                                                            ? "input-error"
                                                                            : null
                                                                        }
                                                                        hasError={checkHighlight(
                                                                          "FR_Grade"
                                                                        )}
                                                                        disabled={
                                                                          checkHighlight("FR_Grade")
                                                                            ? false
                                                                            : true
                                                                        }
                                                                        checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                                          "FR_Grade"
                                                                        )}
                                                                        checkHighlightForTextBox={checkOnlyHighlight(
                                                                          "FR_Grade"
                                                                        )}
                                                                      /> 
                                                                      {errors.FR_Grade && (
                                                                        <span className="text-danger">
                                                                          {errors.FR_Grade}
                                                                        </span>
                                                                      )} 
                                                                      */}
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    name="FR_Grade"
                                                    disablePortal
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    disabled={
                                                      isFromEditable ? false :
                                                        !checkHighlight("FR_Grade")
                                                    }
                                                    hasError={isFromEditable ? false : checkHighlight(
                                                      "FR_Grade"
                                                    )}
                                                    id="FR_Grade"
                                                    value={
                                                      values?.FR_Grade
                                                        ? values?.FR_Grade
                                                        : ""
                                                    }
                                                    // options={salaryItemsList}
                                                    options={PayGradeData}
                                                    getOptionLabel={(option) =>
                                                      option
                                                    }
                                                    onChange={(e, v, reason) => {
                                                      setFieldValue("FR_Grade", v);
                                                    }}
                                                    renderOption={(
                                                      props,
                                                      option,
                                                      index
                                                    ) => {
                                                      const key = `listItem-${index?.index}`;
                                                      return (
                                                        <li {...props} key={key}>
                                                          {option}
                                                        </li>
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        label="Grade"
                                                        className={
                                                          checkOnlyHighlight(
                                                            "FR_Grade"
                                                          )
                                                            ? "isHL"
                                                            : checkSysGenHighlight(
                                                              "FR_Grade"
                                                            )
                                                              ? "isHL1"
                                                              : ""
                                                        }
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        error={checkHighlight(
                                                          "FR_Grade"
                                                        )}
                                                      />
                                                    )}
                                                  />
                                                </Col>
                                              )}
                                              {showField.FR_Step === true && (
                                                <Col>
                                                  {/* <CustomTextField
                                                                        type="number"
                                                                        label="Step"
                                                                        shrink={true}
                                                                        name="FR_Step"
                                                                        value={values.FR_Step}
                                                                        onChange={(e) => {
                                                                          handleChange(e);
                                                                        }}
                                                                        style={{ width: "50%" }}
                                                                        id="FR_Step"
                                                                        className={
                                                                          errors.FR_Step
                                                                            ? "input-error"
                                                                            : null
                                                                        }
                                                                        hasError={checkHighlight(
                                                                          "FR_Step"
                                                                        )}
                                                                        disabled={
                                                                          checkHighlight("FR_Step")
                                                                            ? false
                                                                            : true
                                                                        }
                                                                        onKeyUp={(e) => {
                                                                          getFRSalaryGradeFromStep(
                                                                            e.target.value
                                                                          );
                                                                        }}
                                                                        checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                                          "FR_Step"
                                                                        )}
                                                                        checkHighlightForTextBox={checkOnlyHighlight(
                                                                          "FR_Step"
                                                                        )}
                                                                      /> */}
                                                  <CustomTextField
                                                    type="number"
                                                    name="FR_Step"
                                                    label="Step"
                                                    shrink={true}
                                                    value={values.FR_Step}
                                                    InputProps={{
                                                      inputProps: {
                                                        min: 0,
                                                      },
                                                    }}
                                                    onChange={(e) => {
                                                      if (e.target.value > 0) {
                                                        if (
                                                          parseInt(e.target.value) <
                                                          10
                                                        ) {
                                                          setFieldValue(
                                                            "FR_Step",
                                                            `0${parseInt(
                                                              e.target.value
                                                            )}`
                                                          );
                                                        } else {
                                                          let b = parseInt(
                                                            e.target.value,
                                                            10
                                                          ).toString();
                                                          if (b?.length <= 2) {
                                                            setFieldValue(
                                                              "FR_Step",
                                                              b
                                                            );
                                                          }
                                                        }
                                                      } else {
                                                        setFieldValue(
                                                          "FR_Step",
                                                          e.target.value
                                                        );
                                                      }
                                                    }}
                                                    onKeyUp={(e) => {
                                                      getFRSalaryGradeFromStep(
                                                        e.target.value
                                                      );
                                                    }}
                                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                      "FR_Step"
                                                    )}
                                                    checkHighlightForTextBox={checkOnlyHighlight(
                                                      "FR_Step"
                                                    )}
                                                    style={{ width: "50%" }}
                                                    id="FR_Step"
                                                    className={
                                                      errors.FR_Step
                                                        ? "input-error"
                                                        : null
                                                    }
                                                    hasError={isFromEditable ? false : checkHighlight(
                                                      "FR_Step"
                                                    )}
                                                    disabled={
                                                      isFromEditable ? false :
                                                        checkHighlight("FR_Step")
                                                          ? false
                                                          : true
                                                    }
                                                    forceEnable={isFromEditable ? true : false}
                                                  />
                                                  {errors.FR_Step && (
                                                    <p className="hasErrorLbl">
                                                      {errors.FR_Step}
                                                    </p>
                                                  )}
                                                </Col>
                                              )}
                                            </Row>
                                            <Row className="mt-1">
                                              {showField.FR_Rate === true && (
                                                <Col>
                                                  <CustomTextField
                                                    type="number"
                                                    label="Rate"
                                                    shrink={true}
                                                    name="FR_Rate"
                                                    value={values.FR_Rate}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    style={{ width: "50%" }}
                                                    id="FR_Rate"
                                                    className={
                                                      errors.FR_Rate
                                                        ? "input-error"
                                                        : null
                                                    }
                                                    hasError={checkHighlight(
                                                      "FR_Rate"
                                                    )}
                                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                      "FR_Rate"
                                                    )}
                                                    checkHighlightForTextBox={checkOnlyHighlight(
                                                      "FR_Rate"
                                                    )}
                                                    InputProps={{
                                                      inputProps: { step: "any" },
                                                    }}
                                                  />
                                                  {errors.FR_Rate && (
                                                    <p className="hasErrorLbl">
                                                      {errors.FR_Rate}
                                                    </p>
                                                  )}
                                                </Col>
                                              )}
                                              {showField.FR_Salary === true && (
                                                <Col>
                                                  <CustomTextField
                                                    type="number"
                                                    label="Salary"
                                                    shrink={true}
                                                    name="FR_Salary"
                                                    value={values.FR_Salary}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    style={{ width: "50%" }}
                                                    id="FR_Salary"
                                                    disabled={
                                                      isFromEditable ? false :
                                                        checkHighlight("FR_Salary")
                                                          ? false
                                                          : true
                                                    }
                                                    hasError={isFromEditable ? false : checkHighlight(
                                                      "FR_Salary"
                                                    )}
                                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                      "FR_Salary"
                                                    )}
                                                    checkHighlightForTextBox={checkOnlyHighlight(
                                                      "FR_Salary"
                                                    )}
                                                    InputProps={{
                                                      inputProps: { step: "any" },
                                                    }}
                                                  />
                                                </Col>
                                              )}
                                            </Row>

                                            {showField.FR_Department === true && (
                                              <Row className="mt-2">
                                                <Col>
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    disablePortal
                                                    name="FR_Department"
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    disabled={
                                                      isFromEditable ? false :
                                                        !checkHighlight(
                                                          "FR_Department"
                                                        )
                                                    }
                                                    hasError={isFromEditable ? false : checkHighlight(
                                                      "FR_Department"
                                                    )}
                                                    id="combo-box-demo"
                                                    options={departmentOptions}
                                                    getOptionLabel={(option) =>
                                                      option?.label
                                                        ? option?.label?.toString()
                                                        : ""
                                                    }
                                                    value={
                                                      values?.FR_Department
                                                        ? values.FR_Department
                                                        : {
                                                          value: "",
                                                          label: "",
                                                        }
                                                    }
                                                    onChange={(e, v) => {
                                                      setFieldValue(
                                                        "FR_Department",
                                                        v
                                                      );
                                                      setFieldValue(
                                                        "FR_Division",
                                                        ""
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        className={
                                                          checkOnlyHighlight(
                                                            "FR_Department"
                                                          )
                                                            ? "isHL"
                                                            : checkSysGenHighlight(
                                                              "FR_Department"
                                                            )
                                                              ? "isHL1"
                                                              : ""
                                                        }
                                                        error={checkHighlight(
                                                          "FR_Department"
                                                        )}
                                                        label="Department"
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                      />
                                                    )}
                                                  />
                                                  {errors.FR_Department && (
                                                    <p className="hasErrorLbl">
                                                      {errors.FR_Department
                                                        ? errors.FR_Department
                                                          .value ||
                                                        errors.FR_Department
                                                        : errors.FR_Department}
                                                    </p>
                                                  )}
                                                </Col>
                                              </Row>
                                            )}
                                            {showField.FR_Division === true && (
                                              <Row className="mt-2">
                                                <Col style={{ marginTop: "5px" }}>
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    disablePortal
                                                    name="FR_Division"
                                                    disabled={
                                                      isFromEditable ? false :
                                                        !checkHighlight("FR_Division")
                                                    }
                                                    hasError={isFromEditable ? false : checkHighlight(
                                                      "FR_Division"
                                                    )}
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    id="combo-box-demo"
                                                    options={
                                                      filteredDivisionFromOptions
                                                    }
                                                    getOptionLabel={(option) =>
                                                      option?.label
                                                        ? option?.label?.toString()
                                                        : ""
                                                    }
                                                    value={
                                                      values?.FR_Division
                                                        ? values.FR_Division
                                                        : {
                                                          value: "",
                                                          label: "",
                                                        }
                                                    }
                                                    onChange={(e, v) => {
                                                      setFieldValue(
                                                        "FR_Division",
                                                        v
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        className={
                                                          checkOnlyHighlight(
                                                            "FR_Division"
                                                          )
                                                            ? "isHL"
                                                            : checkSysGenHighlight(
                                                              "FR_Division"
                                                            )
                                                              ? "isHL1"
                                                              : ""
                                                        }
                                                        error={checkHighlight(
                                                          "FR_Division"
                                                        )}
                                                        label="Section/Division"
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                      />
                                                    )}
                                                  />
                                                  {errors.FR_Division && (
                                                    <p className="hasErrorLbl">
                                                      {errors.FR_Division
                                                        ? errors.FR_Division
                                                          .value ||
                                                        errors.FR_Division
                                                        : errors.FR_Division}
                                                    </p>
                                                  )}
                                                </Col>
                                              </Row>
                                            )}
                                            {/* {showField.FR_Dept_Div_Sec === true && (
                                                                  <Row className="mt-2 mb-2">
                                                                    <Col>
                                                                      <Row> */}
                                            {/* <Col xs={4}>
                                                                          <Autocomplete                                                    size="small"
                                                                            disablePortal
                                                                            name="FR_Dept_Div_Sec"
                                                                            disabled={
                                                                              !checkHighlight(
                                                                                "FR_Dept_Div_Sec"
                                                                              )
                                                                            }
                                                                            hasError={checkHighlight(
                                                                              "FR_Dept_Div_Sec"
                                                                            )}
                                                                            InputLabelProps={{
                                                                              shrink: true,
                                                                            }}
                                                                            id="combo-box-demo"
                                                                            options={DpDvOptions}
                                                                            getOptionLabel={(option) =>
                                                                              option.value
                                                                                ? option.value?.toString()
                                                                                : ""
                                                                            }
                                                                            value={
                                                                              values?.FR_Dept_Div_Sec
                                                                                ? values.FR_Dept_Div_Sec
                                                                                : {
                                                                                    value: "",
                                                                                    label: "",
                                                                                  }
                                                                            }
                                                                            onChange={(e, v) => {
                                                                              setFieldValue(
                                                                                "FR_Dept_Div_Sec",
                                                                                v
                                                                              );
                                                                            }}
                                                                            renderInput={(params) => (
                                                                              <TextField
                                                                                {...params}
                                                                                sx={{
                                                                                  "& .MuiInputBase-input.Mui-disabled":
                                                                                    {
                                                                                      WebkitTextFillColor:
                                                                                        "#00000092",
                                                                                    },
                                                                                  "& .MuiFormLabel-root.Mui-disabled":
                                                                                    {
                                                                                      WebkitTextFillColor:
                                                                                        "#00000092",
                                                                                    },
                                                                                }}
                                                                                className={
                                                                                  checkOnlyHighlight(
                                                                                    "FR_Dept_Div_Sec"
                                                                                  )
                                                                                    ? "isHL"
                                                                                    : checkSysGenHighlight(
                                                                                        "FR_Dept_Div_Sec"
                                                                                      )
                                                                                    ? "isHL1"
                                                                                    : ""
                                                                                }
                                                                                error={checkHighlight(
                                                                                  "FR_Dept_Div_Sec"
                                                                                )}
                                                                                label="Dept/DIV Sec."
                                                                                InputLabelProps={{
                                                                                  shrink: true,
                                                                                }}
                                                                              />
                                                                            )}
                                                                          />
                                                                          {errors.FR_Dept_Div_Sec && (
                                                                            <p className="hasErrorLbl">
                                                                              {errors.FR_Dept_Div_Sec
                                                                                ? errors.FR_Dept_Div_Sec
                                                                                    .value ||
                                                                                  errors.FR_Dept_Div_Sec
                                                                                : errors.FR_Dept_Div_Sec}
                                                                            </p>
                                                                          )}
                                                                        </Col> */}
                                            {/* <Col xs={6}>
                                                                          {" "}
                                                                          
                                                                        </Col>
                                                                        <Col xs={6}>
                                                                          
                                                                        </Col>
                                                                      </Row>
                                                                    </Col>
                                                                  </Row>
                                                                )} */}
                                            {showField.FR_FTE_Number === true && (
                                              <Row>
                                                <Col style={{ marginTop: "5px" }}>
                                                  <CustomTextField
                                                    label="FTE Number"
                                                    shrink={true}
                                                    name="FR_FTE_Number"
                                                    value={values.FR_FTE_Number}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                      "FR_FTE_Number"
                                                    )}
                                                    style={{ width: "50%" }}
                                                    id="FR_FTE_Number"
                                                    checkHighlightForTextBox={checkOnlyHighlight(
                                                      "FR_FTE_Number"
                                                    )}
                                                    hasError={isFromEditable ? false :
                                                      checkHighlight(
                                                        "FR_FTE_Number"
                                                      )
                                                        ? true
                                                        : false
                                                    }
                                                    disabled={isFromEditable ? false :
                                                      checkHighlight(
                                                        "FR_FTE_Number"
                                                      )
                                                        ? false
                                                        : true
                                                    }
                                                    forceEnable={isFromEditable ? true : false}
                                                  />
                                                  {errors.FR_FTE_Number && (
                                                    <p className="hasErrorLbl">
                                                      {errors.FR_FTE_Number}
                                                    </p>
                                                  )}
                                                </Col>
                                              </Row>
                                            )}
                                          </div>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                    <Col
                                      xs={6}
                                      style={{
                                        padding: "0px",
                                      }}
                                    >
                                      <Card>
                                        <CardHeader className="bg-primary">
                                          <Typography className="text-center">
                                            {" "}
                                            TO
                                          </Typography>
                                        </CardHeader>
                                        <CardBody>
                                          <div
                                            className="table table-striped table-bordered mt-2"
                                            style={{
                                              marginLeft: "2px",
                                            }}
                                          >
                                            {showField.TO_PositionTitle ===
                                              true && (
                                                <Row>
                                                  <Col
                                                    xs={
                                                      values?.TO_PositionTitle?.tdp ==
                                                        true &&
                                                        values?.natureCode?.value !=
                                                        "24"
                                                        ? 10
                                                        : 12
                                                    }
                                                  >
                                                    <Autocomplete
                                                      isOptionEqualToValue={(
                                                        option,
                                                        value
                                                      ) =>
                                                        option.value === value.value
                                                      }
                                                      size="small"
                                                      name="TO_PositionTitle"
                                                      disablePortal
                                                      InputLabelProps={{
                                                        shrink: true,
                                                      }}
                                                      disabled={isToEditable ? false :
                                                        !checkHighlight(
                                                          "TO_PositionTitle"
                                                        )
                                                      }
                                                      hasError={isToEditable ? false : checkHighlight(
                                                        "TO_PositionTitle"
                                                      )}
                                                      id="TO_PositionTitle"
                                                      value={
                                                        values?.TO_PositionTitle
                                                          ? values.TO_PositionTitle
                                                          : { value: "", label: "" }
                                                      }
                                                      options={
                                                        values?.natureCode?.value ==
                                                          "91"
                                                          ? classifiedPositionOption
                                                          : positionTitleOptions
                                                      }
                                                      // inputValue={newExtraPosition}
                                                      // onInputChange={
                                                      //   handleInputChange
                                                      // }
                                                      freeSolo
                                                      getOptionLabel={(option) =>
                                                        // option.label
                                                        //   ? option.label?.toString()
                                                        //   : ""
                                                        option?.titleWithGrade ||
                                                          option?.label
                                                          ? option?.label?.toString()
                                                          : ""
                                                      }
                                                      onChange={(e, v, reason) => {
                                                        console.log("post value", v);
                                                        if (
                                                          v != undefined ||
                                                          v != null
                                                        ) {
                                                          if (
                                                            v?.range_next?.trim() ==
                                                            ""
                                                          ) {
                                                            setFieldValue(
                                                              "TO_PositionTitle",
                                                              v
                                                            );
                                                            setFieldValue(
                                                              "TO_Grade",
                                                              ""
                                                            );
                                                            setFieldValue(
                                                              "TO_Step",
                                                              ""
                                                            );
                                                            checkUnclassifiedPositions(
                                                              "to"
                                                            );
                                                          } else {
                                                            setFieldValue(
                                                              "TO_PositionTitle",
                                                              v
                                                            );
                                                            // setFieldValue(
                                                            //   "TO_ClassCode",
                                                            //   v?.value?.trim()
                                                            // );
                                                            if (
                                                              v?.range_next?.trim()
                                                            ) {
                                                              setFieldValue(
                                                                "TO_Grade",
                                                                v?.range_next?.trim()
                                                              );
                                                              if (v?.range_next?.trim() == "SDYA") {
                                                                setFieldValue("maxHours", 180)
                                                              } else if (v?.range_next?.trim() == "SDOL") {
                                                                setFieldValue("maxHours", 150)
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          setFieldValue(
                                                            "TO_PositionTitle",
                                                            v
                                                          );
                                                        }
                                                      }}
                                                      renderOption={(
                                                        props,
                                                        option,
                                                        index
                                                      ) => {
                                                        const key = `listItem-${index?.index}-${option["value"]}`;
                                                        return (
                                                          <li {...props} key={key}>
                                                            {/* {option["label"]} */}
                                                            {option["titleWithGrade"]}
                                                          </li>
                                                        );
                                                      }}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          sx={{
                                                            "& .MuiInputBase-input.Mui-disabled":
                                                            {
                                                              WebkitTextFillColor:
                                                                "#00000092",
                                                            },
                                                            "& .MuiFormLabel-root.Mui-disabled":
                                                            {
                                                              WebkitTextFillColor:
                                                                "#00000092",
                                                            },
                                                          }}
                                                          label="Position"
                                                          // className={
                                                          //   checkOnlyHighlight(
                                                          //     "TO_PositionTitle"
                                                          //   )
                                                          //     ? "isHL"
                                                          //     : checkSysGenHighlight(
                                                          //       "TO_PositionTitle"
                                                          //     )
                                                          //       ? "isHL1"
                                                          //       : ""
                                                          // }
                                                          InputLabelProps={{
                                                            shrink: true,
                                                          }}
                                                        // error={checkHighlight(
                                                        //   "TO_PositionTitle"
                                                        // )}
                                                        />
                                                      )}
                                                    />
                                                  </Col>
                                                  {values?.TO_PositionTitle?.tdp ==
                                                    true &&
                                                    values?.natureCode?.value !=
                                                    "24" ? (
                                                    <Col xs={2} className="mt-auto">
                                                      <TextField
                                                        margin="dense"
                                                        // type="number"
                                                        name="tdp"
                                                        label="TDP"
                                                        shrink={true}
                                                        value={
                                                          values?.TO_PositionTitle
                                                            ?.tdp == true
                                                            ? "Yes"
                                                            : "No"
                                                        }
                                                        style={{ width: "100%" }}
                                                        id="TDP"
                                                        size="small"
                                                        className="mt-auto !important"
                                                        disabled
                                                      />
                                                    </Col>
                                                  ) : null}
                                                </Row>
                                              )}
                                            {/****** Hide because not in new sheet - Dipen. */}
                                            {/* {showField.TO_ClassCode === true && (
                                                                  <Row className="mt-3 mb-2">
                                                                    <Col>
                                                                      <CustomTextField
                                                                        name="TO_ClassCode"
                                                                        label="Class Code"
                                                                        value={values.TO_ClassCode}
                                                                        onChange={(e) => {
                                                                          handleChange(e);
                                                                        }}
                                                                        checkHighlightForTextBox={checkOnlyHighlight(
                                                                          "TO_ClassCode"
                                                                        )}
                                                                        shrink={true}
                                                                        id="TO_ClassCode"
                                                                        hasError={checkHighlight(
                                                                          "TO_ClassCode"
                                                                        )}
                                                                        disabled={
                                                                          checkHighlight("TO_ClassCode")
                                                                            ? false
                                                                            : true
                                                                        }
                                                                      />
                                                                    </Col>
                                                                  </Row>
                                                                )} */}

                                            <Row className="mt-1">
                                              {showField.TO_Grade === true && (
                                                <Col style={{ marginTop: "8px" }}>
                                                  {/* <CustomTextField
                                                                        name="TO_Grade"
                                                                        label="Grade"
                                                                        value={values.TO_Grade}
                                                                        onChange={(e) => {
                                                                          handleChange(e);
                                                                        }}
                                                                        checkHighlightForTextBox={checkOnlyHighlight(
                                                                          "TO_Grade"
                                                                        )}
                                                                        checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                                          "TO_Grade"
                                                                        )}
                                                                        shrink={true}
                                                                        id="TO_Grade"
                                                                        hasError={checkHighlight(
                                                                          "TO_Grade"
                                                                        )}
                                                                        disabled={
                                                                          checkHighlight("TO_Grade")
                                                                            ? false
                                                                            : true
                                                                        }
                                                                      /> */}
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    name="TO_Grade"
                                                    disablePortal
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    disabled={isToEditable ? false :
                                                      values?.CurrentProcessStatus
                                                        ?.value == 9
                                                        ? false
                                                        : !checkHighlight(
                                                          "TO_Grade"
                                                        )
                                                    }
                                                    hasError={isToEditable ? false : checkHighlight(
                                                      "TO_Grade"
                                                    )}
                                                    id="TO_Grade"
                                                    value={
                                                      values?.TO_Grade
                                                        ? values?.TO_Grade
                                                        : ""
                                                    }
                                                    // options={salaryItemsList}
                                                    options={PayGradeData}
                                                    getOptionLabel={(option) =>
                                                      // option.grade
                                                      //   ? option.grade
                                                      //   : ""
                                                      option
                                                    }
                                                    onChange={(e, v, reason) => {
                                                      setFieldValue("TO_Grade", v);
                                                      console.log("123123 Grade :::", v, values?.maxHours)
                                                      if (v == "SDYA") {
                                                        setFieldValue("maxHours", 180)
                                                      } else if (v == "SDOL") {
                                                        setFieldValue("maxHours", 150)
                                                      }
                                                      // console.log(
                                                      //   "121212 onchange ::: ",
                                                      //   v,
                                                      //   values?.TO_Grade
                                                      // );
                                                      // setFieldValue(
                                                      //   "TO_ClassCode",
                                                      //   v?.value?.trim()
                                                      // );
                                                      // if (v?.range_next?.trim()) {
                                                      //   setFieldValue(
                                                      //     "TO_Grade",
                                                      //     v?.range_next?.trim()
                                                      //   );
                                                      // }
                                                    }}
                                                    renderOption={(
                                                      props,
                                                      option,
                                                      index
                                                    ) => {
                                                      // const key = `listItem-${index}-${option["grade"]}`;
                                                      const key = `listItem-${index?.index}`;
                                                      return (
                                                        <li {...props} key={key}>
                                                          {/* {option["grade"]} */}
                                                          {option}
                                                        </li>
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        label="Grade"
                                                        // className={
                                                        //   values
                                                        //     ?.CurrentProcessStatus
                                                        //     ?.value == 9
                                                        //     ? "isHL"
                                                        //     : checkOnlyHighlight(
                                                        //       "TO_Grade"
                                                        //     )
                                                        //       ? "isHL"
                                                        //       : checkSysGenHighlight(
                                                        //         "TO_Grade"
                                                        //       )
                                                        //         ? "isHL1"
                                                        //         : ""
                                                        // }
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                        // error={isToEditable ? false :checkHighlight(
                                                        //   "TO_Grade"
                                                        // )}
                                                        disabled={isToEditable ? false :
                                                          checkHighlight("TO_Grade")
                                                            ? false
                                                            : true
                                                        }
                                                      />
                                                    )}
                                                  />
                                                </Col>
                                              )}
                                              {showField.TO_Step === true && (
                                                <Col>
                                                  <CustomTextField
                                                    type="number"
                                                    name="TO_Step"
                                                    label="Step"
                                                    shrink={true}
                                                    value={values.TO_Step}
                                                    InputProps={{
                                                      inputProps: {
                                                        min: 0,
                                                      },
                                                    }}
                                                    onChange={(e) => {
                                                      if (e.target.value > 0) {
                                                        if (
                                                          parseInt(e.target.value) <
                                                          10
                                                        ) {
                                                          setFieldValue(
                                                            "TO_Step",
                                                            `0${parseInt(
                                                              e.target.value
                                                            )}`
                                                          );
                                                        } else {
                                                          let b = parseInt(
                                                            e.target.value,
                                                            10
                                                          ).toString();
                                                          if (b?.length <= 2) {
                                                            setFieldValue(
                                                              "TO_Step",
                                                              b
                                                            );
                                                          }
                                                        }
                                                      } else {
                                                        setFieldValue(
                                                          "TO_Step",
                                                          e.target.value
                                                        );
                                                      }
                                                    }}
                                                    onKeyUp={(e) => {
                                                      getSalaryGradeFromStep(
                                                        e.target.value
                                                      );
                                                    }}
                                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                    //   "TO_Step"
                                                    // )}
                                                    // checkHighlightForTextBox={checkOnlyHighlight(
                                                    //   "TO_Step"
                                                    // )}
                                                    style={{ width: "50%" }}
                                                    id="TO_Step"
                                                    className={
                                                      errors.TO_Step
                                                        ? "input-error"
                                                        : null
                                                    }
                                                    // hasError={isToEditable ? false :checkHighlight(
                                                    //   "TO_Step"
                                                    // )}
                                                    disabled={isToEditable ? false :
                                                      checkHighlight("TO_Step")
                                                        ? false
                                                        : true
                                                    }
                                                    forceEnable={isToEditable ? true : false}
                                                  />
                                                </Col>
                                              )}
                                            </Row>
                                            <Row className="mt-1">
                                              {showField.TO_Rate === true && (
                                                <Col>
                                                  <CustomTextField
                                                    type="number"
                                                    name="TO_Rate"
                                                    label="Rate"
                                                    shrink={true}
                                                    value={values.TO_Rate}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    style={{ width: "50%" }}
                                                    id="TO_Rate"
                                                    // className={
                                                    //   errors.TO_Rate
                                                    //     ? "input-error"
                                                    //     : null
                                                    // }
                                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                    //   "TO_Rate"
                                                    // )}
                                                    // checkHighlightForTextBox={checkOnlyHighlight(
                                                    //   "TO_Rate"
                                                    // )}
                                                    // hasError={isToEditable ? false : checkHighlight(
                                                    //   "TO_Rate"
                                                    // )}
                                                    disabled={isToEditable ? false :
                                                      checkHighlight("TO_Rate")
                                                        ? false
                                                        : true
                                                    }
                                                    InputProps={{
                                                      inputProps: { step: "any" },
                                                    }}
                                                  />
                                                  {errors.TO_Rate && (
                                                    <p className="hasErrorLbl">
                                                      {errors.TO_Rate}
                                                    </p>
                                                  )}
                                                </Col>
                                              )}
                                              {showField.TO_Salary === true && (
                                                <Col>
                                                  <CustomTextField
                                                    type="number"
                                                    label="Salary"
                                                    shrink={true}
                                                    name="TO_Salary"
                                                    value={values.TO_Salary}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    style={{ width: "50%" }}
                                                    id="TO_Salary"
                                                    // className={
                                                    //   errors.TO_Salary
                                                    //     ? "input-error"
                                                    //     : null
                                                    // }
                                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                    //   "TO_Salary"
                                                    // )}
                                                    // checkHighlightForTextBox={checkOnlyHighlight(
                                                    //   "TO_Salary"
                                                    // )}
                                                    // hasError={isToEditable ? false : checkHighlight(
                                                    //   "TO_Salary"
                                                    // )}
                                                    disabled={isToEditable ? false :
                                                      checkHighlight("TO_Salary")
                                                        ? false
                                                        : true
                                                    }
                                                    InputProps={{
                                                      inputProps: { step: "any" },
                                                    }}
                                                  />
                                                </Col>
                                              )}
                                            </Row>
                                            {showField.TO_Department === true && (
                                              <Row className="mt-2">
                                                <Col>
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    disablePortal
                                                    name="TO_Department"
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    disabled={isToEditable ? false :
                                                      !checkHighlight(
                                                        "TO_Department"
                                                      )
                                                    }
                                                    id="TO_Department"
                                                    value={
                                                      values?.TO_Department
                                                        ? values.TO_Department
                                                        : {
                                                          value: "",
                                                          label: "",
                                                        }
                                                    }
                                                    options={departmentOptions}
                                                    getOptionLabel={
                                                      (option) =>
                                                        option?.label
                                                          ? `${option.value} - ${option?.label?.toString()}`
                                                          // ? option?.label?.toString()
                                                          : ""
                                                    }
                                                    onChange={(e, v) => {
                                                      // setFieldValue(
                                                      //   "TO_Dept_Div_Sec",
                                                      //   v
                                                      // );
                                                      setFieldValue(
                                                        "TO_Department",
                                                        v
                                                      );
                                                      setFieldValue(
                                                        "TO_Division",
                                                        ""
                                                      );
                                                    }}
                                                    renderOption={(
                                                      props,
                                                      option,
                                                      index
                                                    ) => {
                                                      const key = `listItem-${index?.index}-${option.id}`;
                                                      return (
                                                        <li {...props} key={key}>
                                                          {option["value"]} - {option["label"]}
                                                        </li>
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        // className={
                                                        //   checkOnlyHighlight(
                                                        //     "TO_Department"
                                                        //   )
                                                        //     ? "isHL"
                                                        //     : checkSysGenHighlight(
                                                        //       "TO_Department"
                                                        //     )
                                                        //       ? "isHL1"
                                                        //       : ""
                                                        // }
                                                        // error={checkHighlight(
                                                        //   "TO_Department"
                                                        // )}
                                                        label="Department"
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                      />
                                                    )}
                                                  />
                                                </Col>
                                              </Row>
                                            )}
                                            {showField.TO_Division === true && (
                                              <Row className="mt-2">
                                                <Col style={{ marginTop: "5px" }}>
                                                  <Autocomplete
                                                    isOptionEqualToValue={(
                                                      option,
                                                      value
                                                    ) =>
                                                      option.value === value.value
                                                    }
                                                    size="small"
                                                    name="TO_Division"
                                                    disablePortal
                                                    InputLabelProps={{
                                                      shrink: true,
                                                    }}
                                                    hasError={isToEditable ? false : checkHighlight(
                                                      "TO_Division"
                                                    )}
                                                    disabled={isToEditable ? false :
                                                      !checkHighlight("TO_Division")
                                                    }
                                                    id="combo-box-demo"
                                                    value={
                                                      values?.TO_Division
                                                        ? values.TO_Division
                                                        : {
                                                          value: "",
                                                          label: "",
                                                        }
                                                    }
                                                    options={
                                                      filteredDivisionOptions
                                                    }
                                                    getOptionLabel={(option) =>
                                                      // option.deptNo ==
                                                      // values?.TO_Department
                                                      //   ?.value
                                                      //   ? option.label
                                                      //   : ""
                                                      option?.label
                                                        // ? option?.label?.toString()
                                                        ? `${option.value} - ${option?.label?.toString()}`
                                                        : ""
                                                    }
                                                    onChange={(e, v) => {
                                                      setFieldValue(
                                                        "TO_Division",
                                                        v
                                                      );
                                                    }}
                                                    renderOption={(
                                                      props,
                                                      option,
                                                      index
                                                    ) => {
                                                      const key = `listItem-${index?.index}-${option["deptDiv"]}`;
                                                      return (
                                                        <li {...props} key={key}>
                                                          {/* {option["label"]} */}
                                                          {option["value"]} - {option["label"]}
                                                        </li>
                                                      );
                                                    }}
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        sx={{
                                                          "& .MuiInputBase-input.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                          "& .MuiFormLabel-root.Mui-disabled":
                                                          {
                                                            WebkitTextFillColor:
                                                              "#00000092",
                                                          },
                                                        }}
                                                        label="Section/Division"
                                                        // className={
                                                        //   checkOnlyHighlight(
                                                        //     "TO_Division"
                                                        //   )
                                                        //     ? "isHL"
                                                        //     : checkSysGenHighlight(
                                                        //       "TO_Division"
                                                        //     )
                                                        //       ? "isHL1"
                                                        //       : ""
                                                        // }
                                                        InputLabelProps={{
                                                          shrink: true,
                                                        }}
                                                      // error={checkHighlight(
                                                      //   "TO_Division"
                                                      // )}
                                                      />
                                                    )}
                                                  />
                                                </Col>
                                              </Row>
                                            )}
                                            {/* {showField.TO_Dept_Div_Sec === true && (
                                                                  <Row className="mt-2 mb-2">
                                                                    <Col>
                                                                      <Row> */}
                                            {/* <Col xs={4}>
                                                                          {" "}
                                                                          <Autocomplete
                                                                            size="small"
                                                                            name="TO_Dept_Div_Sec"
                                                                            disablePortal
                                                                            InputLabelProps={{
                                                                              shrink: true,
                                                                            }}
                                                                            hasError={checkHighlight(
                                                                              "TO_Dept_Div_Sec"
                                                                            )}
                                                                            disabled={
                                                                              !checkHighlight(
                                                                                "TO_Dept_Div_Sec"
                                                                              )
                                                                            }
                                                                            id="combo-box-demo"
                                                                            value={
                                                                              values?.TO_Dept_Div_Sec
                                                                                ? values.TO_Dept_Div_Sec
                                                                                : {
                                                                                    value: "",
                                                                                    label: "",
                                                                                  }
                                                                            }
                                                                            options={DpDvOptions}
                                                                            getOptionLabel={(option) =>
                                                                              option.value
                                                                                ? option.value?.toString()
                                                                                : ""
                                                                            }
                                                                            onChange={(e, v) => {
                                                                              setFieldValue(
                                                                                "TO_Dept_Div_Sec",
                                                                                v
                                                                              );
                                                                            }}
                                                                            renderOption={(
                                                                              props,
                                                                              option,
                                                                              index
                                                                            ) => {
                                                                              const key = `listItem-${index?.index}-${option["value"]}`;
                                                                              return (
                                                                                <li
                                                                                  {...props}
                                                                                  key={key}
                                                                                >
                                                                                  {option["value"]}
                                                                                </li>
                                                                              );
                                                                            }}
                                                                            renderInput={(params) => (
                                                                              <TextField
                                                                                {...params}
                                                                                sx={{
                                                                                  "& .MuiInputBase-input.Mui-disabled":
                                                                                    {
                                                                                      WebkitTextFillColor:
                                                                                        "#00000092",
                                                                                    },
                                                                                  "& .MuiFormLabel-root.Mui-disabled":
                                                                                    {
                                                                                      WebkitTextFillColor:
                                                                                        "#00000092",
                                                                                    },
                                                                                }}
                                                                                label="Dept/DIV Sec."
                                                                                className={
                                                                                  checkOnlyHighlight(
                                                                                    "TO_Dept_Div_Sec"
                                                                                  )
                                                                                    ? "isHL"
                                                                                    : checkSysGenHighlight(
                                                                                        "TO_Dept_Div_Sec"
                                                                                      )
                                                                                    ? "isHL1"
                                                                                    : ""
                                                                                }
                                                                                InputLabelProps={{
                                                                                  shrink: true,
                                                                                }}
                                                                                error={checkHighlight(
                                                                                  "TO_Dept_Div_Sec"
                                                                                )}
                                                                              />
                                                                            )}
                                                                          />
                                                                        </Col> */}
                                            {/* </Row> 
                                                                    </Col>
                                                                  </Row>
                                                                )} */}
                                            {showField.TO_FTE_Number === true && (
                                              <Row>
                                                <Col style={{ marginTop: "5px" }}>
                                                  <CustomTextField
                                                    label="FTE Number"
                                                    shrink={true}
                                                    name="TO_FTE_Number"
                                                    value={values.TO_FTE_Number}
                                                    onChange={(e) => {
                                                      handleChange(e);
                                                    }}
                                                    // checkHighlightForTextBox={checkOnlyHighlight(
                                                    //   "TO_FTE_Number"
                                                    // )}
                                                    // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                                    //   "TO_FTE_Number"
                                                    // )}
                                                    style={{ width: "50%" }}
                                                    id="TO_FTE_Number"
                                                    // className={
                                                    //   checkHighlight(
                                                    //     "TO_FTE_Number"
                                                    //   )
                                                    //     ? "isHLOptional"
                                                    //     : ""
                                                    //   // errors.TO_FTE_Number
                                                    //   //   ? "isHLOptional"
                                                    //   //   : null
                                                    // }
                                                    // className={"isHLOptional"}
                                                    // hasError={
                                                    //   checkHighlight(
                                                    //     "TO_FTE_Number"
                                                    //   )
                                                    //     ? true
                                                    //     : false
                                                    // }
                                                    // disabled={
                                                    //   checkHighlight(
                                                    //     "TO_FTE_Number"
                                                    //   )
                                                    //     ? false
                                                    //     : true
                                                    // }
                                                    // forceEnable={true}
                                                    forceEnable={npaStarted ? false : true}
                                                    disabled={npaStarted ? true : false}
                                                  />
                                                </Col>
                                              </Row>
                                            )}
                                          </div>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                )}
                                {values?.natureCode?.value == "30" ? (
                                  <Row className="mt-1 p-1">
                                    <Col xs={6} className="px-2">
                                      <Autocomplete
                                        size="small"
                                        name="Evalution_Type"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        id="Evalution Type"
                                        className={
                                          errors.Evalution_Type
                                            ? "hasErrorInput"
                                            : null
                                        }
                                        value={
                                          values?.Evalution_Type
                                            ? values.Evalution_Type
                                            : { value: 0, label: "" }
                                        }
                                        // defaultValue={}
                                        // options={values?.CurrentProcessStatus?.value == "18" ? evalTypeItems : evalTypeItems?.filter((item)=>item?.key != "X")}
                                        options={evalTypeItems}
                                        getOptionLabel={(option) =>
                                          option.value
                                            ? option.value?.toString()
                                            : ""
                                        }
                                        renderOption={(props, option, index) => {
                                          const key = `listItem-${index?.index}-${option["value"]}`;
                                          return (
                                            <li {...props} key={key}>
                                              {`${option["value"]} - ${option["label"]}`}
                                            </li>
                                          );
                                        }}
                                        onChange={(e, v) => {
                                          setFieldValue("Evalution_Type", v);
                                        }}
                                        disabled={
                                          !checkHighlight("Evalution_Type")
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            // className={"isHL"}
                                            className={
                                              checkHighlight("Evalution_Type")
                                                ? "isHL"
                                                : ""
                                            }
                                            error={checkHighlight(
                                              "Evalution_Type"
                                            )}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            label="Evalution Type"
                                          />
                                        )}
                                      />
                                    </Col>
                                    <Col xs={6} className="px-2">
                                      <Autocomplete
                                        size="small"
                                        name="Evalution_Type"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        id="Evalution Type"
                                        className={
                                          errors.Evalution_Type
                                            ? "hasErrorInput"
                                            : null
                                        }
                                        value={
                                          values?.Evalution_Type
                                            ? values.Evalution_Type
                                            : { value: "", label: "" }
                                        }
                                        // defaultValue={}
                                        options={evalTypeItems}
                                        getOptionLabel={(option) =>
                                          option.label
                                            ? option.label?.toString()
                                            : ""
                                        }
                                        onChange={(e, v) => {
                                          setFieldValue("Evalution_Type", v);
                                        }}
                                        disabled={
                                          !checkHighlight("Evalution_Type")
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            // className={"isHL"}
                                            className={
                                              checkHighlight("Evalution_Type")
                                                ? "isHL"
                                                : ""
                                            }
                                            error={checkHighlight(
                                              "Evalution_Type"
                                            )}
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            label="Evalution Desc"
                                          />
                                        )}
                                      />
                                    </Col>
                                  </Row>
                                ) : null}
                                {values?.natureCode?.value == "91" && (
                                  <Row>
                                    <Col
                                      xs={6}
                                      className="px-2"
                                      style={{ marginTop: "7px" }}
                                    >
                                      <Autocomplete
                                        isOptionEqualToValue={(option, value) =>
                                          option.value === value.value
                                        }
                                        size="small"
                                        disablePortal
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        id="considerationArea"
                                        name="considerationArea"
                                        // disabled={values?.recruitmentType?.value == 2 ? true : false}
                                        value={
                                          values?.recruitmentType?.value == 2
                                            ? considerationList[2]
                                            : values?.considerationArea
                                        }
                                        options={considerationList}
                                        getOptionLabel={(option) =>
                                          option.label
                                            ? option.label?.toString()
                                            : ""
                                        }
                                        onChange={(e, v) => {
                                          if (
                                            values?.recruitmentType?.value == 2
                                          ) {
                                            setConsideration(
                                              considerationList[2]
                                            );
                                            setFieldValue(
                                              "considerationArea",
                                              considerationList[2]
                                            );
                                          } else {
                                            setConsideration(v);
                                            setFieldValue("considerationArea", v);
                                          }
                                        }}
                                        // hasError={errors.considerationArea ? false : false}
                                        disabled={currentStatus}
                                        renderOption={(props, option, index) => {
                                          const key = `listItem-${index?.index}-${option.value}`;
                                          return (
                                            <li {...props} key={key}>
                                              {option["label"]}
                                            </li>
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            error={
                                              errors.considerationArea
                                                ? false
                                                : false
                                            }
                                            label="Area of Consideration"
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                          // className={`flex w-full mx-10 ${
                                          //   // checkSysGenHighlight("NatureOf")
                                          //   //   ? "isHL1"
                                          //   //   : ""
                                          //   checkOnlyHighlight(
                                          //     "considerationArea"
                                          //   )
                                          //     ? "isHL"
                                          //     : ""
                                          //   } `}
                                          />
                                        )}
                                      />
                                    </Col>
                                  </Row>
                                )}
                                {showField.Remarks === true && (
                                  <Row className="mt-1">
                                    <Col xs={12} className="px-2">
                                      <CustomTextField
                                        label="Remarks"
                                        shrink={true}
                                        name="Remarks"
                                        value={values.Remarks}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        style={{ width: "50%" }}
                                        id="Remarks"
                                        // className={
                                        //   errors.Remarks ? "input-error" : null
                                        // }
                                        // className={
                                        //   checkHighlight("Remarks")
                                        //     ? "isHLOptional"
                                        //     : ""
                                        // }
                                        // disabled={
                                        //   checkHighlight("Remarks") ? false : true
                                        // }
                                        // hasError={checkHighlight(
                                        //   "Remarks"
                                        // )}
                                        // checkHighlightForTextBox={checkOnlyHighlight(
                                        //   "Remarks"
                                        // )}
                                        // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                        //   "Remarks"
                                        // )}
                                        // hasError={
                                        //   checkHighlight("Remarks") ? true : false
                                        // }
                                        hasError={false}
                                        InputProps={{ multiline: true, rows: 4 }}
                                        // forceEnable={true}
                                        forceEnable={npaStarted ? false : true}
                                        disabled={npaStarted ? true : false}
                                      />
                                    </Col>
                                  </Row>
                                )}
                                <Row>
                                  <Col xs={6} lg={6} className="px-2 mt-2 mb-1">
                                    {showField.worK_SCH === true && (
                                      <Autocomplete
                                        disablePortal
                                        disableClearable
                                        size="small"
                                        name="Change Work Status"
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        hasError={checkHighlight("worK_SCH")}
                                        id="worK_SCH"
                                        // defaultValue={""}
                                        value={values?.worK_SCH}
                                        options={workStatusOptions}
                                        getOptionLabel={(option) => option["label"]}
                                        // className={
                                        //   checkHighlight("worK_SCH") ? "isHL" : ""
                                        // }
                                        onChange={(e, v) => {
                                          setFieldValue("worK_SCH", v);
                                        }}
                                        renderOption={(props, option, index) => {
                                          const key = `listItem-${index?.index}`;
                                          return (
                                            <li {...props} key={key}>
                                              {option["label"]}
                                            </li>
                                          );
                                        }}

                                        disabled={npaStarted ? true : false}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            sx={{
                                              "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#00000092",
                                              },
                                              "& .MuiFormLabel-root.Mui-disabled": {
                                                WebkitTextFillColor: "#00000092",
                                              },
                                            }}
                                            label="Change Work Status"
                                            className={
                                              checkHighlight("worK_SCH") ? "isHL" : ""
                                            }
                                            InputLabelProps={{
                                              shrink: true,
                                            }}
                                            error={checkHighlight("worK_SCH")}
                                          />
                                        )}
                                      />
                                    )}
                                  </Col>
                                  <Col xs={6} lg={6} className="px-2 mb-1">
                                    {showField.maxHours === true && (
                                      <CustomTextField
                                        label="Not to exceed number of hours"
                                        type="number"
                                        shrink={true}
                                        name="maxHours"
                                        value={values.maxHours}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === '.' || e.key === 'e' || e.key === '+' || e.key === '-') {
                                            e.preventDefault();
                                          }
                                        }}
                                        // checkHighlightForTextBox={checkOnlyHighlight(
                                        //   "TO_FTE_Number"
                                        // )}
                                        // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                        //   "TO_FTE_Number"
                                        // )}
                                        style={{ width: "50%" }}
                                        id="maxHours"
                                        // className={
                                        //   checkHighlight(
                                        //     "TO_FTE_Number"
                                        //   )
                                        //     ? "isHLOptional"
                                        //     : ""
                                        //   // errors.TO_FTE_Number
                                        //   //   ? "isHLOptional"
                                        //   //   : null
                                        // }
                                        // className={"isHLOptional"}
                                        // hasError={
                                        //   checkHighlight(
                                        //     "TO_FTE_Number"
                                        //   )
                                        //     ? true
                                        //     : false
                                        // }
                                        // disabled={
                                        //   checkHighlight(
                                        //     "TO_FTE_Number"
                                        //   )
                                        //     ? false
                                        //     : true
                                        // }
                                        // forceEnable={true}
                                        forceEnable={npaStarted ? false : true}
                                        disabled={npaStarted ? true : false}
                                      />
                                    )}
                                  </Col>
                                </Row>


                                <Row className="mt-1">
                                  {showField.JOB_Order_Number === true && (
                                    <>

                                      {/* <Col xs={6} className="px-2 mt-2"> */}
                                      {/* <Autocomplete
                                                            isOptionEqualToValue={(option, value)=> option.value === value.value}
                                                            size="small"
                                                            disablePortal
                                                            InputLabelProps={{
                                                              shrink: true,
                                                            }}
                                                            id="JOB_Order_Number"
                                                            name="JOB_Order_Number"
                                                            // disabled={disabledNature}
                                                            value={values?.JOB_Order_Number}
                                                            options={jobOrderOptions}
                                                            getOptionLabel={(option) =>
                                                              option.value
                                                                ? option.value?.toString()
                                                                : ""
                                                            }
                                                            onChange={(e, v) => {
                                                              setFieldValue("JOB_Order_Number",v)
                                                            }}
                                                            disabled={
                                                              !checkHighlight("JOB_Order_Number")
                                                            }
                                                            // hasError={errors.JOB_Order_Number ? true : false}
                                                            renderOption={(props, option, index) => {
                                                              const key = `listItem-${index?.index}-${option.key}`;
                                                              return (
                                                                <li {...props} key={key}>
                                                                  {option["value"]}
                                                                </li>
                                                              );
                                                            }}
                                                            renderInput={(params) => (
                                                              <TextField
                                                                {...params}
                                                                // error={errors.JOB_Order_Number ? true : false}
                                                                label="Job Order Number"
                                                                InputLabelProps={{
                                                                  shrink: true,
                                                                }}
                                                                className={`flex w-full mx-10 ${
                                                                  // checkHighlight("JOB_Order_Number")
                                                                  checkOnlyHighlight("JOB_Order_Number")
                                                                  ? "isHLOptional" //"isHL"
                                                                  : ""
                                                                } `}
                                                              />
                                                            )}
                                                          /> */}

                                    </>
                                  )}

                                  {showField.Budget_Account_Number === false && (
                                    <Col xs={6} className="px-2">
                                      <CustomTextField
                                        name="Budget_Account_Number"
                                        value={values.Budget_Account_Number}
                                        onChange={(e) => {
                                          handleChange(e);
                                        }}
                                        variant="outlined"
                                        label="Budget Account Number"
                                        id="Budget_Account_Number"
                                        className={
                                          checkHighlight("Budget_Account_Number")
                                            ? "isHLOptional" //"isHL"
                                            : ""
                                        }
                                        shrink={true}
                                        hasError={false}
                                        checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                          "Budget_Account_Number"
                                        )}
                                        checkHighlightForTextBox={checkOnlyHighlight(
                                          "Budget_Account_Number"
                                        )}
                                      />
                                    </Col>
                                  )}
                                </Row>
                                {values?.natureCode?.value == "30" &&
                                  <Row className="mt-1 mx-2">
                                    <Typography variant="h6">
                                      Salary Increment GG1's require the Performance Evaluation Document be uploaded.  Scroll down below to do this.
                                    </Typography>
                                  </Row>
                                }
                              </tbody>
                            </table>
                          )}

                          {loadingTransaction ? (
                            renderLoader()
                          ) : (

                            <div>


                              <Grid container spacing={2}>
                                {/* <Grid item xs={6} sm={4} >
                              {showField.natureCode === true && (
                                
                                <Autocomplete
                                  isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                  }
                                  size="small"
                                  disablePortal
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  id="NatureOf"
                                  name="NatureOf"
                                  disabled={disabledNature}
                                  // disabled={true}
                                  value={
                                    values?.NatureOf?.label !== null
                                      ? values.NatureOf
                                      : { value: "", label: "" }
                                  }
                                  options={natureOfOptions}
                                  // options={natureOptionsExceptSI}
                                  getOptionLabel={(option) =>
                                    option.label
                                      ? option.label?.toString()
                                      : ""
                                  }
                                  onChange={(e, v) => {
                                    setFieldValue("natureCode", v);
                                    setFieldValue("NatureOf", v);
                                    if (v?.authority) {
                                      setFieldValue(
                                        "LegalAuthority",
                                        v?.authority
                                      );
                                      // console.log(
                                      //   "121212 on changed Authority ifff ::: ",
                                      //   v,
                                      //   values?.LegalAuthority
                                      // );
                                    } else {
                                      setFieldValue("LegalAuthority", "");
                                    }
                                    if(!v){
                                      setFieldValue(
                                        "CurrentProcessStatus",
                                        {
                                          value: 18,
                                          label: "Dept Admin",
                                        }
                                      );
                                    }
                                    setTempProcessStatus({
                                      value: 18,
                                      label: "Dept Admin",
                                    });
                                  }}
                                  hasError={errors.NatureOf ? true : false}
                                  renderOption={(props, option, index) => {
                                    const key = `listItem-${index?.index}-${option.id}`;
                                    return (
                                      <li {...props} key={key}>
                                        {option["label"]}
                                      </li>
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      error={errors.NatureOf ? true : false}
                                      label="Nature Of Action"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      className={`flex w-full mx-10 ${
                                        // checkSysGenHighlight("NatureOf")
                                        //   ? "isHL1"
                                        //   : ""
                                        checkOnlyHighlight("NatureOf")
                                          ? "isHL"
                                          : ""
                                        } `}
                                    />
                                  )}
                                />
                                      
                              )}


                                


                              </Grid> */}

                                {/* <Grid  mt={-1} item xs={6} sm={4} >
                                {showField.EffDate === true && (
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    
                                  >
                                    <DesktopDatePicker
                                    
                                      label="Eff Date"
                                      inputFormat="MM/DD/YYYY"
                                      name="EffDate"
                                      minDate={
                                        values?.natureCode?.value == "17"
                                          ? values?.EmploymentDate
                                            ? moment(values?.EmploymentDate)
                                            : ""
                                          : ""
                                      }
                                      // maxDate={
                                      //   CheckMinMax()
                                      //     ? values?.ExpirationDate
                                      //     : ""
                                      // }
                                      maxDate={
                                        values?.natureCode?.value == "17"
                                          ? moment()
                                          : autoGeneratedItem?.employee_Status ==
                                            "A" && values?.Next_INCR_date
                                            ? moment(values?.Next_INCR_date)
                                            : ""
                                      }
                                      onChange={(value) => {
                                        const formatDate = value?.$d;
                                        if (formatDate) {
                                          let date1 =
                                            moment(formatDate).format(
                                              "MM/DD/YYYY"
                                            );
                                          setFieldValue("EffDate", date1);
                                        } else {
                                          setFieldValue("EffDate", null);
                                        }
                                      }}
                                      // className={
                                      //   (values?.natureCode?.value == 15 || values?.natureCode?.value == 16) ?
                                      //   checkHighlight("EffDate") ? "isHL" : ""
                                      //   :
                                      //   checkHighlight("EffDate")
                                      //     ? "isHLOptional"
                                      //     : ""
                                      // }
                                      // error={checkHighlight("EffDate")}
                                      disabled={
                                        checkHighlight("EffDate") ? false : true
                                      }
                                      value={values.EffDate}
                                      renderInput={(params) => (
                                        <TextField
                                          size="small"
                                          sx={{
                                            "& .MuiInputBase-input.Mui-disabled":
                                            {
                                              WebkitTextFillColor:
                                                "#00000092",
                                            },
                                            "& .MuiFormLabel-root.Mui-disabled":
                                            {
                                              WebkitTextFillColor:
                                                "#00000092",
                                            },
                                          }}
                                          fullWidth
                                          autoComplete="off"
                                          name="EffDate"
                                          margin="dense"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          inputProps={{
                                            style: {
                                              fontSize: "12px",
                                            },
                                          }}
                                          {...params}
                                          error={
                                            values?.natureCode?.value == 15 ||
                                              values?.natureCode?.value == 16 ||
                                              values?.natureCode?.value == 34 ||
                                              values?.natureCode?.value == 32 ||
                                              values?.natureCode?.value == 1 ||
                                              values?.natureCode?.value == 37 ||
                                              values?.natureCode?.value == 2
                                              ? checkHighlight("EffDate")
                                              : false
                                          }
                                          className={
                                            values?.natureCode?.value == 15 ||
                                              values?.natureCode?.value == 16 ||
                                              values?.natureCode?.value == 34 ||
                                              values?.natureCode?.value == 32 ||
                                              values?.natureCode?.value == 1 ||
                                              values?.natureCode?.value == 37 ||
                                              values?.natureCode?.value == 2
                                              ? checkHighlight("EffDate")
                                                ? "isHL"
                                                : ""
                                              : checkHighlight("EffDate")
                                                ? "isHLOptional"
                                                : ""
                                          }
                                        />
                                      )}
                                    />
                                  </LocalizationProvider>
                                )}
                              </Grid> */}




                                {/* <Grid item xs={6} sm={4} style={{paddingTop: "0px"}}>
                                {showField.Budget_Account_Number === true && (
                                  <CustomTextField
                                    name="Budget_Account_Number"
                                    value={values.Budget_Account_Number}
                                    onChange={(e) => {
                                      handleChange(e);
                                    }}
                                    variant="outlined"
                                    label="Budget Account Number"
                                    id="Budget_Account_Number"
                                    className={
                                      checkHighlight("Budget_Account_Number")
                                        ? "isHLOptional" //"isHL"
                                        : ""
                                    }
                                    shrink={true} 
                                    hasError={ false } 
                                    checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                      "Budget_Account_Number"
                                    )}
                                    checkHighlightForTextBox={checkOnlyHighlight(
                                      "Budget_Account_Number"
                                    )}
                                    forceEnable={true}
                                  /> 
                                )}
                              </Grid> */}


                              </Grid>


                            </div>

                          )}
                        </AccordionDetails>
                      </Accordion>


                      {open50 ? (
                        <ChangeWorkStatusModal
                          isOpen={open50}
                          handleClose={handleClose50}
                          currentStatus={
                            values.worK_SCH ? values.worK_SCH : item.worK_SCH
                          }
                          values={values}
                        />
                      ) : (
                        <></>
                      )}
                      {openAlert ? (
                        <NextIncrOverDueModal
                          isOpen={openAlert}
                          handleClose={closeAlert}
                          msg={alertMsg}
                        />
                      ) : null}
                      {!hrControl && openSubmitted ? (
                        <SubmittedModal
                          isOpen={openSubmitted}
                          handleClose={handleCloseSubmitted}
                          data={TransactionCreated}
                        />
                      ) : (
                        <></>
                      )}

                      {openStatusChange && values?.CurrentProcessStatus ? (
                        <StatusChangeModalBlanket
                          currentStatus={values?.CurrentProcessStatus}
                          newProcessStatus={newProcessStatus}
                          isOpen={openStatusChange}
                          handleClose={() => {
                            setOpenStatusChange(false);
                          }}
                          processStatusList={processStatusList}
                          setStatusRemark={setStatusRemark}
                          setFieldValue={setFieldValue}
                          setStatusAction={setStatusAction}
                          setProcessStatusChanged={setProcessStatusChanged}
                          setLocalCurrentStatus={setLocalCurrentStatus}
                          isGG1Transaction={true}
                          setOptionalMessages={setOptionalMessages}
                          errorMsgs={errorMessage}
                          role={role}
                          noa={values?.natureCode?.value}
                          evaluation={values?.Evalution_Type}
                          uploadedDocuments={uploadedDocuments}
                          toGrade={values?.TO_Grade}
                          fromGrade={values?.FR_Grade}
                          maxStatus={maxState}
                          toDepartment={values?.TO_Department?.label}
                          toDivision={values?.TO_Division?.label}
                          bbmrAnalyst={values?.bbmrAnalyst}
                          BBMRSkipLogin={BBMRSkipLogin}
                          batchId={batchId}
                          maxHours={values?.maxHours}
                        />
                      ) : null}

                      {openBBMRSummary ? (
                        <BBMRSummaryModal
                          open={openBBMRSummary}
                          onClose={handleCloseSummaryModal}
                          // onAssign={handleAssign}
                          // results={results}
                          hrControlNo={values?.hrControlNo}
                          ParentId={batchId || ""}
                          batchName={batchData?.Batchname || ""}
                          rate={updatedData?.Rate}
                          hours={updatedData?.NoOfHours}
                          noa={values?.natureCode?.label}
                        />
                      ) : null}


                      {openResetmodal ? (
                        <ResetModel
                          open={openResetmodal}
                          onClose={() => {
                            setOpenResetModal(false);
                          }}
                          // onAssign={handleAssign}
                          // results={results}
                          ParentId={batchId || ""}
                          batchName={batchData?.Batchname || ""}
                        />
                      ) : null}

                      {/* {employeeID && hrControl ? (
                      <Card className="p-3 my-3" elevation={1}>
                        <CardBody>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "1rem",
                            }}
                          >
                            <Typography variant="h6">
                              <FontAwesomeIcon
                                className="m-r-10 font-primary"
                                icon={faTentArrowLeftRight}
                                size="lg"
                              />
                              Audit Trail
                            </Typography>
                            {auditHistory?.length &&
                              transactionProcessStatuses &&
                              transactionProcessStatuses?.length ? (
                              <Btn
                                attrBtn={{
                                  color: "primary",
                                  onClick: () => {
                                    OpenHistoryComponent();
                                  },
                                  style: {
                                    marginLeft: "6px",
                                  },
                                }}
                              >
                                History
                              </Btn>
                            ) : null}
                          </div>
                          <TableContainer
                            style={{ marginBottom: "15px" }}
                            component={Paper}
                          >
                            <Table
                              sx={{ minWidth: 700 }}
                              aria-label="simple table"
                            >
                              {transactionProcessStatuses &&
                                transactionProcessStatuses?.length ? (
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Sr No</TableCell>
                                    <TableCell>Performed Date</TableCell>
                                    <TableCell>Process</TableCell>
                                    <TableCell>Performed by</TableCell>
                                    <TableCell>Remark</TableCell>
                                    <TableCell>Status</TableCell>
                                  </TableRow>
                                </TableHead>
                              ) : null}
                              {transactionProcessStatuses &&
                                transactionProcessStatuses?.length ? (
                                transactionProcessStatuses.map((item, i) => {
                                  return (
                                    <TableBody>
                                      <TableRow>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>
                                          {item?.transactionProcessStatus
                                            ?.performedDate === null
                                            ? "N/A"
                                            : dayjs(
                                              item?.transactionProcessStatus
                                                ?.performedDate
                                            ).format("MM/DD/YYYY hh:mm A")}
                                        </TableCell>
                                        <TableCell>
                                          {processStatusList?.length &&
                                            processStatusList.find((itm) => {
                                              return (
                                                itm.id ===
                                                item?.transactionProcessStatus
                                                  ?.processStatusId
                                              );
                                            })?.statusName}
                                        </TableCell>
                                        <TableCell>
                                          {item?.transactionProcessStatus
                                            ?.peformedByName
                                            ? item?.transactionProcessStatus
                                              ?.peformedByName
                                            : "N/A"}
                                        </TableCell>
                                        <TableCell>
                                          {item?.transactionProcessStatus
                                            ?.statusRemarks || "N/A"}
                                        </TableCell>

                                        <TableCell>
                                          {item?.transactionProcessStatus
                                            ?.status || "Completed"}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  );
                                })
                              ) : (
                                <div className="text-center p-2">
                                  No Data Found
                                </div>
                              )}
                            </Table>
                          </TableContainer>
                        </CardBody>
                      </Card>
                    ) : null}  */}

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Form>
          </>

          <Card>
            <CardBody>
              {values?.natureCode?.label?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" && (
                <Accordion expanded={contactView}>
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    onClick={() => setContactView(!contactView)}
                  >
                    <Typography variant="h6">
                      <FontAwesomeIcon
                        className="m-r-10 font-primary"
                        icon={faUsers}
                        size="lg"
                      />
                      {/* BBMR Information */}
                      Assign Job Order No.
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>


                    <Row>
                      <Col md={2} style={{ display: "flex" }}>
                        <Icon style={{ fontSize: '25px', marginTop: "17px", marginRight: "5px", cursor: "pointer" }} name="eye" onClick={() => setJobOrderModal(!jobOrderModal)} />

                        <CustomTextField
                          name="JOB_Order_Number"
                          value={values.JOB_Order_Number}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Job Order Number"
                          id="JOB_Order_Number"
                          shrink={true}
                          // className={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? "isHLOptional" //"isHL"
                          //     : ""
                          // }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                        // disabled={
                        //   checkHighlight("JOB_Order_Number")
                        //     ? false
                        //     : true
                        // }
                        // checkHighlightSysGenForTextBox={checkSysGenHighlight(
                        //   "JOB_Order_Number"
                        // )}
                        // checkHighlightForTextBox={checkOnlyHighlight(
                        //   "JOB_Order_Number"
                        // )}
                        // forceEnable={true}
                        />
                        {/* {errors.JOB_Order_Number && (
                            <p className="hasErrorLbl">
                              {errors.JOB_Order_Number}
                            </p>
                          )} */}
                      </Col>

                      <Col md={2}>
                        <CustomTextField
                          name="Main_Account"
                          value={values.Main_Account}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Main Account"
                          id="Main_Account"
                          shrink={true}
                          className={
                            checkHighlight("Main_Account")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "Main_Account"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "Main_Account"
                          )}
                        />
                      </Col>

                      <Col md={2}>
                        <CustomTextField
                          name="AccountDescription"
                          value={values.Account_Description}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Account Description"
                          id="Description"
                          shrink={true}
                          className={
                            checkHighlight("Description")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "Description"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "Description"
                          )}
                        />
                      </Col>

                      <Col md={2}>
                        <CustomTextField
                          name="Description"
                          value={values.Description}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Description"
                          id="Description"
                          shrink={true}
                          className={
                            checkHighlight("Description")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "Description"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "Description"
                          )}
                        />
                      </Col>

                      {/* <Col md={2}>
                      <CustomTextField
                              name="D365_Account_No"
                              value={values.D365_Account_No}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              label="D365 Account No"
                              id="D365_Account_No"
                              shrink={true}
                              className={
                                checkHighlight("D365_Account_No")
                                  ? "isHLOptional" //"isHL"
                                  : ""
                              }
                              // hasError={
                              //   checkHighlight("JOB_Order_Number")
                              //     ? true
                              //     : false
                              // }
                              hasError={false}
                              // disabled={
                              //   checkHighlight("JOB_Order_Number")
                              //     ? false
                              //     : true
                              // }
                              checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                "D365_Account_No"
                              )}
                              checkHighlightForTextBox={checkOnlyHighlight(
                                "D365_Account_No"
                              )}
                            />
                      </Col> */}

                      <Col md={2}>
                        <CustomTextField
                          name="AS400_Account_No"
                          value={values.AS400_Account_No}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="AS400 Account No"
                          id="AS400_Account_No"
                          shrink={true}
                          className={
                            checkHighlight("AS400_Account_No")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "AS400_Account_No"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "AS400_Account_No"
                          )}
                        />
                      </Col>

                      {/* <Col md={2}>
                      <CustomTextField
                              name="Description"
                              value={values.Description}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              label="Description"
                              id="Description"
                              shrink={true}
                              className={
                                checkHighlight("Description")
                                  ? "isHLOptional" //"isHL"
                                  : ""
                              }
                              // hasError={
                              //   checkHighlight("JOB_Order_Number")
                              //     ? true
                              //     : false
                              // }
                              hasError={false}
                              // disabled={
                              //   checkHighlight("JOB_Order_Number")
                              //     ? false
                              //     : true
                              // }
                              checkHighlightSysGenForTextBox={checkSysGenHighlight(
                                "Description"
                              )}
                              checkHighlightForTextBox={checkOnlyHighlight(
                                "Description"
                              )}
                            />
                      </Col> */}
                      <Col md={1}>
                        <CustomTextField
                          name="Fund_Dimension"
                          value={values.Fund_Dimension}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Fund Dimension"
                          id="Fund_Dimension"
                          shrink={true}
                          className={
                            checkHighlight("Fund_Dimension")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "Fund_Dimension"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "Fund_Dimension"
                          )}
                        />
                      </Col>

                      <Col md={1}>
                        <CustomTextField
                          name="Year_Dimension"
                          value={values.Year_Dimension}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          label="Year Dimension"
                          id="Year_Dimension"
                          shrink={true}
                          className={
                            checkHighlight("Year_Dimension")
                              ? "isHLOptional" //"isHL"
                              : ""
                          }
                          // hasError={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? true
                          //     : false
                          // }
                          hasError={false}
                          // disabled={
                          //   checkHighlight("JOB_Order_Number")
                          //     ? false
                          //     : true
                          // }
                          checkHighlightSysGenForTextBox={checkSysGenHighlight(
                            "Year_Dimension"
                          )}
                          checkHighlightForTextBox={checkOnlyHighlight(
                            "Year_Dimension"
                          )}
                        />
                      </Col>
                    </Row>


                  </AccordionDetails>
                </Accordion>
              )}
              {values?.natureCode?.label?.trim()?.toUpperCase() !== "PAY ADJUSTMENT - INC" ?
                <DataTable
                  tableName={"vw_Blanket_gg1"}
                  visibleColumns={AssignBatchVisibleColumn}
                  title={`Assig Batch Employees`}
                  // sort={[{ field: "EndDate", dir: "desc" }]}
                  // deleteData={deleteData}
                  // isLoading={false}
                  // additionalWheres={additionalWheresN}
                  additionalWheres={additionalWheresN}
                  defaultAdditionalWhere={`parentId=${batchId}`}
                  parentId={batchId}
                  setAdditionalWheresN={setAdditionalWheresN}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                  checkboxAction={true}
                  checkboxKey={"ID"}
                  customsubmitBtn={customsubmitBtn}
                  // isAssignEmployee={true}
                  // setDeleteData={setDeleteData}
                  // supervisorId={params?.superVisorId}
                  setShowDoc={setShowDoc}
                  showDoc={showDoc}
                  applicationName="Blanketgg1"
                  setTotalEmployees={setTotalEmployees}
                />
                :

                <DataTable
                  tableName={"vw_Blanket_gg1"}
                  visibleColumns={AssignBatchVisibleColumnTwo}
                  title={`Assig Batch Employees`}
                  additionalWheres={additionalWheresN2}
                  defaultAdditionalWhere={`parentId=${batchId}`}
                  parentId={batchId}
                  setAdditionalWheresN={setAdditionalWheresN2}
                  showFilterOptions={false}
                  setShowDoc={setShowDoc}
                  showDoc={showDoc}
                  applicationName="Blanketgg1"
                />

              }

              {values?.hrControlNo ? (
                <Card className="p-3 my-3" elevation={1}>
                  <CardBody>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                      }}
                    >
                      <Typography variant="h6">
                        <FontAwesomeIcon
                          className="m-r-10 font-primary"
                          icon={faTentArrowLeftRight}
                          size="lg"
                        />
                        Audit Trail
                      </Typography>
                      {auditTrailData?.length ? (
                        // auditHistory?.length &&
                        // transactionProcessStatuses &&
                        // transactionProcessStatuses?.length ? (
                        <Btn
                          attrBtn={{
                            color: "primary",
                            onClick: () => {
                              OpenHistoryComponent();
                            },
                            style: {
                              marginLeft: "6px",
                            },
                          }}
                        >
                          History
                        </Btn>
                      ) : null}
                    </div>
                    <TableContainer
                      style={{ marginBottom: "15px" }}
                      component={Paper}
                    >
                      <Table
                        sx={{ minWidth: 700 }}
                        aria-label="simple table"
                      >
                        {/* {transactionProcessStatuses &&
                                transactionProcessStatuses?.length ? ( */}
                        <TableHead>
                          <TableRow>
                            <TableCell>Sr No</TableCell>
                            <TableCell>Performed Date</TableCell>
                            <TableCell>Process</TableCell>
                            <TableCell>Performed by</TableCell>
                            <TableCell>Remark</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        {/* ) : null} */}
                        {auditTrailData &&
                          auditTrailData?.length ? (
                          auditTrailData.map((item, i) => {
                            return (
                              <TableBody>
                                <TableRow>
                                  <TableCell>{i + 1}</TableCell>
                                  <TableCell>
                                    {/* {item?.transactionProcessStatus
                                            ?.performedDate === null
                                            ? "N/A"
                                            : dayjs(
                                              item?.transactionProcessStatus
                                                ?.performedDate
                                            ).format("MM/DD/YYYY hh:mm A")} */}
                                    {
                                      item?.dateStarted ? moment(item?.dateStarted).format("MM/DD/YYYY hh:mm A") : "N/A"
                                    }
                                  </TableCell>
                                  <TableCell>
                                    {/* {processStatusList?.length &&
                                            processStatusList.find((itm) => {
                                              return (
                                                itm.id ===
                                                item?.transactionProcessStatus
                                                  ?.processStatusId
                                              );
                                            })?.statusName} */}
                                    {
                                      item?.statusName ? item?.statusName : "N/A"
                                    }
                                  </TableCell>
                                  <TableCell>
                                    {/* {item?.transactionProcessStatus
                                            ?.peformedByName
                                            ? item?.transactionProcessStatus
                                              ?.peformedByName
                                            : "N/A"} */}
                                    {item?.peformedByName ? item?.peformedByName : item?.performedBy ? item?.performedBy : "N/A"}
                                  </TableCell>
                                  <TableCell>
                                    {/* {item?.transactionProcessStatus
                                            ?.statusRemarks || "N/A"} */}
                                    {item?.statusRemarks ? item?.statusRemarks : "N/A"}
                                  </TableCell>

                                  <TableCell>
                                    {/* {item?.transactionProcessStatus
                                            ?.status || "Completed"} */}
                                    {
                                      item?.finalStatus ? item?.finalStatus : "N/A"
                                    }
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          })
                        ) : (
                          <div className="text-center p-2">
                            No Data Found
                          </div>
                        )}
                      </Table>
                    </TableContainer>
                  </CardBody>
                </Card>
              ) : null}
              <HistoryDataTable
                openHistory={openHistory}
                setOpenHistory={setOpenHistory}
                data={auditTrailHistory || []}
                sortData={sortData}
                selectedColumns={sortedColumns}
                setSortedColumns={setSortedColumns}
                onSortChange={handleSortChange}
                actions={actions}
                title={"History"}
              />
              <DifferencesModalBlanket
                visible={openDiffModal}
                setVisible={setOpenDiffModal}
                data={differenceData?.length > 0 ? differenceData : []}
                loadingPanel={loadingPanel}
                loading={
                  differenceData &&
                    differenceData?.length > 0 &&
                    auditTrailHistory?.HRControlNo
                    ? false
                    : true
                }
              />

              <Accordion expanded={documentView}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                // onClick={() => setDocumentView(!documentView)}
                >
                  <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                    <Typography variant="h6" >
                      <FontAwesomeIcon
                        className="m-r-10 font-primary"
                        icon={faUsers}
                        size="lg"
                      />
                      Document Upload


                    </Typography>

                    <Btn
                      type='button'
                      attrBtn={{
                        color: "primary",
                        type: "submit",
                        style: {
                          marginRight: "4px",
                        },
                        onClick: (e) => {
                          // e.stopPropagation();
                          setShowDoc(true)

                        },

                      }}

                    >
                      <Icon style={{ fontSize: "18px", marginRight: "10px" }} name="save" />
                      Show Document
                    </Btn>
                  </div>
                </AccordionSummary>
                <AccordionDetails>


                  {showDoc ? <DocumentListing
                    title={
                      values?.natureCode?.value == "91"
                        ? "Position Description"
                        : values?.natureCode?.value == "30" ||
                          values?.natureCode?.value == "58"
                          ? "Upload Performance Evaluation"
                          : "GG1-Attachment"
                    }
                    isDocumentManagement={false}
                    isShowActions={true}
                    isDashboard={false}
                    referenceId={values?.hrControlNo ? values?.hrControlNo : null}
                    employeeId={
                      values?.natureCode?.value != "91" &&
                        employeeID != "recruitment"
                        ? empID || employeeID
                        : null
                    }
                    sourceName="GG1"
                    applicationName="Blanket"
                  /> : null}

                </AccordionDetails>
              </Accordion>


            </CardBody>
          </Card>

        </Container> :
        <Container fluid={true}>
          {rolesArray && rolesArray?.length ?
            <AccessDenide></AccessDenide>
            : null
          }
        </Container>}


      <JobOrderSelectModal jobOrderModal={jobOrderModal} setJobOrderModal={setJobOrderModal} setFieldValue={setFieldValue} />


    </Fragment>
  );
};
export default AssignTransactionsBatch;
